// FTLEngine.js — saf FTL hesap motoru (UI yok, Supabase yok)
// TEK KAYNAK: ftl_rulesets satırı (regulation + company JSONB).
// Değerler koda GÖMÜLMEZ — SHT-FTL/EASA/FAA farkları ruleset'ten gelir.
// Tüm süreler DAKİKA cinsinden hesaplanır; "HH:MM" yalnız giriş/çıkış formatıdır.

// ── zaman yardımcıları ──────────────────────────────────────────────
import { geceMiMeydan } from './SolarTimes.js';   // uzanti ZORUNLU: Deno (Edge Fn) uzantisiz cozemiyor
import { utcGunAy, utcGunAySaat } from '../utcTarih.js';   // uzanti ZORUNLU (ayni sebep) — ay adlari TEK kaynak
// ── SEKTOR SAATLERI VE GUN DEVRI — TEK KAYNAK (20 Eyl 2026) ─────────────
//
// 🔑 NEDEN BURADA: bu kural 18 Eyl'de Edge'de yazildi, ama AYNI kural web'de
//    9 Eyl'de zaten cozulmustu ve ikisi ayri duruyordu. Serkan'in dersi:
//    *"Bir kurali duzeltince, o kurali uygulayan HER kosucuya bakilir."*
//    Artik ortak evde: web (`FTLPanel`) ve Edge (`archive-flight`) AYNI
//    fonksiyonu cagirir. Edge bunlari yeniden disa aktarir — `zaman.test.ts`
//    kendi testlerini `index.ts` uzerinden kosmaya devam eder.
//
// ⚠️ FTLPanel icinde gun devri kurali BASKA 5 YERDE daha elle yaziliydi
//    (olculdu, 20 Eyl). Onlar bu turda DEGISTIRILMEDI — ayri ve bilincli bir
//    supurme isi. Yeni yazilan hicbir yerde altinci kopya cikarilmaz.

export function ts(hhmm, isoDate) {
  if (!hhmm || !isoDate) return null;
  const d = new Date(`${isoDate}T${hhmm}:00.000Z`);
  return isNaN(d.getTime()) ? null : d.toISOString();
}

// ── GUN DEVRI (18 Eyl 2026) ─────────────────────────────────────────────────
//
// 🔴 `ts()` HER saati AYNI gune cakiyordu. 15 Eyl EGLF-LTBA: off_block 20:35,
//    on_block 00:10 → on_blocks "15 Eyl 00:10" olarak yazildi, yani kalkistan
//    20 saat ONCE. FDP de o damgadan turedigi icin **-19:25** cikti ve
//    `-19:25 < 14:00` her zaman gectigi icin AZAMI FDP FIILEN DENETLENMEDI.
//    Ekranda satir yemyesildi (Ilke 1 ihlali).
//    Ayni tuzak gece tespitinde de pusudaydi: 00:30'da inen ucus BIR ONCEKI
//    gunun gunes saatlerine gore olculurdu.
//
// 🔑 Kural (web tarafinda ZATEN var — PlannedOutcomeModal/EditDutyModal
//    `nextDay()`): bir sektorun saatleri SIRAYLA okunur ve saat geriye
//    gittiginde gun bir ileri alinir. Ucuncu bir tanim yazilmaz; ayni mantik
//    buraya tasindi.
//
//    Sira: off_block → takeoff → landing → on_block. Bos degerler atlanir ama
//    "onceki saat" olarak SON DOLU deger tutulur, yoksa eksik bir alan devri
//    gizlerdi.
// sonrakiAn: `taban`dan SONRAKI ilk `hhmm` ani.
//
// FDP'de gun devrinin olcusu SEKTOR SIRASI DEGIL, GOREVIN BASLANGICIDIR:
// report 15 Eyl 19:35 ise on_block 00:10 ertesi gundur. Ayni gune cakilinca
// fark eksi cikar ve `fdp < max` karsilastirmasi HER ZAMAN gecer — yani
// azami FDP fiilen denetlenmez (15 Eyl EGLF-LTBA: -19:25 / 14:00).
export function sonrakiAn(taban, hhmm) {
  if (!taban || !hhmm) return null;
  const t = new Date(taban);
  if (isNaN(t.getTime())) return null;
  let an = ts(hhmm, t.toISOString().slice(0, 10));
  if (!an) return null;
  if (new Date(an).getTime() < t.getTime()) {
    const d = new Date(t); d.setUTCDate(d.getUTCDate() + 1);
    an = ts(hhmm, d.toISOString().slice(0, 10));
  }
  return an;
}

export function sektorZamanlari(isoDate, saatler) {
  if (!isoDate) return saatler.map(() => null);
  const dk = (h) => {
    const m = /^(\d{1,2}):(\d{2})$/.exec(h);
    return m ? Number(m[1]) * 60 + Number(m[2]) : null;
  };
  let gun = isoDate, oncekiDk = null;
  return saatler.map((h) => {
    if (!h) return null;
    const bu = dk(h);
    if (bu === null) return null;
    if (oncekiDk !== null && bu < oncekiDk) {
      const d = new Date(`${gun}T00:00:00.000Z`);
      d.setUTCDate(d.getUTCDate() + 1);
      gun = d.toISOString().slice(0, 10);
    }
    oncekiDk = bu;
    return ts(h, gun);
  });
}

export const toMin = (hhmm) => {
  if (hhmm == null || hhmm === '') return null;
  if (typeof hhmm === 'number') return hhmm;
  const parts = String(hhmm).split(':').map(Number);
  if (parts.some(isNaN)) return null;
  return parts[0] * 60 + (parts[1] || 0);
};

export const fmtMin = (min) => {
  if (min == null || isNaN(min)) return '—';
  const neg = min < 0; const a = Math.abs(Math.round(min));
  return `${neg ? '-' : ''}${String(Math.floor(a / 60)).padStart(2, '0')}:${String(a % 60).padStart(2, '0')}`;
};

// dakika farkı, gece yarısını geçen aralıklar için (end < start ise +24h)
export const spanMin = (startHHMM, endHHMM) => {
  const s = toMin(startHHMM), e = toMin(endHHMM);
  if (s == null || e == null) return null;
  return e >= s ? e - s : e + 1440 - s;
};

// ── BLOK TOPLAMLARI — DUTY HISTORY + DUTY SHEET TEK HESAP (21 Eki 2026) ─────────────────────────────────────
// 🔴 Kod taraması (W1): DUTY HISTORY toplamı paket görevdeki DH bacağını (rolü boş → PF) PF bloğuna katıyordu; DUTY
//    SHEET katmıyordu — aynı pilotun PF bloğu iki ekranda farklı çıkıyordu. Serkan: *"DH PF bloğuna niye girsin ki"* ·
//    *"tek kaynak · tek ekran tek kural"*. Kural: verilen UÇUŞ görevlerinin sektörleri; DH bacağı (ekip yolcu) SAYILMAZ;
//    rolü yazılmamış bacak PF sayılır (iki ekranın ortak kuralı); blok = OFF→ON (yoksa ETD→ETA). Hangi görevlerin
//    verileceğini (gerçekleşmiş, aralık) çağıran seçer.
export function blokToplamlari(gorevler) {
  const t = { pf: { n: 0, dk: 0 }, pm: { n: 0, dk: 0 }, crz: { n: 0, dk: 0 }, blokDk: 0 };
  for (const d of gorevler || []) {
    if (d?.duty_type !== 'flight') continue;
    for (const s of d.sectors || []) {
      if (!s || s.deadhead) continue;
      const dk = spanMin(s.off_block || s.etd, s.on_block || s.eta) || 0;
      const rol = String(s.role || 'PF').toUpperCase();
      const k = rol === 'PM' ? 'pm' : rol === 'CRZ CPT' ? 'crz' : 'pf';
      t[k].n += 1; t[k].dk += dk; t.blokDk += dk;
    }
  }
  return t;
}

// ── GEÇMİŞE GİRİLEN GÖREV (21 Ağu 2026, Serkan) ─────────────────────
// Kural: *"görevin bitiş saati ON block + 30, şu anki andan geride ise"* ·
//        *"görevin bitiş saati görevin girildiği saatten geride ise."*
// Yani ölçü görevin BAŞLANGICI değil BİTİŞİdir. Sonucu: süregelen görev geçmiş
// SAYILMAZ (bugün başlamış, henüz bitmemiş bir görev planlamadır); yalnız
// tamamen bitmiş görev "olmuş bitmiş iş"tir ve actual olarak kaydedilir.
// `duty_end` zaten son bacağın ETA'sına company.postFlightDutyMin (30 dk)
// eklenerek kuruluyor — eşik burada uydurulmuyor, mevcut kuraldan geliyor.
//
// 🔴 AN KARŞILAŞTIRILIR, METİN DEĞİL. 21 Ağu sabahı archive-flight'ta tam
//    tersi yapıldı ve koruma hiç çalışmadı: "…+00:00" ile "….000Z" AYNI ANdır,
//    FARKLI METİNdir. Bu yüzden ikisi de ms'e çevrilip karşılaştırılır.
export function isPastDuty(dutyEndISO, nowISO) {
  const end = Date.parse(dutyEndISO);
  const now = Date.parse(nowISO);
  if (!Number.isFinite(end) || !Number.isFinite(now)) return false;
  return end < now;
}

// Atama satırlarını geçmişe göre işaretler. SAF: girdiyi değiştirmez, yeni
// dizi döner. `off` satırlarına DOKUNULMAZ — onların `duty_end`'i yoktur ve
// durumları offPeriodStatuses'tan gelir. Sektörü olmayan görevde (ground)
// `sectors` anahtarı AÇILMAZ; boş `sectors: []` yazmak 1b'deki hayalet satırın
// ta kendisidir.
export function backdateRows(rows, nowISO) {
  const hit = (r) => r && r.duty_type !== 'off' && isPastDuty(r.duty_end, nowISO);
  const list = rows || [];
  if (!list.some(hit)) return { past: false, rows: list };
  return {
    past: true,
    rows: list.map(r => {
      if (!hit(r)) return r;
      const out = { ...r, status: 'actual', duty_finished: true };
      if (Array.isArray(r.sectors)) {
        // GIRILEN SAATLER GERCEK SAATTIR (Serkan, 21 Agu) — ayrica off/on block
        // sorulmaz. `entered_manually` ayrimi tasir: plan_id'si olan sektor
        // ARSIVDEN olculmustur, bu ELLE yazilmistir.
        out.sectors = r.sectors.map(sec => ({
          ...sec,
          off_block: sec.off_block ?? sec.etd,
          on_block: sec.on_block ?? sec.eta,
          entered_manually: true,
        }));
      }
      return out;
    }),
  };
}

// ── etkin kurallar: regulation + company (override yalnız emniyetli yönde) ──
// company.overrides = { "cumulative_limits.flt_28d_min": 5400, "min_rest.home_base_min": 780, ... }
// Emniyetli yön: *_limit → yalnız DÜŞÜK kabul; min_rest/min_off → yalnız YÜKSEK kabul.
// Yanlış yönlü override SESSİZCE YOK SAYILMAZ — {ignored:[...]} içinde raporlanır (UI uyarı basar).
export function effectiveRules(ruleset) {
  const reg = ruleset?.regulation || {};
  const comp = ruleset?.company || {};
  const eff = JSON.parse(JSON.stringify(reg));
  const ignored = [];
  const overrides = comp.overrides || {};
  Object.entries(overrides).forEach(([path, val]) => {
    const keys = path.split('.');
    let node = eff;
    for (let i = 0; i < keys.length - 1; i++) {
      if (node[keys[i]] == null) { node = null; break; }
      node = node[keys[i]];
    }
    if (!node) { ignored.push({ path, val, reason: 'unknown parameter' }); return; }
    const leaf = keys[keys.length - 1];
    const regVal = node[leaf];
    const dir = overrideDirection(path);
    // 🔑 KILITLI: yonu acikca yazilmamis mevzuat parametresi degistirilemez.
    // Sessizce uygulamak yerine REDDEDILIR ve sebebi `ignored`'a yazilir —
    // ekranda gorunur (Ilke 2: sessiz basarisizlik yok).
    if (dir === 'locked') { ignored.push({ path, val, reason: 'regulation parameter is locked — no tightening direction defined' }); return; }
    if (dir === 'decrease_only' && val > regVal) { ignored.push({ path, val, reason: 'above regulation' }); return; }
    if (dir === 'increase_only' && val < regVal) { ignored.push({ path, val, reason: 'below regulation' }); return; }
    node[leaf] = val;
  });
  // ── SIRKET KURALI: FERRY (Serkan, 3 Eyl 2026) ────────────────────────────
  // 🔑 SHT-FTL/HG'de FERRY KATEGORISI YOKTUR (metin tarandi). Bu yuzden ferry
  // MEVZUAT bloguna yazilmaz — o blok talimatin kendisidir ve orada olmayan bir
  // sey uydurulmaz. Ferry bir ISLETME POLITIKASIDIR: Serkan *"rule sette
  // degistirilebilir bir company rule olsun"* dedi.
  //
  // Politika: ferry ucus ticari bir ucusun da genel havacilik ucusunun da
  // arkasindan gelebilir; tipi belirsiz oldugu icin ADAY TIPLERIN EN DAR limiti
  // uygulanir. Hangi tiplerin aday oldugu SIRKET tarafindan degistirilebilir.
  // Varsayilan: hava taksi + genel havacilik (Serkan: "ferry egitim ucusu degil").
  //
  // `overrides` yolundan GECMEZ cunku o mekanizma mevzuatta VAR OLAN bir
  // parametreyi daraltmak icindir; burada mevzuatta karsilik yok.
  const ferry = comp.ferry;
  if (ferry && Array.isArray(ferry.of) && ferry.of.length && eff.fdp_limits) {
    eff.fdp_limits.ferry = {
      style: 'most_restrictive_of',
      of: ferry.of,
      source: 'company policy — not a regulation category',
      note: ferry.note || null,
    };
  }

  // ── ŞİRKET: FTL HESAP ESASI (30 Eki 2026) — `hesapTuru`. Bilinmeyen değer sessizce uygulanmaz, sebebi `ignored`'da (İlke 2).
  if (comp.hesap_esasi != null) {
    if (HESAP_ESASLARI[comp.hesap_esasi]) eff.hesap_esasi = comp.hesap_esasi;
    else ignored.push({ path: 'company.hesap_esasi', val: comp.hesap_esasi, reason: 'unknown calculation basis' });
  }

  return {
    rules: eff,
    company: {
      // Md.10 şirket değerleri — yoksa null: taban kural setinden (`bildirimSureleri`), koddan 60 / 30 uydurulmaz (4 Eki 2026).
      preFlightReportMin: comp.pre_flight_report_minutes ?? null,
      postFlightDutyMin: comp.post_flight_duty_minutes ?? null,
      // SKPK raporunun işleticiye son süresi ŞİRKETİN değeridir (Md.12(1)(c)(1) süre vermez) — yoksa null, koddan 72
      // uydurulmaz (5 Eki 2026, Serkan A; canlıda iki kural setinde de 72 girili). Son tarih: `skpkRaporSonTarihi`.
      mandatoryReportHours: comp.mandatory_report_hours ?? null,
      minOffDaysPerMonth: comp.min_off_days_per_month ?? null,
    },
    ignored,
  };
}

// parametrenin emniyetli yönü — limit mi taban mı?
/** Bir mevzuat parametresi hangi yone degistirilebilir?
 *
 * 🔑 SERKAN (3 Eyl 2026): *"SHT'den gelenler regulasyona bagli — sayet SHT
 *  degisirse bu kural degisebilir, sirket bunu ancak DARALTABILIR, gevsetemez."*
 *
 * 🔴 ESKI VARSAYILAN `'free'` IDI VE KAPIYI ACIK BIRAKIYORDU: yonu tanimlanmamis
 * her mevzuat parametresi IKI YONE de degistirilebiliyordu. Ornek:
 * `commander_discretion.fdp_extension_max_min` Md.12'de 120 dk; sirket bunu 180
 * yapabilir ve sistem KABUL EDERDI — mevzuati gevsetmek. Canlida `overrides`
 * bos oldugu icin kimse yapmamisti, ama kapi acikti.
 *
 * YENI VARSAYILAN `'locked'`: yonu ACIKCA yazilmamis mevzuat parametresi
 * DEGISTIRILEMEZ. Cunku hangi yonun daralttigini BILMIYORSAK, tahminle karar
 * vermek gevsetme riski tasir (Ilke 1 + Ilke 7). Yon eklemek bilincli bir is
 * olur: parametreye bakilir, hangi yon daraltiyor yazilir.
 *
 * @returns 'decrease_only' | 'increase_only' | 'locked'
 */
export function overrideDirection(path) {
  // ── AZAMI limitler: KUCULTMEK daraltir ──────────────────────────────
  if (path.startsWith('cumulative_limits.')) return 'decrease_only';   // Md.13
  if (path.startsWith('fdp_limits.')) return 'decrease_only';          // Md.22 · Md.25 · Md.27
  if (path === 'long_range.max_daily_fdp') return 'decrease_only';     // Md.22(3)
  if (path.startsWith('augmented_crew.extension_')) return 'decrease_only';  // Md.11
  if (path === 'split_duty.extension_cap_min') return 'decrease_only'; // Md.15
  if (path === 'standby.other.max_min') return 'decrease_only';        // Md.17(2)(a)
  if (path === 'commander_discretion.fdp_extension_max_min') return 'decrease_only';        // Md.12
  if (path === 'commander_discretion.fdp_extension_augmented_max_min') return 'decrease_only';
  if (path === 'commander_discretion.rest_reduction_max_min') return 'decrease_only';
  if (path === 'days_off.single_day_off_after_consecutive_days') return 'decrease_only';    // Md.5

  // ── ASGARI limitler: BUYUTMEK daraltir ──────────────────────────────
  if (path.startsWith('min_rest.') && path.endsWith('_min')) return 'increase_only';        // Md.16
  if (path === 'commander_discretion.rest_floor_min') return 'increase_only';               // Md.12
  if (path === 'days_off.per_calendar_month_local_days') return 'increase_only';            // Md.5
  if (path === 'days_off.per_calendar_year_local_days') return 'increase_only';
  if (path === 'days_off.notice_hours') return 'increase_only';
  if (path.startsWith('augmented_crew.inflight_rest_')) return 'increase_only';             // Md.11
  if (path.startsWith('notification_times.')) return 'increase_only';                       // Md.10

  // ── Yonu ACIKCA yazilmamis her sey KILITLI ──────────────────────────
  // Ornek: `split_duty.break_threshold_min` — esigi buyutmek mi kucultmek mi
  // daraltir? Molanin uzunluguna gore degisir. Bilmedigimiz yerde tahmin etmeyiz.
  return 'locked';
}

// ── Max FDP (Tablo-2) ───────────────────────────────────────────────
// reportLocalHHMM: YEREL rapor saati. sectors: bacak sayısı.
// 15 dk basamaklı bantlar ruleset'ten okunur — interpolasyon YOK.
// FAALIYET TIPI (Md.9): gerceklestirilen faaliyetin hukumleri gecerlidir.
//   air_taxi        → Md.22(2) Tablo 1 (matris)
//   aerial_work     → Md.26, hava taksi limitlerine alias
//   general_aviation→ Md.25 (duz: tek 12:00 / cift 14:00)
//   training        → Md.27 (UGS 12:00 + AYRI gunluk ucus suresi siniri)
//   ferry           → SHT'de KARSILIGI YOK; tipi BELIRSIZ oldugu icin
//                     air_taxi ile general_aviation'un AYNI bant/sektorde
//                     hesaplanan limitlerinden KUCUGU alinir (bkz. asagida)
export const OPERATION_TYPES = ['air_taxi', 'aerial_work', 'general_aviation', 'training', 'ferry'];
/** BACAĞIN FAALİYET TİPİ — TEK KURAL (25 Eki 2026, tasarım A; 31 Eki 2026 tek kaynağa çıktı: EDIT + STATISTICS).
 *  Her bacak kendi tipini taşır; tipsiz eski bacak (22 Ağu öncesi) görevin tipiyle açılır — o tip zaten ona
 *  uygulanıyordu. DH sektör değildir (Md.14/1/b), tipi yok. `opSrc`: tipin kaynağı (bacağınki ya da görevinki). */
export const bacakTipi = (x, duty) => (x?.deadhead ? { operation_type: '', opSrc: '' }
  : { operation_type: x?.operation_type || duty?.operation_type || '',
      opSrc: x?.operation_type ? (x.operation_type_source || '') : (duty?.operation_type_source || '') });
// ── FTL HESAP ESASI — ŞİRKET SEÇİMİ (30 Eki 2026) ──────────────────────────────────────────────────────────────
// 🔑 REC geri bildirimi (Serkan): *"uçuşun türü ne olursa olsun SHT-FTL uygulanacak, genel havacılık FTL limitleri
//    uygulanmayacak"* · *"yani tek motor hesap yapacak"*. Süper admin şirket başına seçer (`company.hesap_esasi`):
//    'sht' = her uçuş hava taksi (Md.22) · 'ga' = her uçuş genel havacılık (Md.25) · yoksa türe göre (bugünkü davranış).
//    KAYITTAKİ TÜR DEĞİŞMEZ — rapor uçuşun kendi türünü söyler; hesap bu türle yapılır. Seçim varsa Md.27 eğitim kontrolleri
//    uygulanmaz (Serkan B: *"eğitim organizasyonları dışında o kural pek işlemiyor — pilot tip eğitiminde, öğrenci değil"*).
export const HESAP_ESASLARI = Object.freeze({ sht: 'air_taxi', ga: 'general_aviation' });
/** Hesapta kullanılan tür — TEK eşleme noktası. Seçim yoksa türün kendisi. */
export const hesapTuru = (tip, rules) => HESAP_ESASLARI[rules?.hesap_esasi] || tip;
/** Şirket esası seçili mi (o zaman Md.27 eğitim kontrolleri ve karışık görev seçimi uygulanmaz). */
export const esasSecili = (rules) => !!HESAP_ESASLARI[rules?.hesap_esasi];
/** Şirketin seçimini (customers.ftl_hesap_esasi) kural setinin şirket katmanına koyar — 31 Eki 2026.
 *  Seçim KURAL SETİNDE SAKLANMAZ (REC-TR'yi REC ve GO2Demo paylaşıyor): panel açılışta birleştirir, görev kopyası
 *  (`ruleset_snapshot`) bu birleşik setten yazılır. Kural setinde kalmış eski değer her zaman silinir — tek kaynak şirket. */
export function sirketEsasiyla(ruleset, esas) {
  if (!ruleset) return ruleset;
  const { hesap_esasi: _eski, ...company } = ruleset.company || {};
  return { ...ruleset, company: HESAP_ESASLARI[esas] ? { ...company, hesap_esasi: esas } : company };
}

/** Faaliyet tipinin limit blogunu cozer (alias'i takip eder). Yoksa null. */
export function fdpLimitSet(rules, operationType = 'air_taxi') {
  const all = rules?.fdp_limits;
  if (!all) return null;
  let set = all[operationType] || all.air_taxi;
  if (set?.style === 'alias') set = all[set.same_as];
  return set || null;
}

/** Bu kural bu faaliyet tipine uygulanir mi? applies_to yoksa HEPSINE uygulanir. */
export function ruleAppliesTo(block, operationType = 'air_taxi') {
  if (!block) return false;
  if (!Array.isArray(block.applies_to)) return true;
  return block.applies_to.includes(operationType);
}

/// KARIŞIK FAALİYET TİPLİ GÖREV — EN KISITLAYICI BELİRLER (22 Ağu 2026)
///
/// 🔴 SAHA: 22 Ağu'da tek görevin iki bacağı FARKLI faaliyet tipindeydi —
///    LTAC→LTFE `RMK/BUSINESS FLIGHT` (hava taksi), LTFE→LFMN `RMK/PRIVATE
///    FLIGHT` (genel havacılık). Serkan doğruladı: *"birinci bacak business,
///    ikinci bacak general aviation, bu şekilde uçuldu."* Görev tek tip
///    taşıdığı için arşiv çelişkiyi görüp `match_review` kaldırmıştı.
///
/// Md.9 *"gerçekleştirmekte olduğu operasyon faaliyetine ilişkin hükümler
/// geçerli"* der ama KARIŞIK görev için hüküm koymaz.
/// 🔑 Serkan'ın kuralı: *"en dar kapsamlı belirler görev süresi limitini."*
/// Gerekçesi İlke 7: bir bacağı hava taksiyse, o bacağı da kapsayan TEK bir
/// UGS penceresine genel havacılığın daha uzun limitini uygulamak emniyet
/// kapısını GEVŞETİRDİ.
///
/// SIRALAMA KODA GÖMÜLMEZ: hangi tipin daha dar olduğu ruleset'ten ÖLÇÜLÜR —
/// aynı bant ve aynı sektör sayısıyla her tipin azami UGS'si hesaplanır, en
/// küçüğü kazanır. Böylece ruleset değişirse kural kendiliğinden doğru kalır.
/// Ölçülemeyen (limit dönmeyen) tip belirleyici sayılmaz; hiçbiri ölçülemezse
/// ilk tip döner (uydurma yok).
export function governingOperation(types, bandReportHHMM, sectorCount, rules, opts = {}) {
  const liste = [...new Set((types || []).filter(Boolean))];
  if (liste.length <= 1) return liste[0] ?? null;
  let kazanan = null, enDar = null;
  for (const t of liste) {
    const m = maxFdpMinutes(bandReportHHMM, sectorCount, rules,
                            { singlePilot: opts.singlePilot, operationType: t });
    if (m == null) continue;
    if (enDar == null || m < enDar) { enDar = m; kazanan = t; }
  }
  return kazanan ?? liste[0];
}

export function maxFdpMinutes(reportLocalHHMM, sectors, rules, opts = {}) {
  const t = toMin(reportLocalHHMM);
  const set = fdpLimitSet(rules, opts.operationType);
  if (!set || t == null) return null;

  // FERRY (Serkan, 2 Eyl 2026): *"Ferry ucus bir ticari ucus veya genel
  // havacilik ucusunun arkasindan olabilir; bu sebeple planlama yaparken EN DAR
  // KAPSAMLI olan limiti secelim SHT acisindan."*
  //
  // 🔑 SHT-FTL/HG'de FERRY KATEGORISI YOK (metin tarandi): talimatin ayrimi
  // isletmenin turudur (Md.22 hava taksi · Md.25 genel havacilik). Ferry ikisinin
  // de arkasindan gelebildigi icin tipi BELIRSIZDIR — belirsizligi TAHMINLE
  // degil DAR limitle kapatiriz (Ilke 7: emniyet kapisi gevsetilmez).
  //
  // Siralama KODA GOMULMEZ: her aday tipin limiti AYNI bant ve AYNI sektor
  // sayisiyla HESAPLANIR, kucugu kazanir — `governingOperation`'in deseninin
  // aynisi. Ruleset degisirse kural kendiliginden dogru kalir.
  // Olculemeyen (null donen) aday atlanir; hicbiri olculemezse null doner —
  // sayi UYDURULMAZ (Ilke 1).
  if (set.style === 'most_restrictive_of') {
    let enDar = null;
    for (const aday of set.of || []) {
      const m = maxFdpMinutes(reportLocalHHMM, sectors, rules,
                              { ...opts, operationType: aday });
      if (m == null) continue;
      if (enDar == null || m < enDar) enDar = m;
    }
    return enDar;
  }

  // Md.27 — egitim: gunun UGS tavani sabit; ucus suresi AYRI kontrol edilir
  // (egitimUcusSiniri). Bant/sektor ayrimi yoktur.
  if (set.style === 'training') return toMin(set.max_fdp) ?? null;

  // Md.25 — genel havacilik: duz limit, yalniz pilot sayisina bagli.
  if (set.style === 'flat') return toMin(opts.singlePilot ? set.single : set.dual) ?? null;

  // Md.22(2) Tablo 1 — matris: bant × sektor grubu (1-4 / 5 / 6+) × tek/cift.
  // Sektor cezasi ve FDP tabani YOK; deger dogrudan tablodan okunur.
  // (6 Agu 2026: eski havayolu SHT-FTL semasi KALDIRILDI — gecmis ucuslarin
  //  hepsi demo, eski EASA motoru baglamiyor. Taninmayan sema null doner:
  //  "hesaplayamadim" der, sayi UYDURMAZ — Ilke 1.)
  if (set.style !== 'matrix') return null;
  for (const b of set.bands) {
    const from = toMin(b.from), to = toMin(b.to);
    const inBand = from <= to ? (t >= from && t <= to) : (t >= from || t <= to); // 18:01–05:59 sarar
    if (!inBand) continue;
    const grp = sectors <= 4 ? 's1_4' : sectors === 5 ? 's5' : 's6plus';
    const col = opts.singlePilot ? 'single' : 'dual';
    return toMin(b.fdp?.[grp]?.[col]) ?? null;
  }
  return null;
}

// ── RAPOR SAATİ GERÇEK OFF-BLOCK'TAN TÜRETİLİR (21 Eyl 2026) ────────────────
//
// 🔑 Serkan: *"Actual off block girildiğinde reporting time, actual off block
//    − 60 dk olarak tanımlanmalı."* · *"Gerçek bu şekilde oluyor zaten; aksi
//    hâlde sürekli ihlal olur."*
//
// DAYANAK METNİN KENDİSİ: SHT-FTL/HG **Md.10(1)(a)** süreyi *"bir uçuş görevi
// için hazırlık yapılması ile ilk uçuş süresinin başlaması arasında"* ölçer;
// **Md.4(aa)/(çç)** uçuş süresini **block time** diye tanımlar (*"kalkış
// amacıyla park yerinden ilk hareket ettiği an"*). Yani sayaç **OFF-BLOCK**'ta
// başlar. Planlanan ETD mevzuat metninde HİÇ GEÇMEZ — o bir niyet kaydıdır,
// ölçüm girdisi değildir.
//
// 🔴 NEDEN GECİKME KORUMASI YOK (Serkan, 20 Ağu): genel havacılıkta ekip uçakta
//    beklemez, koordinasyonu pilotlar yapar; saat kayarsa görev de kayar.
//    Havayolu mantığı (sabit rapor + bekleme) burada geçerli değil. Uçak başı
//    yapıldıktan SONRA çıkan gecikme için elle görev EDIT'i (gerekçeli, izli)
//    açık durur.
//
// 🔴 KURALIN TEK SAHİBİ OLMASI ŞART (21 Eyl ölçümü): türetme yalnız
//    `archive-flight` içinde yazılıydı. Ama gerçek saat İKİNCİ bir kapıdan da
//    giriyor — kâğıt OFP / elle geriye dönük giriş (web EDIT) — ve o kapı
//    kuralı hiç çağırmıyordu. 17 Eylül uçuşunda gerçek off-block **06:45**
//    yazıldı, rapor **06:00**'da kaldı; kayıtlı hâliyle Md.10 tabanının 15 dk
//    altında ve hiçbir ekran bunu söylemedi. 46 görevde kuralın işlemediği tek
//    canlı vaka buydu — sebebi kuralın eksikliği değil, İKİNCİ KAPI'ydı.

/** Bir anın verilen dilimdeki duvar saati (HH:MM); dilim yoksa UTC.
 *  🔴 `hour12:false` KULLANILMAZ — h24 döngüsünde gece yarısı `00` değil `24`
 *     yazılır (19 Eyl 2026 kusuru, bkz. `tzOffsetMin`). Nöbetçi:
 *     `tzOffsetMin.test.js`.
 *  @param {string} anISO
 *  @param {string|null} [tz]
 *  @returns {string|null} */
export function yerelHHMM(anISO, tz = null) {
  const t = new Date(anISO).getTime();
  if (!Number.isFinite(t)) return null;
  if (!tz) return new Date(t).toISOString().slice(11, 16);
  const p = Object.fromEntries(new Intl.DateTimeFormat('en-US',
    { timeZone: tz, hourCycle: 'h23', hour: '2-digit', minute: '2-digit' })
    .formatToParts(new Date(t)).map(x => [x.type, x.value]));
  return `${p.hour}:${p.minute}`;
}

// ── BİLDİRİM SÜRELERİ — Md.10, TEK KAYNAK (4 Eki 2026, FTL adım 8) ────────────────────────────────────────────────────
// (1)(a) uçuş öncesi ≥ preflight_report_min · (b) uçuş sonrası ≥ postflight_min · (c) simülatör ve eğitim sonrası ≥
//    postflight_sim_training_min. Şirket değeri yalnız ARTIRABİLİR (Math.max — emniyet yönü). Hava ambulans (c)(ç) kapsam
//    dışı (Serkan 4 Eki: "bizim öyle bir uçuşumuz yok").
// 🔴 ÖNCESİ: 60 ve 30 yedi yerde kopyaydı (motor 4, panel 4, arşiv 1); EDIT uçuş sonrasını ham kural setinden YANLIŞ adla
//    okuyordu (`company.postFlightDutyMin` — ham alan `post_flight_duty_minutes`) ve şirket ayarı ne olursa olsun 30
//    kullanıyordu (canlı 4 Eki: bütün kopyalarda şirket 60 / 30 — kayıt şaşmamış). Sayı YALNIZ kural setinden; yoksa null.
export function bildirimSureleri(rules, company, { egitim = false } = {}) {
  const nt = rules?.notification_times || {};
  const sayi = (v) => (v != null && Number.isFinite(Number(v)) ? Number(v) : null);
  const once = sayi(nt.preflight_report_min);
  const sonra = sayi(egitim ? nt.postflight_sim_training_min : nt.postflight_min);
  if (once == null || sonra == null) return null;
  return {
    preFlightMin: Math.max(once, sayi(company?.preFlightReportMin) ?? once),
    postFlightMin: Math.max(sonra, sayi(company?.postFlightDutyMin) ?? sonra),
  };
}
/** Kayıttaki görevin uçuş sonrası süresi (dk) — KENDİ kural seti kopyasından; görevli bacaklardan biri eğitimse (c), değilse (b)
 *  (`dutyWindow` ile aynı seçim). Kural seti vermiyorsa null — görev sonu uydurulmaz. */
export function gorevUcusSonrasiDk(duty) {
  if (!duty?.ruleset_snapshot?.regulation) return null;
  const { rules, company } = effectiveRules(duty.ruleset_snapshot);
  const tipler = (duty.sectors || []).filter(s => s && !s.deadhead).map(s => hesapTuru(s.operation_type, rules)).filter(Boolean);
  const egitim = tipler.length ? tipler.includes('training') : hesapTuru(duty.operation_type, rules) === 'training';
  return bildirimSureleri(rules, company, { egitim })?.postFlightMin ?? null;
}
/** Md.10(1)(a) uçuş öncesi bildirim süresi (dk) — görevin KENDİ kural setinden; kural seti vermiyorsa null. */
export function bildirimOncesiDk(rulesetSnapshot) {
  const { rules, company } = effectiveRules(rulesetSnapshot);
  return bildirimSureleri(rules, company)?.preFlightMin ?? null;
}

/** Gerçekleşen ilk off-block'tan rapor anını türetir.
 *  @param ilkOffBlock  'HH:MM' ya da tam ISO damga
 *  @param gorevGunu    'YYYY-MM-DD' (HH:MM verildiğinde hangi güne çakılacağı)
 *  @returns {{reportISO, offBlockISO, preMin}|null} — off-block yoksa **null**;
 *           uydurulmuş bir rapor ÜRETİLMEZ (İlke 1: ölçemediğimizi yazmayız).
 */
export function raporSaatiTuret(ilkOffBlock, gorevGunu, rulesetSnapshot) {
  if (!ilkOffBlock) return null;
  const ham = String(ilkOffBlock);
  const offISO = /^\d{4}-\d{2}-\d{2}T/.test(ham)
    ? (Number.isFinite(new Date(ham).getTime()) ? new Date(ham).toISOString() : null)
    : ts(ham, gorevGunu);
  if (!offISO) return null;
  const preMin = bildirimOncesiDk(rulesetSnapshot);
  if (preMin == null) return null;                    // kural seti Md.10 süresini vermiyor — rapor uydurulmaz
  return {
    reportISO: new Date(new Date(offISO).getTime() - preMin * 60000).toISOString(),
    offBlockISO: offISO,
    preMin,
  };
}

/** Rapor anı kaydığında azami UGS'yi Md.22 Tablo-1 bandıyla yeniden okur.
 *  🔑 Rapor kayarsa BANT da kayabilir; eski tavanı bırakmak sessiz bir
 *     yanlıştır — aşım ya kaçar ya uydurulur. Nöbet indirimi ve SKPK uzatması
 *     tavanın üstüne aynen taşınır. */
// ── ARTIRILMIŞ EKİP UZATMASI — Md.11, TEK KURAL (4 Eki 2026, FTL adım 8) ──────────────────────────────────────────────
// (4) bir ilave pilotla +extension_one_additional_min, iki ilave pilotla +extension_two_additional_min — Tablo 1 değerinin
//    ÜSTÜNE. (2) "UGS, 3 sektör ile sınırlıdır" — maddenin başlığı ("uçuş sırasındaki dinlenmeye bağlı olarak azami günlük
//    UGS'nin uzatılması") ile: UZATMA kullanılan UGS en fazla `max_sectors`. Fazlasında uzatma YOK; ekip standart sayılır
//    (Tablo 1, uzun menzil tavanı, açık mesai) — Serkan 4 Eki: "evet B, mevzuata uygun olanı".
// 🔴 ÖNCESİ: 4+ sektörde de +2 saat veriliyordu (yalnız ASSIGN'da kırmızı not) — iki kopyada (dutyWindow, azamiUgsYeniden).
// UÇUŞ İÇİ DİNLENME OLANAĞI (4 Eki 2026, Serkan A: *"kullanımda seçerken uzasın, aksi halde uzamasın"*): Md.11(1) olanağı
//    tanımlar, (4) uzatmayı uçuş sırasındaki dinlenmeye bağlar. Aynı uçak yolcusuz bacakta olanak sunar, koltuklar doluyken
//    sunmaz — beyan GÖREVDE (`inflight_rest_facility`): yalnız 'in_use' uzatır; 'not_in_use' ya da beyan yoksa uzatma yok.
// Dönüş: null — artırılmış ekip yok / faaliyet tipi kapsamıyor · { uygulanir: true, ekDk } · { uygulanir: false,
//    olanakYok: true, beyan } · { uygulanir: false, sinirAsildi: true, sinir } · { uygulanir: false, olculemedi: true }
//    — kural setinde sayı yok (uydurulmaz).
export function artirilmisEkipUzatmasi(rules, opType, sektorSayisi, { ucPilot = false, dortPilot = false,
                                                                       dinlenmeOlanagi = null } = {}) {
  if (!(ucPilot || dortPilot) || !ruleAppliesTo(rules?.augmented_crew, opType)) return null;
  if (dinlenmeOlanagi !== 'in_use') return { uygulanir: false, olanakYok: true, beyan: dinlenmeOlanagi || null };
  const ac = rules.augmented_crew || {};
  const sinir = ac.max_sectors != null && Number.isFinite(Number(ac.max_sectors)) ? Number(ac.max_sectors) : null;
  const ek = dortPilot ? ac.extension_two_additional_min : ac.extension_one_additional_min;
  if (sinir == null || ek == null || !Number.isFinite(Number(ek))) return { uygulanir: false, olculemedi: true };
  if (sektorSayisi > sinir) return { uygulanir: false, sinirAsildi: true, sinir };
  return { uygulanir: true, ekDk: Number(ek) };
}

// uzunMenzil (30 Eyl 2026 · B2-3): standart ekipte tablo degeri `uzunMenzilTabani` ile
// sinirlanir, split USTUNE eklenir — planlamayla ayni kural. Cagiran olcer (tek olcu).
// `dortPilot` (5 Eki 2026): iki ilave pilot (bacakta iki CRZ CPT) — Md.11(4) +3 saat; `ucPilot` ile birlikte ya da tek başına verilir.
export function azamiUgsYeniden(duty, sektorSayisi, faaliyetTipi, tekPilot, ucPilot = false, uzunMenzil = false,
                                dortPilot = false) {
  try {
    if (!duty?.ruleset_snapshot?.regulation || !duty.report_time || !faaliyetTipi) return null;
    const { rules } = effectiveRules(duty.ruleset_snapshot);
    faaliyetTipi = hesapTuru(faaliyetTipi, rules);   // şirket esası (30 Eki 2026)
    const repLocal = yerelHHMM(duty.report_time, duty.report_tz || null);
    if (!repLocal) return null;
    const base = maxFdpMinutes(repLocal, sektorSayisi, rules,
      { operationType: faaliyetTipi, singlePilot: tekPilot });
    if (base == null) return null;
    // ── ARTIRILMIŞ EKİP (Md.11) — 29 Eyl 2026 ──────────────────────────────
    // 🔴 Bu fonksiyon üçüncü pilotu HİÇ bilmiyordu: CRZ CPT'li bir görevin
    //    tavanı rapor kayınca ya da arşiv yeniden hesaplayınca +2:00'siz
    //    yazılıyordu — olmayan bir aşım. `dutyWindow` ile AYNI kural: tablo
    //    değerinin ÜSTÜNE bir ilave pilotla uzatma (split uzatması zaten
    //    burada yok, Md.15(d) ile çelişmez). Uzatma değeri kural setinde
    //    yoksa tavan UYDURULMAZ, null döner (çağıran eskiye dokunmaz).
    let tavan = base;
    // 4 Eki 2026: tek kural `artirilmisEkipUzatmasi` — 3 sektörün üstünde uzatma yok, standart yol (Md.11(2)).
    const aug = artirilmisEkipUzatmasi(rules, faaliyetTipi, sektorSayisi,
      { ucPilot, dortPilot, dinlenmeOlanagi: duty.inflight_rest_facility ?? null });
    if (aug?.olculemedi) return null;
    if (aug?.uygulanir) {
      tavan = base + aug.ekDk;
    } else {
      // ── AÇIK MESAİ (Md.15) — 29 Eyl 2026 ──────────────────────────────────
      // 🔴 Bu fonksiyon split uzatmasını HİÇ bilmiyordu: arşivde, EDIT'te ve
      //    RECORD AS FLOWN'da rapor kayınca split görevin tavanı split'siz
      //    değere düşüyor, olmayan bir aşım görünüyordu. Artık kaydın KENDİ
      //    sektörleri (gerçek varsa gerçek on/off-block) ve BEYAN EDİLEN
      //    dinlenme yeri (`accommodation`) ile aynı kural uygulanır.
      const am = gorevAcikMesai(duty.sectors, duty.accommodation ?? null, rules, faaliyetTipi,
                                { gercek: true });
      // Uzun menzil (Md.22(3)): tablo degeri sinirlanir, split USTUNE (planlamayla ayni).
      tavan = uzunMenzilTabani(base, rules, faaliyetTipi, !!uzunMenzil).dk + (am.extensionMin || 0);
    }
    return Math.max(0, tavan - (duty.standby_reduction_min ?? 0))
         + (skpkUgsUzatirMi(faaliyetTipi) ? (duty.skpk_fdp_extension_min ?? 0) : 0);   // eğitimde SKPK uzatmaz (Md.27(1)(b))
  } catch { return null; }
}

/** AZAMİ UGS DÖKÜMÜ — kayıttaki azami UGS'nin parçaları (12 Eki 2026, DUTY SHEET kutusu).
 *  🔑 Serkan: *"max fdp + ext: 13:30 + 2:54 = 16:24 — o görevin uzatmasız hâlini de düşelim, çünkü o veri ekranda yok"* ·
 *     *"bu denetlemede gösterilecek evrak olacak"*.
 *  Toplam KAYITTAN (`max_fdp_minutes` — sunucunun motoru yazdı). Parçalar kaydın kendi girdisinden, `azamiUgsYeniden` ve
 *  `gorevHesabi` ile AYNI kurallarla: artırılmış ekip (Md.11, `artirilmisEkipUzatmasi`) YA DA split (Md.15, `gorevAcikMesai`)
 *  — ikisi birleşmez (Md.15(1)(d)) —, nöbet kısaltması (Md.17, `standby_reduction_min`), SKPK (Md.12, `skpk_fdp_extension_min`).
 *  Taban (uzatmasız azami UGS) = toplam − uzatmalar + nöbet kısaltması: toplamanın tersi, sayı uydurulmaz.
 *  `ekip`: `ekipBilgisi` sonucu ({ ucPilot, dortPilot }) — sunucunun bildiği ekip.
 *  Dönüş: null (uçuş değil / kayıtta toplam ya da kural seti yok) · { toplam, taban, artirilmisDk, nobetDk, skpkDk,
 *         split: null | { meydan, yer: 'hotel'|'aircraft'|null, molaMin, uzatmaMin, tavanli } } */
export function azamiUgsDokumu(duty, { ucPilot = false, dortPilot = false } = {}) {
  const toplam = duty?.max_fdp_minutes;
  if (duty?.duty_type !== 'flight' || toplam == null || !Number.isFinite(Number(toplam))) return null;
  if (!duty.ruleset_snapshot?.regulation) return null;
  const { rules } = effectiveRules(duty.ruleset_snapshot);
  const tip = hesapTuru(duty.operation_type || 'air_taxi', rules);
  const aug = artirilmisEkipUzatmasi(rules, tip, ucusSektorSayisi(duty.sectors),
    { ucPilot, dortPilot, dinlenmeOlanagi: duty.inflight_rest_facility ?? null });
  const artirilmisDk = aug?.uygulanir ? aug.ekDk : 0;
  let split = null;
  if (!aug?.uygulanir && duty.split_duty) {
    const am = gorevAcikMesai(duty.sectors, duty.accommodation ?? null, rules, tip, { gercek: true });
    if (am.isSplit) {
      const tavan = Number(rules?.split_duty?.extension_cap_min);
      split = { meydan: am.bekleme?.meydan || null, yer: duty.accommodation || null, molaMin: am.countedBreakMin,
                uzatmaMin: am.extensionMin || 0, tavanli: am.extensionMin > 0 && am.extensionMin === tavan };
    }
  }
  const nobetDk = duty.standby_reduction_min || 0;
  const skpkDk = skpkUgsUzatirMi(tip) ? (duty.skpk_fdp_extension_min || 0) : 0;
  const taban = Number(toplam) - (split?.uzatmaMin || 0) - artirilmisDk - skpkDk + nobetDk;
  if (!(taban > 0)) return null;
  return { toplam: Number(toplam), taban, split, artirilmisDk, nobetDk, skpkDk };
}

/** Görevin UÇUŞ sektörü sayısı — DH (konumlandırma) sektör DEĞİLDİR
 *  (SHT-FTL/HG Md.14/1/b). 29 Eyl 2026: arşiv yeniden hesabı `sectors.length`
 *  kullanıyordu, DH bacağını da Tablo-1 sektörü sayıyordu; panel (`dutyWindow`)
 *  saymıyordu — aynı görev iki yerde iki tavan. Tek sayım burada. */
export function ucusSektorSayisi(sektorler) {
  return (sektorler || []).filter(s => !s?.deadhead).length;
}

/** Md.27 — eğitim faaliyetinde GÜNLÜK azami uçuş süresi; aynı gün teorik eğitim de yapıldıysa YARIYA iner (Md.27(1)(ç)).
 *  Sınırın ayrıntısı (5 Eki 2026, Serkan A) — sayı, eğitim türünün adı ve bendi kural setinden:
 *  { dk, etiket, ref, yari } · eğitim seti yoksa null · tür seçilmemişse { dk: null, turYok: true } · türün sayısı kural
 *  setinde yoksa { dk: null, kuralEksik }. Sunucu gerekçesi, ASSIGN ve EDIT kapısı bunu okur.
 *  Künye bendi kural setindeki `reference`tan ("Md.27(1)(a) satır 1" → "SHT-FTL/HG Md.27(1)(a)"); okunamazsa "Md.27(1)" —
 *  düz "Md.27" azami UGS künyesidir (`maxFdpKunyesi`), onunla karışmasın (SKPK cümlesi ona bağlı).
 *  TÜR PİLOT BAŞINADIR (5 Eki 2026, Serkan: *"öğrenci 4 saat limiti öğretmene uygulanmamalı"*) ve VARSAYILMAZ — 🔴 önce
 *  tür yoksa öğretmenin 6 saati (en geniş) alınıyordu: türü değiştirilmemiş tip eğitiminde eğitim alan 4 saati sessizce aşıyordu. */
export function egitimUcusSiniri(rules, trainingKind, sameDayTheory = false) {
  const set = fdpLimitSet(rules, 'training');
  if (set?.style !== 'training') return null;
  if (!trainingKind) return { dk: null, turYok: true };
  const k = set.kinds?.[trainingKind];
  const base = k?.flight_time_min;
  if (base == null || !Number.isFinite(Number(base))) {
    return { dk: null, kuralEksik: `fdp_limits.training.kinds.${trainingKind}.flight_time_min` };
  }
  const yari = !!(sameDayTheory && set.same_day_theory_halves_flight);
  const bent = String(k.reference || '').match(/^Md\.27\(\d+\)\([a-zçğıöşü]+\)/)?.[0] || 'Md.27(1)';
  return { dk: yari ? Math.floor(base / 2) : base, etiket: k.label || trainingKind || null,
           ref: `SHT-FTL/HG ${bent}`, yari };
}
/** Md.27 planlı görevi DURDURAN sunucu gerekçeleri — ASSIGN ve EDIT önizlemeden bunları okur (tek liste). */
export const EGITIM_ENGEL_TURLERI = ['training_flight_time', 'training_day_total'];
/** Eğitim türü seçilmemiş — sunucu (CANNOT VERIFY) ve ASSIGN / EDIT kapısı AYNI cümle. */
export const EGITIM_TURU_SECILMEDI = 'TRAINING KIND NOT SELECTED — the daily training flight time limit depends on it '
  + '(instructor / examiner or the trainee\'s kind, Md.27(1))';
/** Eğitim uçuş süresi aşımının metni — sunucu gerekçesi ve ASSIGN kırmızı notu AYNI cümle (`dutyWindow` sonucundan). */
export const egitimUcusAsimMetni = (w) => `TRAINING FLIGHT TIME ${fmtMin(w.flightMin)} > MAX ${fmtMin(w.flightLimitMin)}`
  + (w.flightLimitLabel ? ` — ${w.flightLimitLabel}` : '')
  + (w.flightLimitHalved ? ' (halved: theoretical training the same day, Md.27(1)(ç))' : '');

// ── AÇIK MESAİ (SPLIT DUTY) — SHT-FTL/HG Md.15 (29 Eyl 2026) ────────────────
//
// 🔑 Serkan (29 Eyl): *"Kural kesinlikle titizlikle uygulanmalı."* · *"1'den fazla
//    bacak girildiğinde ve aralarda kurala göre bir boşluk olduğunda split duty
//    seçelim ve hotel mi uçak mı diye sormalısın; gerekli box'ı check edip
//    ilerlememiz lazım."* · *"Doğrusu neyse öyle olmalı."*
// Md.15(1): (a) mola uygun konaklama tesisinde, UGS dâhilinde, asgari ARDIŞIK
//   3 saat · (b) azami UGS molanın %50'sine kadar uzar, hiçbir şekilde 4 saati
//   aşamaz · (c) mola bütünüyle UGS'dir · (ç) uygun konaklama sağlanır ·
//   (d) uçuş sırasındaki dinlenmeyle BİRLEŞTİRİLEMEZ · (e) uçuş sonrası ve
//   öncesi görevleri ile seyahatin asgari toplam süresi 60 dakikadır.
// 🔴 ÖLÇÜLEN ESKİ HÂL: bacaklar arasındaki BEKLEMENİN tamamı mola sayılıyordu —
//    (e) bendi (kural setinde `pre_post_travel_total_min: 60`) HİÇ okunmuyordu.
//    3:00–3:59 arası bekleme yanlışlıkla açık mesai sayılıyor, uzatma
//    olduğundan büyük çıkıyordu (gevşek yön). Dinlenme yeri de sorulmadan
//    "hotel" varsayılıyordu.
// ARTIK: mola = bekleme − (e) · eşik ve (e) kural setinden okunur, yoksa ÖLÇÜLMEZ
//   (uzatma verilmez, sebep döner) · dinlenme yeri SORULUR: 'hotel' | 'aircraft',
//   cevap yoksa `cevapGerekli` ve uzatma YOK.
// Dönen: {isSplit, extensionMin, countedBreakMin, beklemeMin, molaMin, yolMin,
//         cevapGerekli, olculemedi}
export function splitDuty(beklemeBasHHMM, beklemeBitHHMM, accommodation, rules) {
  const sd = rules?.split_duty || {};
  const bekleme = spanMin(beklemeBasHHMM, beklemeBitHHMM);
  const bos = { isSplit: false, extensionMin: 0, countedBreakMin: 0, beklemeMin: bekleme,
                molaMin: null, yolMin: null, cevapGerekli: false, olculemedi: null };
  if (bekleme == null) return bos;
  const yol = sd.pre_post_travel_total_min;
  const esik = sd.break_threshold_min;
  // (b) oran ve tavan da YALNIZ kural setinden (4 Eki 2026, madde haritası Md.15 ②): eskiden %50 koda yazılıydı ve tavan
  // yoksa uzatma TAVANSIZ kalıyordu. Tanımlı oran türü yalnız '50pct_of_break'; başkası ya da eksik alan → ölçülemedi.
  const tavan = sd.extension_cap_min;
  const oran = ({ '50pct_of_break': 0.5 })[sd.extension] ?? null;
  const yokAlan = [['break_threshold_min', esik], ['pre_post_travel_total_min', yol], ['extension_cap_min', tavan]]
    .filter(([, v]) => v == null || !Number.isFinite(Number(v))).map(([k]) => k);
  if (oran == null) yokAlan.push(`extension${sd.extension ? ` (${sd.extension})` : ''}`);
  if (yokAlan.length) {
    return { ...bos, olculemedi: `RULE SET: split_duty.${yokAlan.join(' / ')} `
                                 + 'missing — split duty cannot be measured, no extension (Md.15)' };
  }
  const mola = bekleme - yol;
  if (mola < esik) return { ...bos, molaMin: mola, yolMin: yol };
  let counted = mola;
  if (sd.break_over_6h_not_counted) counted = Math.min(counted, 360);
  if (sd.wocl_portion_not_counted) counted -= woclOverlapMin(beklemeBasHHMM, beklemeBitHHMM);
  counted = Math.max(0, counted);
  const yerSart = !!sd.requires_suitable_accommodation;
  const cevapGerekli = yerSart && accommodation !== 'hotel' && accommodation !== 'aircraft';
  const hotelOk = !yerSart || accommodation === 'hotel';
  // SHT-FTL/HG Md.15(1)(b): molanın %50'sine kadar, hiçbir şekilde 4 saati aşamaz — oran ve tavan kural setinden.
  // `otelUzatmaMin`: dinlenme yeri OTEL seçilirse verilecek uzatma — ekran, cevap verilmeden önce iki seçeneğin
  // sonucunu gösterebilsin diye.
  const otelUzatmaMin = Math.min(Math.floor(counted * oran), Number(tavan));
  const extensionMin = hotelOk ? otelUzatmaMin : 0;
  return { isSplit: true, extensionMin, countedBreakMin: counted, beklemeMin: bekleme,
           molaMin: mola, yolMin: yol, esikMin: esik, otelUzatmaMin, cevapGerekli, olculemedi: null };
}

/** Uçuş bacakları arasındaki beklemeler — açık mesai adayları (Md.15).
 *  DH bacağı arasındaki bekleme mola DEĞİLDİR (Md.14). `gercek: true` ise
 *  gerçek on-block → sonraki gerçek off-block kullanılır, yoksa plan (ETA →
 *  ETD) — GERÇEK PLANI EZER (29 Eyl 2026). Dönen `en`: en uzun bekleme; Md.15
 *  tek bir molaya bağlı uzatmadan söz eder. */
export function acikMesaiBeklemeleri(sektorler, { gercek = false } = {}) {
  const fl = (sektorler || []).filter(s => !s?.deadhead);
  const adaylar = [];
  for (let i = 1; i < fl.length; i++) {
    const bas = (gercek && fl[i - 1].on_block) || fl[i - 1].eta;
    const bit = (gercek && fl[i].off_block) || fl[i].etd;
    const min = spanMin(bas, bit);
    if (min == null) continue;
    adaylar.push({ min, start: bas, end: bit, meydan: fl[i - 1].actual_dest || fl[i - 1].dest || null, sira: i });
  }
  const en = adaylar.reduce((a, x) => (a == null || x.min > a.min ? x : a), null);
  return { en, adaylar };
}

/** Bir görevin (kayıtlı sektörleri + beyan edilen dinlenme yeri) açık mesai
 *  sonucu — `dutyWindow` ile AYNI kural, kayıt üzerinden. */
// Md.15(1)(d) — "uçuş sırasındaki dinlenme ile birleştirilemez" (4 Eki 2026, Serkan A): birleşmez yalnız Md.11 uzatması
// GERÇEKTEN uygulanıyorsa (CRZ CPT + dinlenme olanağı IN USE + ≤3 sektör — `artirilmisEkipUzatmasi`, `dutyWindow` ile aynı).
// 🔴 Önce CRZ CPT varlığına bakıyordu: NOT IN USE 3 pilotlu görevde EDIT ve roster açık mesaiyi kapatıyor, sunucu veriyordu.
export function gorevAcikMesai(sektorler, accommodation, rules, faaliyetTipi,
                               { gercek = false, ucPilot = false, dortPilot = false, dinlenmeOlanagi = null } = {}) {
  // Dönüş biçimi HER dalda aynı — okuyan taraf alan var mı diye tahmin etmesin.
  const { en, adaylar } = acikMesaiBeklemeleri(sektorler, { gercek });
  const bos = { isSplit: false, extensionMin: 0, cevapGerekli: false, birlesmez: false,
                uygulanmaz: null, bekleme: en, adaylar, beklemeMin: en?.min ?? null };
  if (!ruleAppliesTo(rules?.split_duty, faaliyetTipi || 'air_taxi')) return { ...bos, uygulanmaz: 'OPERATION TYPE' };
  if (!en) return bos;
  const s = splitDuty(en.start, en.end, accommodation, rules);
  // Md.15(1)(d): uçuş sırasındaki dinlenmeyle (artırılmış ekip uzatması uygulanıyorsa) BİRLEŞMEZ.
  const aug = (ucPilot || dortPilot) ? artirilmisEkipUzatmasi(rules, faaliyetTipi || 'air_taxi', ucusSektorSayisi(sektorler),
                                               { ucPilot: true, dortPilot, dinlenmeOlanagi }) : null;
  if (aug?.uygulanir && s.isSplit) return { ...bos, ...s, extensionMin: 0, cevapGerekli: false, birlesmez: true };
  return { ...bos, ...s };
}

// WOCL: 02:00–05:59 yerel (EASA tanımı)
export function woclOverlapMin(startHHMM, endHHMM) {
  const s = toMin(startHHMM); let e = toMin(endHHMM);
  if (s == null || e == null) return 0;
  if (e < s) e += 1440;
  let overlap = 0;
  for (const [ws, we] of [[120, 360], [120 + 1440, 360 + 1440]]) {
    overlap += Math.max(0, Math.min(e, we) - Math.max(s, ws));
  }
  return overlap;
}

// ── Min rest ────────────────────────────────────────────────────────
// prevDutyMin: biten görevin süresi (dk). atBase: üste mi dinlenecek?
// travelMin: otele yol (tek yön, dk) — 30 dk üstünün 2 katı eklenir (üs dışı).
// 🔴 26/27 AGU 2026 — BU FONKSIYON DIRILTILDI, KURAL TEK SAHIBE DONDU.
//
// Yazildigi gunden beri HICBIR YERDEN CAGRILMIYORDU: panel ve `archive-flight`
// ayni kurali kendi iclerine KOPYALAMISTI (alti ayri yer). Kopyalar zamanla
// AYRISTI ve saha kusuru oradan cikti — bkz. asagidaki mandal notu.
//
// 🔴 SAHA (27 Agu, Serkan): *"Selcuk'a atanmis yarinki gorevin resti 14 saat
// cikmis neden? Planlanan FDP 13 saat."* Denetim izi:
//     ilk atama : 2 bacak · 13:00 gorev -> rest max(13:00, 12:00) = 13:00
//     1. duzenleme: 3 bacak · 14:00 gorev -> rest max(14:00, 13:00) = 14:00
//     2. duzenleme: tekrar 2 bacak · 13:00 -> rest max(13:00, **14:00**) = 14:00
// Ucuncu adimda dinlenme, ARTIK VAR OLMAYAN bir gorevin suresinde takildi.
//
// 🔴 MANDAL: guncelleme yollari tabani MEVZUATTAN degil KENDI ESKI DEGERINDEN
// aliyordu (`Math.max(yeniGorev, satirin_eski_resti)`). Boylece dinlenme yalniz
// ARTABILIYOR, gorev kisalinca geri INEMIYORDU. Dort yerde ayni desen vardi.
//
// 🔑 Serkan'in kurali (27 Agu): *"gerceklesmis zamanlar her zaman gercegi
// belirleyecek; planlama asamasinda ne oldugu degil, ucusun nasil gerceklestigi
// mesele."* Yani dinlenme HER SEFERINDE o anki gercek gorevden yeniden
// hesaplanir; eski deger bir taban DEGILDIR.
//
// ⚠️ Fazla dinlenme "emniyetli taraf" gibi gorunur ama degildir: denetim
// kaydina yanlis sayi yazar ve YASAL bir atamayi engeller (23 Agu'daki
// "Selcuk'a gorev atayamiyorum" sikayetinin ayni ailesi).
//
// ⚠️ SKPK telafisi (Md.12/2, kisaltmanin 2 kati) BURAYA GIRMEZ — o, kisaltmayi
// tasiyan gorevin KENDI dinlenmesine ayrica eklenir (bkz. skpkLimits'in
// `minRestWithCompensationMin` alani ve panelin SKPK dali).
// Md.16 (4 Eki 2026, madde haritası ④): taban YALNIZ kural setinden — eskiden 720 / 600 / 840 koddan yedekti. Alan yoksa
// `null` döner ("ölçülemedi"); sebep cümlesi `dinlenmeEksikMetni`.
export const dinlenmeTabanAlani = (atBase, tz4Rotation = false) => (atBase ? 'min_rest.home_base_min'
  : tz4Rotation ? 'min_rest.tz4_rotation_out_of_base_min' : 'min_rest.out_of_base_min');
export const dinlenmeEksikMetni = (alanlar, ref = 'Md.16') =>
  `RULE SET: ${[].concat(alanlar).join(' / ')} missing — the minimum rest cannot be computed (${ref})`;
export function minRestMinutes(prevDutyMin, atBase, travelMin, rules, opts = {}) {
  const alan = dinlenmeTabanAlani(atBase, !!opts.tz4Rotation).split('.')[1];
  const floor = Number(rules?.min_rest?.[alan]);
  if (rules?.min_rest?.[alan] == null || !Number.isFinite(floor)) return null;
  const mr = rules.min_rest;
  let rest = Math.max(prevDutyMin || 0, floor);
  if (!atBase && travelMin > 30 && mr.travel_over_30min === '2x_excess_added') {
    rest += (travelMin - 30) * 2;
  }
  return rest;
}

// ── İZ DEĞERİ — TEK BİÇİM (3 Eki 2026) ─────────────────────────────────────────────────────────────────
// İz satırı (`izDegerleri`) TEK biçim yazar: dakikalar HH:MM, zaman
// damgaları YYYY-MM-DDTHH:MM (UTC), evet/hayır YES/NO, boş "—".
export function izDegeri(alan, v) {
  if (v === null || v === undefined || v === '') return '—';
  if (/(_minutes|_min)$/.test(alan) && Number.isFinite(Number(v))) {
    const n = Number(v);
    return `${String(Math.floor(n / 60)).padStart(2, '0')}:${String(n % 60).padStart(2, '0')}`;
  }
  if (/(_time|_end|_report|_due)$/.test(alan)) {
    const d = new Date(v);
    return Number.isNaN(d.getTime()) ? String(v).slice(0, 16) : d.toISOString().slice(0, 16);
  }
  if (typeof v === 'boolean') return v ? 'YES' : 'NO';
  // 4a: durum sebepleri — türleri yazılır (ayrıntı kartta).
  if (Array.isArray(v)) return v.length ? v.map(x => x?.tur || '?').join('+') : 'none';
  return String(v);
}

// ── YENİDEN HESAP İZİ (3 Eki 2026, Serkan "A": görev başına TEK satır, arşiv iziyle aynı tip) ────────────
// `gorevFarklari`nın çıktısı → iz satırının eski/yeni metni: "alan=değer · alan=değer". Fark yoksa null.
export function izDegerleri(farklar) {
  const f = farklar || [];
  if (!f.length) return null;
  return { old_value: f.map(x => `${x.alan}=${izDegeri(x.alan, x.eski)}`).join(' · '),
           new_value: f.map(x => `${x.alan}=${izDegeri(x.alan, x.yeni)}`).join(' · ') };
}

// ═══════════════════════════════════════════════════════════════════════
// UZUN MENZIL — TESPIT VE DINLENME (27 Agu 2026)
// ═══════════════════════════════════════════════════════════════════════
//
// 🔴 UC KUSUR BIRDEN, HEPSI AYNI AILEDEN:
//  ① `long_range.arrival_min_rest_rule` ruleset'te YAZILI ama kodda YOKTU.
//  ② Ekrandaki uyari "arrival rest max(duty,14:00)" DIYORDU, kayda 12:00
//     gidiyordu — sistem yapmadigi seyi soyluyordu (Ilke 1).
//  ③ Dilim farki ILK KALKIS ile SON VARIS arasinda olculuyordu; git-gel
//     ucusta ikisi ayni meydan oldugu icin fark HER ZAMAN SIFIR cikiyordu.
//     Yani uzun menzil HIC tespit edilemiyordu — Md.22(3)'un uzun menzil siniri
//     da bu yuzden bugune kadar bir kez bile devreye girmedi.
//
// 🔑 Serkan'in verdigi ornek: *"14 saat ucus yapip Amerika'dan gelen kisinin
// resti time zone'a bakar."* Somut: LTAC→KJFK→LTAC, dilim farki 7 saat, gorev
// 14 saat, usse donuyor. Bugunku sistem `max(14:00, 12:00)` = 14 saat der;
// mevzuat 48 saat ister. Yani pilot 34 SAAT ERKEN uygun gorunur.
// Bugune kadar buldugumuz butun sapmalar FAZLA dinlenme yonundeydi (sikiydi
// ama tehlikesiz); bu, TERSI YONDE ilk bulgu.

/** Md.4(ee): "Bir UGS ICINDE, asgari 4 saatlik zaman dilimi GECILEN uçuş."
 *
 *  Olculecek sey gorev boyunca UGRANAN BUTUN meydanlarin dilim ARALIGIDIR,
 *  bas ile son arasindaki fark degil. Git-gelde bas ve son ayni meydandir ama
 *  dilim o UGS icinde IKI KEZ gecilmistir.
 *
 *  Girdi: meydanlarin UTC ofsetleri (dakika). Cikti: saat cinsinden aralik. */
export function tzSpanHours(offsetsMin) {
  const v = (offsetsMin || []).filter(x => typeof x === 'number' && Number.isFinite(x));
  if (v.length < 2) return 0;
  return (Math.max(...v) - Math.min(...v)) / 60;
}

// ── YEREL GECE — Md.4(1)(ff), TEK ÖLÇÜ (3 Eki 2026, FTL adım 8) ─────────────
// Metin: "Yerel gece: Yerel saatle 22.00 ila 08.00 arasına tekabül eden HERHANGİ BİR 8 saatlik süreyi".
// 🔑 Serkan (3 Eki 2026): *"mevzuata uyacağız"* · *"biz çok sıkı yapmışız"*. Gece = pencerede KESİNTİSİZ 8 boş saat.
// 🔴 ÖNCESİ: İKİ ölçü vardı. Boş gün tarafı (`bosGunCakismasi`: OFF kapısı, OFF→REST, REST→OFF, çizelge) pencereye EN
//    UFAK değmeyi geceyi bozulmuş sayıyordu — yerel 23:30'da biten görev 23:30–08:00 = 8:30 boş bırakırken OFF'u REST'e
//    çeviriyordu; kural setindeki `local_night_length_hours: 8` hiç okunmuyordu. Uzun menzil tarafı (`localNightsCovered`)
//    8 saati doğru arıyordu ama 22:00 / 08:00 / 480'i koddan alıyordu.
// Pencere ve saat YALNIZ kural setinden (days_off.local_night_start / _end / _length_hours). Biri yoksa `null` —
//    "ölçülemedi"; koddan sayı uydurulmaz (SHGM değiştirirse yalnız kural seti değişir).
export function yerelGeceKurali(rules) {
  const c = rules?.days_off;
  const saat = Number(c?.local_night_length_hours);
  if (!c?.local_night_start || !c?.local_night_end || !Number.isFinite(saat) || saat <= 0) return null;
  return { bas: c.local_night_start, son: c.local_night_end, dk: Math.round(saat * 60) };
}

/** [ws, we] penceresinde, meşgul aralıkların ([s, e] ms) dışında kalan EN UZUN kesintisiz boşluk — dakika. */
export function enUzunBosluk(ws, we, mesgul) {
  const ic = (mesgul || []).map(([a, b]) => [Math.max(a, ws), Math.min(b, we)]).filter(([a, b]) => b > a)
    .sort((x, y) => x[0] - y[0]);
  let en = 0, imlec = ws;
  for (const [a, b] of ic) {
    if (a > imlec) en = Math.max(en, a - imlec);
    imlec = Math.max(imlec, b);
  }
  return Math.floor(Math.max(en, we - imlec) / 60000);
}

/** [start, end] dinlenmesinin kapsadığı yerel gece sayısı (Md.16(3)(b) "2 yerel geceyi kapsayan"): pencerenin
 *  içinde en az kural setindeki saat kadar dinlenme olan her gece bir sayılır. Kural seti geceyi tanımlamıyorsa `null`. */
export function localNightsCovered(startISO, endISO, tz, rules) {
  const k = yerelGeceKurali(rules);
  if (!k) return null;
  const s = new Date(startISO).getTime(), e = new Date(endISO).getTime();
  if (!Number.isFinite(s) || !Number.isFinite(e) || e <= s) return 0;
  let n = 0;
  for (const w of gecePencereleri(s, e, tz, k)) {
    if (Math.min(e, w.end) - Math.max(s, w.start) >= k.dk * 60000) n++;
  }
  return n;
}

/** Aralikla kesisebilecek yerel gece pencereleri: her takvim gunu icin [yerel baslangic, ertesi gun yerel bitis]
 *  (kural setinden). Sinirlarda gece kacmasin diye bir gun geriden baslar, bir gun ileriye tasar. */
function gecePencereleri(startMs, endMs, tz, k) {
  const out = [];
  const gun = (ms) => new Date(ms).toISOString().slice(0, 10);
  for (let i = -1; i <= Math.ceil((endMs - startMs) / 86400000) + 1; i++) {
    const d = gun(startMs + i * 86400000);
    const ertesi = gun(new Date(`${d}T12:00:00Z`).getTime() + 86400000);
    const a = zonedISO(d, k.bas, tz), b = zonedISO(ertesi, k.son, tz);
    if (!a || !b) continue;
    out.push({ start: new Date(a).getTime(), end: new Date(b).getTime() });
  }
  return out;
}

/** Md.16(3)(b): "ana us veya gecici us'se dondukten sonra 2 YEREL GECEYI
 *  KAPSAYAN asgari 48 SAATLIK dinlenme suresi verilir."
 *
 *  Iki sart BIRLIKTE saglanir: sure >= 48 saat VE 2 yerel gece kapsanmis.
 *  48 saat tamamlaninca geceler hala eksikse, ikinci gecenin 8 saati DOLANA
 *  KADAR uzatilir.
 *
 *  ⚠️ Meydan dilimi bilinmiyorsa GECE HESABI YAPILMAZ ve bunu SOYLERIZ:
 *  `nightsVerified:false` doner. Olcemedigimiz seye "saglandi" demeyiz
 *  (Ilke 1) — cagiran bunu ekranda gostermek zorundadir. */
export function longRangeReturnRestMin(dutyEndISO, tz, rules) {
  // 4 Eki 2026 (madde haritası Md.16 ④): 48 saat / 2 gece / yerel gece YALNIZ kural setinden; biri yoksa ya da gece
  // ölçülemiyorsa `restMin: null` + `olculemedi` — eskiden 48 / 2 koddan yedekti ve gece ölçülemeyince 48 saat gece
  // şartı DOĞRULANMADAN uygulanıyordu (`nightsVerified:false` hiçbir yerde okunmuyordu).
  const lr = rules?.long_range || {};
  const k = yerelGeceKurali(rules);
  const yok = [['long_range.return_rest_min_hours', lr.return_rest_min_hours], ['long_range.return_local_nights', lr.return_local_nights]]
    .filter(([, v]) => v == null || !Number.isFinite(Number(v))).map(([a]) => a);
  if (!k) yok.push('days_off.local_night_start / _end / _length_hours');
  const bos = (olculemedi) => ({ restMin: null, nightsVerified: false, nights: null, olculemedi });
  if (yok.length) return bos(dinlenmeEksikMetni(yok, 'Md.16(3)(b)'));
  const saat = Number(lr.return_rest_min_hours);
  const geceSayisi = Number(lr.return_local_nights);
  const taban = saat * 60;
  const s = dutyEndISO ? new Date(dutyEndISO).getTime() : NaN;   // new Date(null) 1970 olur — boş an değildir
  if (!Number.isFinite(s)) return bos('start or end time missing — the duty end is unknown, the long-range return rest cannot be computed (Md.16(3)(b))');
  if (!tz) return bos('time zone unknown — home base (Md.16(3)(b): the 2 local nights cannot be measured)');
  const bitis48 = s + taban * 60000;
  let n = localNightsCovered(dutyEndISO, new Date(bitis48).toISOString(), tz, rules);
  if (n >= geceSayisi) return { restMin: taban, nightsVerified: true, nights: n };

  // 48 saat yetmedi: gereken geceyi TAMAMLAYAN ana kadar uzat.
  const gerekli = k.dk;
  const tamamlanma = [];
  for (const w of gecePencereleri(s, s + (saat + 72) * 3600000, tz, k)) {
    const bas = Math.max(s, w.start);
    if (w.end - bas >= gerekli * 60000) tamamlanma.push(bas + gerekli * 60000);
  }
  tamamlanma.sort((a, b) => a - b);
  const hedef = tamamlanma[geceSayisi - 1];
  if (hedef == null) return bos(`time zone unknown — ${tz} (Md.16(3)(b): the local nights cannot be built)`);
  return {
    restMin: Math.max(taban, Math.ceil((hedef - s) / 60000)),
    nightsVerified: true, nights: geceSayisi,
  };
}

/** UZUN MENZIL DINLENMESI — Md.16(3), TEK KARAR NOKTASI.
 *
 *  us disi varis  -> Md.16(3)(a): max(onceki gorev, 14:00)
 *  usse donus     -> Md.16(3)(b): 48 saat + 2 yerel gece
 *  uzun menzil degilse -> normal kural (Md.16(1)(2))
 *
 *  🔑 Serkan (27 Agu): *"usse dondugumuzde duty'ye bakilir, min 12 saat ya da
 *  bir onceki duty"* — o kural UZUN MENZIL OLMAYAN gorevler icindir; uzun
 *  menzilden donuste devreye 48 saat girer. */
export function restForDuty({ dutyMin, atBase, longRange, dutyEndISO, arrivalTz, rules, rotasyonUzunMenzil = false }) {
  // Md.16(3)(b) ROTASYON (4 Eki 2026, Serkan A): üsse dönen görev kendisi uzun menzil olmasa da, üsten çıkıştan bu
  // yana uçulan bir uzun menzil görev varsa dönüşte 48 saat + 2 yerel gece (`rotasyondaUzunMenzil`).
  const donusUzunMenzil = atBase && rotasyonUzunMenzil === true;
  // `olculemedi` (4 Eki 2026, Md.16 ④): kural setinde taban yoksa `restMin: null` + ADIYLA sebep — çağıran sebebe yazar.
  if (!longRange && !donusUzunMenzil) {
    const restMin = minRestMinutes(dutyMin, atBase, 0, rules);
    return { restMin, rule: 'Md.16(1)(2)', nightsVerified: null,
             olculemedi: restMin == null ? dinlenmeEksikMetni(dinlenmeTabanAlani(atBase)) : null };
  }
  if (!atBase) {
    const restMin = minRestMinutes(dutyMin, false, 0, rules, { tz4Rotation: true });
    return { restMin, rule: 'Md.16(3)(a)', nightsVerified: null,
             olculemedi: restMin == null ? dinlenmeEksikMetni(dinlenmeTabanAlani(false, true), 'Md.16(3)(a)') : null };
  }
  const r = longRangeReturnRestMin(dutyEndISO, arrivalTz, rules);
  const rule = longRange ? 'Md.16(3)(b)' : 'Md.16(3)(b) rotation';
  if (r.restMin == null) return { restMin: null, rule, nightsVerified: false, nights: null, olculemedi: r.olculemedi };
  return { restMin: Math.max(r.restMin, dutyMin || 0), rule, nightsVerified: r.nightsVerified, nights: r.nights,
           olculemedi: null };
}

/** UZUN MENZİL ROTASYONU — Md.16(3)(b) + Md.4(p), TEK KAYNAK (4 Eki 2026, madde haritası Md.16 ②).
 *
 *  🔑 Serkan (4 Eki 2026) **A**: SHT-FTL/HG Md.16(3)(b) "ilgili ekip üyelerine, ana üs veya geçici üs'se döndükten
 *     sonra 2 yerel geceyi kapsayan asgari 48 saatlik dinlenme" — dönüş görevinin uzun menzil olmasını şart koşmaz.
 *     EASA CS FTL.1.235(b) da ölçüyü ROTASYONA bağlar. Sayılar SHT'den (48 saat + 2 gece), ölçü rotasyondan.
 *  🔴 ÖNCESİ: 48 saat yalnız üsse dönen görevin KENDİSİ uzun menzilse veriliyordu — KTEB→EGLF (uzun menzil) + ertesi
 *     gün EGLF→LTAC (2 saat) dönüşünde Ankara'da 12:00 isteniyordu.
 *  ROTASYON (Md.4(p)): üsse dönen görev üs DIŞINDAN kalkıyorsa geriye doğru, ANA ÜSTEN KALKAN göreve kadar (dahil).
 *     Ekibin yeri yalnız UÇUŞ ve DH bacaklarının meydanlarından okunur; OFF, ofis, simülatör, nöbet rotasyonu kesmez
 *     (üs dışındaki OFF bir dinlenmedir, ekip hâlâ dışarıdadır). Üste BİTEN bir görevle karşılaşılırsa rotasyon ondan
 *     sonra başlamıştır. Uzun menzil ölçüsü her görevin kendi anları ve kural setiyle (`uzunMenzilOlcumu`); DH görevi
 *     uçuş görevi olmadığından (Md.4(ee)) uzun menzil sayılmaz, yalnız yer bildirir. Ana üs tanımsızsa `endedAtBase`
 *     her yeri üs sayar — rotasyon görevin kendisidir (mevcut varsayım değişmez).
 *  @param gorev      üsse dönen görev (sectors, id)
 *  @param oncekiler  pilotun diğer görevleri (hesaplanmış ya da kayıttaki report_time / duty_end ile)
 *  @returns {{ uzunMenzil: boolean|null, gorev: object|null, eksik: string[] }} — `null`: rotasyondaki bir görevin
 *           meydan dilimi bilinmiyor, ölçülemedi ("değil" denmez). */
export function rotasyondaUzunMenzil(gorev, oncekiler, { anaUs = null, tz = {}, raporISO = null } = {}) {
  const sek = (d) => (d?.sectors || []).filter(Boolean);
  const ilkKalkis = (d) => sek(d)[0]?.dep ?? null;
  const sonVaris = (d) => { const x = sek(d)[sek(d).length - 1]; return x?.actual_dest ?? x?.dest ?? null; };
  const hayir = { uzunMenzil: false, gorev: null, eksik: [] };
  if (!sek(gorev).length || endedAtBase(ilkKalkis(gorev), anaUs)) return hayir;
  const t = new Date(raporISO || gorev?.report_time || NaN).getTime();
  if (!Number.isFinite(t)) return hayir;
  const liste = (oncekiler || [])
    .filter(d => d && d.id !== gorev.id && d.status !== 'cancelled' && (d.duty_type === 'flight' || d.duty_type === 'dh')
              && sek(d).length && d.duty_end && new Date(d.duty_end).getTime() <= t)
    .sort((a, b) => new Date(b.duty_end) - new Date(a.duty_end));
  const eksik = [];
  for (const d of liste) {
    if (endedAtBase(sonVaris(d), anaUs)) break;            // ekip ondan önce üsteydi — rotasyon ondan sonra başladı
    if (d.duty_type === 'flight') {
      const um = uzunMenzilOlcumu(d.sectors, tz, effectiveRules(d.ruleset_snapshot || null).rules,
        { raporISO: d.report_time, bitisISO: d.duty_end });
      if (um.uzunMenzil === true) return { uzunMenzil: true, gorev: d, eksik: [] };
      if (um.olculemedi) eksik.push(...(um.kuralEksik ? [`rule set ${um.kuralEksik}`] : um.eksik));
    }
    if (endedAtBase(ilkKalkis(d), anaUs)) break;           // rotasyonun ilk görevi — üsten kalktı
  }
  return eksik.length ? { uzunMenzil: null, gorev: null, eksik: [...new Set(eksik)] } : hayir;
}

/** GÖREVİN DİNLENMESİ UZUN MENZİL DİNLENMESİ Mİ — Md.16(3)(a)(b), TEK KAYNAK (4 Eki 2026, madde haritası Md.16 ⑥).
 *  `gorevHesabi`'nin dinlenme kararıyla AYNI mantık: uçuş görevi kendisi uzun menzilse (a) üs dışında / (b) üste; değilse
 *  ve üste (DH dahil son varış) biterse rotasyon (`rotasyondaUzunMenzil`). Tek başına DH görevi yalnız rotasyonla.
 *  @param gorev  HESAPLANMIŞ görev (report_time / duty_end / sectors / ruleset_snapshot)
 *  @returns {{ uzunMenzil: boolean|null, kural: string|null, eksik: string[] }} — `null`: meydan dilimi yok, ölçülemedi */
export function uzunMenzilDinlenmesi(gorev, oncekiler, { anaUs = null, tz = {} } = {}) {
  const hayir = { uzunMenzil: false, kural: null, eksik: [] };
  const sek = (gorev?.sectors || []).filter(Boolean);
  if (!sek.length || (gorev.duty_type !== 'flight' && gorev.duty_type !== 'dh')) return hayir;
  const son = sek[sek.length - 1];
  const usteBitti = endedAtBase(son?.actual_dest ?? son?.dest ?? null, anaUs);
  if (gorev.duty_type === 'flight') {
    const um = uzunMenzilOlcumu(gorev.sectors, tz, effectiveRules(gorev.ruleset_snapshot || null).rules,
      { raporISO: gorev.report_time, bitisISO: gorev.duty_end });
    if (um.olculemedi) return { uzunMenzil: null, kural: null, eksik: um.kuralEksik ? [`rule set ${um.kuralEksik}`] : um.eksik };
    if (um.uzunMenzil) return { uzunMenzil: true, kural: usteBitti ? 'Md.16(3)(b)' : 'Md.16(3)(a)', eksik: [] };
  }
  if (!usteBitti) return hayir;
  const rot = rotasyondaUzunMenzil(gorev, oncekiler, { anaUs, tz, raporISO: gorev.report_time });
  if (rot.uzunMenzil == null) return { uzunMenzil: null, kural: null, eksik: rot.eksik };
  return rot.uzunMenzil ? { uzunMenzil: true, kural: 'Md.16(3)(b)', eksik: [] } : hayir;
}

/** UZUN MENZİL DİNLENMESİNİN İÇİNDE BAŞLAYAN GÖREV — Md.16 ⑥ (4 Eki 2026, Serkan A).
 *  🔑 Md.16(3) "UGS öncesinde" demez: (a) "varış noktasındaki asgari dinlenme", (b) "döndükten sonra … 48 saatlik dinlenme
 *     süresi VERİLİR"; Md.4(d) dinlenme = "tüm görevlerden ve nöbetten muaf … sürekli, kesintisiz". Ofis (idari görev),
 *     simülatör (eğitim), DH (konumlandırma), nöbet Md.4(ğ)'ye göre görevdir → uzun menzil dinlenmesinin içinde HİÇBİRİ
 *     başlayamaz. Normal dinlenme (Md.16(1)(2)) bugünkü gibi yalnız UGS'den önce (3 Eki "A").
 *  🔴 ÖLÇÜLDÜ (4 Eki): LTAC→KJFK + KJFK→LTAC (dinlenme 51:30) + ertesi gün 8 saat ofis → ofis LEGAL ve sonraki uçuş da
 *     LEGAL (dinlenme ofisin bitişinden ölçülüyordu) — 48 saat tamamen kayboluyordu.
 *  Bakılan: dinlenmesi bu görevin raporundan SONRA biten BÜTÜN önceki görevler (yalnız hemen önceki değil — araya giren
 *  ofis uzun menzil dinlenmesini silmez). `haric`: uçuşta hemen önceki görev — onu Md.16 REST SHORT zaten ölçer.
 *  @returns {{ ihlal: object|null, eksik: string[] }} */
export function uzunMenzilDinlenmesiIhlali(duty, raporISO, oncekiler, { anaUs = null, tz = {}, haric = null } = {}) {
  const t = new Date(raporISO || NaN).getTime();
  if (!Number.isFinite(t)) return { ihlal: null, eksik: [] };
  const adaylar = (oncekiler || [])
    .filter(d => d && d.id !== duty.id && d.id !== haric && d.duty_type !== 'off' && d.status !== 'cancelled'
              && d.duty_end && d.earliest_next_report && new Date(d.duty_end).getTime() <= t
              && new Date(d.earliest_next_report).getTime() > t)
    .sort((a, b) => new Date(b.earliest_next_report) - new Date(a.earliest_next_report));
  const eksik = [];
  for (const d of adaylar) {
    const lr = uzunMenzilDinlenmesi(d, oncekiler, { anaUs, tz });
    if (lr.uzunMenzil == null) { eksik.push(...lr.eksik); continue; }
    if (!lr.uzunMenzil) continue;
    const kisa = Math.ceil((new Date(d.earliest_next_report).getTime() - t) / 60000);
    return { eksik: [], ihlal: { tur: 'long_range_rest', ref: `SHT-FTL/HG ${lr.kural}`,
      metin: `REST SHORT ${fmtMin(kisa)} — THIS DUTY STARTS ${anDamga(raporISO)} INSIDE THE LONG-RANGE REST OF `
        + `${gorevKisaAdi(d)} (${lr.kural}), REST ENDS ${anDamga(d.earliest_next_report)} — no duty may start during a `
        + `rest period (Md.4(d))` } };
  }
  return { ihlal: null, eksik: eksik.length
    ? [`time zone unknown — ${[...new Set(eksik)].join(', ')} (Md.16(3): whether an earlier rest is a long-range rest cannot be measured)`]
    : [] };
}

/** UZUN MENZIL OLCUSU — Md.4(ee), TEK KAYNAK (30 Eyl 2026 · FTL nobetcisi B2-3).
 *
 *  Md.4(ee): "Bir UGS icinde, asgari 4 saatlik zaman dilimi gecilen bir ucus
 *  gorevi." Olculen: gorevde UGRANAN BUTUN meydanlarin RESMI saat farki araligi
 *  (divert'te gercek varis `actual_dest`; ugranmayan planli meydan sayilmaz).
 *
 *  🔑 KURAL (Serkan, 30 Eyl 2026):
 *   · Fark GOREVIN TARIHINDE olculur — "bugun" degil (yaz saati farki degistirir:
 *     Ankara–Azorlar eylulde 3, aralikta 4 saat).
 *   · Gorev sirasinda saat degisirse GUVENLI tarafta kalinir: fark RAPOR aninda
 *     ve GOREV SONUNDA olculur, BUYUK olan alinir.
 *   · Kesir YUKARI yuvarlanir: 7,5 saat → 8, 3,5 saat → 4.
 *   · Esik kural setinden (`long_range.tz_crossing_hours_min`, bugun 4).
 *   · Dilimi bilinmeyen meydan varsa ya da gorevin ani yoksa `olculemedi` —
 *     "uzun menzil degil" DENMEZ (Ilke 1).
 *  ASSIGN, EDIT, panel acilisi (projeksiyon), CRZ yakinligi ve arsiv BUNU cagirir;
 *  ikinci bir hesap yazilmaz (kaynak nobetcisi: UzunMenzilTekKaynak.test.js).
 *  @param {object[]} sektorler  dep / dest / actual_dest
 *  @param {Object<string,string>} tzMap  ICAO -> IANA dilimi
 *  @param {object} rules  effectiveRules(...).rules
 *  @param {{raporISO?:string|null, bitisISO?:string|null}} anlar
 *  @returns {{ uzunMenzil: boolean|null, farkSaat: number|null, varisTz: string|null,
 *              olculemedi: boolean, eksik: string[] }} */
export function uzunMenzilOlcumu(sektorler, tzMap = {}, rules = {}, { raporISO = null, bitisISO = null } = {}) {
  const kod = (x) => String(x || '').toUpperCase();
  const list = sektorler || [];
  const icaos = [...new Set(list.flatMap(x => [x?.dep, x?.actual_dest ?? x?.dest])
    .filter(Boolean).map(kod))];
  const son = list[list.length - 1];
  const varisTz = son ? (tzMap[kod(son.actual_dest ?? son.dest)] || null) : null;
  const eksik = icaos.filter(i => !tzMap[i]);
  if (eksik.length) return { uzunMenzil: null, farkSaat: null, varisTz, olculemedi: true, eksik };
  if (icaos.length < 2) return { uzunMenzil: false, farkSaat: 0, varisTz, olculemedi: false, eksik };
  const anlar = [raporISO, bitisISO].map(x => (x ? new Date(x).getTime() : NaN)).filter(Number.isFinite);
  if (!anlar.length) return { uzunMenzil: null, farkSaat: null, varisTz, olculemedi: true, eksik };
  const aralikDk = Math.max(...anlar.map(t => Math.round(tzSpanHours(icaos.map(i => tzOffsetMin(tzMap[i], t))) * 60)));
  const farkSaat = Math.ceil(aralikDk / 60);
  // 5 Eki 2026 (Md.22 ②): 4 saat YALNIZ kural setinden (Md.4(ee)) — eskiden `?? 4`; yoksa ölçülemedi, alan adıyla.
  const esikHam = rules?.long_range?.tz_crossing_hours_min;
  if (esikHam == null || !Number.isFinite(Number(esikHam))) {
    return { uzunMenzil: null, farkSaat, varisTz, olculemedi: true, eksik, kuralEksik: 'long_range.tz_crossing_hours_min' };
  }
  return { uzunMenzil: farkSaat >= Number(esikHam), farkSaat, varisTz, olculemedi: false, eksik };
}

/** PLANLI GOREVIN PROJEKSIYONUNU TAZELE — TEK GECIS NOKTASI (27 Agu 2026).
 *
 * 🔑 Serkan: *"Bizim amacimiz planlamada, planner 'boyle gerceklesirse ne olur
 * rest, ne olur duty time, FDP' gorebilsin diye veri uretmek. Ama nihai saatler
 * geldiginde onlarin belirlemesi gerekiyor."* + *"plan ile act arasinda celiski
 * dogmamasi gerekir."*
 *
 * IKI FARKLI SEY, IKI FARKLI KAYNAK:
 *   PLN  -> **projeksiyon**: "boyle gerceklesirse su olur". O ANKI plandan
 *           TURETILIR; saklanan sayiya bakilmaz.
 *   ACT  -> **kayit**: "boyle gerceklesti". Islenen saatlerden hesaplanip
 *           DONDURULUR, burada ona DOKUNULMAZ.
 *
 * 🔴 NEDEN GEREKLI: `min_rest_minutes` turetilmis bir degerdi ama planli
 * gorevde de SAKLANIYORDU. Plan degisince onu yeniden hesaplamayi hatirlamasi
 * gereken DORT ayri yol vardi ve dordu de unutmustu (27 Agu: gorev 3 bacakli
 * halinden 2 bacaga indi, dinlenme 14:00'te takili kaldi). Serkan: *"ucusun
 * rotasinin surekli degismesi olagan bir durum; her seferinde planlamada kalan
 * saatler bize sorun cikariyor."*
 *
 * 🔑 CELISKI URETMEMEK ICIN TEK YERDE: roster, gorev gecmisi, FTL LIMITS
 * cubugu, atama uygunlugu ve can HEPSI bu normalize edilmis listeyi okur. Kural
 * ekranlara dagitilsaydi iki ekran ayni gorev icin farkli sayi gosterirdi —
 * cozerken yeni bir celiski uretmis olurduk.
 *
 * KAPSAM BILEREK DAR: yalnizca `min_rest_minutes` ve ondan tureyen
 * `earliest_next_report`. `fdp_minutes`/`max_fdp_minutes`/`duty_end` her
 * kayitta zaten yeniden yaziliyor ve mandal kusuru onlarda yoktu — dokunmuyoruz
 * (gereksiz yere yeniden hesaplamak, atamada donmus limitle ekranda gosterilen
 * limiti ayirir ve YENI bir celiski acardi). */
// 🔴 30 EYL 2026 (FTL nobetcisi B2-2): burasi `minRestMinutes`'i HAM mevzuatla
//    cagiriyordu — uzun menzil (Md.16(3)) YOKTU. ASSIGN planli uzun menzil
//    gorevine usse donuste 48 saat + 2 yerel gece yaziyor, panel her acilista
//    bunu ekranda max(gorev, 12:00)'ye ceviriyordu (roster, gecmis, limit cubugu,
//    atama uygunlugu hepsi bu listeyi okur). Simdi ASSIGN / EDIT / arsivle AYNI
//    karar noktasi: `restForDuty` + `effectiveRules` + `uzunMenzilOlcumu`.
//    Uzun menzil OLCULEMEZSE (meydan dilimi yok) kayitli degere DOKUNULMAZ —
//    atamada olculerek yazilmisti, tahminle ezilmez (Ilke 1).
// tzMap: ICAO -> IANA dilimi (panel acilista planli ucuslarin meydanlari icin okur).
export function projectPlannedRest(duties, homeBases = {}, tzMap = {}) {
  const pilotun = new Map();
  (duties || []).forEach(d => { if (d) pilotun.set(d.pilot_id, [...(pilotun.get(d.pilot_id) || []), d]); });
  return (duties || []).map(d => {
    if (d?.status !== 'planned' || d?.duty_type !== 'flight') return d;
    if (!d.report_time || !d.duty_end) return d;
    const dutyMin = Math.round(
      (new Date(d.duty_end).getTime() - new Date(d.report_time).getTime()) / 60000);
    if (!Number.isFinite(dutyMin) || dutyMin <= 0) return d;
    const legs = d.sectors || [];
    const son = legs[legs.length - 1];
    const rules = effectiveRules(d.ruleset_snapshot || null).rules;
    const um = uzunMenzilOlcumu(legs, tzMap, rules, { raporISO: d.report_time, bitisISO: d.duty_end });
    if (um.olculemedi) return d;
    const atBase = endedAtBase(son?.actual_dest ?? son?.dest ?? null, homeBases[d.pilot_id]);
    // Md.16(3)(b) rotasyon (4 Eki 2026) — sunucuyla aynı fonksiyon; ölçülemezse kayıttaki değer kalır.
    const rot = atBase && !um.uzunMenzil ? rotasyondaUzunMenzil(d, pilotun.get(d.pilot_id),
      { anaUs: homeBases[d.pilot_id] || null, tz: tzMap, raporISO: d.report_time }) : null;
    if (rot && rot.uzunMenzil == null) return d;
    const rest = restForDuty({ dutyMin, atBase, longRange: um.uzunMenzil, rotasyonUzunMenzil: rot?.uzunMenzil === true,
      dutyEndISO: d.duty_end, arrivalTz: um.varisTz, rules }).restMin;
    if (rest == null) return d;   // kural setinde taban yok — kayıttaki (sunucunun) değer kalır
    if (rest === d.min_rest_minutes) return d;   // degismediyse nesneyi de degistirme
    return { ...d, min_rest_minutes: rest,
      earliest_next_report: new Date(new Date(d.duty_end).getTime() + rest * 60000).toISOString() };
  });
}

/** GOREV USTE MI BITTI? — dinlenme tabanini bu belirler (Md.16(1)(2)).
 *  Us TANIMSIZ ise `true` doner: bilinmeyende daha UZUN tabani (12:00)
 *  uygulamak muhafazakar taraftir. Ama bu bir VARSAYIMDIR — us tanimlamak
 *  isin dogrusudur. */
export function endedAtBase(lastDest, homeBase) {
  if (!homeBase) return true;
  return String(lastDest || '').toUpperCase() === String(homeBase).toUpperCase();
}

// ── Saat dilimi yardımcıları (saf hesap — I/O yok) ──────────────────
// Yerel duvar saatini bir IANA diliminde MUTLAK ana çevirir. Yerel gece /
// intibak hesapları bunu kullanır; panel de aynı fonksiyonu kullanır ki
// aynı aritmetiğin ikinci kopyası olmasın (K-2 dersi).
// 🔴 19 EYL 2026 — `hour12:false` DEGIL, `hourCycle:'h23'`.
//    `hour12:false` saat dongusunu **h24**'e dusuruyor ve o donguda gece yarisi
//    `00` degil **`24`** yaziliyor. `Date.UTC(..., 24, mm)` ertesi gune tasar →
//    fark TAM 24 SAAT (1440 dk) fazla cikar. Meydanda yerel saat 00:00–00:59
//    ise, yani HER GUNUN BIR SAATI.
//    Olculdu (gercek rota LTFE–LFMN, gercek fark 1 saat): ekran 21:00–22:00Z
//    arasinda acilirsa fark **25 saat** gorunuyordu → `tzSpanHours >= 4` →
//    ucus UZUN MENZIL damgasi yiyordu: MAX FDP Md.22(3) sinirina kirpilir,
//    varis dinlenmesi max(gorev,14:00) olur, donuste 48 sa / 2 yerel gece
//    istenir (Md.16/3). Hicbiri gercek degildi.
//    En kotusu: sonuc EKRANA NE ZAMAN BAKILDIGINA bagliydi — ayni gorev sabah
//    baska, gece baska. `archive-flight` de ayni cagriyi yapiyor (index.ts:522,
//    1280), yani o saat araliginda arsivlenen ucusta yanlis deger KAYDA gecerdi.
//    Ayrica `zonedISO(tarih,'00:00',tz)` her seferinde 24 saat erken donuyordu
//    (bos gun adayi sayan `FTLEngine.js` gunBasi'nin tam olarak yaptigi cagri).
//    `hourCycle:'h23'` gece yarisini `00` yazar. Node 20 ve Deno 2.9'da
//    olculdu, ikisinde de dogru. Nobetci: `tzOffsetMin.test.js`.
export function tzOffsetMin(tz, ts) {
  const dtf = new Intl.DateTimeFormat('en-US', { timeZone: tz, hourCycle: 'h23',
    year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' });
  const p = Object.fromEntries(dtf.formatToParts(new Date(ts)).map(x => [x.type, x.value]));
  return (Date.UTC(+p.year, +p.month - 1, +p.day, +p.hour, +p.minute) - ts) / 60000;
}

// 🔴 21 EYL 2026 — DILIMSIZ CAGRI ARTIK MAKINEYE DUSMUYOR.
//    Eskiden `tz` yoksa `new Date('2026-09-03T22:00:00')` yaziliyordu; bu
//    MAKINENIN dilimidir, yani yerel gece penceresi EKRANA NEREDEN BAKILDIGINA
//    baglaniyordu. Olculdu (3 Eyl SCL vakasi, OFF + yer egitimi 06:30-14:30Z,
//    motor dort makine diliminde kosturuldu): Istanbul'da bos gun AYAKTA,
//    UTC/London/New York'ta DUSUYOR — ayni kayit, Md.5 sayacinda 1 mi 0 mi
//    oldugu tarayicinin yerine bagli. REC'te gorunmuyordu cunku makine de LTAC
//    de +03:00; kusur sessizdi, yok degildi.
//    Artik `null` doner ve cagiran OLCMEZ (Ilke 1: olcemedigimizi olcmus gibi
//    gostermeyiz). Kodda emsali: "dilim yoksa bant UYDURULMAZ".
export function zonedISO(dateStr, hhmm, tz) {
  if (!dateStr || !hhmm || !tz) return null;
  const [y, m, d] = dateStr.split('-').map(Number);
  const [hh, mm] = String(hhmm).split(':').map(Number);
  const guess = Date.UTC(y, m - 1, d, hh, mm);
  let ts = guess - tzOffsetMin(tz, guess) * 60000;
  ts = guess - tzOffsetMin(tz, ts) * 60000;   // DST sınırı için ikinci geçiş
  return new Date(ts).toISOString();
}

// UTC gün ekleme — TEK KAYNAK (3 Eki 2026: FTL paneli de bunu kullanır; Serkan "UTC olması lazım").
export const shiftDate = (dateStr, days) => {
  const d = new Date(dateStr + 'T12:00:00Z');
  d.setUTCDate(d.getUTCDate() + days);
  return d.toISOString().slice(0, 10);
};

// ── Boş günler (SHT-FTL/HG Md.5, tanım Md.4(ü)(ff)) ─────────────────
// TEK BOŞ GÜN = 1 yerel gün + 2 YEREL GECE. Yerel gece 22:00–08:00.
// Yani D günü tek boş gün sayılabilmesi için D-1 22:00→D 08:00 VE
// D 22:00→D+1 08:00 pencerelerinin ikisinin de tüm görevlerden muaf olması
// gerekir. Sadece "o gün görev yok" YETMEZ — Talimatın tanımı budur.
// tz: EKIP UYESININ ana us dilimi (Md.4(ff) "yerel saatle", Md.7(1)(a) her
// ekip uyesi icin bir ana us). Dilim YOKSA `null` doner — "olculemedi".
// 🔑 Serkan (21 Eyl 2026): *"home base bos kalamaz"* · *"home base sirketin
//    tanimlamasi gereken bir durum dinlenme sureleri icin"* · pilot ucakla ayni
//    usttedir, *"hicbir sirket baska bir ulkede base olan bir pilotu
//    calistirmaz"*. Bu yuzden us bos kalmasi ONLENIR; burasi yalnizca, buna
//    ragmen bos kalirsa SESSIZ KALMAMAK icin var.
// ⚠️ `false` DONMEZ: "bos gun degil" ile "olcemedim" ayri seylerdir. `false`
//    donseydi olculemeyen gun sayacin disinda kalir ve eksik gorunurdu —
//    olcmedigimiz bir seyi olcmus gibi yazmak olurdu (Ilke 1).
// ── BOŞ GÜNÜN SAATİ: OFF NEREDE VERİLDİYSE (1 Eki 2026) ─────────────
// 🔑 Serkan (1 Eki 2026): *"OFF nerede verilmişse orada ölçülmeli demiyor mu mevzuat"* → *"bence A, OFF
//    girilirken lokasyon da girilir"* · *"ICAO kod girelim, hızlı"*. Talimat "yerel saat"in nereyi kastettiğini
//    söylemiyor (Md.4(ff)/(gg)/(ü)); doğal okuma boş günün GEÇİRİLDİĞİ yer.
// 🔴 ÖNCESİ (20 Eyl `7a46a00`): iki yerel gece hep ANA ÜS diliminden ölçülüyordu.
// KURAL: kayıtta meydan + dilim varsa o dilim · meydan yazılı ama dilimi yoksa ÖLÇÜLEMEZ (null — tahmin edilmez)
//    · meydan hiç yoksa (1 Eki öncesi kayıtlar) ana üs dilimi. Bütün boş gün ölçüleri BURADAN geçer.
export function bosGunDilimi(offRow, evDilimi) {
  if (offRow?.location_tz) return offRow.location_tz;
  if (offRow?.location) return null;
  return evDilimi || null;
}

// ── BOŞ GÜNÜ BOZAN GÖREV — ölçünün GEREKÇELİ hâli (1 Eki 2026) ──────
// 🔑 Serkan (1 Eki 2026, SCL 22 Eyl: 21 Eyl uçuşu yerel 00:40'ta bitti, ertesi güne girilen OFF sessizce
//    yazıldı): *"OFF rest olması gereken yere girilemez … gerçekleşmiş uçuşun arkasına OFF girilmek istenirse
//    direkt uyarı verir, OFF'u mümkün kılmaz, kural ihlal edilemez"* · ölçü Md.4/ü (*"a, çünkü rule set bunu
//    istiyor"*). `isSingleDayOff` aynı ölçüdür, yalnız evet/hayır söyler; giriş kapısı NEDENİ de söylemeli.
// Dönüş: null → ölçülemedi (dilim yok) · { gecerli: true } · { gecerli: false, gece: 'once'|'sonra', gorev }
//    'once' = OFF gününden önceki gece (D-1 22:00 → D 08:00) · 'sonra' = sonraki gece (D 22:00 → D+1 08:00).
// ── BOŞ GÜNÜN TEBLİĞİ — Md.4(ü) + Md.7(1)(c) (4 Eki 2026, Serkan A: *"mevzuatı takip ediyoruz, A olacak"*) ─────────────
// Md.4(ü) tek boş günü "ÖNCEDEN TEBLİĞ EDİLEN" diye tanımlar; Md.7(1)(c) "asgari 24 saat önceden bildirecektir" der. Günün
//    yerel başlangıcına (OFF'un yerinde 00:00) `notice_hours`tan az kala girilen OFF boş gün SAYILMAZ (aylık / yıllık sayım,
//    6 günlük serinin 7. günü). Kayıt engellenmez — pilot gerçekten serbesttir; yalnız mevzuattaki boş gün değildir.
// Bildirim anı = satırın `created_at`'i (updated_at değil: durum yazımında da değişir). `created_at`'i olmayan satır
//    ÖLÇÜLMEZ (null) — "şimdi"yi bildirim anı saymak, saat ilerledikçe her eski kaydı geç gösterirdi. Girilmekte olan
//    (kaydedilmemiş) OFF için çağıran `created_at: şimdi` verir (giriş uyarısı).
// Yalnız `TEBLIG_KONTROL_BASI`ndan SONRA girilen OFF'lar ölçülür: öncekiler toplu veri girişiyle geldi, giriş anları tebliğ
//    anı değildir (canlı 4 Eki: 182 OFF satırı). Süre ya da dilim yoksa null (ölçülemedi — sayımı düşürmez, uydurulmaz).
// Bilinen sınır: tarihi sonradan değiştirilen OFF'un tebliği yine ilk girişten ölçülür (harita Md.7(1)(c) notu).
export const TEBLIG_KONTROL_BASI = '2026-10-04T09:00:00Z';
export function gecTeblig(offRow, rules, tz) {
  const saat = Number(rules?.days_off?.notice_hours);
  if (!offRow?.duty_date || !offRow.created_at || !tz || rules?.days_off?.notice_hours == null || !Number.isFinite(saat)) return null;
  const girildi = Date.parse(offRow.created_at);
  if (!Number.isFinite(girildi) || girildi < Date.parse(TEBLIG_KONTROL_BASI)) return null;
  const gunBasi = Date.parse(zonedISO(offRow.duty_date, '00:00', tz));
  if (!Number.isFinite(gunBasi)) return null;
  const sonAn = gunBasi - saat * 3600000;
  return girildi > sonAn
    ? { gec: true, girildiISO: new Date(girildi).toISOString(), sonAnISO: new Date(sonAn).toISOString(), saat }
    : { gec: false };
}
/** GİRİŞ UYARISI — girilmekte olan OFF günlerinden geç tebliğ edilecek olanlar (kayıt ENGELLENMEZ; Serkan A). ASSIGN, EDIT
 *  ve "olmadı → OFF" aynı cümleyi gösterir. Boş gün sayılmayan tür (ör. verilmiş izin) uyarılmaz. */
export function gecTebligUyarisi(dates, rules, tz, { simdi = Date.now(), offTypes = null, subtype = null } = {}) {
  if (offTypes && subtype && offTypes.find(x => x.code === subtype)?.counts_as_recurrent_rest === false) return [];
  const an = new Date(simdi).toISOString();
  return (dates || []).map(tarih => ({ tarih, t: gecTeblig({ duty_date: tarih, created_at: an }, rules, tz) }))
    .filter(x => x.t?.gec)
    .map(x => `${utcGunAy(`${x.tarih}T12:00:00Z`)} — LATE NOTICE: ${gecTebligMetni(x.t)}. It is recorded, but it does not `
      + 'count as a day off.');
}
/** Geç tebliğin cümlesi — duty sheet, DUTY HISTORY ve giriş uyarısı AYNI metni gösterir. */
export const gecTebligMetni = (t) => `notified late — entered ${utcGunAySaat(t.girildiISO, { z: true })}, needed by `
  + `${utcGunAySaat(t.sonAnISO, { z: true })} (${t.saat} h notice, Md.7(1)(c)) — not a day off`;

// Gece ölçüsü `yerelGeceKurali` (Md.4(ff), 3 Eki 2026): pencereye değen görev geceyi BOZMAZ; gece ancak pencerede
//    kesintisiz `dk` (8 saat) boş kalmazsa bozulur. Dönüşte `bosDk` (en uzun boşluk) ve `gerekenDk` — cümleler bunu söyler.
//    Kural seti yerel geceyi tanımlamıyorsa null (ölçülemedi), dilim yoksa null.
export function bosGunCakismasi(offDate, duties, rules, tz = null) {
  if (!tz) return null;
  const k = yerelGeceKurali(rules);
  if (!k) return null;
  const windows = [
    ['once',  zonedISO(shiftDate(offDate, -1), k.bas, tz), zonedISO(offDate, k.son, tz)],
    ['sonra', zonedISO(offDate, k.bas, tz), zonedISO(shiftDate(offDate, 1), k.son, tz)],
  ].map(([gece, a, b]) => [gece, new Date(a).getTime(), new Date(b).getTime()]);

  const busy = (duties || []).filter(d =>
    d.duty_type !== 'off' && d.status !== 'cancelled' && d.report_time && d.duty_end)
    .map(d => ({ d, s: new Date(d.report_time).getTime(), e: new Date(d.duty_end).getTime() }));
  const gb = new Date(zonedISO(offDate, '00:00', tz)).getTime();
  const gs = new Date(zonedISO(shiftDate(offDate, 1), '00:00', tz)).getTime();
  // GÖREVİN GÜNÜ GECELERDEN ÖNCE (27 Eki 2026, Serkan: *"off'tan uçuşa gidiyor … duty olarak görünmeli"* · *"off to duty olur
  //    bu görev"*): raporu OFF'un YEREL GÜNÜNDE olan görev o günü alır → 'gun' (OFF → DUTY), gece yarısını geçse de. Gece
  //    ('once' / 'sonra' → OFF → REST) yalnız günü değil gecesini alan görevdir: önceki günden taşan (22 Eyl: 00:40'ta biten)
  //    ya da ertesi sabah erken raporlu. 🔴 ÖNCESİ: geceler önce ölçülüyordu; 29 Eki 19:30 LT raporlu, 00:30 LT biten uçuş
  //    "night after busy" → OFF → REST yazılıyor, ROSTER pilotu uçuşun yanında OFF satırında da gösteriyordu.
  //    Boş gün kararı (`gecerli`) değişmez — o görev günün içinde olduğu için zaten bozuyordu; değişen yalnız sınıfı.
  const gundeBaslayan = busy.filter(x => x.s >= gb && x.s < gs);
  if (gundeBaslayan.length) {
    return { gecerli: false, gece: 'gun', gorev: gundeBaslayan.reduce((a, b) => (b.s < a.s ? b : a)).d,
             bosDk: null, gerekenDk: k.dk, pencere: [k.bas, k.son] };
  }
  for (const [gece, ws, we] of windows) {
    const degen = busy.filter(x => x.s < we && x.e > ws);
    if (!degen.length) continue;
    const bosDk = enUzunBosluk(ws, we, degen.map(x => [x.s, x.e]));
    if (bosDk >= k.dk) continue;                                     // pencerede 8 boş saat var — gece duruyor
    // Adı geçen görev: önceki gecede en GEÇ biten, sonraki gecede en ERKEN başlayan (cümle "ends" / "reports" der).
    const gorev = gece === 'once'
      ? degen.reduce((a, b) => (b.e > a.e ? b : a)).d
      : degen.reduce((a, b) => (b.s < a.s ? b : a)).d;
    return { gecerli: false, gece, gorev, bosDk, gerekenDk: k.dk, pencere: [k.bas, k.son] };
  }
  // YEREL GÜN — GECELERDEN SONRA (4 Eki 2026, Serkan A — *"mevzuata uygun olacak"*): Md.4(ü) boş günü "bir yerel gün ve iki yerel geceden
  //    oluşan, TÜM GÖREVLERDEN ve nöbet görevinden muaf" süre diye tanımlar. OFF'un kendi günü (yerel 00:00–24:00) bir
  //    göreve değiyorsa o gün boş gün DEĞİLDİR. 🔴 ÖNCESİ (8 Ağu / 4 Eyl): yalnız geceler ölçülüyordu; gündüz görevli OFF
  //    "OFF TO DUTY — day off stands" diye boş gün sayılıyordu (SCL 3 Eyl: OFF + 09:30–17:30 eğitim).
  //    Sıra (27 Eki 2026'dan beri): ① o gün raporlu görev (yukarıda) ② geceler — önceki günden taşan görev gecede 8 saat
  //    bırakmaz ve cümlesi gecenin saatini söyler (22 Eyl: 00:40'ta biten uçuş) ③ burası: önceki günden başlayıp günün
  //    içine taşan ama geceyi bozmayan görev.
  const gunde = busy.filter(x => x.s < gs && x.e > gb);
  if (gunde.length) {
    return { gecerli: false, gece: 'gun', gorev: gunde.reduce((a, b) => (b.s < a.s ? b : a)).d,
             bosDk: null, gerekenDk: k.dk, pencere: [k.bas, k.son] };
  }
  return { gecerli: true, gerekenDk: k.dk, pencere: [k.bas, k.son] };
}

export function isSingleDayOff(offDate, duties, rules, tz = null) {
  const c = bosGunCakismasi(offDate, duties, rules, tz);
  return c ? c.gecerli : null;
}

/** OFF GİRİŞ KAPISI (Md.4/ü) — yeni OFF günlerinden boş gün tanımını tutturamayanlar. Bunlar YAZILMAZ.
 *  Yalnız Md.5 boş günü sayılan türler ölçülür (`offDayRelease` ile aynı ayrım: verilmiş izin boş gün değildir).
 *  Ölçülemeyen gün (dilim yok) engellenmez — uydurma engel olurdu (İlke 1); o eksik zaten ayrıca söylenir.
 *  duties: pilotun MEVCUT kayıtları (iptal edilecek satır çıkarılmış olarak).
 *  @returns {{ tarih: string, gece: 'once'|'sonra', gorev: object, tz: string }[]} */
export function offGirisEngeli(dates, duties, rules, tz, { offTypes = null, subtype = null } = {}) {
  if (offTypes && subtype) {
    const t = offTypes.find(x => x.code === subtype);
    if (t && t.counts_as_recurrent_rest === false) return [];
  }
  return (dates || []).map(tarih => ({ tarih, c: bosGunCakismasi(tarih, duties, rules, tz) }))
    .filter(x => x.c && !x.c.gecerli)
    .map(x => ({ tarih: x.tarih, gece: x.c.gece, gorev: x.c.gorev, tz, bosDk: x.c.bosDk, gerekenDk: x.c.gerekenDk, pencere: x.c.pencere }));
}

// Çakışan görevin adı ve gecenin anı — OFF kapısı ve OFF → REST çeviricisi AYNI parçaları kullanır.
function cakismaParcalari(e) {
  const g = e.gorev || {};
  const sek = (g.sectors || []).filter(s => !s.deadhead);
  const ad = g.duty_type === 'flight' && sek.length
    ? `${sek[0].dep}→${sek[sek.length - 1].actual_dest || sek[sek.length - 1].dest}`
    : String(g.ground_kind || g.duty_type || 'duty').replace(/_/g, ' ').toUpperCase();
  const an = e.gece === 'once' ? g.duty_end : g.report_time;
  return { ad, lt: yerelHHMM(an, e.tz), z: yerelHHMM(an), gunAy: utcGunAy(`${e.tarih}T12:00:00Z`) };
}
// Hangi parça dolu: önceki gece · günün kendisi (4 Eki 2026) · sonraki gece.
const parcaAdi = (gece) => (gece === 'once' ? 'the night before' : gece === 'gun' ? 'the day itself' : 'the night after');

// Gecede ne kaldı — Md.4(ff) ölçüsünü cümleye koyar (kapı, OFF → REST ve REST → OFF aynı parça). Ölçü yoksa boş.
const geceBoslukMetni = (e) => (e?.bosDk != null && e?.gerekenDk != null && e?.pencere
  ? `; only ${fmtMin(e.bosDk)} free between ${e.pencere[0]} and ${e.pencere[1]} LT — a local night needs ${fmtMin(e.gerekenDk)} (Md.4(ff))`
  : e?.gece === 'gun' ? '; a day off is free of all duties (Md.4(ü))' : '');

/** Kapının cümlesi — ASSIGN, EDIT ve iptal→OFF AYNI metni gösterir (tek kaynak). */
export function offGirisEngeliMetni(e) {
  const p = cakismaParcalari(e);
  return `${p.gunAy} — NOT A VALID DAY OFF (Md.4/ü): ${parcaAdi(e.gece)} `
    + `is not free — ${p.ad} ${e.gece === 'once' ? 'ends' : 'reports'} ${p.lt} LT (${p.z}Z)${geceBoslukMetni(e)}. `
    + 'An OFF cannot be entered on this day.';
}

// ── GERÇEKLEŞMİŞ GÖREVİN BOZDUĞU OFF → REST (1 Eki 2026) ─────────────
// 🔑 Serkan (1 Eki 2026): *"gerçekleşmiş bir uçuş arşive gittiğinde daha önceden girilmiş bir off gününü
//    etkiliyorsa o off rest olarak güncellenir"* · *"roster güncellenmesi gerekir"* · kural motorda, beş yerden
//    çağrılır (*"başlayalım A'ya"*).
// PLANLI görevden FARKI: asgariye BAKILMAZ — uçuş olmuştur, o boş gün gerçekleşmemiştir. Yalnız GERÇEKLEŞMİŞ
//    görevlerle çakışma sayılır; planlı görevin bozduğu OFF planlamacının işidir (uyarı + elle REST, `fitness`).
// Md.5 boş günü sayılmayan tür (verilmiş izin) çevrilmez; dilimi bilinmeyen gün ÖLÇÜLEMEZ, çevrilmez (uydurulmaz).
// gorev: kaydedilen SON hâli (id, pilot_id, report_time, duty_end, sectors…). Dönüş: [{ off, tarih, gece, gorev, tz }]
export function gercekGorevinBozduguOfflar(duties, pilotId, gorev, rules, { offTypes = null, tz = null } = {}) {
  if (!gorev?.report_time || !gorev?.duty_end) return [];
  const mine = (duties || []).filter(d => (!pilotId || d.pilot_id === pilotId) && d.status !== 'cancelled'
                                          && (!gorev.id || d.id !== gorev.id));
  const gercek = [...mine.filter(d => d.duty_type !== 'off' && d.status === 'actual'), { ...gorev, status: 'actual' }];
  const sayilir = (kod) => {
    if (!offTypes || !kod) return true;
    const t = offTypes.find(x => x.code === kod);
    return t ? t.counts_as_recurrent_rest !== false : true;
  };
  const bas = new Date(gorev.report_time).toISOString().slice(0, 10);
  const son = new Date(gorev.duty_end).toISOString().slice(0, 10);
  const out = [];
  for (let dt = shiftDate(bas, -1); dt <= shiftDate(son, 1); dt = shiftDate(dt, 1)) {
    const off = mine.find(d => d.duty_type === 'off' && d.duty_date === dt);
    if (!off || !sayilir(off.off_subtype)) continue;
    const dilim = bosGunDilimi(off, tz);
    const c = bosGunCakismasi(dt, gercek, rules, dilim);
    if (c && !c.gecerli) out.push({ off, tarih: dt, gece: c.gece, gorev: c.gorev, tz: dilim, bosDk: c.bosDk, gerekenDk: c.gerekenDk, pencere: c.pencere });
  }
  return out;
}

// ── GECESİ BOŞALAN OFF GERİ GELİR — REST → OFF (3 Eki 2026) ──────────────────────────────────────────────────────
// 🔑 Serkan: *"off geri gelsin"* (A). OFF → REST otomatik çevrildikten SONRA geceyi alan görevin saati düzeltilir ya da
//    görev iptal edilir / silinirse gece boşalır; eskiden gün REST kalıyordu, hiçbir yol geri getirmiyordu.
// YALNIZ otomatik çevrilen OFF: son `day_nature` izi `→ REST` olan (offRestCevirici yazar). Planlamacının elle iptal
//    ettiği OFF (`status → cancelled` izi) DOKUNULMAZ — o bir karardır.
// Ölçü ileri yönle AYNI (`bosGunCakismasi`, Md.4/ü), ama BÜTÜN görevlerle (planlı da): geri gelen OFF'un gecesine planlı bir
//    görev değiyorsa gelmez — geçersiz OFF yaratılmaz. Dilim bilinmiyorsa ölçülemez, gelmez (uydurulmaz). Aynı günde
//    planlamacının yeni girdiği bir OFF varsa gelmez (çift OFF olmasın).
// Durum: günü gelmişse actual, gelmemişse planned (gece OFF işi günü gelince actual yapar — `offPeriodStatuses`in
//    "geri kalanı günü gelince" kuralı).
// sonIz: { [offId]: o OFF'un EN SON day_nature iz satırı } · tzOf: pilotun ana üs dilimi · bugun: 'YYYY-MM-DD' (UTC)
// Dönüş: [{ off, tarih, durum }]
/** @param {{ duties: any[], sonIz?: Record<string, any>, tzOf?: (pilotId: string) => (string | null), bugun?: string }} p
 *  @returns {{ off: any, tarih: string, durum: string }[]} */
export function geriGelecekOfflar({ duties, sonIz = {}, tzOf = (_pilotId) => null, bugun }) {
  const out = [];
  for (const off of (duties || []).filter(d => d.duty_type === 'off' && d.status === 'cancelled')) {
    const iz = sonIz[off.id];
    // 4 Eki 2026: otomatik çevirme gününde görev varsa DUTY, yalnız gecesine değdiyse REST yazar — ikisi de geri gelir.
    if (!iz || iz.field_name !== 'day_nature' || !['REST', 'DUTY'].includes(iz.new_value)) continue;
    const mine = duties.filter(d => d.pilot_id === off.pilot_id);
    if (mine.some(d => d.id !== off.id && d.duty_type === 'off' && d.status !== 'cancelled' && d.duty_date === off.duty_date)) continue;
    const kurallar = off.ruleset_snapshot?.regulation ? effectiveRules(off.ruleset_snapshot).rules : null;
    const c = bosGunCakismasi(off.duty_date, mine, kurallar, bosGunDilimi(off, tzOf(off.pilot_id)));
    if (!c || !c.gecerli) continue;
    out.push({ off, tarih: off.duty_date, durum: bugun && off.duty_date <= bugun ? 'actual' : 'planned', gerekenDk: c.gerekenDk, pencere: c.pencere,
               onceki: iz.new_value });
  }
  return out;
}
/** REST → OFF izinin cümlesi (tek kaynak). */
// 3 Eki 2026 (Md.4(ff)): "the duty that took one was corrected or removed" denmez — gece ölçüsü mevzuata çekildiğinde de
//    OFF geri gelir ve o cümle yanlış olurdu. Cümle yalnız ÖLÇÜLENİ söyler.
export const offGeriMetni = (x) => `${utcGunAy(`${x.tarih}T12:00:00Z`)} ${x?.onceki === 'DUTY' ? 'DUTY' : 'REST'} → OFF (Md.4/ü): `
  + `${x?.onceki === 'DUTY' ? 'the day and ' : ''}both local nights are free again`
  + (x?.gerekenDk != null && x?.pencere
    ? ` — each has ${fmtMin(x.gerekenDk)} free between ${x.pencere[0]} and ${x.pencere[1]} LT (Md.4(ff))` : '')
  + '; the day off is restored';

// ── MATCH REVIEW: SORUN NE — AÇIKÇA (3 Eki 2026) ─────────────────────────────────────────────────────────────────
// 🔑 Serkan: *"match review'de benim tek istediğim sorunun ne olduğu mutlaka söylensin, öteki türlü bazen insan bakıyor ama
//    bulamıyor … LEMD LEDM arasındaki farkı ben göremedim, gözüm harflerin farklı konumlandığını çok geç anladı"*.
// Not artık farkı KENDİSİ söyler: farklı harfler köşeli parantezle işaretlenir, yer değiştirmiş iki harf adıyla söylenir.
const SIRA_ADI = ['1st', '2nd', '3rd', '4th', '5th', '6th', '7th', '8th'];
/** İki kodun farkı: "flight LE[MD], duty LE[DM] — letters 3 and 4 are swapped (M↔D)". Aynıysa null. */
export function kodFarki(ucus, gorev) {
  const a = String(ucus ?? '').trim().toUpperCase(), b = String(gorev ?? '').trim().toUpperCase();
  if (a === b) return null;
  if (!a || !b || a.length !== b.length) return `flight ${a || '—'}, duty ${b || '—'} — different codes`;
  const fark = [...a].map((c, i) => (c !== b[i] ? i : -1)).filter(i => i >= 0);
  const bitisik = fark.length === 2 && fark[1] === fark[0] + 1;
  const isaretle = (s) => (bitisik
    ? `${s.slice(0, fark[0])}[${s.slice(fark[0], fark[1] + 1)}]${s.slice(fark[1] + 1)}`
    : [...s].map((c, i) => (fark.includes(i) ? `[${c}]` : c)).join(''));
  const bas = `flight ${isaretle(a)}, duty ${isaretle(b)}`;
  if (bitisik && a[fark[0]] === b[fark[1]] && a[fark[1]] === b[fark[0]]) {
    return `${bas} — letters ${fark[0] + 1} and ${fark[1] + 1} are swapped (${a[fark[0]]}↔${a[fark[1]]})`;
  }
  if (fark.length === 1) return `${bas} — the ${SIRA_ADI[fark[0]] || `${fark[0] + 1}th`} letter differs`;
  return `${bas} — ${fark.length} letters differ`;
}
/** Uçuşun rotası ile günün UÇULMAMIŞ planlı bacakları — en yakın bacağı bulur, farkı alan alan söyler.
 *  @returns cümle ("Closest planned sector LTBA-LEDM: DEP matches (LTBA); DEST differs: flight LE[MD], duty LE[DM] — …") */
export function rotaFarkiMetni(dep, dest, sektorler) {
  const d0 = String(dep ?? '').toUpperCase(), a0 = String(dest ?? '').toUpperCase();
  const farkSayisi = (x, y) => { x = String(x ?? '').toUpperCase(); y = String(y ?? '').toUpperCase();
    return x.length !== y.length ? 9 : [...x].filter((c, i) => c !== y[i]).length; };
  const aday = (sektorler || []).filter(s => s && (s.dep || s.dest))
    .map(s => ({ s, puan: farkSayisi(d0, s.dep) + farkSayisi(a0, s.dest) }))
    .sort((p, q) => p.puan - q.puan)[0];
  if (!aday) return `No sector is still planned for this day to compare with the flight ${d0 || '?'}-${a0 || '?'}.`;
  const s = aday.s;
  const parca = (ad, u, g) => { const f = kodFarki(u, g); return f ? `${ad} differs: ${f}` : `${ad} matches (${String(u ?? '').toUpperCase()})`; };
  return `Closest planned sector ${String(s.dep ?? '?').toUpperCase()}-${String(s.dest ?? '?').toUpperCase()}: `
    + `${parca('DEP', d0, s.dep)}; ${parca('DEST', a0, s.dest)}.`;
}

// ── OFF → DUTY / OFF → REST — iptal edilen OFF'un yerine ne geldi (4 Eki 2026, Serkan: *"görev vermiş, OFF to REST
//    değil OFF to DUTY olması lazım"*) ────────────────────────────────────────────────────────────────────────────────
// Mevzuatın kayıt kategorileri (Md.18(1)): görev · dinlenme · boş gün. Görev OFF'un GÜNÜNÜN içindeyse o gün bir GÖREV
//    günüdür (Md.18(1)(b)) → DUTY; görev yalnız yerel gecelerinden birine değdiyse gün görevsizdir ama boş gün değildir,
//    bir DİNLENME süresidir (Md.4(1)(d), Md.18(1)(c)) → REST. İkisinde de boş gün sayılmaz. `deger` iz satırına yazılır
//    (`day_nature`), `etiket` kutu notu, açıklama ve bildirimde görünür.
export const offDonusumu = (gece) => (gece === 'gun'
  ? { deger: 'DUTY', etiket: 'OFF → DUTY' } : { deger: 'REST', etiket: 'OFF → REST' });

/** OFF GÜNÜNÜN GÖRÜNÜMÜ — YALNIZ GÖSTERİM (13 Eki 2026, Serkan: *"bu güncelleme kurala, mevzuata, motorların hesaplamasına
 *  etki etmeyecek; görüntüde daha net bir görüntü olacak"*). Ölçüler AYNI (`bosGunCakismasi` = c, `gecTeblig`); boş gün
 *  sayımı (Md.5) ve kayıt değişmez — değişen yalnız ekranda ne yazdığı. Serkan'ın kuralı:
 *   · OFF gününe görev verilirse → OFF → DUTY (yalnız gecesine değerse OFF → REST): SARI not, uyuşmazlık DEĞİL
 *   · REST gününe görev → not yok (zaten öyleydi)
 *   · 24 saatten geç girilen OFF → gün REST'tir: görevsizken kırmızı "not a day off" DOĞRU; üstüne görev girilirse HİÇBİR
 *     NOT yok (*"ihtiva REST olduğu için üstüne görev girilebilir, remarksız"*)
 *  🔴 ÖNCESİ: görev alan OFF kırmızı "OFF ENTERED — NOT VALID" + ⚑ + MISMATCH idi; plan değişikliği ihlal gibi görünüyordu.
 *  @param c `bosGunCakismasi(tarih, görevler, rules, dilim)` — çağıran hesaplar (ölçü tek yerde)
 *  @returns null (OFF ayakta) · { tur:'gec', metin } kırmızı · { tur:'donusum', etiket, metin } sarı · { tur:'sessiz' } */
export function offGunuGorunumu(offRow, c, rules, dilim) {
  const tg = gecTeblig(offRow, rules, dilim);
  if (c && !c.gecerli) {
    if (tg?.gec) return { tur: 'sessiz' };
    const an = c.gece === 'once' ? c.gorev.duty_end : c.gorev.report_time;
    const metin = c.gece === 'once' ? `night before busy until ${yerelHHMM(an, dilim)} LT`
      : c.gece === 'gun' ? `duty on the day from ${yerelHHMM(an, dilim)} LT`
      : `night after busy from ${yerelHHMM(an, dilim)} LT`;
    return { tur: 'donusum', etiket: offDonusumu(c.gece).etiket, metin };
  }
  if (tg?.gec) return { tur: 'gec', metin: gecTebligMetni(tg) };
  return null;
}

/** OFF → DUTY / OFF → REST izinin ve bildiriminin cümlesi (tek kaynak). */
export function offRestMetni(x) {
  const p = cakismaParcalari(x);
  return `${p.gunAy} ${offDonusumu(x.gece).etiket} (Md.4/ü): ${parcaAdi(x.gece)} was not free — `
    + `${p.ad} (actual) ${x.gece === 'once' ? 'ended' : 'reported'} ${p.lt} LT (${p.z}Z)${geceBoslukMetni(x)}`;
}

// Bir takvim ayı / yılı için boş gün özeti.
// offTypes: [{code, counts_as_recurrent_rest}] — hangi OFF alt tipi boş gün sayılır
// (kolon adı eski, anlamı Md.5'teki "boş gün"dür).
// BASELINE (4 Eki 2026, Serkan A — FTL adım 8, Md.5(1)(c)): baseline formunun OFF DAYS alanları (`off_days_month`,
//    `off_days_cal_year`) yazılıyordu ama HİÇ OKUNMUYORDU — 2026 yıllık sayımı yalnız 16 Tem sonrası OFF'larla 96'ya
//    karşılaştırılıyordu (canlı: AAK 101, SCL 109, SEL 99 tabanı görünmüyordu). Anlam öteki baseline toplamlarıyla AYNI:
//    taban, baseline TARİHİNİN BAŞINDAKİ değerdir — o günden önceki boş günler sayıdan, o gün ve sonrası kayıtlardan.
//    Baseline'dan önceki OFF kaydı sayılmaz (tabanın içindedir). Baseline ayında bloklar ve iki yarı ÖLÇÜLEMEZ (tabanda
//    yalnız sayı var, günler yok) → null. Baseline'dan tamamen önceki dönem ölçülemez (`oncesi`).
export function daysOffSummary(duties, rules, { year, month = null, tz = null, offTypes = null, baseline = null } = {}) {
  const cfg = rules?.days_off || {};
  const tabanTarih = baseline?.effective_date ? String(baseline.effective_date).slice(0, 10) : null;
  const ayGunu = month != null ? new Date(Date.UTC(year, month, 0)).getUTCDate() : null;
  const donemSonu = month != null ? `${year}-${String(month).padStart(2, '0')}-${String(ayGunu).padStart(2, '0')}` : `${year}-12-31`;
  const tabanli = !!tabanTarih && Number(tabanTarih.slice(0, 4)) === year
    && (month == null || Number(tabanTarih.slice(5, 7)) === month);
  const tabanAlan = month == null ? 'off_days_cal_year' : 'off_days_month';
  // Baseline dönemin İLK günündeyse (1 Ocak / ayın 1'i) öncesinde o döneme ait gün yoktur: taban 0'dır.
  const donemBasi = month != null ? `${year}-${String(month).padStart(2, '0')}-01` : `${year}-01-01`;
  const tabanSayi = !tabanli ? null
    : (baseline?.[tabanAlan] != null && Number.isFinite(Number(baseline[tabanAlan]))) ? Number(baseline[tabanAlan])
    : (tabanTarih === donemBasi ? 0 : null);
  const tabanEksik = tabanli && tabanSayi == null;
  const taban = tabanli ? { tarih: tabanTarih, sayi: tabanSayi } : null;
  const counts = (code) => {
    if (!offTypes || !code) return true;
    const t = offTypes.find(x => x.code === code);
    return t ? t.counts_as_recurrent_rest !== false : true;
  };
  const inPeriod = (dt) => {
    const [y, m] = dt.split('-').map(Number);
    return y === year && (month == null || m === month);
  };
  const offDates = [...new Set((duties || [])
    .filter(d => d.duty_type === 'off' && d.status !== 'cancelled' && d.duty_date
                 && inPeriod(d.duty_date) && counts(d.off_subtype) && (!tabanTarih || d.duty_date >= tabanTarih))
    .map(d => d.duty_date))].sort();

  const required = month != null
    ? (cfg.per_calendar_month_local_days ?? null)
    : (cfg.per_calendar_year_local_days ?? null);

  // 🔴 DILIM YOKSA SAYMAYIZ (21 Eyl 2026). `offDates` bir KAYITTIR — kac OFF
  //    girildigi dilimden bagimsiz bilinir ve dondurulur. `valid`/`count` ise
  //    bir OLCUMDUR: Md.4(u) iki YEREL GECE arar, yerel gece de bir dilim
  //    olmadan tanimsizdir. Ikisini ayirmak sart — eskiden dilimsizken makinenin
  //    yereliyle olculuyor ve ekranda gercek bir sayi gibi duruyordu.
  // Dönemin tamamı baseline'dan önceyse ya da baseline'ın o dönem sayısı yoksa: ölçülemez (uydurulmaz).
  const olcumsuz = (ek) => ({
    measured: false, offDates, valid: null, invalid: null, count: null, required,
    ok: null, blocks: null, blocksOf2: null, groupingOk: null,
    firstHalf: null, secondHalf: null, balancedOk: null, taban, ...ek,
  });
  if (tabanTarih && donemSonu < tabanTarih) return olcumsuz({ oncesi: true });
  if (!tz) return olcumsuz({});

  // Her boş gün KENDİ yerinin saatiyle (bosGunDilimi) — aynı güne birden çok OFF satırı varsa ilki.
  const offSatiri = new Map();
  (duties || []).forEach(d => {
    if (d.duty_type === 'off' && d.status !== 'cancelled' && d.duty_date && !offSatiri.has(d.duty_date)) offSatiri.set(d.duty_date, d);
  });
  const valid = offDates.filter(dt => isSingleDayOff(dt, duties, rules, bosGunDilimi(offSatiri.get(dt), tz))
    && !gecTeblig(offSatiri.get(dt), rules, bosGunDilimi(offSatiri.get(dt), tz))?.gec);   // Md.7(1)(c), 4 Eki 2026

  // ardışık blokları çıkar (2+2+1+1+1 kontrolü ve denge için)
  const blocks = [];
  for (const dt of valid) {
    const last = blocks[blocks.length - 1];
    if (last && shiftDate(last[last.length - 1], 1) === dt) last.push(dt);
    else blocks.push([dt]);
  }
  const half = (dt) => (Number(dt.slice(8, 10)) <= 15 ? 1 : 2);
  const firstHalf = valid.filter(d => half(d) === 1).length;
  const secondHalf = valid.length - firstHalf;
  // Md.5 gruplama: kural setinde yoksa ÖLÇÜLMEZ (groupingOk null) — 5 Eki 2026; eskiden `?? 0` kuralı sessizce düşürüyordu.
  const minBlocks2 = cfg.month_grouping_min_blocks_of_2 == null || !Number.isFinite(Number(cfg.month_grouping_min_blocks_of_2))
    ? null : Number(cfg.month_grouping_min_blocks_of_2);
  // Taban sayısı eksikse TOPLAM bilinmez (geçerli günlerin listesi yine ölçülür — ör. aralıktaki boş günler).
  const count = tabanEksik ? null : valid.length + (tabanSayi || 0);
  // Baseline ayında günler bilinmez: bloklar ve iki yarı ölçülmez.
  const gunlerBilinir = !(tabanli && month != null);
  return {
    measured: true,
    offDates, valid, invalid: offDates.filter(d => !valid.includes(d)),
    count, required,
    ok: required == null || count == null ? null : count >= required,
    blocks, blocksOf2: gunlerBilinir ? blocks.filter(b => b.length >= 2).length : null,
    groupingOk: month == null || !gunlerBilinir || minBlocks2 == null ? null : blocks.filter(b => b.length >= 2).length >= minBlocks2,
    firstHalf: gunlerBilinir ? firstHalf : null, secondHalf: gunlerBilinir ? secondHalf : null,
    balancedOk: month == null || !gunlerBilinir ? null : (firstHalf > 0 && secondHalf > 0),
    taban, tabanEksik,
  };
}

/** Boş gün sayısı neden ölçülemedi — ekranların TEK cümlesi (4 Eki 2026). Ölçüldüyse null. */
export function bosGunOlcumsuzNedeni(o) {
  if (!o) return null;
  if (o.oncesi) return 'BEFORE THE BASELINE DATE';
  if (!o.measured) return 'HOME BASE NOT SET';
  if (o.count == null && o.tabanEksik) return 'BASELINE HAS NO DAYS-OFF FIGURE';
  return null;
}
/** Tabanın payı — "incl. 101 before 16 JUL (baseline)"; taban yoksa boş. */
export const bosGunTabanMetni = (o) => (o?.taban?.sayi != null
  ? ` (incl. ${o.taban.sayi} before ${utcGunAy(`${o.taban.tarih}T12:00:00Z`)} — baseline)` : '');

// ── Md.5(1)(a) — 6 GÜNDE 1 TEK BOŞ GÜN: ARDIŞIK GÖREV SERİLERİ (1 Eki 2026) ──
//
// 🔑 Serkan (1 Eki 2026): kayıtsız gün boş gün DEĞİLDİR — *"a, tabi mevzuatta böyle zaten"*. Md.4(ü) tek boş günü
//    "önceden tebliğ edilen … tüm görevlerden ve nöbetten muaf" süre diye tanımlar; Md.7(1)(c) boş günü PLANLA ve
//    24 saat önce TEBLİĞ ET der. Aylık 7 gün sayımı (`daysOffSummary`) bunu zaten böyle sayıyordu.
// 🔴 ÖNCESİ: kapı kayıtsız günü DİNLENME sayıyordu (seri orada kırılıyordu) — aynı motorda bir yerde "kayıtsız gün
//    OFF değildir", başka yerde "OFF'tur" (tek kaynak ihlali). Kapı yalnız GERİYE bakıyordu: araya sokulan görevin
//    İLERİDEKİ seriyi uzattığını görmüyordu.
// ── SERİ — 3 Eki 2026, Serkan **A** (FTL adım 8, madde haritası Md.5(1)(a)) ──────────────────────────────────────────
// 🔑 Serkan: *"A olacak tabiki"* · *"tabi 7 off gün olmaz, boş demek off demek değildir"* · *"24 saat gelmeden off
//    girerim o görevsiz günlere"* · uyarı/engel sorusuna *"tamam a"*.
// Metin: "Biribirini takip eden 6 günü müteakip asgari 1 tek boş gün".
// KURAL: seri = takvimde ARDIŞIK görev günleri (OFF dışındaki her iptal edilmemiş kayıt — uçuş, DH, yer, NÖBET).
//    Görevsiz gün ardışıklığı bozar, seriyi KIRAR — ama boş gün DEĞİLDİR (aylık 7 / yıllık 96'ya girmez, 1 Eki kararı).
//    Seri sınıra (6) ulaşırsa ERTESİ GÜN girilmiş GEÇERLİ bir OFF olmalı (`altiGunSonrasiOff`): görevsiz bırakmak yetmez.
// 🔴 ÖNCESİ (1–3 Eki): kayıtsız gün seriyi ne kırıyor ne sayıyordu — takvimden atlanıyordu. SCL'nin 10 Eki uçuşu,
//    55 güne yayılmış 7 görev günü (10 Eki, 20 Eki, Kasım–4 Ara) "ardışık" sayılıp NOT LEGAL çıktı. "Kırmaz" kısmı
//    Serkan'ın kararı değildi, benim 1 Eki çıkarımımdı.
// GECE YARISINI GEÇEN GÖREV (4 Eki 2026, Serkan A: *"sayılsın, mevzuatta bunu söylüyor zaten"*): görevin değdiği HER UTC
//    günü görev günüdür — başladığı günden bittiği güne. Çizelge, roster, DUTY HISTORY ve seri aynı yardımcıyı kullanır.
export const gorevSonGunu = (d) => {
  if (!d || d.duty_type === 'off' || !d.duty_end) return d?.duty_date ?? null;
  const t = new Date(d.duty_end).toISOString().slice(0, 10);
  return t > d.duty_date ? t : d.duty_date;
};
export const gorevGunleri = (d) => {
  const out = [];
  for (let t = d.duty_date, son = gorevSonGunu(d); t && t <= son; t = shiftDate(t, 1)) out.push(t);
  return out;
};
export function gorevSerileri(duties, _rules, { extraBusy = [] } = {}) {
  const gunler = [...new Set([
    ...(duties || []).filter(d => d.duty_type !== 'off' && d.status !== 'cancelled' && d.duty_date).flatMap(gorevGunleri),
    ...(extraBusy || []).filter(Boolean),
  ])].sort();
  const seriler = [];
  let acik = null;
  for (const dt of gunler) {
    if (acik && shiftDate(acik.son, 1) === dt) { acik.son = dt; acik.gun++; continue; }
    acik = { bas: dt, son: dt, gun: 1 };
    seriler.push(acik);
  }
  return { seriler };
}

// ── 6 GÜNDEN SONRAKİ GÜN — Md.5(1)(a) + Md.7(1)(c) (3 Eki 2026, Serkan A: önce UYARI, süre dolunca NOT LEGAL) ──────
// Uzunluğu TAM sınır (6) olan her serinin ertesi günü girilmiş GEÇERLİ bir OFF olmalı: sayılan OFF türü, iki yerel
//    gecesi boş (Md.4(ü)), en az `notice_hours` önce tebliğ (Md.7(1)(c)). Son an = o günün yerel 00:00'ı − tebliğ süresi.
// Dönüş: [{ seri, gun, off, durum, sonAnISO, saat }] — durum:
//    'var'        geçerli OFF girilmiş
//    'bekliyor'   yok (ya da geçersiz), son an gelmedi → UYARI: planlamacı OFF'u girer
//    'gecti'      yok (ya da geçersiz), son an geçti → NOT LEGAL
//    'olculemedi' ana üs dilimi ya da tebliğ süresi yok — son an hesaplanamaz (sayı koddan uydurulmaz)
// Sınırı aşan seri (7+) burada değil, kapıda doğrudan ihlaldir.
export function altiGunSonrasiOff(duties, rules, { tz = null, offTypes = null, simdi = Date.now(), extraBusy = [] } = {}) {
  const sinir = rules?.days_off?.single_day_off_after_consecutive_days;
  if (sinir == null) return [];
  const saat = rules?.days_off?.notice_hours;
  const sayilir = (kod) => {
    if (!offTypes || !kod) return true;
    const t = offTypes.find(x => x.code === kod);
    return t ? t.counts_as_recurrent_rest !== false : true;
  };
  const anMs = new Date(simdi).getTime();
  return gorevSerileri(duties, rules, { extraBusy }).seriler.filter(x => x.gun === sinir).map(seri => {
    const gun = shiftDate(seri.son, 1);
    const off = (duties || []).find(d => d.duty_type === 'off' && d.status !== 'cancelled' && d.duty_date === gun) || null;
    const geceGun = !!off && sayilir(off.off_subtype) && isSingleDayOff(gun, duties, rules, bosGunDilimi(off, tz)) !== false;
    const tg = geceGun ? gecTeblig(off, rules, bosGunDilimi(off, tz)) : null;                 // Md.7(1)(c), 4 Eki 2026
    const teblig = tg?.gec ? tg : null;
    if (geceGun && !teblig) return { seri, gun, off, sayilir: true, durum: 'var', sonAnISO: null, saat };
    const say = !!off && sayilir(off.off_subtype);
    const gunBasi = tz ? zonedISO(gun, '00:00', tz) : null;
    if (!gunBasi || !Number.isFinite(Number(saat))) return { seri, gun, off, sayilir: say, teblig, durum: 'olculemedi', sonAnISO: null, saat };
    const sonAnISO = new Date(new Date(gunBasi).getTime() - Number(saat) * 3600000).toISOString();
    return { seri, gun, off, sayilir: say, teblig, durum: anMs < new Date(sonAnISO).getTime() ? 'bekliyor' : 'gecti', sonAnISO, saat };
  });
}

/** Kapının ve görev durumunun cümlesi (tek kaynak). Son an UTC yazılır (yerel saat günü karıştırır: 00:00 LT hangi gün?). */
export function altiGunMetni(x) {
  const gun = utcGunAy(`${x.gun}T12:00:00Z`);
  const aralik = `${utcGunAy(`${x.seri.bas}T12:00:00Z`)}–${utcGunAy(`${x.seri.son}T12:00:00Z`)}`;
  const neden = !x.off ? `nothing is entered on ${gun} — a day with no duty is not a day off`
    : !x.sayilir ? `${gun} is entered as ${x.off.off_subtype || 'OFF'}, which does not count as a day off`
    : x.teblig ? `the OFF on ${gun} was ${gecTebligMetni(x.teblig)}`
    : `the OFF entered on ${gun} is not a valid day off — a local night is not free (Md.4(ü))`;
  const bas = `after ${x.seri.gun} consecutive duty days (${aralik}); ${neden}.`;
  const ref = '(SHT-FTL/HG Md.5(1)(a), Md.7(1)(c))';
  if (x.durum === 'olculemedi') {
    return `${gun} MUST BE A DAY OFF ${bas} The notice deadline cannot be computed — the home base time zone or the rule `
      + `set's notice hours are unknown ${ref}`;
  }
  const son = utcGunAySaat(x.sonAnISO, { z: true });
  if (x.durum === 'gecti') return `${gun} IS NOT A DAY OFF ${bas} The ${x.saat} h notice ended ${son} ${ref}`;
  return `${gun} MUST BE A DAY OFF ${bas} Enter the OFF before ${son} — ${x.saat} h before ${gun} begins at the home base ${ref}`;
}

// ── SERİ SEBEPLERİ — GÖREV DURUMU (Md.5(1)(a), 3 Eki 2026, Serkan A · 2. adım: *"başla"*) ────────────────────────
// Kapı yalnız ATAMA anını görür. Sonradan oluşan durumu görev KAYDI söyler (roster rozeti, duty sheet notu, FTL STATUS):
//   · seride 7. (ve sonraki) görev günü → NOT LEGAL 'consecutive_days' (ör. plansız uçuş, iptal edilen OFF)
//   · tam 6 günlük serinin SON görevi: ertesi gün geçerli OFF yok VE tebliğ süresi geçti → NOT LEGAL 'day_off_after_6'
//     (zamanla değişir — gece taraması yakalar); süre ölçülemiyor VE gün geldi → CANNOT VERIFY 'day_off_notice_unmeasured'
//   · süre henüz dolmadıysa durum DEĞİŞMEZ — uyarı kapıda (Serkan A).
// Sınır ve tebliğ süresi görevin KENDİ kural seti kopyasından. tz: pilotun ana üs dilimi.
// @returns Map<dutyId, gerekce[]>
const SERI_TURLERI = new Set(['consecutive_days', 'day_off_after_6', 'day_off_notice_unmeasured']);
export function seriSebepleri(satirlar, { tz = null, offTypes = null, simdi = Date.now() } = {}) {
  const out = new Map();
  const ekle = (d, g) => { if (d?.id) out.set(d.id, [...(out.get(d.id) || []), g]); };
  const gorevler = (satirlar || []).filter(d => d.duty_type !== 'off' && d.status !== 'cancelled' && d.duty_date);
  const kurallarOf = (d) => (d?.ruleset_snapshot?.regulation ? effectiveRules(d.ruleset_snapshot).rules : null);
  const bugun = new Date(simdi).toISOString().slice(0, 10);
  const ref = 'SHT-FTL/HG Md.5(1)(a)';
  for (const seri of gorevSerileri(satirlar, null).seriler) {
    const icinde = gorevler.filter(d => d.duty_date >= seri.bas && d.duty_date <= seri.son);
    // 7. ve sonraki gün — her görev kendi kural setinin sınırıyla
    icinde.forEach(d => {
      const n = kurallarOf(d)?.days_off?.single_day_off_after_consecutive_days;
      if (n == null) return;
      const sira = Math.round((Date.parse(`${d.duty_date}T00:00:00Z`) - Date.parse(`${seri.bas}T00:00:00Z`)) / 86400000) + 1;
      if (sira <= n) return;
      ekle(d, { tur: 'consecutive_days', durum: FTL_DURUM.NOT_LEGAL, ref,
        metin: `DUTY DAY ${sira} IN A ROW (${utcGunAy(`${seri.bas}T12:00:00Z`)}–${utcGunAy(`${d.duty_date}T12:00:00Z`)}) — `
          + `a single day off is required after ${n} (SHT-FTL/HG Md.5(1)(a))` });
    });
    // tam sınır uzunluğundaki serinin ertesi günü
    const sonGorevler = icinde.filter(d => d.duty_date === seri.son);
    const kurallar = kurallarOf(sonGorevler[0]);
    if (!kurallar || seri.gun !== kurallar.days_off?.single_day_off_after_consecutive_days) continue;
    const x = altiGunSonrasiOff(satirlar, kurallar, { tz, offTypes, simdi }).find(y => y.seri.son === seri.son);
    if (!x || x.durum === 'var' || x.durum === 'bekliyor') continue;
    if (x.durum === 'olculemedi' && x.gun > bugun) continue;
    const g = x.durum === 'gecti'
      ? { tur: 'day_off_after_6', durum: FTL_DURUM.NOT_LEGAL, ref, metin: altiGunMetni(x) }
      : { tur: 'day_off_notice_unmeasured', durum: FTL_DURUM.CANNOT_VERIFY, ref, metin: altiGunMetni(x) };
    sonGorevler.forEach(d => ekle(d, g));
  }
  return out;
}

// ── AYLIK OFF GÖSTERGESİ — FTL LIMITS ÇUBUĞU (1 Eki 2026) ──────────────
// 🔑 Serkan (1 Eki 2026): *"OFF çizelgesini tamamlayalım, bi bitsin"* · 2+2+1+1+1 ve ay yarıları ayın 15'ine kadar
//    renksiz, 15'inden sonra tutmuyorsa SARI (*"a"*) · kayıtsız gün boş gün değil (*"a"*).
//    Korunan eski kararlar: aylık sayaç KIRMIZI yalnız ay matematiksel olarak dolamazsa (4 Eyl) · yıllık satır
//    renksiz (17 Ağu — bu fonksiyon onu üretmez).
// Hesap BURADA, çubuk yalnız çizer (Ilke 3): sayılar `monthlyOffFeasibility` ve `gorevSerileri`nden — atama
//    kapısının kullandığı fonksiyonların AYNISI.
export function aylikOffGostergesi(duties, rules, { asOf = new Date(), tz = null, offTypes = null, baseline = null } = {}) {
  const bugun = new Date(asOf).toISOString().slice(0, 10);
  const [yil, ay] = bugun.split('-').map(Number);
  const f = monthlyOffFeasibility(duties, rules, { year: yil, month: ay, tz, offTypes, asOf, baseline });
  const faz = daysOffPhase(bugun) !== null;                        // 15'i ve sonrası
  const sinir = rules?.days_off?.single_day_off_after_consecutive_days ?? null;
  const ileri = gorevSerileri(duties, rules).seriler.filter(r => r.son >= bugun);
  const seri = ileri.reduce((en, r) => (!en || r.gun > en.gun ? r : en), null);
  return {
    ay: utcGunAy(bugun).slice(3), measured: f.measured,          // ay adı tek kaynaktan (utcTarih.js)
    sayi: f.count, gereken: f.required,
    renkAy: f.reachable === false ? 'red' : null,
    ikili: f.blocksOf2, ikiliGereken: rules?.days_off?.month_grouping_min_blocks_of_2 ?? null,
    renkIkili: faz && f.groupingOk === false ? 'amber' : null,
    yari1: f.firstHalf, yari2: f.secondHalf, ayGunu: AY_GUNU(yil, ay),
    renkYari: faz && f.balancedOk === false ? 'amber' : null,
    seri, sinir,
    renkSeri: seri && sinir != null && seri.gun > sinir ? 'red' : null,
  };
}

// ── AY DOLDURULABİLİR Mİ (4 Eyl 2026, Serkan) ───────────────────────
//
// 🔑 Serkan: *"Rostering yapıldığında ve güncelleme yaptığında uyarı vermesi
//    lazım — assign ederken."* · *"Eksik OFF girildi 1 ay içinde uyarı verecek
//    mi?"*
//
// 🔴 ÖLÇÜLDÜ (4 Eyl 2026): `daysOffSummary` atama ekranında hesaplanıyordu ama
//    sonucu HİÇ OKUNMUYORDU (dosyada `.off.` erişimi = 0). Yani ay 0/7 iken
//    sistem tek kelime etmiyordu. Uyarı ancak var olan bir OFF'un ÜSTÜNE görev
//    verilince çıkıyordu; ay baştan eksik planlanırsa sessizdi.
//
// ⚠️ BOŞ BIRAKILMIŞ GÜN, BOŞ GÜN DEĞİLDİR. Md.4/ü: *"Tek boş gün: ÖNCEDEN
//    TEBLİĞ EDİLEN, bir yerel günden ve iki yerel geceden oluşan, tüm
//    görevlerden ve nöbet görevinden muaf olunan süre"*; Md.7(1)(c):
//    *"Boş günler PLANLANACAK ve ekip üyelerine asgari 24 saat önceden tebliğ
//    edilecektir."* Planlama bir EYLEMDİR — atama yokluğu planlama sayılmaz.
//    Roster'da 20 boş gün varsa bu 0/7'dir, 20/7 değil.
//
// 🔑 EŞİK KARARI (Serkan onayı, 4 Eyl): kırmızı YALNIZ ay artık
//    MATEMATİKSEL OLARAK doldurulamaz hale gelince yanar. Sayaç her zaman
//    görünür ama ayın 3'ünde 0/7 diye kimseyi kırmızı yakmayız — yanlış alarm
//    uyarıyı öldürür (17 Ağu'daki "OFF satırı renklendirilmez" kararının
//    sebebi de buydu).
//
// Aday gün sayımı BİLEREK İYİMSERDİR: bir günü aday saymak için yalnız
// "görev yok" yeter, iki yerel gecesinin gerçekten boş kalacağı aranmaz.
// Çünkü bu sayı bir ENGEL üretiyor: iyimser sayı bile yetmiyorsa ay KESİN
// dolmaz. Kötümser saysaydık, dolabilecek bir ayı dolmaz ilan ederdik.
const AY_GUNU = (y, m) => new Date(Date.UTC(y, m, 0)).getUTCDate();

export function monthlyOffFeasibility(duties, rules, {
  year, month, tz = null, offTypes = null, asOf = null, excludeId = null,
  extraBusy = [], baseline = null,
} = {}) {
  const gozetilen = (duties || []).filter(d => !excludeId || d.id !== excludeId);
  const ozet = daysOffSummary(gozetilen, rules, { year, month, tz, offTypes, baseline });
  // Dilim yoksa aday gun de sayilmaz: adaylik "gun bos mu"dan ibaret degil,
  // olculen bos gun sayisiyla karsilastirilir — biri yoksa oran anlamsizdir.
  if (!ozet.measured || ozet.required == null) {
    return { ...ozet, candidates: null, reachable: null, shortBy: null };
  }

  // Md.7(1)(c): 24 saatten yakın bir gün artık BOŞ GÜN YAPILAMAZ — tebliğ
  // süresi geçmiştir. Geçmiş günler de geriye dönük boş güne çevrilemez.
  //
  // ⚠️ Ölçü GÜNÜN BAŞLANGICIDIR, tarih dizgesi değil. Tarihleri karşılaştırmak
  // bir gün kaydırıyordu: ayın 28'inde saat 12:00'de dururken 29'u aday
  // sayıyordu, oysa 29 yalnız 12 saat ötede — tebliğ penceresi çoktan geçmiş.
  // ⚠️ Sure KODA GOMULMEZ (Ilke 6): `days_off.notice_hours` ruleset'te durur
  // ve RULE SET ekraninda gorunur. Ilk yazimda 24 sabitini gomdum — ruleset
  // degisse ekran bir sey, motor baska sey soylerdi.
  // 5 Eki 2026: kural setinde yoksa (ya da sayı değilse) aday gün ÖLÇÜLMEZ — eskiden `?? 24` sessizce varsayılıyordu.
  const tebligSaat = rules?.days_off?.notice_hours == null ? NaN : Number(rules.days_off.notice_hours);
  if (!Number.isFinite(tebligSaat)) {
    return { ...ozet, candidates: null, reachable: null, shortBy: null, kuralEksik: 'days_off.notice_hours' };
  }
  const teblig = tebligSaat * 3600000;
  const simdi = asOf ? new Date(asOf).getTime() : Date.now();
  const enErkenMs = simdi + teblig;
  // Dilim buraya kadar geldiyse KESIN var (`ozet.measured`). Eskiden burada
  // ikinci bir yedek kural vardi (`...T00:00:00Z` = UTC) ve `zonedISO`'nunki
  // makine yereliydi — TEK fonksiyonun icinde iki farkli yedek (Ilke 3).
  const gunBasi = (dt) => new Date(zonedISO(dt, '00:00', tz)).getTime();

  // `extraBusy`: henuz kaydedilmemis gorevin gunu. Atanan gun artik aday
  // degildir — son bos gunu doldurmak uyariyi TETIKLEMELI, tetiklemezse
  // uyari her zaman bir gorev gec kalir.
  const dolu = new Set([
    ...gozetilen
      .filter(d => d.duty_type !== 'off' && d.status !== 'cancelled' && d.duty_date)
      .map(d => d.duty_date),
    ...(extraBusy || []).filter(Boolean),
  ]);
  const zatenOff = new Set(ozet.offDates);

  let aday = 0;
  for (let g = 1; g <= AY_GUNU(year, month); g++) {
    const dt = `${year}-${String(month).padStart(2, '0')}-${String(g).padStart(2, '0')}`;
    if (gunBasi(dt) < enErkenMs) continue;
    if (dolu.has(dt) || zatenOff.has(dt)) continue;
    aday++;
  }

  const eksik = Math.max(0, ozet.required - ozet.count);
  return { ...ozet, candidates: aday, reachable: aday >= eksik, shortBy: eksik,
           daysInMonth: AY_GUNU(year, month) };
}

/**
 * Md.5(3) DENGE ve Md.5(4) GRUPLAMA ne zaman konussun?
 *
 * 🔑 Serkan (4 Eyl 2026): *"15. gunde, bir de son haftada ciksin — son haftaya
 *    birakirsak ops kilitlenir."*  Yani uyari, duzeltecek gun kalmisken gelmeli.
 *
 * ⚠️ Bu iki kural AYIN BASINDA DOGAL OLARAK EKSIK gorunur: 3'unde 2+2+1+1+1
 *    tutmuyor demek bilgi degil gurultudur (aylik sayacta da ayni tuzak vardi).
 *    Bu yuzden olcu, ATANAN GOREVIN AYIN KACINDA oldugudur: planlayici ayin
 *    ikinci yarisini doldurmaya basladiginda konusur ve son haftada susmaz.
 *
 * Donen `phase`: null (sessiz) · 'mid' (15 → son haftadan once) · 'final'.
 */
export function daysOffPhase(dutyDate) {
  if (!dutyDate) return null;
  const [y, m, d] = String(dutyDate).split('-').map(Number);
  if (!y || !m || !d) return null;
  const sonHaftaBasi = AY_GUNU(y, m) - 6;        // son 7 gun
  if (d >= sonHaftaBasi) return 'final';
  if (d >= 15) return 'mid';
  return null;
}

// ── BOŞ GÜNE GÖREV VERİLEBİLİR Mİ (8 Ağu 2026, Serkan) ──────────────
// ⚠️ REST İLE OFF AYRI ŞEYLERDİR (Serkan, 8 Ağu: "mecburi dinlenmeler OFF
//    değil REST olur"). Mecburi dinlenme bir crew_duties satırı DEĞİLDİR;
//    önceki görevin `earliest_next_report`undan TÜREİR ve `fitness()` içinde
//    zorlanır — orada OFF satırları bilerek filtrelenir. Bu fonksiyon o kulvara
//    HİÇ karışmaz; yalnız Md.5 BOŞ GÜN asgarilerine bakar.
//
// "Regülatif bir OFF'a görev verilemez, uyarı vermeli. Sistem ruleset'e göre
//  arka planda takip yapar."  Kural KODA GÖMÜLMEZ: hangi OFF tipinin boş gün
//  saydığı `ftl_off_types.counts_as_recurrent_rest`ten, asgariler
//  `rules.days_off`tan gelir.
//
// KRİTİK İNCELİK (Serkan'ın örneği: "off tutan pilota öğleden sonra uçuş
// verilebilir"): boş gün İKİ YEREL GECE PENCERESİYLE tanımlıdır
// (önceki 22:00→08:00 ve o gün 22:00→ertesi 08:00). Öğleden sonraki bir görev
// bu pencerelere DEĞMEZ — gün boş gün olarak DURUR, kayıp yoktur. Bu yüzden
// "OFF günü = dokunulmaz" demek yanlış olurdu; ölçü GÜN değil, ÇAKIŞMA.
//
// Dönüş: { isOffDay, keepsDayOff, allowed, breaks[], before, after }
//   breaks: 'monthly_minimum' | 'monthly_grouping' | 'monthly_balance' | 'yearly_minimum'
// ── "OFF TO DUTY" (4 Eyl 2026, Serkan) ──────────────────────────────
//
// 🔑 Serkan: *"OFF to duty yazması gerekir — kanunen görev verilebilirse,
//    rest bölmüyorsa mesela, OFF TO DUTY olur, remark olarak."*
//
// 🔴 SAHA (SCL, 3 Eyl 2026): aynı güne hem OFF hem yer dersi kayıtlı. Bakan
//    kişi "mükerrer kayıt" sanıyor. Oysa mevzuata göre boş gün AYAKTA:
//    LTAC UTC+3, ders 06:30–14:30 UTC = yerel 09:30–17:30, yerel gece
//    pencerelerine (22:00–08:00) değmiyor. Md.4/ü'nün ölçüsü GÜN değil
//    ÇAKIŞMA — Serkan'ın 8 Ağu kuralı: *"off tutan pilota öğleden sonra uçuş
//    verilebilir."*  Eksik olan kural değil, kaydın KENDİNİ ANLATMASIYDI.
//
// ⚠️ TÜRETİLİR, SAKLANMAZ: görevin saatleri değişince damga bayatlardı
//    (27 Ağu'daki "takılı kalan dinlenme" dersinin aynısı). Ölçü her seferinde
//    `isSingleDayOff`ten geçer — tek kaynak (İlke 3).
export function offToDuty(duties, pilotId, offDate, rules, { offTypes = null, tz = null } = {}) {
  const mine = (duties || []).filter(d => !pilotId || d.pilot_id === pilotId);
  const offRow = mine.find(d => d.duty_type === 'off' && d.status !== 'cancelled'
                                && d.duty_date === offDate);
  if (!offRow) return null;

  const gorev = mine.filter(d => d.duty_type !== 'off' && d.status !== 'cancelled'
                                 && d.duty_date === offDate);
  if (!gorev.length) return null;              // sade boş gün — remark yok

  // Bos gun ayakta mi? Kaydin kendisi burada iki farkli sey soyler.
  // `standing` UC degerlidir: true (ayakta) · false (dustu) · null (olculemedi
  // — ana us dilimi yok). Ucuncusu bir cevap degil, bir EKSIK KAYIT isaretidir.
  const standing = isSingleDayOff(offDate, mine, rules, bosGunDilimi(offRow, tz));
  // gec: OFF 24 saatten geç girilmiş mi (gösterim: o gün zaten REST'tir, üstündeki görev not almaz — 13 Eki 2026).
  return { offDate, duties: gorev.length, standing, measured: standing !== null,
           subtype: offRow.off_subtype || null, gec: !!gecTeblig(offRow, rules, bosGunDilimi(offRow, tz))?.gec };
}

export function offDayRelease(duties, pilotId, offDate, newDuty, rules,
                              { offTypes = null, tz = null, baseline = null } = {}) {
  const mine = (duties || []).filter(d => !pilotId || d.pilot_id === pilotId);
  const offRow = mine.find(d => d.duty_type === 'off' && d.status !== 'cancelled'
                                && d.duty_date === offDate);
  if (!offRow) return { isOffDay: false, keepsDayOff: true, allowed: true, breaks: [] };

  // Bu alt tip boş gün saymıyorsa (ruleset diyor) asgarileri beslemiyordur;
  // kaldırmak bir asgariyi bozamaz.
  const countsAsDayOff = (() => {
    if (!offTypes || !offRow.off_subtype) return true;
    const t = offTypes.find(x => x.code === offRow.off_subtype);
    return t ? t.counts_as_recurrent_rest !== false : true;
  })();
  if (!countsAsDayOff) {
    return { isOffDay: true, keepsDayOff: true, allowed: true, breaks: [], measured: true,
             note: `${offRow.off_subtype} does not count as a day off in this ruleset` };
  }

  // Görev gece pencerelerine değiyor mu? TEK KAYNAK: isSingleDayOff.
  const withNew = [...mine, { ...newDuty, duty_type: newDuty.duty_type || 'flight',
                              status: newDuty.status || 'planned' }];
  const keepsDayOff = isSingleDayOff(offDate, withNew, rules, bosGunDilimi(offRow, tz));
  // ⚠️ OLCULEMEDIYSE ENGELLEMEYIZ. Ana us dilimi yokken "bos gunu dusurdun"
  //    demek UYDURMA bir engel olurdu; yanlis alarm uyariyi oldurur (Ilke 1).
  //    Atama gecer, ama durum `measured:false` olarak yukari cikar ve ekran
  //    eksik ana ussu soyler — sessiz gecmez.
  if (keepsDayOff === null) {
    return { isOffDay: true, keepsDayOff: null, allowed: true, breaks: [], measured: false };
  }
  if (keepsDayOff) {
    return { isOffDay: true, keepsDayOff: true, allowed: true, breaks: [], measured: true };
  }

  // Gün düşüyor — asgariler hâlâ tutuyor mu?
  const [year, month] = offDate.split('-').map(Number);
  const opts = { tz, offTypes, baseline };
  const before = {
    month: daysOffSummary(mine, rules, { year, month, ...opts }),
    year:  daysOffSummary(mine, rules, { year, ...opts }),
  };
  const after = {
    month: daysOffSummary(withNew, rules, { year, month, ...opts }),
    year:  daysOffSummary(withNew, rules, { year, ...opts }),
  };

  const breaks = [];
  const lost = (b, a) => b === true && a === false;      // yalnız SAĞLAMDAN bozuğa
  if (lost(before.month.ok, after.month.ok)) breaks.push('monthly_minimum');
  if (lost(before.month.groupingOk, after.month.groupingOk)) breaks.push('monthly_grouping');
  if (lost(before.month.balancedOk, after.month.balancedOk)) breaks.push('monthly_balance');
  if (lost(before.year.ok, after.year.ok)) breaks.push('yearly_minimum');

  return { isOffDay: true, keepsDayOff: false, allowed: breaks.length === 0,
           breaks, before, after, measured: true };
}

// ── OFF PERİYODUNDA GÜN BAŞINA STATUS (8 Ağu, Serkan) ───────────────
// "10 günlük bir OFF'un ilk 2 günü regülasyondan geliyorsa actual olabilir,
//  diğerleri gerçekleştiği gün tek tek actual olsun. AVAC girilmişse ilgili
//  periyotta actual olabilir — ama yine edit'lenebilir."
//
// ⚠️ TEK SAYI KAYNAĞI SORUNU: regülasyonun istediği ardışık blok boyutu (2)
//    ruleset'te DEĞER olarak yok; yalnız `month_grouping_min_blocks_of_2`
//    anahtarının ADINDA gömülü. Burada `regBlockDays` parametresi olarak
//    dışarı alındı ve varsayılanı 2. Başka bir otoritenin bloğu 2 değilse o
//    anahtar genelleştirilmeli — o güne kadar bu tek yerden değiştirilir.
//
// grantedLeave: `ftl_off_types.granted_leave` — VERİLMİŞ İZİN (AVAC/UVAC/MEDC)
//    dinlenme değildir; taahhüt edildiği için tüm periyot actual yazılır.
export function offPeriodStatuses(dates, { grantedLeave = false, today = null,
                                           regBlockDays = 2 } = {}) {
  const sorted = [...new Set((dates || []).filter(Boolean))].sort();
  const out = {};
  if (grantedLeave) { sorted.forEach(d => { out[d] = 'actual'; }); return out; }
  sorted.forEach((d, i) => {
    if (i < regBlockDays) { out[d] = 'actual'; return; }   // regülasyonun istediği blok
    out[d] = (today && d <= today) ? 'actual' : 'planned'; // geri kalanı günü gelince
  });
  return out;
}

/** offDayRelease sonucunun insan okur karşılığı — panel ve sihirbaz AYNI metni
 *  göstersin diye burada (Ilke 2). */
export function offDayReleaseText(r) {
  if (!r || !r.isOffDay) return null;
  if (r.note) return r.note;
  if (r.keepsDayOff) return 'DAY OFF PRESERVED — duty does not touch the local night windows';
  const map = {
    monthly_minimum:  `monthly days off would fall to ${r.after?.month?.count} (required ${r.after?.month?.required})`,
    monthly_grouping: 'monthly grouping rule (blocks of 2) would be broken',
    monthly_balance:  'both halves of the month must contain a day off',
    yearly_minimum:   `yearly days off would fall to ${r.after?.year?.count} (required ${r.after?.year?.required})`,
  };
  if (!r.breaks.length) return 'DAY OFF WOULD BE LOST — minimums still met';
  return `BLOCKED — ${r.breaks.map(b => map[b] || b).join(' · ')}`;
}

// ── GÖREVİN BOZDUĞU BOŞ GÜNLER — AYNI GÜN VE KOMŞU GÜNLER (1 Eki 2026) ──
// 🔑 Serkan (1 Eki 2026): gece yarısını geçen görev ERTESİ günün, yerel 08:00'den önce başlayan görev ÖNCEKİ
//    günün OFF'unu bozar (SCL 21→22 Eyl). Kural 8 Ağu'nun aynısı — `offDayRelease`: regülatif OFF (kaybı asgariyi
//    bozan) ENGELLER; değilse görünür UYARI — *"A iyi, planlamacı A tasarımında uyarıyı görür ve o günü REST
//    olarak edit eder"* · *"uygun method bu bence"*.
// 🔴 ÖNCESİ: yalnız görevle AYNI tarihteki OFF'a bakılıyordu ve bu kontrol ASSIGN'a özeldi — `fitness`in dışında
//    durduğu için uçuş EDIT'i ve yer görevi EDIT'i OFF'a hiç bakmıyordu. Asgari tutunca OFF SESSİZCE kayboluyordu.
// gorev: { report_time, duty_end, duty_type? } · Dönüş: [{ tarih, r }] — yalnız OFF'u kaybedenler (r = offDayRelease).
export function gorevinBozduguOfflar(duties, pilotId, gorev, rules, { offTypes = null, tz = null, baseline = null } = {}) {
  if (!gorev?.report_time || !gorev?.duty_end) return [];
  const bas = new Date(gorev.report_time).toISOString().slice(0, 10);
  const son = new Date(gorev.duty_end).toISOString().slice(0, 10);
  const out = [];
  for (let dt = shiftDate(bas, -1); dt <= shiftDate(son, 1); dt = shiftDate(dt, 1)) {
    const r = offDayRelease(duties, pilotId, dt, gorev, rules, { offTypes, tz, baseline });
    if (r.isOffDay && r.keepsDayOff === false) out.push({ tarih: dt, r });
  }
  return out;
}

/** Bozulan OFF'un cümlesi — engel (regülatif) ya da uyarı (asgari tutuyor). ASSIGN ve EDIT AYNI metin. */
export function bozulanOffMetni({ tarih, r }) {
  const gun = utcGunAy(`${tarih}T12:00:00Z`);
  if (!r.allowed) return `DAY OFF ${gun} (Md.5) — ${offDayReleaseText(r)}`;
  const a = r.after?.month;
  return `DAY OFF ${gun} WILL BE LOST (Md.4/ü) — its day or a local night is no longer free; minimums still met`
    + `${a && a.required != null ? ` (${a.count} / ${a.required} this month)` : ''} — edit that day as REST`;
}

// ── Nöbet (SHT-FTL/HG Md.17) ────────────────────────────────────────
// HAVAALANI NÖBETİ (Md.17/1): tamamı görev süresidir; azami UGS, nöbette
//   geçen 4 saatin ÜZERİNDEKİ süre kadar kısalır; nöbet + tahsis edilen UGS
//   birleşik süresi 16 saati aşamaz.
// HAVAALANI HARİCİ NÖBET (Md.17/2): azami 16 saat; süresinin %25'i görev
//   sayılır; nöbet ilk 6 saatten SONRA biterse azami UGS aşan süre kadar
//   kısalır (UGS uçuş içi dinlenme veya açık mesai ile uzatıldıysa 6 → 8 saat);
//   görev verilmezse asgari 8 saat dinlenme gelir.
/** Nöbet türlerinin kural setinde ZORUNLU alanları (5 Eki 2026, Md.17 ③) — biri yoksa etki ölçülemez. */
export const NOBET_ALANLARI = {
  airport: ['fdp_reduction_after_min', 'duty_credit_ratio', 'standby_plus_fdp_cap_min'],
  other: ['max_min', 'duty_credit_ratio', 'fdp_reduction_after_min', 'fdp_reduction_after_min_if_extended_fdp',
          'rest_after_no_duty_min'],
};
const NOBET_BLOGU = { airport_standby: 'airport', other_standby: 'other' };
/** Nöbetin görev süresine sayılan oranı — Md.17(1)(b) havaalanı, (2)(g) harici; YALNIZ kural setinden, yoksa `null`. */
export function nobetGorevOrani(kind, rules) {
  const blok = NOBET_BLOGU[kind];
  const v = blok ? rules?.standby?.[blok]?.duty_credit_ratio : null;
  return v == null || !Number.isFinite(Number(v)) ? null : Number(v);
}
/** Pilotun görevlerinde nöbet varsa ve kural seti o türün oranını tanımlamıyorsa eksik alanlar (kümülatif ölçülemez). */
export function kumulatifNobetOraniEksik(rules, gorevler) {
  const turler = new Set((gorevler || []).filter(d => d && d.duty_type === 'ground' && d.status !== 'cancelled'
    && NOBET_BLOGU[d.ground_kind]).map(d => d.ground_kind));
  return [...turler].filter(k => nobetGorevOrani(k, rules) == null).map(k => `standby.${NOBET_BLOGU[k]}.duty_credit_ratio`);
}
export const nobetOraniEksikMetni = (alanlar) => `RULE SET: ${alanlar.join(' / ')} missing — standby cannot be counted in `
  + 'the duty-time totals (Md.17(1)(b), (2)(g))';
export function standbyEffect(standbyDuty, rules, opts = {}) {
  if (!standbyDuty || standbyDuty.duty_type !== 'ground') return null;
  const kind = standbyDuty.ground_kind;
  // RULESET NÖBET TANIMLAMIYORSA SAYIYI KODDAN UYDURMA (İlke 1 + "değerler koda
  // GÖMÜLMEZ" temel kuralı). Eski SHT-FTL Rev02 şemasında `standby` bloğu YOK;
  // `?? 240` gibi yedekler sessizce Türk HG rakamlarını uygular ve başka bir
  // regülasyondaki müşteriye yanlış limit dayatır. Hesaplayamıyorsak SÖYLERİZ.
  if (!rules?.standby) {
    return { kind, reference: 'Md.17', unavailable: true, standbyMin: null,
             fdpReductionMin: 0, dutyCreditMin: 0, invalid: false, maxExceeded: false };
  }
  const sb = rules.standby;
  if (!standbyDuty.report_time || !standbyDuty.duty_end) return null;
  // ÇAĞRI (5 Eki 2026, Serkan A — şartlar tek tek metinle): nöbet UGS BAŞLAYINCA biter — ev nöbetinde (2)(c) metin;
  // havaalanında bildirilen bitişle UGS arasındaki süre de nöbete sayılır (güvenli taraf). `opts.cagriISO` = UGS başlangıcı.
  const son = opts.cagriISO || standbyDuty.duty_end;
  const raw = (new Date(son) - new Date(standbyDuty.report_time)) / 60000;
  // BOZUK VERI SESSIZCE "ZARARSIZ" GORUNMESIN (kuru kosuda yakalandi, 6 Agu):
  // bitis baslangictan onceyse (gece yarisini gecen nobette yanlis tarih) fark
  // NEGATIF cikar. Sifira kirpmak, 17 SAATLIK bir nobeti "0 dk, etkisi yok,
  // gecerli" diye gostermek demektir — azami sure kontrolu de sessizce gecer.
  // Paneldeki kayit yolu nextDay() ile dogru tarihi yaziyor, yani bu veri
  // saha tarafindan uretilmiyor; ama motor VERIYE GUVENMEZ, isaretler.
  const invalid = !(raw > 0);
  const mins = Math.max(0, raw);

  // 5 Eki 2026 (Md.17 ③): her sayı YALNIZ kural setinden — eskiden 240 / 1 / 960 ve 360 / 480 / 960 / 0.25 / 480 koddan
  // yedekti. Türün bir alanı eksikse etki ÖLÇÜLEMEZ (`unavailable` + `eksikAlan`); `standbyLimits` adıyla söyler.
  const blok = kind === 'airport_standby' ? 'airport' : kind === 'other_standby' ? 'other' : null;
  if (!blok) return null;
  const cfg = sb[blok] || {};
  const yok = (NOBET_ALANLARI[blok] || []).filter(a => cfg[a] == null || !Number.isFinite(Number(cfg[a])))
    .map(a => `standby.${blok}.${a}`);
  if (yok.length) {
    return { kind, reference: blok === 'airport' ? 'Md.17(1)' : 'Md.17(2)', unavailable: true, eksikAlan: yok,
             standbyMin: null, fdpReductionMin: 0, dutyCreditMin: 0, invalid: false, maxExceeded: false };
  }
  const n = (a) => Number(cfg[a]);
  if (blok === 'airport') {
    const after = n('fdp_reduction_after_min');
    return {
      kind, reference: 'Md.17(1)', standbyMin: mins, invalid,
      fdpReductionMin: Math.max(0, mins - after),
      dutyCreditMin: Math.round(mins * n('duty_credit_ratio')),
      combinedCapMin: n('standby_plus_fdp_cap_min'),
      reductionThresholdMin: after,
      maxExceeded: false,
    };
  }
  const after = opts.fdpExtended ? n('fdp_reduction_after_min_if_extended_fdp') : n('fdp_reduction_after_min');
  const maxMin = n('max_min');
  return {
    kind, reference: 'Md.17(2)', standbyMin: mins, invalid,
    fdpReductionMin: Math.max(0, mins - after),
    dutyCreditMin: Math.round(mins * n('duty_credit_ratio')),
    maxStandbyMin: maxMin, maxExceeded: mins > maxMin,
    restIfNoDutyMin: n('rest_after_no_duty_min'),
    reductionThresholdMin: after,
  };
}

/** Bir uçuş görevinden ÖNCE gelen, aynı gün ve aynı pilota ait nöbeti bulur.
 *  reportISO verilirse nöbetin ondan önce bitmiş olması aranır. */
/** ÇAĞRI NÖBETİ — Md.17 (5 Eki 2026, Serkan A; şartlar tek tek metinle karşılaştırıldı, madde haritası Md.17 ①).
 *  UGS'den HEMEN önceki görev bir nöbetse ve UGS o nöbetin "görev verilmezse gelen" dinlenmesi dolmadan başlıyorsa
 *  (ev nöbetinde (2)(b) 8 saat, havaalanında (1)(d) Md.16 — nöbetin `earliest_next_report`ı), nöbet bu UGS'ye YOL AÇMIŞTIR
 *  (çağrı) ve bağlanır: azami UGS kısalır, birleşik tavan aranır, nöbetin kendi dinlenmesi aranmaz. Dinlenmesi dolduktan
 *  sonra başlayan UGS'ye bağlanmaz — nöbet görevsiz bitmiş, dinlenme gelmiştir.
 *  🔴 ÖNCESİ: aynı TAKVİM GÜNÜNDEKİ nöbet bağlanıyordu — 12 EKİ 22:00–13 EKİ 06:00 ev nöbetinden sonra 13 EKİ uçuşu
 *     kısalmıyordu; sabah nöbetinden 12 saat dinlenip akşam uçulunca kısalıyordu. Metinde "aynı gün" yok.
 *  `dutyDate` artık kullanılmaz (imza çağıranlar için korunur). Rapor anı yoksa bağlanamaz. */
export function standbyBefore(duties, pilotId, dutyDate, reportISO = null) {
  if (!reportISO) return null;
  const onceki = previousDuty(duties, pilotId, reportISO);
  if (!onceki || onceki.duty_type !== 'ground'
      || (onceki.ground_kind !== 'airport_standby' && onceki.ground_kind !== 'other_standby')) return null;
  if (!onceki.earliest_next_report) return null;
  return new Date(reportISO).getTime() < new Date(onceki.earliest_next_report).getTime() ? onceki : null;
}

/** SİMÜLATÖR + UÇUŞ AYNI GÖREV PERİYODU — Md.23(1) (5 Eki 2026, Serkan "a tabiki"; madde haritası Md.23 ①).
 *  🔑 Md.23(1): "aynı görev periyodu içerisinde hem simülatörde … hem de hava aracında uçuş için görevlendirilmesi durumunda,
 *     simülatörde görevlendirilen sürenin tamamı UGS'ye dâhil edilecek, ancak sektör olarak sayılmayacaktır." · Md.4(o): mola
 *     "dinlenme süresinden daha kısa", görev sayılır.
 *  🔴 ÖNCESİ: sim 04:00–08:00Z + 09:00Z raporlu uçuş → NOT LEGAL rest_short (sim'den sonra 12 saat aranıyordu), UGS 4 saat.
 *  Bağ (nöbet çağrısıyla aynı ölçü): UGS'den HEMEN önceki görev simülatörse ve UGS onun dinlenmesi (`earliest_next_report`) dolmadan
 *  başlıyorsa aradaki boşluk dinlenme değil moladır → aynı görev periyodu. Dinlenmesi dolduktan sonraki uçuş ayrı görevdir. */
//  YER EĞİTİMİ DE (5 Eki 2026, Serkan A — madde haritası Md.27 ④b): dersten (TRAINING / THEORETICAL) sonra dinlenmeden yapılan
//  uçuş aynı görev periyodudur — Md.4(z) UGS "görev yerinde hazır bulunmasıyla başlar"; Md.27(1)(ç) aynı gün ders + uçuşu öngörür.
//  🔴 Önce ders ayrı görev sayılıyordu: sabah 3 saat ders + öğleden sonra eğitim uçuşu REST SHORT (12 saat aranıyordu) — (ç) hiç
//  uygulanamıyordu. Ad tarihsel (`simBaglantisi`); bağlanan türler `UGS_BASLATAN_YER_GOREVLERI`.
export const UGS_BASLATAN_YER_GOREVLERI = {
  sim: { etiket: 'SIMULATOR', ref: 'Md.23(1)', isaret: 'SIM' },
  training: { etiket: 'GROUND TRAINING', ref: 'Md.4(z)', isaret: 'GRD TRG' },
  theoretical: { etiket: 'GROUND TRAINING', ref: 'Md.4(z)', isaret: 'GRD TRG' },
  // OFİS (5 Eki 2026, Serkan: *"rest yaptı ofise geldi, ofis saati başlangıcı duty başlangıcı sayılır ve arkasına uçuş yapılırsa
  // limiti ofis saat başlangıcı belirler"*) — Md.4(ğ) idari görev görevdir, (h) görev süresi kesintisiz, (z) UGS görev yerinde hazır
  // bulunmayla başlar; aradaki saatler dinlenme değil (Md.4(d)). 🔴 Önce ofisten sonra uçuşa 12 saat dinlenme aranıyordu (metinde yok).
  office: { etiket: 'OFFICE DUTY', ref: 'Md.4(z)', isaret: 'OFFICE' },
};
export const ugsBaslatanMi = (d) => d?.duty_type === 'ground' && !!UGS_BASLATAN_YER_GOREVLERI[d.ground_kind];
/** Bağlı görevin (simülatör / ders / ofis) UGS aşımı notu — sunucu gerekçesi, ASSIGN / EDIT ve kapı AYNI cümle (5 Eki 2026,
 *  Serkan "yap"): aşımın asıl sebebi aradaki dinlenmenin tamamlanmaması — planlayıcı onu görür (uçuşu ileri al ya da görevi kaldır). */
export const baglantiNotu = (bagli) => {
  const b = UGS_BASLATAN_YER_GOREVLERI[bagli?.ground_kind];
  if (!b || !bagli.report_time) return '';
  const an = new Date(bagli.report_time).toISOString().slice(5, 16).replace('T', ' ');
  return ` — the ${b.etiket.toLowerCase()} ${an} starts this duty period: there was no full rest after it (SHT-FTL/HG ${b.ref}, Md.16)`;
};
export function simBaglantisi(duties, pilotId, reportISO, excludeId = null) {
  if (!reportISO) return null;
  let onceki = previousDuty(duties, pilotId, reportISO, excludeId);
  // Uçuş, arkasındaki simülatörle aynı anda biter (14 Eki 2026, periyot simülatörün sonunda) — bitişler eşitken öndeki görev
  // uçuş çıkabilir; bağın adayı periyodu kapatan simülatördür.
  if (onceki?.duty_type === 'flight') onceki = (duties || []).find(y => ugsBaslatanMi(y) && y.status !== 'cancelled'
    && y.pilot_id === pilotId && y.id !== excludeId && Date.parse(y.duty_end) === Date.parse(onceki.duty_end) && ucusunKapsadigi(duties, y) === onceki) || onceki;
  if (!onceki || !ugsBaslatanMi(onceki) || !onceki.earliest_next_report) return null;
  // Uçuşla AYNI PAKETTE girilmiş simülatör (14 Eki 2026) o uçuşun periyodundadır — sonraki uçuşun periyodunu başlatmaz; sonraki
  // uçuş o periyodun dinlenmesine göre ölçülür (REST SHORT).
  if (ucusunKapsadigi(duties, onceki)) return null;
  return new Date(reportISO).getTime() < new Date(onceki.earliest_next_report).getTime() ? onceki : null;
}
/** Yer görevi bir uçuşun görev periyodunun İÇİNDE mi (14 Eki 2026, Md.23(1) uçuştan sonra simülatör): aynı pilotun iptal
 *  edilmemiş bir uçuşu ondan önce başlıyor ve görevi onun bitişinde ya da sonra bitiyor (hesaplanmış `duty_end`). */
/** Uçuşla AYNI PAKETTE (ASSIGN'da aynı kayıt → aynı `assignment_id`) girilmiş simülatör mü (14 Eki 2026, açık bağ). */
export const ayniPakettekiSim = (ucus, yer) => !!(ucus?.assignment_id && yer && yer.duty_type === 'ground'
  && yer.ground_kind === 'sim' && yer.status !== 'cancelled' && yer.assignment_id === ucus.assignment_id
  && yer.pilot_id === ucus.pilot_id && yer.duty_end);
export function ucusunKapsadigi(duties, yer) {
  if (!yer || yer.duty_type !== 'ground' || !yer.report_time || !yer.duty_end) return null;
  const b = Date.parse(yer.report_time), e = Date.parse(yer.duty_end);
  return (duties || []).find(u => u && u.duty_type === 'flight' && u.status !== 'cancelled' && u.pilot_id === yer.pilot_id
    && u.id !== yer.id && Date.parse(u.report_time) < b && Date.parse(u.duty_end) >= e) || null;
}
/** `ucusunKapsadigi`nin toplu hâli — kümülatif sayım için (pilot başına uçuşlar raporla sıralı, ikili arama; uçuşu kapsayan
 *  yalnız ondan önce başlayan EN SON uçuş olabilir). Yer görevi yoksa boş küme. */
export function ucusIcindekiYerGorevleri(duties) {
  const kume = new Set();
  const yerler = (duties || []).filter(d => d && d.duty_type === 'ground' && d.status !== 'cancelled' && d.report_time && d.duty_end);
  if (!yerler.length) return kume;
  const ucuslar = new Map();
  (duties || []).forEach(u => {
    if (!u || u.duty_type !== 'flight' || u.status === 'cancelled' || !u.report_time || !u.duty_end) return;
    const l = ucuslar.get(u.pilot_id) || []; l.push({ r: Date.parse(u.report_time), e: Date.parse(u.duty_end) });
    ucuslar.set(u.pilot_id, l);
  });
  ucuslar.forEach(l => l.sort((a, b) => a.r - b.r));
  yerler.forEach(y => {
    const l = ucuslar.get(y.pilot_id);
    if (!l) return;
    const b = Date.parse(y.report_time), e = Date.parse(y.duty_end);
    let lo = 0, hi = l.length - 1, k = -1;
    while (lo <= hi) { const m = (lo + hi) >> 1; if (l[m].r < b) { k = m; lo = m + 1; } else hi = m - 1; }
    if (k >= 0 && l[k].e >= e) kume.add(y);
  });
  return kume;
}
/** Uçuştan sonraki bağlı simülatörün notu (14 Eki 2026) — UGS aşımında planlayıcı simülatörün UGS'ye girdiğini görür. */
export const simSonraNotu = (s) => {
  if (!s?.report_time) return '';
  const an = new Date(s.report_time).toISOString().slice(5, 16).replace('T', ' ');
  return ` — the simulator ${an} after this flight is in the same duty period: its whole time counts in the FDP (SHT-FTL/HG Md.23(1))`;
};

/** Nöbet + görev birleşik kontrolleri (Md.17). standbyEffect'in verdiği ETKİYİ
 *  atanan UGS ile birleştirir ve İHLAL gerekçelerini üretir.
 *  Neden ayrı fonksiyon: birleşik tavan iki bilgiyi birden ister (nöbet süresi +
 *  tahsis edilen UGS); standbyEffect yalnız nöbeti görür. Panel, EDIT modali,
 *  arşiv ve rapor AYNI kaynağı kullansın diye motorda duruyor (K-2'nin dersi).
 *  effect: standbyEffect() çıktısı · assignedFdpMin: planlanan UGS (dk)
 *  Dönen: effect + { combinedMin, combinedExceeded, reasons:[...] } */
export function standbyLimits(effect, assignedFdpMin) {
  if (!effect) return null;
  // `reasons` düz metin (ekranlar okur) · `kunyeli` aynı sırada { metin, ref }
  // — ref, kartın ⓘ'sinde maddenin kendi metnini açar (29 Eyl 2026, bkz. fitness).
  const reasons = [];
  const kunyeli = [];
  const neden = (metin, ref = null) => { reasons.push(metin); kunyeli.push({ metin, ref }); };
  const out = { ...effect, assignedFdpMin: assignedFdpMin ?? null, combinedMin: null, combinedExceeded: false };

  // Kural seti nöbeti tanımlamıyorsa DOĞRULAYAMAYIZ. Sessizce "uygun" demek,
  // limiti bilmeden yasal ilan etmektir.
  if (out.unavailable) {
    neden('THIS DUTY\'S RULESET DOES NOT DEFINE STANDBY RULES (Md.17)'
          + (out.eksikAlan?.length ? ` — ${out.eksikAlan.join(', ')} missing` : '')
          + ' — the effect on max FDP cannot be verified; assign the duty under a ruleset that defines them',
          'SHT-FTL/HG Md.17');
    out.reasons = reasons; out.kunyeli = kunyeli; out.ok = false;
    return out;
  }

  // BOZUK NOBET KAYDI (bitis <= baslangic) sessizce "etkisi yok" sayilamaz —
  // 17 saatlik bir nobet 0 dk gorunur ve azami sure kontrolu de bosa duser.
  if (out.invalid) {
    neden('STANDBY END IS NOT AFTER ITS START — duration cannot be determined (record is corrupt, fix the standby duty)');
  }

  // Md.17(1)(ç) — HAVAALANI NÖBETİ: nöbet + tahsis edilen UGS birleşik süresi
  // 16 saati AŞAMAZ. Bu, UGS kısaltmasından AYRI ve ondan sonra gelen bir tavan;
  // kısaltma uygulandıktan sonra bile birleşik süre tavanı aşabilir.
  if (out.kind === 'airport_standby' && out.combinedCapMin != null && assignedFdpMin != null) {
    out.combinedMin = out.standbyMin + assignedFdpMin;
    out.combinedExceeded = out.combinedMin > out.combinedCapMin;
    if (out.combinedExceeded) {
      // 29 Eyl 2026: etiket "Md.17/1/c" idi — talimatta 16 saatlik birleşik tavan (1)(ç) bendidir.
      neden(`STANDBY ${fmtMin(out.standbyMin)} + FDP ${fmtMin(assignedFdpMin)} = ${fmtMin(out.combinedMin)} > ${fmtMin(out.combinedCapMin)} COMBINED CAP (SHT-FTL/HG Md.17/1/ç)`,
            'SHT-FTL/HG Md.17(1)(ç)');
    }
  }
  // Md.17(2)(a) — HAVAALANI HARİCİ NÖBET azami 16 saat. Nöbetin KENDİ ihlali;
  // görev atanmasa da geçersizdir, bu yüzden assignedFdpMin'den bağımsız bakılır.
  if (out.kind === 'other_standby' && out.maxExceeded) {
    // 29 Eyl 2026: etiket "Md.17/2/b" idi — talimatta 16 saatlik azami süre (2)(a) bendidir.
    neden(`OTHER STANDBY ${fmtMin(out.standbyMin)} > ${fmtMin(out.maxStandbyMin)} MAX (SHT-FTL/HG Md.17/2/a)`,
          'SHT-FTL/HG Md.17(2)(a)');
  }
  out.reasons = reasons;
  out.kunyeli = kunyeli;
  out.ok = reasons.length === 0;
  return out;
}

// ── İNTİBAK — Acclimatisation (SHT-FTL/HG Md.22(1)) ─────────────────
// Md.4(l): "İntibak edilmiş" = ekip üyesinin günlük biyolojik saatinin ilgili
//   meydanın yerel saatiyle uyumlu sayıldığı hal.
// Md.22(1) c.1: kalkış noktasındaki yerel saati çevreleyen 2 SAAT GENİŞLİĞİNDEKİ
//   dilimdeki bir meydana uçuş sonrası, asgari dinlenmeyi müteakip yapılacak
//   İLK görev için o meydanın yerel saatine intibak edilmiş sayılır.
// Md.22(1) c.2: azami günlük UGS hesabı için, görevin başladığı yerel saat bir
//   sonraki görevin başladığı yerel saatten 2 SAATTEN FAZLA farklıysa —
//     ana üs / geçici üs DIŞINDA 24 saatten AZ dinlenildiyse → İLK kalkış meydanı
//     24 saat ve ÜZERİ dinlenildiyse                        → MEVCUT kalkış meydanı
//
// NEDEN ÖNEMLİ: intibak edilen meydan, Tablo 1'in HANGİ SATIRININ okunacağını
// belirler. Rapor saatini kalkış meydanının saatiyle okumak, doğu-batı uçuşundan
// sonra YANLIŞ BANDA düşürür ve azami UGS'yi olduğundan büyük/küçük gösterir.
// Fiziksel saatler (report_time) DEĞİŞMEZ — değişen yalnız bandın okunduğu saat.
//
// Motor TZ SORGUSU YAPMAZ (saf kalır, longRange ile aynı desen): çağıran
// meydan dilimlerinin ofsetlerini geçirir.
//   prev: { refIcao, refOffsetMin, dutyEndISO, minRestMin } | null   (önceki intibak referansı + önceki görevin asgari dinlenmesi)
//   next: { depIcao, depOffsetMin, reportISO, homeBaseIcao }
export function acclimatisation(prev, next, rules) {
  const cfg = rules?.acclimatisation;
  // Kural seti intibakı tanımlamıyorsa UYDURMA (İlke 1) — hangi bandın
  // okunacağını bilmeden azami UGS'yi doğrulamış sayılamayız.
  if (!cfg) {
    return { unavailable: true, icao: null, offsetMin: null, reference: 'Md.22(1)',
             reason: 'ruleset does not define acclimatisation (Md.22/1)' };
  }
  // 5 Eki 2026 (madde haritası Md.22 ②): eşikler YALNIZ kural setinden — eskiden `?? 120` / `?? 1440` koddan yedekti.
  const yokA = ['band_tolerance_min', 'rest_threshold_min']
    .filter(a => cfg[a] == null || !Number.isFinite(Number(cfg[a]))).map(a => `acclimatisation.${a}`);
  if (yokA.length) {
    return { unavailable: true, icao: null, offsetMin: null, reference: 'Md.22(1)', kuralEksik: yokA.join(' / '),
             reason: `ruleset does not define ${yokA.join(' / ')} (Md.22/1)` };
  }
  const band = Number(cfg.band_tolerance_min);
  const restThreshold = Number(cfg.rest_threshold_min);
  const at = (icao, offsetMin, reason, extra = {}) =>
    ({ unavailable: false, icao, offsetMin, band, reference: 'Md.22(1)', reason, ...extra });

  if (!next?.depIcao || next.depOffsetMin == null) {
    return { unavailable: true, icao: null, offsetMin: null, reference: 'Md.22(1)',
             reason: 'departure aerodrome timezone unknown' };
  }
  // İlk görev / önceki referans yok: kalkış meydanına intibaklı kabul edilir.
  if (!prev?.refIcao || prev.refOffsetMin == null) {
    return at(next.depIcao, next.depOffsetMin, 'first duty in chain — acclimatised to departure aerodrome');
  }
  const diffMin = Math.abs(prev.refOffsetMin - next.depOffsetMin);
  const restMin = (prev.dutyEndISO && next.reportISO)
    ? Math.max(0, (new Date(next.reportISO) - new Date(prev.dutyEndISO)) / 60000) : null;
  // c.1 — 2 saatlik bant içinde: mevcut kalkış meydanına intibaklı — ama "asgari dinlenme süresini MÜTEAKİBEN"
  // (5 Eki 2026, madde haritası Md.22 ①, Serkan A). 🔴 Önce dinlenmeye bakılmıyordu: SKPK ile kısaltılmış (yasal ama asgarinin
  // altında) dinlenmeden sonra Roma 14:15 / Ankara 15:15 raporu Roma saatinde 13:30 alıyordu; ekip henüz Ankara saatinde → 12:30.
  // Asgari dinlenme tamamlanmadıysa ekip önceki referansta kalır. Aynı dilimde (fark 0) bant değişmez — dinlenmeye bakılmaz.
  if (diffMin <= band) {
    if (diffMin > 0) {
      if (restMin == null || prev.minRestMin == null) {
        return { unavailable: true, icao: null, offsetMin: null, reference: 'Md.22(1)', diffMin,
                 reason: 'the rest before this duty or its minimum is unknown — cannot tell whether the crew is acclimatised to the new aerodrome' };
      }
      if (restMin < prev.minRestMin) {
        return at(prev.refIcao, prev.refOffsetMin,
          `rested ${fmtMin(restMin)}, less than the minimum rest ${fmtMin(prev.minRestMin)} — not yet acclimatised to ${next.depIcao}, `
          + `still acclimatised to ${prev.refIcao} (Md.22(1): after the minimum rest)`, { diffMin, restMin });
      }
    }
    return at(next.depIcao, next.depOffsetMin,
      `within the ${fmtMin(band)} band of the previous reference (${prev.refIcao})`, { diffMin, restMin });
  }
  // c.2 — bant dışı: dinlenme süresi ve yeri belirler.
  const atBase = !!(next.homeBaseIcao &&
    String(next.depIcao).toUpperCase() === String(next.homeBaseIcao).toUpperCase());
  if (atBase) {
    return at(next.depIcao, next.depOffsetMin,
      'rest taken at home base — acclimatised to home base', { diffMin, restMin });
  }
  if (restMin == null) {
    return { unavailable: true, icao: null, offsetMin: null, reference: 'Md.22(1)', diffMin,
             reason: 'rest duration unknown — cannot decide acclimatisation outside base' };
  }
  if (restMin < restThreshold) {
    return at(prev.refIcao, prev.refOffsetMin,
      `rested ${fmtMin(restMin)} (<${fmtMin(restThreshold)}) away from base — still acclimatised to ${prev.refIcao}`,
      { diffMin, restMin });
  }
  return at(next.depIcao, next.depOffsetMin,
    `rested ${fmtMin(restMin)} (≥${fmtMin(restThreshold)}) away from base — acclimatised to ${next.depIcao}`,
    { diffMin, restMin });
}

/** İntibak edilen meydanın YEREL saatiyle rapor saati — Tablo 1 bu saatle okunur.
 *  reportHHMM kalkış meydanının yerel saatidir; iki ofsetin farkı kadar kaydırılır. */
export function bandReportHHMM(reportHHMM, depOffsetMin, acclOffsetMin) {
  const r = toMin(reportHHMM);
  if (r == null || depOffsetMin == null || acclOffsetMin == null) return null;
  return fmtMin(((r + (acclOffsetMin - depOffsetMin)) % 1440 + 1440) % 1440);
}

// ── SKPK — Sorumlu Kaptan Pilot Kararı (SHT-FTL/HG Md.12) ───────────
// Md.12(1): "GÖREV BAŞLANGICI SONRASINDA başlayan öngörülemeyen haller" —
//   SKPK bir PLANLAMA aracı DEĞİLDİR, olmuş bitmiş bir olayın kaydıdır.
//   Bu yüzden yalnız gerçekleşmiş (actual) görevlere yazılır.
// Md.12(1)(a): azami UGS en fazla +2 saat; artırılmış ekipte +3 saat.
// Md.12(1)(c)(1): her SKPK'da işleticiye rapor — İSTİSNASIZ.
// Md.12(1)(c)(2): gerçekleşen uzatma VEYA kısaltma 1 saati AŞARSA, kaptan
//   raporunun kopyası işleticinin yorumlarıyla 28 gün içinde Genel Müdürlüğe.
// Md.12(2): dinlenme en fazla 2 saat kısaltılır; kısaltılırsa MÜTEAKİP GÖREV
//   sonrasındaki hak edilen dinlenme kısaltılan miktarın 2 KATI kadar artar;
//   hak edilen dinlenme 10 saatin altına inemez.
// Md.12(3): SKPK ile UZATILMIŞ bir UGS'yi müteakip dinlenme KISALTILAMAZ.
//
// ctx: { augmented, baseMaxFdpMin, fdpMin, earnedRestMin, prevMinRestMin, actualRestMin,
//        prevHadSkpkExtension, dutyEndISO }
// `actualRestMin` = önceki görevin sonundan bu görevin raporuna gerçekte geçen dinlenme (Md.12(1)(c)(2) gerçekleşen kısaltma).
// `augmented` = EKİP artırılmış (Md.4(1)(b): asgarinin üzerinde uçuş ekibi — CRZ CPT var), bütün ekibe aynı. Md.11 uzatmasının
//    uygulanıp uygulanmadığı (dinlenme olanağı, 3 sektör) DEĞİL — Serkan 4 Eki 2026 A: *"mevzuatta CRZ pilot için özel bir
//    uygulama yok, bütün pilotlar aynı duty yazıyor"*. 🔴 Önce sunucu `win.augmented`ı (uzatma uygulandı mı), EDIT pilotun
//    KENDİ satırındaki CRZ rolünü okuyordu: aynı ekipte CRZ'ye +3:00, PF/PM'e +2:00; sunucu ile EDIT ayrı cevap.
// Md.12'nin kural setindeki sayıları — hepsi zorunlu (yedek yok).
export const SKPK_ALANLARI = ['fdp_extension_max_min', 'fdp_extension_augmented_max_min', 'rest_reduction_max_min',
                              'rest_floor_min', 'authority_report_over_min', 'authority_report_days'];
export function skpkLimits({ fdpExtensionMin = 0, restReductionMin = 0 } = {}, rules, ctx = {}) {
  const ext = Math.max(0, Math.round(fdpExtensionMin || 0));
  const red = Math.max(0, Math.round(restReductionMin || 0));
  const reasons = [];
  const kunyeli = [];   // aynı sırada { metin, ref } — bkz. fitness
  const neden = (metin, ref = null) => { reasons.push(metin); kunyeli.push({ metin, ref }); };
  // RULESET SKPK TANIMLAMIYORSA TAVANI KODDAN UYDURMA (İlke 1). 4 Eki 2026 (madde haritası Md.12 ④): alan alan da —
  // eskiden bölüm varsa eksik alan için 2:00 / 3:00 / 2:00 / 10:00 / 1:00 / 28 gün koddan varsayılıyordu; başka bir
  // regülasyona tabi müşteride sessizce yanlış tavan uygulanır, ihlal "geçerli" görünürdü. Eksik alan ADIYLA söylenir.
  const cfg = rules?.commander_discretion || null;
  const eksikAlan = cfg ? SKPK_ALANLARI.filter(k => cfg[k] == null || !Number.isFinite(Number(cfg[k]))) : SKPK_ALANLARI;
  if (eksikAlan.length) {
    const metin = cfg
      ? `THIS DUTY'S RULESET DOES NOT DEFINE ${eksikAlan.join(', ')} (Md.12) — the entry cannot be validated`
      : 'THIS DUTY\'S RULESET DOES NOT DEFINE COMMANDER\'S DISCRETION LIMITS (Md.12) — the entry cannot be validated';
    return { reference: 'Md.12', applied: ext > 0 || red > 0, unavailable: true, eksikAlan,
      extensionMin: ext, reductionMin: red, extensionMaxMin: null, reductionMaxMin: null,
      extensionExceeded: false, reductionExceeded: false, restFloorMin: null,
      restAfterReductionMin: null, restFloorBreached: false, afterExtensionBlocked: false,
      compensationMin: 0, minRestWithCompensationMin: null, maxFdpWithSkpkMin: null,
      fdpStillExceeded: null, operatorReportRequired: ext > 0 || red > 0,
      authorityReportRequired: false, authorityReportOverMin: null,
      authorityReportDays: null, authorityDueISO: null,
      reasons: [metin], kunyeli: [{ metin, ref: 'SHT-FTL/HG Md.12' }], ok: false };
  }

  // — Md.12(1)(a) uzatma tavanı (artırılmış ekipte 3 saat)
  const extMax = Number(ctx.augmented ? cfg.fdp_extension_augmented_max_min : cfg.fdp_extension_max_min);
  const extensionExceeded = ext > extMax;
  if (extensionExceeded) {
    neden(`SKPK FDP EXTENSION ${fmtMin(ext)} > ${fmtMin(extMax)} MAX${ctx.augmented ? ' (augmented crew)' : ''} (SHT-FTL/HG Md.12/1/a)`,
          'SHT-FTL/HG Md.12(1)(a)');
  }

  // — Md.12(2) kısaltma tavanı + 10 saat tabanı
  const redMax = Number(cfg.rest_reduction_max_min);
  const restFloor = Number(cfg.rest_floor_min);
  const reductionExceeded = red > redMax;
  if (reductionExceeded) {
    neden(`SKPK REST REDUCTION ${fmtMin(red)} > ${fmtMin(redMax)} MAX (SHT-FTL/HG Md.12/2)`, 'SHT-FTL/HG Md.12(2)');
  }
  // Taban, KISALTILAN dinlenmenin kendisine uygulanır: hak edilen dinlenme
  // (onceki gorevin min_rest'i) eksi kisaltma, 10 saatin altina inemez.
  const earned = ctx.prevMinRestMin ?? ctx.earnedRestMin ?? null;
  const restAfterReductionMin = (red > 0 && earned != null) ? earned - red : null;
  const restFloorBreached = restAfterReductionMin != null && restAfterReductionMin < restFloor;
  if (restFloorBreached) {
    neden(`REST AFTER REDUCTION ${fmtMin(restAfterReductionMin)} < ${fmtMin(restFloor)} FLOOR (SHT-FTL/HG Md.12/2)`, 'SHT-FTL/HG Md.12(2)');
  }

  // — Md.12(3): uzatılmış UGS'yi müteakip dinlenme kısaltılamaz.
  //   Bu görevin dinlenmesi kısaltıldıysa ve ÖNCEKİ görev SKPK ile uzatıldıysa
  //   ihlal vardır (kısaltılan dinlenme tam da o uzatmayı müteakip olandır).
  const afterExtensionBlocked = red > 0 && !!ctx.prevHadSkpkExtension
    && (cfg.no_rest_reduction_after_skpk_extension !== false);
  if (afterExtensionBlocked) {
    neden('REST MAY NOT BE REDUCED AFTER AN FDP EXTENDED BY COMMANDER\'S DISCRETION (SHT-FTL/HG Md.12/3)', 'SHT-FTL/HG Md.12(3)');
  }

  // — Md.12(2): telafi, MÜTEAKİP GÖREV SONRASINDAKİ dinlenmeye eklenir (2 kat).
  //   Yani kısaltmayı taşıyan görevin KENDİ min_rest'i artar.
  const compensationMin = red > 0 ? red * 2 : 0;
  const minRestWithCompensationMin = ctx.earnedRestMin != null
    ? ctx.earnedRestMin + compensationMin : null;

  // — Md.12(1)(c): raporlama
  // (c)(2) "GERÇEKLEŞTİRİLEN UGS'nin artırılmasının … 1 saati aştığı hallerde" — eşik, girilen SKPK sayısıyla DEĞİL, uçulan
  // UGS'nin SKPK'sız azami UGS'yi ne kadar aştığıyla ölçülür (Serkan 4 Eki 2026 A). 🔴 Önce yalnız girilen sayıya bakıyordu:
  // yerde 0:45 SKPK, havada 2:20 aşım → "OPERATOR REPORT ONLY", 28 günlük SHGM süresi hiç başlamıyordu.
  const any = ext > 0 || red > 0;
  const gerceklesenArtisMin = (ctx.baseMaxFdpMin != null && ctx.fdpMin != null)
    ? Math.max(0, ctx.fdpMin - ctx.baseMaxFdpMin) : null;
  // Dinlenme tarafı da aynı cümle (Serkan 4 Eki 2026 A): gereken dinlenme − gerçekte alınan dinlenme.
  const gerceklesenKisaltmaMin = (ctx.prevMinRestMin != null && ctx.actualRestMin != null)
    ? Math.max(0, ctx.prevMinRestMin - ctx.actualRestMin) : null;
  const overMin = Number(cfg.authority_report_over_min);
  const authorityReportRequired = Math.max(ext, gerceklesenArtisMin ?? 0) > overMin
    || Math.max(red, gerceklesenKisaltmaMin ?? 0) > overMin;
  const days = Number(cfg.authority_report_days);
  const authorityDueISO = authorityReportRequired ? skpkSonGunu(ctx.dutyEndISO, days) : null;   // Md.12(1)(c)(2), takvim günü

  return {
    reference: 'Md.12', applied: any,
    extensionMin: ext, extensionMaxMin: extMax, extensionExceeded,
    reductionMin: red, reductionMaxMin: redMax, reductionExceeded,
    restFloorMin: restFloor, restAfterReductionMin, restFloorBreached,
    afterExtensionBlocked,
    compensationMin, minRestWithCompensationMin,
    // `ugsUzatmaz` (eğitim, 5 Eki 2026): girilen uzatma azami UGS'ye eklenmez — Md.27(1)(b) 12:00 kesin tavan.
    maxFdpWithSkpkMin: ctx.baseMaxFdpMin != null ? ctx.baseMaxFdpMin + (ctx.ugsUzatmaz ? 0 : ext) : null,
    fdpStillExceeded: (ctx.baseMaxFdpMin != null && ctx.fdpMin != null)
      ? ctx.fdpMin > ctx.baseMaxFdpMin + (ctx.ugsUzatmaz ? 0 : ext) : null,
    operatorReportRequired: any, gerceklesenArtisMin, gerceklesenKisaltmaMin,
    authorityReportRequired, authorityReportOverMin: overMin,
    authorityReportDays: days, authorityDueISO,
    reasons, kunyeli, ok: reasons.length === 0,
  };
}

/** Bir görevin ÖNCESİNDEKİ (aynı pilot) en son görevi bulur — SKPK'nın
 *  "hak edilen dinlenme" ve Md.12(3) zincir kontrolü bunun üzerinden döner. */
export function previousDuty(duties, pilotId, reportISO, excludeId = null) {
  if (!reportISO) return null;
  const t = new Date(reportISO).getTime();
  return (duties || [])
    .filter(d => d.pilot_id === pilotId && d.id !== excludeId && d.duty_type !== 'off'
              && d.status !== 'cancelled' && d.duty_end && new Date(d.duty_end).getTime() <= t)
    .sort((a, b) => new Date(b.duty_end) - new Date(a.duty_end))[0] || null;
}

// ── DİNLENME DURUMU — DENETÇİNİN GÖRECEĞİ REMARK (19 Eyl 2026) ────────
//
// 🔑 Serkan: *"Geçmişe dönük kayıt girilirken rest kısaltılmış veya görev
//    uzatılmışsa rapor yazılması şartını koşup o görevin yanına remark
//    koyalım... denetlemede baktığında bu remark kalıcı olduğu için denetçi
//    remark'ı görür, renk kodu zaten orange veya amber olur, 'nerede bunun
//    raporu' diye sorar."*
//
// 🔴 ASIL TEHLİKELİ VAKA, SKPK KAYDI OLAN DEĞİL — OLMAYANDIR. Roster
//    hatasından kısa kalmış bir dinlenmede kimse SKPK girmez; o satırda
//    bugüne kadar roster'da HİÇBİR iz yoktu, kırmızı gerekçe yalnız düzenleme
//    modalının içinde duruyordu. Denetçi tam o satırı göremezdi.
//
// 🔑 İKİ HÂL, İKİ RENK — ve fark "açıklanmış mı" sorusudur:
//    · kısa dinlenme + SKPK kaydı + rapor  → AMBER: mevzuatın tanıdığı istisna
//    · kısa dinlenme, SKPK YOK             → ORANGE: açıklaması olmayan eksik
//
// 🔑 TÜRETİLİR, SAKLANMAZ (İlke 3). Kayıt düzeltilince remark kendiliğinden
//    düşer. Saklansaydı görevin saati değişince damga bayatlardı — 4 Eyl'deki
//    "OFF TO DUTY" ve 27 Ağu'daki "takılı kalan dinlenme" dersi.
//
// ⚠️ SKPK kaydı önceki görevin `earliest_next_report`'unu DEĞİŞTİRMEZ; hak
//    edilen dinlenme neyse odur, kısaltma onun üzerine yazılan bir İSTİSNADIR.
//    Bu yüzden SKPK'lı satır da "kısa" görünür — ve görünmelidir.

// ── DİNLENME PENCERESİ — EKRAN VE ÇIKTI İÇİN (29 Eyl 2026) ────────────────
// 🔑 Serkan: *"pilot uçuştan geldikten sonraki gün roster'ında rest görünmüyor …
//    ertesi güne sarkması lazım … 23:00–11:00 arasına rest girmeli ki aylık
//    programı print edildiğinde restler de görünsün"* · *"geçmişe dönük de"*.
// 🔑 Dinlenme SAKLANMAZ, TÜRETİLİR (İlke 3 — türetilebilen saklanmaz): görevin
//    bitişi (`duty_end`) → dinlenmenin bittiği an (`earliest_next_report`). Bu
//    iki alan her görevde zaten kayıtlı, o yüzden geçmiş görevler de kendiliğinden
//    görünür. OFF ve iptal edilmiş görevde dinlenme penceresi yoktur.
/** @returns {null | { basISO, bitisISO, dk, olculemedi:boolean, planli:boolean }}
 *  olculemedi: görevde bitiş ya da dinlenme sonu yok / tutarsız — "yok" DENMEZ,
 *  ekranda "not recorded" diye söylenir (İlke 1). */
export function dinlenmePenceresi(d) {
  if (!d || d.duty_type === 'off' || d.status === 'cancelled') return null;
  const bas = d.duty_end || null, bit = d.earliest_next_report || null;
  const olculemedi = !bas || !bit || !(Date.parse(bit) > Date.parse(bas));
  return { basISO: bas, bitisISO: bit, dk: d.min_rest_minutes ?? null,
           olculemedi, planli: d.status === 'planned' };
}

/** Kaydı OLMAYAN bir güne (UTC takvim günü, "YYYY-MM-DD") sarkan dinlenme:
 *  o güne değen pencerelerden EN GEÇ biteni. Ölçülemeyen pencere sarkmaz
 *  (sınırı bilinmeyen bir şey bir güne yazılamaz). Yoksa null. */
export function gunDinlenmesi(duties, gunISO) {
  const gunBas = Date.parse(`${gunISO}T00:00:00Z`), gunSon = gunBas + 86400000;
  let en = null;
  for (const d of duties || []) {
    const p = dinlenmePenceresi(d);
    if (!p || p.olculemedi) continue;
    const b = Date.parse(p.basISO), s = Date.parse(p.bitisISO);
    if (b < gunSon && s > gunBas && (!en || s > Date.parse(en.bitisISO))) en = { ...p, dutyId: d.id };
  }
  return en;
}

/**
 * Bir görevin dinlenme durumu; remark için.
 * @returns {null|{kisa:boolean, eksikMin:number, gerekenISO:string,
 *                 skpkVar:boolean, raporVar:boolean, olculemedi:boolean,
 *                 oncekiKusur:string[]}}
 *          null = söylenecek bir şey yok.
 */
export function dinlenmeDurumu(duty, duties) {
  if (!duty?.report_time || duty.duty_type === 'off' || duty.status === 'cancelled') return null;
  const onceki = previousDuty(duties, duty.pilot_id, duty.report_time, duty.id);
  if (!onceki) return null;

  const skpkVar = (duty.skpk_rest_reduction_min || 0) > 0
                || (duty.skpk_fdp_extension_min || 0) > 0;
  const raporVar = !!String(duty.skpk_reason || '').trim();

  // ÖNCEKİ GÖREV BOZUKSA ÖLÇÜM YOKTUR — "kısa değil" DEMEYİZ (İlke 1).
  const oncekiKusur = imkansizDegerler(onceki);
  if (oncekiKusur.length) {
    return { kisa: false, eksikMin: 0, gerekenISO: null, skpkVar, raporVar,
             olculemedi: true, oncekiKusur };
  }
  if (!onceki.earliest_next_report) {
    return { kisa: false, eksikMin: 0, gerekenISO: null, skpkVar, raporVar,
             olculemedi: true, oncekiKusur: [] };
  }

  const gereken = new Date(onceki.earliest_next_report).getTime();
  const rapor = new Date(duty.report_time).getTime();
  if (!Number.isFinite(gereken) || !Number.isFinite(rapor)) return null;

  const eksikMin = Math.round((gereken - rapor) / 60000);
  if (eksikMin <= 0) return skpkVar ? { kisa: false, eksikMin: 0, gerekenISO: null,
                                        skpkVar, raporVar, olculemedi: false, oncekiKusur: [] }
                                    : null;

  // SKPK KISA DİNLENMEYİ KARŞILIYOR MU (3 Eki 2026). 🔑 Serkan: *"not legal olan bir durum SKPK yapılıp rapor yazılmışsa
  // ve SKPK limitleri içerisindeyse gerçekleşmiş durum o zaman not legal değildir"* · *"rapor yazılıp save edilince legale
  // döner"*. Karşılar = rapor var + kaydedilen dinlenme KISALTMASI eksiğin tamamı kadar + Md.12(2)/(3) sınırları (kural
  // setinden: kısaltma tavanı, 10 saat tabanı, uzatılmış UGS sonrası kısaltma yok). Önceki hâl: HERHANGİ bir SKPK kaydı
  // (UGS uzatması dahil, raporsuz da) rozeti susturuyordu.
  const red = duty.skpk_rest_reduction_min || 0;
  let skpkKarsilar = false, skpkNeden = null;
  if (skpkVar) {
    const kurallar = duty.ruleset_snapshot?.regulation ? effectiveRules(duty.ruleset_snapshot).rules : null;
    const lim = red > 0 ? skpkLimits({ restReductionMin: red }, kurallar,
      { prevMinRestMin: onceki.min_rest_minutes ?? null,
        prevHadSkpkExtension: (onceki.skpk_fdp_extension_min || 0) > 0 }) : null;
    if (red <= 0) skpkNeden = 'the commander\'s discretion recorded is an FDP extension, not a rest reduction';
    else if (!raporVar) skpkNeden = 'the commander\'s discretion has no commander\'s report';
    else if (!lim.ok) skpkNeden = lim.reasons.join('; ');
    else if (red < eksikMin) skpkNeden = `the commander's discretion reduces the rest by ${fmtMin(red)} only`;
    else skpkKarsilar = true;
  }
  return { kisa: true, eksikMin, gerekenISO: onceki.earliest_next_report,
           skpkVar, raporVar, skpkKarsilar, skpkNeden, olculemedi: false, oncekiKusur: [] };
}

/** SKPK UZATMA SURESI — kayittan okunur, UYDURULMAZ.
 *
 *  Iki hal var ve ikisi de dogru cevaptir:
 *   · SKPK kaydedilmisse: kaptanin uyguladigi uzatma (`skpk_fdp_extension_min`).
 *   · Henuz kaydedilmemisse: OLCULEN asim (`fdp − max_fdp`). Kayit yapilinca
 *     `max_fdp_minutes` uzatmayi ICERECEK sekilde guncellendigi icin asim
 *     kendiliginden sifirlanir — yani bu olcu kendini temizler.
 *  Ikisi de yoksa `null` doner: sure bilinmiyorsa yazilmaz (Ilke 1). */
export function skpkOvershootMin(d) {
  if ((d?.skpk_fdp_extension_min || 0) > 0) return d.skpk_fdp_extension_min;
  if (d?.fdp_minutes == null || d?.max_fdp_minutes == null) return null;
  const over = d.fdp_minutes - d.max_fdp_minutes;
  return over > 0 ? over : null;
}

/** KAPTAN RAPORU — MATBU METIN (26 Agu 2026, Serkan onayladi).
 *
 *  🔑 *"Raporun formati matbu text, biz sadece reason kismini doldurcaz."*
 *
 *  🔑 CUMLENIN TAMAMI SAKLANMAZ (Serkan onayladi): kayda yalniz PILOTUN YAZDIGI
 *  bosluk girer (`skpk_reason`), geri kalani her gosterimde kayittan kurulur.
 *  Boylece tarih/meydan/sure sonradan duzeltilirse (arsiv gercek saatleri
 *  yazdiginda oluyor) rapor da kendiliginden dogru kalir. Turetilebilen
 *  saklanmaz (Ilke 3) — saklansaydi metin ile kayit sessizce ayrisirdi.
 *
 *  Off-block ARSIV KAYDINDAN gelir (ilk sektorun gercek off-block'u). Yoksa
 *  bosluk "—" kalir; olmayan saat uydurulmaz. */
export function skpkStatement(d, reason) {
  const legs = d?.sectors || [];
  const rota = legs.length
    ? `${(legs[0].dep || '????').toUpperCase()}–${(legs[legs.length - 1].dest || '????').toUpperCase()}`
    : '????–????';
  const g = String(d?.duty_date || '');
  const tarih = /^\d{4}-\d{2}-\d{2}$/.test(g) ? `${g.slice(8, 10)}.${g.slice(5, 7)}.${g.slice(0, 4)}` : '—';
  const off = legs[0]?.off_block || '—';
  const ext = skpkOvershootMin(d);
  // SKPK'NIN TÜRÜNE GÖRE CÜMLE (4 Eki 2026, Serkan A — Md.12(1)(c)(1) rapor uzatmayı DA kısaltmayı DA kapsar). 🔴 Önce
  // yalnız dinlenme kısaltmasında kâğıda "was extended by — due to" basılıyordu. Yalnız uzatmada metin 26 Ağu'daki gibi.
  const red = (d?.skpk_rest_reduction_min || 0) > 0 ? d.skpk_rest_reduction_min : null;
  const uzatmaVar = (d?.skpk_fdp_extension_min || 0) > 0;
  const kim = `flight ${rota}, planned for ${tarih} with off-block at ${off} UTC, `;
  const before = !red
    ? `The ${kim}was extended by ${ext != null ? fmtMin(ext) : '—'} due to `
    : uzatmaVar
      ? `The ${kim}was extended by ${fmtMin(ext)} and the rest before it reduced by ${fmtMin(red)} due to `
      : `For the ${kim}the rest before it was reduced by ${fmtMin(red)} due to `;
  const after = `. The crew agreed that the flight could be conducted safely, and it was `
              + `therefore completed under commander's discretion (SKPK) in accordance with `
              + `SHT-FTL/HG Md.12.`;
  const yazi = (reason || '').trim();
  return { before, after, text: before + (yazi || '________________') + after };
}

/** RAPORU YAZILMAMIS SKPK OLAYLARI — canin kirmizi uyarisi buradan cikar.
 *
 *  🔑 Serkan (26 Agu): *"Ucus uzadi, actual saatler SKPK yapmayi gerektirdi.
 *  Plan saatleri ucus bitince guncellendiginde yukarda zilde KIRMIZI
 *  notification olsun, ilgili ucusu gosterip 'SKPK yapildi rapor yaz' uyarisi
 *  ciksin; rapor yazinca uyari kalksin."*
 *
 *  ⚠️ UYARI METNI "SKPK YAPILDI" DEMEZ, "FDP ASILDI" DER. Tavanin asilmis
 *  olmasi takdirin KULLANILDIGINI kanitlamaz — takdiri kullandigini KAPTAN
 *  beyan eder. Sistem yalnizca olctugu seyi soyler (Ilke 1).
 *
 *  Uyari, rapor yazilinca (`skpk_reason` dolunca) kendiliginden duser.
 *
 *  Sure ve esik RULESET'ten okunur: Md.12(1)(c)(2) uzatma 1 SAATI ASIYORSA
 *  isleticinin kendi yorumlariyla birlikte kaptan raporunun bir kopyasi olaydan
 *  itibaren 28 GUN icinde SHGM'ye gonderilir. Ruleset bunlari tanimlamiyorsa
 *  geri sayim URETILMEZ — bilmedigimiz sureyi saymayiz. */
export function skpkAlerts(duties, rules, nowISO = null) {
  const cfg = rules?.commander_discretion || null;
  const overMin = cfg?.authority_report_over_min ?? null;
  const days = cfg?.authority_report_days ?? null;
  const now = nowISO ? new Date(nowISO).getTime() : Date.now();
  return (duties || [])
    .filter(d => d.status !== 'cancelled'
              && d.duty_type === 'flight'
              && !String(d.skpk_reason || '').trim()
              && d.fdp_minutes != null && d.max_fdp_minutes != null
              && d.fdp_minutes > d.max_fdp_minutes)
    .map(d => {
      const overshootMin = d.fdp_minutes - d.max_fdp_minutes;
      // Esik bilinmiyorsa "gerekli degil" DEMEYIZ — bilinmiyor deriz.
      const authorityRequired = overMin != null ? overshootMin > overMin : null;
      const dueISO = authorityRequired === true ? skpkSonGunu(d.duty_end, days) : null;   // tek kural (K9)
      return {
        duty: d, overshootMin, authorityRequired, authorityOverMin: overMin,
        authorityDays: days, dueISO,
        // Tek hesap (`sonTarihDurumu`) — SKPK sekmesiyle aynı sayı, aynı yazı; takvim günü, gecikme son günün ertesi.
        ...(() => { const sd = sonTarihDurumu(dueISO, now);
                    return { daysLeft: sd ? sd.kalan : null, gecti: !!sd?.gecti, kalanMetni: sd?.metin ?? null }; })(),
      };
    })
    // En acil ustte: son tarihi bilinen ve az kalan once, bilinmeyen sonda.
    .sort((a, b) => (a.daysLeft ?? 99999) - (b.daysLeft ?? 99999));
}

/** İKİ AN ARASINDAKİ TAKVİM GÜNÜ FARKI (UTC), `a − b` — GÜN HESABININ TEK ÖLÇÜSÜ (21 Eki 2026; Serkan: *"hesap metodu tek
 *  olmalı"* · *"gün hesabı"*). Saate bakılmaz, yalnız UTC günü. 'YYYY-MM-DD', ISO, ms ya da Date alır; okunamazsa null.
 *  Kullananlar: SKPK son günü (`sonTarihDurumu`), FCL.060 "son 90 gün" (`fclPenceresinde`, yaş). */
export function utcGunFarki(a, b) {
  if (a == null || b == null) return null;
  const ta = new Date(a).getTime(), tb = new Date(b).getTime();
  if (Number.isNaN(ta) || Number.isNaN(tb)) return null;
  return Math.floor(ta / 86400000) - Math.floor(tb / 86400000);
}

/** SKPK RAPORUNUN SON GÜNÜ — SHT-FTL/HG Md.12(1)(c)(2): kaptan raporunun kopyası "söz konusu olaydan en geç 28 gün
 *  içerisinde" Genel Müdürlüğe gönderilir (gün sayısı kural setinden). 21 Eki 2026, K9 — Serkan: *"takvim günü olmalı, saat
 *  hesabı değil gün hesabı"*; olay günü SAYILMAZ, 28. gün DAHİL (B; eğitim ve sağlık bitişleriyle aynı yöntem: bitiş günü
 *  sonuna kadar geçerli). Gün sınırı UTC. 🔴 Önce: görev bitişi + 28 × 24 SAAT (o günün saatinde bitiyordu). Dönen değer son
 *  günün sonu (23:59:59.999Z). Eski kayıtların takvim günü aynıdır (bitiş + 28 gün aynı UTC gününe düşer). */
export function skpkSonGunu(olayISO, gun) {
  const g = olayISO ? new Date(olayISO) : null;
  if (!g || Number.isNaN(g.getTime()) || gun == null || !Number.isFinite(Number(gun))) return null;
  return new Date(Date.UTC(g.getUTCFullYear(), g.getUTCMonth(), g.getUTCDate() + Number(gun), 23, 59, 59, 999)).toISOString();
}

/** SON GÜNE KALAN / GEÇEN GÜN — TEK HESAP (21 Eki 2026, K9; Serkan: *"hesap metodu tek olmalı, birden farklı hesaplama kabul
 *  edilemez"* · *"mevzuat ne diyorsa o olmalı"* · *"gün hesabı"*). TAKVİM GÜNÜ farkı (UTC): son gün "DUE TODAY", ertesi gün
 *  "1 DAY OVERDUE". 🔴 Önce SKPK sekmesi aşağı, zil yukarı yuvarlıyordu (aynı son tarihe "DUE IN 1" / "2 DAYS LEFT"); zil
 *  gecikmeyi "kalan gün < 0" diye anlıyor, kısa gecikmede "0 DAYS LEFT" yazıyordu. */
export function sonTarihDurumu(sonISO, simdi = Date.now()) {
  const fark = sonISO ? utcGunFarki(sonISO, simdi) : null;
  if (fark == null) return null;
  const gecti = fark < 0, gun = Math.abs(fark);
  const gunler = `${gun} DAY${gun === 1 ? '' : 'S'}`;
  return { gecti, gun, kalan: fark, metin: gecti ? `${gunler} OVERDUE` : fark === 0 ? 'DUE TODAY' : `${gunler} LEFT` };
}

/** SKPK'nın insan-okur özeti — kayda donar (standby_ref ile aynı gerekçe). */
export function skpkRef(skpk) {
  if (!skpk?.applied) return null;
  const parts = [];
  if (skpk.extensionMin > 0) parts.push(`FDP +${fmtMin(skpk.extensionMin)} (max ${fmtMin(skpk.extensionMaxMin)})`);
  // Uçulan artış girilen SKPK'yı geçtiyse SHGM süresinin dayanağı odur — kayıtta görünür (Md.12(1)(c)(2)).
  if (skpk.gerceklesenArtisMin != null && skpk.gerceklesenArtisMin > (skpk.extensionMin || 0)) {
    parts.push(`ACTUAL FDP +${fmtMin(skpk.gerceklesenArtisMin)}`);
  }
  if (skpk.reductionMin > 0) parts.push(`REST −${fmtMin(skpk.reductionMin)} → next rest +${fmtMin(skpk.compensationMin)} (Md.12/2)`);
  if (skpk.gerceklesenKisaltmaMin != null && skpk.gerceklesenKisaltmaMin > (skpk.reductionMin || 0)) {
    parts.push(`ACTUAL REST −${fmtMin(skpk.gerceklesenKisaltmaMin)}`);
  }
  parts.push(skpk.authorityReportRequired
    ? `DGCA REPORT DUE (>${fmtMin(skpk.authorityReportOverMin)}, ${skpk.authorityReportDays} days)`
    : 'OPERATOR REPORT ONLY');
  return `COMMANDER'S DISCRETION (SHT-FTL/HG Md.12) — ${parts.join(' · ')}`;
}

/** Nöbetin insan-okur özeti — kayda (crew_duties.standby_ref) donar.
 *  ruleset_snapshot mantığı: hesabın dayanağı, kaynak satır sonradan
 *  değişse/silinse bile kaydın İÇİNDE kalsın. */
export function standbyRef(standbyDuty, effect) {
  if (!standbyDuty || !effect) return null;
  const hhmm = (iso) => iso ? new Date(iso).toISOString().slice(11, 16) : '—';
  const label = effect.kind === 'airport_standby' ? 'AIRPORT STANDBY' : 'OTHER STANDBY';
  return `${label} ${standbyDuty.duty_date} ${hhmm(standbyDuty.report_time)}–${hhmm(standbyDuty.duty_end)}Z `
       + `(${fmtMin(effect.standbyMin)}, ${effect.reference}) → FDP −${fmtMin(effect.fdpReductionMin)}`;
}

// ── KÜMÜLATİF LİMİTLER — TEK TABLO (3 Eki 2026, FTL adım 4b · 21 Eki 2026 K5: BÜTÜN ekranların tek listesi) ────────────
// ASSIGN (`fitness`), görev durumu (`kumulatifIhlaller`), FTL LIMITS çubuğu, DUTY HISTORY / DUTY SHEET limit tablosu ve
// ASSIGN ekip tablosunun sütunları AYNI satırı, AYNI adı ve künyeyi buradan okur. 🔴 Önce üç ayrı liste, üç ayrı ad vardı
// (aynı limit gerekçede "FLT 28D", çubukta "LAST 28 D", DUTY HISTORY'de "FLIGHT 28 D") ve gösterim kuralı farklıydı.
// Ad DUTY HISTORY'ninki (Serkan 21 Eki: *"duty history'deki formatı beğeniyorum"*): `grup` + `pencere` → "DUTY 7 D";
// çubuk grubu ve pencereyi ayrı sütunda, tablolar ve gerekçeler tam adı yazar. Sıra: önce görev, sonra uçuş.
// Künyeler SHT-FTL/HG Md.13'ün bentleri (1)(a)-(ç) görev · (2)(a)-(b) uçuş. `cum`: `cumulatives` anahtarı · `lim`: kural
// seti anahtarı. `zorunlu` (4 Eki 2026, madde haritası Md.13 ③): Md.13'ün koyduğu altı sınır kural setinde OLMALI — yoksa
// toplam ÖLÇÜLEMEZ (görev CANNOT VERIFY, ASSIGN durur), sessizce "aşılmadı" sayılmaz. FLIGHT CAL YEAR'ın Md.13'te sınırı
// YOK (12 ay 1000 s var) — şirket kural seti tanımlarsa izlenir ve gösterilir.
const kumulatifLimit = (grup, pencere, cum, lim, ref, zorunlu = true) => ({
  cum, lim, grup, pencere, etiket: `${grup} ${pencere}`, ref, tur: grup === 'DUTY' ? 'duty' : 'flt', zorunlu,
  takvimYili: pencere === 'CAL YEAR',
});
export const KUMULATIF_LIMITLER = [
  kumulatifLimit('DUTY', '7 D', 'duty7d', 'duty_7d_min', 'SHT-FTL/HG Md.13(1)(a)'),
  kumulatifLimit('DUTY', '14 D', 'duty14d', 'duty_14d_min', 'SHT-FTL/HG Md.13(1)(b)'),
  kumulatifLimit('DUTY', '28 D', 'duty28d', 'duty_28d_min', 'SHT-FTL/HG Md.13(1)(c)'),
  kumulatifLimit('DUTY', 'CAL YEAR', 'dutyCalYear', 'duty_cal_year_min', 'SHT-FTL/HG Md.13(1)(ç)'),
  kumulatifLimit('FLIGHT', '28 D', 'flt28d', 'flt_28d_min', 'SHT-FTL/HG Md.13(2)(a)'),
  kumulatifLimit('FLIGHT', '12 MO', 'flt12mo', 'flt_12mo_min', 'SHT-FTL/HG Md.13(2)(b)'),
  kumulatifLimit('FLIGHT', 'CAL YEAR', 'fltCalYear', 'flt_cal_year_min', 'SHT-FTL/HG Md.13', false),
];
/** Ekranda gösterilen limit satırları — TEK KURAL (çubuk ve DUTY HISTORY): Md.13'ün zorunlu altısı her zaman (kural
 *  setinde yoksa satır kalır, "—" / NO LIMIT IN RULESET der — eksik görünür); isteğe bağlı olan yalnız tanımlıysa. */
export const gorunenLimitler = (lim) => KUMULATIF_LIMITLER.filter(x => x.zorunlu || (lim || {})[x.lim] != null);
/** Limitin adı (ör. `flt28d` → "FLIGHT 28 D") — sütun başlıkları da aynı adı yazar. */
export const limitAdi = (cum) => KUMULATIF_LIMITLER.find(x => x.cum === cum)?.etiket || cum;
/** Görevin kısa adı — uçuşta ilk kalkış–son varış (DH hariç), yer görevinde türü (OFFICE, SIM …). */
export function gorevKisaAdi(d) {
  const sek = (d?.sectors || []).filter(s => !s.deadhead);
  if (d?.duty_type === 'flight' && sek.length) {
    return `${String(sek[0].dep || '?').toUpperCase()}–${String(sek[sek.length - 1].actual_dest || sek[sek.length - 1].dest || '?').toUpperCase()}`;
  }
  return String(d?.ground_kind || d?.duty_type || 'duty').replace(/_/g, ' ').toUpperCase();
}
/** Kural setinde eksik zorunlu Md.13 sınırları (tek kaynak — görev durumu ve ASSIGN aynı cümleyi kullanır). */
export const kumulatifSinirEksik = (rules) => {
  const lim = rules?.cumulative_limits || {};
  return KUMULATIF_LIMITLER.filter(x => x.zorunlu && (lim[x.lim] == null || !Number.isFinite(Number(lim[x.lim]))));
};
export const kumulatifEksikMetni = (x) => `THIS DUTY'S RULESET DOES NOT DEFINE THE ${x.etiket} LIMIT (${x.lim}) — the total cannot be checked`;

/** GÖREV DURUMU — KÜMÜLATİF SEBEPLER (3 Eki 2026, FTL adım 4b). Ölçü ASSIGN'ınkiyle AYNI: pencere görevin BİTİŞİNDE
 *  biter (4 Eki 2026, Md.13 "herhangi 7 gün" — Serkan A; önce rapor anında bitiyordu), her görevin yalnız pencere içindeki
 *  dakikaları sayılır; planlı ve uçulmuş sayılır, iptal sayılmaz (`cumulatives`). Pilotun baseline'ı yoksa
 *  toplam bilinemez → CANNOT VERIFY (ASSIGN aynı durumda "BASELINE NOT SET" ile engeller, limit çubuğu çizilmez).
 *  @param duty     görevin satırı · alanlar: motorun hesapladığı (rapor/bitiş uçuşta buradan)
 *  @param gorevler pilotun diğer satırları (rapordan sonrakiler pencereye girmez)
 *  @returns gorevDurumu'nun `ihlaller` biçiminde liste */
export function kumulatifIhlaller({ duty, alanlar = {}, gorevler = [], baseline = null, rules = null }) {
  const d = { ...duty, ...alanlar };
  if (!d.report_time || d.duty_type === 'off' || d.status === 'cancelled') return [];
  if (!baseline) {
    return [{ tur: 'baseline_missing', durum: FTL_DURUM.CANNOT_VERIFY, ref: 'SHT-FTL/HG Md.13',
              metin: 'BASELINE NOT SET — the pilot\'s flight and duty totals before the system are unknown' }];
  }
  const lim = rules?.cumulative_limits || {};
  const cum = cumulatives(baseline, [...(gorevler || []).filter(x => x.id !== d.id), d], new Date(d.duty_end || d.report_time), rules);
  // Eksik zorunlu sınır → ölçülemedi, adıyla (4 Eki 2026 ③; önce sessizce atlanıyordu).
  const eksik = kumulatifSinirEksik(rules).map(x => ({ tur: 'ruleset_missing', durum: FTL_DURUM.CANNOT_VERIFY, ref: x.ref,
    metin: kumulatifEksikMetni(x) }));
  const oranYok = kumulatifNobetOraniEksik(rules, [...(gorevler || []), d]);
  if (oranYok.length) eksik.push({ tur: 'ruleset_missing', durum: FTL_DURUM.CANNOT_VERIFY, ref: 'SHT-FTL/HG Md.17',
    metin: nobetOraniEksikMetni(oranYok) });
  return [...eksik, ...KUMULATIF_LIMITLER.filter(({ cum: k, lim: l }) => lim[l] != null && cum[k] > lim[l])
    .map(({ cum: k, lim: l, etiket, ref }) => ({ tur: 'cumulative_limit', ref,
      metin: `${etiket} ${fmtMin(cum[k])} > ${fmtMin(lim[l])}` }))];
}

// ── TEORİK EĞİTİM — SHT-FTL/HG Md.27(1)(c) (5 Eki 2026) ───────────────────────────────────────────────────────────
// 🔑 Serkan: *"yerde yapılan bütün eğitimler, simülatör hariç"* — TRAINING ve THEORETICAL yer görevleri (simülatörün kendi
//    standardı var, Md.27(1)(a) sentetik) · gün UTC (A). Günlük sınır: görevin dokunduğu her UTC gününde, günün başından
//    görevin bitişine (ya da gün sonuna) kadar bütün yer eğitimlerinin o güne düşen dakikaları. 7 gün: Md.13 gibi görevin
//    BİTİŞİNDE biten 7 × 24 saat ("herhangi 7 gün" — toplamın tepesi hep bir görevin bitişindedir). Sayılar yalnız kural
//    setinden (`fdp_limits.training.theoretical_*`), yoksa ölçülemedi. 🔴 Önce kural setinde vardı, motor hiç okumuyordu:
//    9 saatlik teorik ders LEGAL yazılıyordu. Sunucu (`gorevHesabi`) ve kapı (`fitness`) bunu okur.
export const TEORIK_EGITIM_TURLERI = ['training', 'theoretical'];
export const teorikEgitimMi = (d) => d?.duty_type === 'ground' && TEORIK_EGITIM_TURLERI.includes(d.ground_kind)
  && d.status !== 'cancelled';
/** @returns gorevDurumu'nun `ihlaller` biçiminde liste — { tur: 'theoretical_training' | 'ruleset_missing', ref, metin } */
export function teorikEgitimIhlalleri({ duty, gorevler = [], rules = null }) {
  if (!teorikEgitimMi(duty) || !duty.report_time || !duty.duty_end) return [];
  if (esasSecili(rules)) return [];   // şirket esası seçili — Md.27 uygulanmaz (30 Eki 2026, Serkan B)
  const set = fdpLimitSet(rules, 'training');
  const gunluk = set?.theoretical_daily_max_min, haftalik = set?.theoretical_7d_max_min;
  const yok = [['theoretical_daily_max_min', gunluk], ['theoretical_7d_max_min', haftalik]]
    .filter(([, v]) => v == null || !Number.isFinite(Number(v))).map(([k]) => `fdp_limits.training.${k}`);
  const ref = 'SHT-FTL/HG Md.27(1)(c)';
  if (yok.length) {
    return [{ tur: 'ruleset_missing', durum: FTL_DURUM.CANNOT_VERIFY, ref,
              metin: `RULE SET: ${yok.join(' / ')} missing — theoretical training cannot be measured (Md.27(1)(c))` }];
  }
  const GUN = 86400000;
  const bas = new Date(duty.report_time).getTime(), son = new Date(duty.duty_end).getTime();
  const liste = [...(gorevler || []).filter(d => d.id !== duty.id && teorikEgitimMi(d) && d.report_time && d.duty_end), duty];
  const dk = (lo, hi) => liste.reduce((a, d) => {
    const x = Math.max(lo, new Date(d.report_time).getTime()), y = Math.min(hi, new Date(d.duty_end).getTime());
    return a + (y > x ? (y - x) / 60000 : 0);
  }, 0);
  const out = [];
  for (let g = Math.floor(bas / GUN) * GUN; g < son; g += GUN) {
    const t = dk(g, Math.min(g + GUN, son));
    if (t > Number(gunluk)) {
      out.push({ tur: 'theoretical_training', ref,
                 metin: `THEORETICAL TRAINING ${fmtMin(t)} ON ${utcGunAy(new Date(g).toISOString())} (UTC DAY) > MAX ${fmtMin(Number(gunluk))}` });
    }
  }
  const t7 = dk(son - 7 * GUN, son);
  if (t7 > Number(haftalik)) {
    out.push({ tur: 'theoretical_training', ref,
               metin: `THEORETICAL TRAINING ${fmtMin(t7)} IN 7 DAYS > MAX ${fmtMin(Number(haftalik))}` });
  }
  return out;
}

// ── AYNI GÜN UÇUŞ + YER EĞİTİMİ — SHT-FTL/HG Md.27(1)(ç) (5 Eki 2026, Serkan A) ──────────────────────────────────────
// "Aynı gün içerisinde uçuş/simülatör ve teorik eğitim gerçekleştirilmesi durumunda" (1) eğitim uçuş süresi sınırları YARIYA
// iner, (2) o günün uçuş + teori toplamı kural setindeki sınırı (8 saat) geçemez. Gün UTC; "teori" Md.27(1)(c) ile aynı küme
// (TRAINING + THEORETICAL). KENDİLİĞİNDEN — kayıttan okunur, dersin önce ya da sonra olması fark etmez. 🔴 Önce ASSIGN'daki
// "SAME-DAY THEORY" kutusuna bağlıydı (unutulabilir, kayıttaki dersi görmüyordu); toplam hiç ölçülmüyordu. Simülatör 5.
// bulguda eklenecek (Md.27(1)(a) sentetik). Gün: uçuşun BLOK süresinin düştüğü UTC günleri. (`GUN_MS` aşağıda, FCL bölümünde.)
/** Uçuş görevinin bacak blokları [başlangıç, bitiş] ms — gerçek planı ezer, DH sayılmaz (Md.14(1)(b)). */
const egitimBloklari = (d) => {
  const legs = (d?.sectors || []).map(x => ({ ...x, etd: x.off_block || x.etd, eta: x.on_block || x.eta }));
  const z = sektorZamanlari(d?.duty_date, legs.flatMap(l => [l.etd, l.eta]));
  return legs.map((l, k) => (l.deadhead ? null : [new Date(z[k * 2]).getTime(), new Date(z[k * 2 + 1]).getTime()]))
    .filter(x => x && Number.isFinite(x[0]) && Number.isFinite(x[1]) && x[1] > x[0]);
};
const gunOrtusmesi = (a, b, g) => Math.max(0, Math.min(b, g + GUN_MS) - Math.max(a, g)) / 60000;
// ── SİMÜLATÖR (Md.27(1)(a) son satır, 5 Eki 2026 — Serkan A: *"simülatörde öğretmenlik yapılmıyor"* → 4 saat SIM görevindeki her
//    pilota; ileride pilot yetkileri (TRI / SFI / TRE / SFE) tanımlanırsa rol ayrımı o yetkiye bağlanır). Ölçülen OTURUM: başlangıçtan
//    "Sim ends"e — görev bitişinden simülatör sonrası süre (Md.10(c)) çıkarılır, görevin KENDİ kural seti kopyasından (ASSIGN bitişi
//    aynı kuralla yazar). Sınır kural setindeki `kinds.synthetic` satırı; aynı UTC gününde yer eğitimi varsa yarıya iner (ç).
export const SIM_EGITIM_TURU = 'synthetic';
export const simMi = (d) => d?.duty_type === 'ground' && d.ground_kind === 'sim' && d.status !== 'cancelled';
/** Simülatör oturumu [başlangıç, bitiş] ms — simülatör sonrası süre kural setinden; ölçülemezse null. */
export function simOturumu(d, rules = null, company = null) {
  if (!simMi(d) || !d.report_time || !d.duty_end) return null;
  const k = d.ruleset_snapshot?.regulation ? effectiveRules(d.ruleset_snapshot) : { rules, company };
  const sonra = bildirimSureleri(k.rules, k.company, { egitim: true })?.postFlightMin;
  if (sonra == null) return null;
  const a = new Date(d.report_time).getTime(), b = new Date(d.duty_end).getTime() - sonra * 60000;
  return b > a ? [a, b] : null;
}
/** Uçuş görevlerinin "eğitim uçuşu" sayılıp sayılmadığı — kayıttaki yönetici tip (Md.9). */
const egitimUcusuMu = (d) => d?.duty_type === 'flight' && d.status !== 'cancelled' && d.operation_type === 'training';
/** Bir UTC gününün eğitim parçaları — uçuş görevi, simülatör ve kapı AYNI ölçüyü kullanır. `kendisi` listede yoksa eklenir. */
function egitimGunParcalari(g, kendisi, gorevler, rules, company) {
  const liste = [kendisi, ...(gorevler || []).filter(d => d && d.id !== kendisi.id && d.status !== 'cancelled')];
  const teoriDk = liste.filter(d => teorikEgitimMi(d) && d.report_time && d.duty_end)
    .reduce((t, d) => t + gunOrtusmesi(new Date(d.report_time).getTime(), new Date(d.duty_end).getTime(), g), 0);
  const ucusDk = liste.filter(d => d === kendisi ? d.duty_type === 'flight' : egitimUcusuMu(d))
    .reduce((t, d) => t + egitimBloklari(d).reduce((x, [a, b]) => x + gunOrtusmesi(a, b, g), 0), 0);
  const simDk = liste.filter(simMi).map(d => simOturumu(d, rules, company)).filter(Boolean)
    .reduce((t, [a, b]) => t + gunOrtusmesi(a, b, g), 0);
  return { g, teoriDk, ucusDk, simDk };
}
/** @param ucus eğitim uçuşu (sektörleri + duty_date) · gorevler pilotun diğer satırları (her tür)
 *  @returns {{ teoriVar, sinir, gunler: { g, teoriDk, ucusDk, simDk }[] }} — gunler: bu uçuşun bloklarının düştüğü UTC günleri */
export function egitimGunu({ ucus, gorevler = [], rules = null, company = null }) {
  const gunSet = new Set();
  egitimBloklari(ucus).forEach(([a, b]) => { for (let g = Math.floor(a / GUN_MS) * GUN_MS; g < b; g += GUN_MS) gunSet.add(g); });
  const sinir = fdpLimitSet(rules, 'training')?.same_day_total_cap_min;
  const gunler = [...gunSet].sort((a, b) => a - b).map(g => egitimGunParcalari(g, ucus, gorevler, rules, company));
  return { teoriVar: gunler.some(x => x.teoriDk > 0), gunler,
           sinir: sinir != null && Number.isFinite(Number(sinir)) ? Number(sinir) : null };
}
/** (ç) ikinci cümle — o günün eğitim uçuşu + simülatör + yer eğitimi toplamı. Teori olmayan günde uygulanmaz. */
export function egitimGunuToplamIhlalleri(eg) {
  const ikili = (eg?.gunler || []).filter(x => x.teoriDk > 0 && (x.ucusDk + (x.simDk || 0)) > 0);
  if (!ikili.length) return [];
  const ref = 'SHT-FTL/HG Md.27(1)(ç)';
  if (eg.sinir == null) {
    return [{ tur: 'ruleset_missing', durum: FTL_DURUM.CANNOT_VERIFY, ref, metin: 'RULE SET: fdp_limits.training.'
      + 'same_day_total_cap_min missing — the day total of training flight and ground training cannot be measured (Md.27(1)(ç))' }];
  }
  return ikili.filter(x => x.ucusDk + (x.simDk || 0) + x.teoriDk > eg.sinir).map(x => ({ tur: 'training_day_total', ref,
    metin: `TRAINING DAY ${fmtMin(x.ucusDk + (x.simDk || 0) + x.teoriDk)} ON ${utcGunAy(new Date(x.g).toISOString())} (UTC DAY) — `
      + [x.ucusDk > 0 || !x.simDk ? `FLIGHT ${fmtMin(x.ucusDk)}` : null, x.simDk ? `SIMULATOR ${fmtMin(x.simDk)}` : null,
         `GROUND TRAINING ${fmtMin(x.teoriDk)}`].filter(Boolean).join(' + ') + ` > MAX ${fmtMin(eg.sinir)}` }));
}
/** Md.27(1)(a) simülatör — SIM görevinin sebepleri: günlük oturum toplamı (görevin bitişine kadar, teori gibi) ve (ç) gün toplamı.
 *  @returns gorevDurumu'nun `ihlaller` biçiminde liste */
export function simulatorIhlalleri({ duty, gorevler = [], rules = null, company = null }) {
  if (!simMi(duty) || !duty.report_time || !duty.duty_end) return [];
  const oturum = simOturumu(duty, rules, company);
  if (!oturum) {
    return [{ tur: 'ruleset_missing', durum: FTL_DURUM.CANNOT_VERIFY, ref: 'SHT-FTL/HG Md.10',
      metin: 'RULE SET: notification_times.postflight_sim_training_min missing — the simulator session cannot be measured (Md.27(1)(a))' }];
  }
  if (egitimUcusSiniri(rules, SIM_EGITIM_TURU)?.dk == null) {
    return [{ tur: 'ruleset_missing', durum: FTL_DURUM.CANNOT_VERIFY, ref: 'SHT-FTL/HG Md.27(1)(a)',
      metin: `RULE SET: fdp_limits.training.kinds.${SIM_EGITIM_TURU}.flight_time_min missing — the simulator limit cannot be measured (Md.27(1)(a))` }];
  }
  const [bas, son] = oturum;
  const liste = [duty, ...(gorevler || []).filter(d => d && d.id !== duty.id)];
  const sinirGun = fdpLimitSet(rules, 'training')?.same_day_total_cap_min;
  const out = [];
  for (let g = Math.floor(bas / GUN_MS) * GUN_MS; g < son; g += GUN_MS) {
    const tam = egitimGunParcalari(g, duty, gorevler, rules, company);
    const sinir = egitimUcusSiniri(rules, SIM_EGITIM_TURU, tam.teoriDk > 0);
    const kadar = liste.filter(simMi).map(d => simOturumu(d, rules, company)).filter(Boolean)
      .reduce((t, [a, b]) => t + Math.max(0, Math.min(b, Math.min(g + GUN_MS, son)) - Math.max(a, g)) / 60000, 0);
    if (kadar > sinir.dk) {
      out.push({ tur: 'simulator_time', ref: sinir.ref,
        metin: `SIMULATOR ${fmtMin(kadar)} ON ${utcGunAy(new Date(g).toISOString())} (UTC DAY) > MAX ${fmtMin(sinir.dk)} — ${sinir.etiket}`
          + (sinir.yari ? ' (halved: theoretical training the same day, Md.27(1)(ç))' : '') });
    }
    out.push(...egitimGunuToplamIhlalleri({ gunler: [tam],
      sinir: sinirGun != null && Number.isFinite(Number(sinirGun)) ? Number(sinirGun) : null }));
  }
  return out;
}
/** Kapı için: bir uçuş görevinde "eğitim uçuşu" seçilebilecek türler — SİMÜLATÖR türü (`synthetic`) yalnız SIM görevinin sınırıdır. */
export const ucusEgitimTurleri = (rules) => Object.entries(fdpLimitSet(rules, 'training')?.kinds || {})
  .filter(([k]) => k !== SIM_EGITIM_TURU);
/** Kayıtlı bir eğitim uçuşunun Md.27 sebepleri, verilen görev listesiyle — kapı, yeni yer eğitiminin aynı gündeki uçuşları
 *  aşırıp aşırmadığını önce / sonra karşılaştırarak bulur. Sunucu aynı ölçüyü `gorevHesabi`nde yapar. */
/** Md.27(1)(a)(b) GÜNLÜK uçuş süresi — aynı UTC günündeki BÜTÜN eğitim uçuşlarının toplamı (5 Eki 2026, Serkan: *"aynı gün toplam
 *  süre belli, tek parça veya iki parça bu süreyi geçemez"*). 🔴 Önce her görev ayrı ölçülüyordu: sabah 2 + öğleden sonra 3 saatlik
 *  tip eğitimi (sınır 4) ikisi de LEGAL. Yalnız başka görevler de toplama girdiğinde yazılır — görevin kendi süresi aşıyorsa görev
 *  başına sebep zaten yazılır (aynı ihlal iki kez yazılmaz). Bütün gün sayılır (önce ya da sonra): gün bir bütün olarak aşılır.
 *  @param sinir egitimUcusSiniri(...) — { dk, ref, etiket, yari } */
export function egitimGunlukUcusIhlalleri(ucus, eg, sinir) {
  if (sinir?.dk == null || !eg) return [];
  const kendi = egitimBloklari(ucus);
  return (eg.gunler || []).filter(x => {
    const kendiDk = kendi.reduce((t, [a, b]) => t + gunOrtusmesi(a, b, x.g), 0);
    return x.ucusDk > kendiDk && x.ucusDk > sinir.dk;
  }).map(x => ({ tur: 'training_flight_time', ref: sinir.ref,
    metin: `TRAINING FLIGHT TIME ${fmtMin(x.ucusDk)} ON ${utcGunAy(new Date(x.g).toISOString())} (UTC DAY — ALL TRAINING FLIGHTS) `
      + `> MAX ${fmtMin(sinir.dk)}` + (sinir.etiket ? ` — ${sinir.etiket}` : '')
      + (sinir.yari ? ' (halved: theoretical training the same day, Md.27(1)(ç))' : '') }));
}
export function egitimUcusuIhlalleri(ucus, gorevler, rules, company = null) {
  if (ucus?.duty_type !== 'flight' || ucus.operation_type !== 'training' || ucus.status === 'cancelled') return [];
  if (esasSecili(rules)) return [];   // şirket esası seçili — Md.27 uygulanmaz (30 Eki 2026, Serkan B)
  const eg = egitimGunu({ ucus, gorevler, rules, company });
  const sinir = egitimUcusSiniri(rules, ucus.training_kind, eg.teoriVar);
  const ucusDk = egitimBloklari(ucus).reduce((t, [a, b]) => t + (b - a) / 60000, 0);
  const out = [];
  if (sinir?.dk != null && ucusDk > sinir.dk) {
    out.push({ tur: 'training_flight_time', ref: sinir.ref, metin: egitimUcusAsimMetni({ flightMin: ucusDk,
      flightLimitMin: sinir.dk, flightLimitLabel: sinir.etiket, flightLimitHalved: sinir.yari }) });
  }
  return [...out, ...egitimGunlukUcusIhlalleri(ucus, eg, sinir), ...egitimGunuToplamIhlalleri(eg)];
}

// ── Kümülatifler ────────────────────────────────────────────────────
// baseline: ftl_pilot_baselines satırı (yoksa null)
// duties: pilotun crew_duties satırları (effective_date sonrası; status fark etmez — planned da sayılır)
// asOf: Date — pencere sonu
// Muhafazakâr devir: baseline penceresi, effective_date + pencere süresi boyunca TAM sayılır.
export function cumulatives(baseline, duties, asOf, rules = null) {
  // IPTAL EDILEN GOREV SAYILMAZ (17 Agu 2026, Serkan: "iptaller ve edit
  // edilmisler guncellensin, sayilmasin — en guncel durumu takip etsin, aksi
  // halde yanlis dag gibi buyur; orada zaten emniyet kapimiz EDIT REPORT").
  //
  // Once hicbir status filtresi YOKTU: PLN -> "gerceklesmedi" deyip iptal
  // edilen bir gorev kumulatif toplamda durmaya devam ediyordu. Bu hem yeni
  // FTL LIMITS panelini hem atama sihirbazinin NOT LEGAL kapisini olmayan
  // saatlerle besliyordu. Yon emniyetli taraftaydi (fazla gosteriyordu) ama
  // yanlisti ve her iptalde birikiyordu.
  //
  // 'planned' ve 'open' SAYILIR: biri henuz uculmamis ama planlanmis gorev
  // (ORO.FTL.110 — limit planlama asamasinda da tutmali), digeri arsivde
  // kapanmamis gercek gorev. Yalnizca 'cancelled' dusuyor.
  // (daysOffSummary ayni filtreyi zaten uyguluyordu.)
  duties = (duties || []).filter(d => d.status !== 'cancelled');

  const DAY = 86400000;
  const asOfT = asOf.getTime();
  const baseT = baseline ? new Date(baseline.effective_date).getTime() : null;
  const baseCarry = (days, val) => {
    if (!baseline || baseT == null) return 0;
    return (baseT + days * DAY) >= asOfT ? (val || 0) : 0; // pencere hâlâ devri kapsıyor mu
  };
  // ── PENCERE: "BİRBİRİNİ İZLEYEN HERHANGİ 7 / 14 / 28 GÜN" (Md.13, 4 Eki 2026 — Serkan A: *"herhangi 7 gün"*) ──────
  // Pencere [asOf − N × 24 saat, asOf]; görevin (uçuşta sektörün) YALNIZ pencerenin İÇİNDE kalan dakikaları sayılır.
  // Metin "gün"ü tanımlamaz; takvime bağlı dönemleri adıyla söyler (yerel gün, takvim ayı, takvim yılı) — Md.13(1)
  // bunların hiçbirini demez. Görevin kendi ölçüsü pencere görevin BİTİŞİNDE biterken alınır (`kumulatifIhlaller`, `fitness`).
  // 🔴 Önce raporu pencereye düşen görevin TAMAMI sayılıyor, raporu pencereden hemen önce olan HİÇ sayılmıyordu; ölçü de
  //    raporda bitiyordu. Ölçüldü: gerçek 61:00 iken 56:00 LEGAL · gerçek 56:00 iken 60:00.
  // Baseline tarihinden önceki dakikalar sayılmaz — onları baseline taşır (`baseCarry`).
  const an = (x) => { const t = x ? new Date(x).getTime() : NaN; return Number.isFinite(t) ? t : null; };
  const altSinir = (bas) => (baseT != null ? Math.max(bas, baseT) : bas);
  const ortusmeDk = (a, b, bas) => {
    const lo = Math.max(a, altSinir(bas)), hi = Math.min(b, asOfT);
    return hi > lo ? (hi - lo) / 60000 : 0;
  };
  // Saati olmayan eski kayıt: kısmı ölçülemez — tarihi pencereye düşüyorsa tamamı sayılır (eski davranış, muhafazakâr).
  const noktaIcinde = (d, bas) => {
    const t = an(d.report_time) ?? an(d.duty_date);
    return t != null && t >= altSinir(bas) && t <= asOfT;
  };
  // Md.23(1) + Md.4(o) (5 Eki 2026): simülatöre bağlı uçuşta simülatör ile uçuş arasındaki MOLA görevdir — uçuş görevi
  // simülatörün bitişinden sayılır (iki kayıt ayrı; simülatörün kendi saatleri iki kez sayılmaz). Bağ `simBaglantisi`nin
  // ölçüsüyle, bir kez ve sıralı listede ikili aramayla kurulur; pilotun simülatörü yoksa hiç aranmaz.
  const simdenSonra = new Map();
  // Md.23(1) uçuştan SONRA simülatör (14 Eki 2026): uçuşun görevi simülatörün bitişine kadar sayılır — periyodun İÇİNDEKİ yer
  // görevinin kendi dakikaları sayılmaz (iki kez sayılırdı) ve o yer görevi sonraki uçuşun periyodunu başlatmaz.
  const kapsanan = ucusIcindekiYerGorevleri(duties);
  if ((duties || []).some(ugsBaslatanMi)) {   // simülatör + yer eğitimi (5 Eki 2026)
    const sirali = (duties || []).filter(d => d && d.duty_type !== 'off' && d.status !== 'cancelled' && d.duty_end)
      .map(d => ({ d, t: new Date(d.duty_end).getTime() })).sort((x, y) => x.t - y.t);
    (duties || []).forEach(u => {
      if (u?.duty_type !== 'flight' || u.status === 'cancelled' || !u.report_time) return;
      const r = new Date(u.report_time).getTime();
      let lo = 0, hi = sirali.length - 1, k = -1;
      while (lo <= hi) { const m = (lo + hi) >> 1; if (sirali[m].t <= r) { k = m; lo = m + 1; } else hi = m - 1; }
      while (k >= 0 && (sirali[k].d === u || sirali[k].d.pilot_id !== u.pilot_id)) k--;
      const o = k >= 0 ? sirali[k].d : null;
      if (o && ugsBaslatanMi(o) && o.earliest_next_report && !kapsanan.has(o)
          && r < new Date(o.earliest_next_report).getTime() && sirali[k].t < r) simdenSonra.set(u, o.duty_end);
    });
  }
  const gorevDk = (d, bas) => {
    if (d.duty_type === 'off' || kapsanan.has(d)) return 0;
    const a = an(simdenSonra.get(d) ?? d.report_time), b = an(d.duty_end);
    if (a != null && b != null) {
      const dk = ortusmeDk(a, Math.max(a, b), bas);
      // Md.17(2)(g): havaalanı harici nöbette geçen sürenin %25'i, (1)(b) havaalanı nöbetinin tamamı görev sayılır — oran
      // YALNIZ kural setinden (5 Eki 2026, Md.17 ③ / Md.13 ⑤; eskiden `?? 0.25` ve havaalanında koddan 1). Oran yoksa sayılamaz:
      // 0 eklenir ve `kumulatifNobetOraniEksik` görevi / kapıyı ÖLÇÜLEMEDİ yapar.
      if (d.duty_type === 'ground' && NOBET_BLOGU[d.ground_kind]) {
        const r = nobetGorevOrani(d.ground_kind, rules);
        return r == null ? 0 : Math.round(dk * r);
      }
      return dk;
    }
    return noktaIcinde(d, bas) ? (d.fdp_minutes || 0) : 0;
  };
  const ucusDk = (d, bas) => {
    if (d.duty_type !== 'flight') return 0;
    // 🔴 KONUMLANDIRMA UCUS SAATI DEGILDIR (SHT-FTL/HG Md.14, 22 Agu 2026).
    // Serkan: *"duty time devamindaki resti belirler ama flight duty gibi flt
    // time limitlerini belirlemez."* DH bacaklari ayni gorevin sektor
    // listesinde durur (FDP'ye girmeleri gerektigi icin) ama UCUS SAATI
    // kumulatiflerine (28 gun / 12 ay) girmezler. Suzgec konmazsa pozisyon
    // ucusu pilotun ucus saatine yazilirdi — tam olarak olmamasi gereken sey.
    // Sektör anları motorun TEK kuralıyla (`sektorZamanlari`, gorevHesabi ile aynı): gerçek varsa o, yoksa plan (alan alan).
    const legs = (d.sectors || []).map(x => ({ ...x, etd: x.off_block || x.etd, eta: x.on_block || x.eta }));
    const zincir = sektorZamanlari(d.duty_date, legs.flatMap(l => [l.etd, l.eta]));
    let sum = 0;
    legs.forEach((l, k) => {
      if (l.deadhead) return;
      const a = an(zincir[k * 2]), b = an(zincir[k * 2 + 1]);
      if (a != null && b != null) sum += ortusmeDk(a, b, bas);
      else if (noktaIcinde(d, bas)) sum += spanMin(l.etd, l.eta) || 0;
    });
    return sum;
  };
  const sum = (days, fn) => duties.reduce((a, d) => a + fn(d, asOfT - days * DAY), 0);
  // Takvim yılı UTC'dir (Serkan 3 Eki 2026: *"UTC olması lazım"*) — eskiden çalışan makinenin yerel saatiyle ayrılıyordu:
  // sunucu (UTC) ile ofisteki tarayıcı (İstanbul) yılbaşı gecesi üç saat boyunca farklı yıla sayıyordu.
  // Pencere [1 Ocak 00:00Z, asOf] — yılbaşını geçen görevin yalnız bu yıla düşen kısmı.
  const year = asOf.getUTCFullYear();
  const yilBasi = Date.UTC(year, 0, 1);
  const sumCalYear = (fn) => duties.reduce((a, d) => a + fn(d, yilBasi), 0);
  // 12 TAKVİM AYI (Md.13(2)(b) "birbirini izleyen herhangi 12 takvim ayı", 4 Eki 2026 — Serkan A): pencere ölçü anının ayı
  // dahil geriye 12 takvim ayı (UTC), ilk ayın 1'i 00:00Z'den ölçü anına; içindeki dakikalar. 🔴 Önce son 365 gündü — metin
  // "takvim ayı" der (7 / 14 / 28 günde "takvim" demez, orada 7 × 24 saat). Baseline'daki 12 aylık toplam, pencere baseline
  // tarihini içerdikçe taşınır (muhafazakâr).
  const onIkiAyBasi = Date.UTC(year, asOf.getUTCMonth() - 11, 1);
  const sumOnIkiAy = (fn) => duties.reduce((a, d) => a + fn(d, onIkiAyBasi), 0);
  const onIkiAyDevri = baseline && baseT != null && baseT >= onIkiAyBasi ? (baseline.flt_12mo_min || 0) : 0;
  return {
    duty7d:  baseCarry(7, baseline?.duty_7d_min)  + sum(7, gorevDk),
    duty14d: baseCarry(14, baseline?.duty_14d_min) + sum(14, gorevDk),
    duty28d: baseCarry(28, baseline?.duty_28d_min) + sum(28, gorevDk),
    dutyCalYear: (baseline && new Date(baseline.effective_date).getUTCFullYear() === year ? (baseline.duty_cal_year_min || 0) : 0) + sumCalYear(gorevDk),
    flt28d:  baseCarry(28, baseline?.flt_28d_min) + sum(28, ucusDk),
    fltCalYear: (baseline && new Date(baseline.effective_date).getUTCFullYear() === year ? (baseline.flt_cal_year_min || 0) : 0) + sumCalYear(ucusDk),
    flt12mo: onIkiAyDevri + sumOnIkiAy(ucusDk),
  };
}

// ── PLANLAMA GÖRÜNÜMÜ — "roster planlandığı gibi giderse ne olur?" ──
//
// Serkan (17 Ağu 2026): "Bu roster planlandığı gibi uçulursa, herhangi bir
//  anda limit aşılıyor mu? Planlandığı gibi giderse durumunu görmeliyiz;
//  planlama değişirse de değişim sonrasında tekrar güncellenmeli."
//
// SORUN: `cumulatives()` penceresi ŞU ANDA biter (`t <= asOfT`). Gelecekteki
// planlı görevler hesaba HİÇ girmez — FTL LIMITS panelinde mor (planlanan)
// pay bu yüzden hiç görünmüyordu. `fitness()` için doğru davranıştı (o,
// denenen görevi ayrıca kendisi ekliyor) ama "ACTUAL + PLANNED" diyen bir
// gösterge için yanlıştı.
//
// ÇÖZÜM — üst sınırı KALDIRMAK DEĞİL (o zaman [şimdi−28g, ∞) olurdu ve
// pencere olmaktan çıkardı), DEĞERLENDİRME ANINI KAYDIRMAK:
//   noktalar = şu an + gelecekteki her görevin BİTİŞİ
//   her nokta X için cumulatives(..., X) → [X−28g, X] penceresi
//   sonuç = noktaların EN BÜYÜĞÜ (en kötü an)
// Kümülatif toplam bir görev biter bitmez tepe yapar; o yüzden değerlendirme
// noktası `duty_end`tir.
//
// `cumulatives()` DEĞİŞTİRİLMEDİ — dolayısıyla `fitness()` kapısı aynı kaldı.
//
// Dönüş: { <anahtar>: { now, worst, worstAt } }
//   now     bugünkü değer
//   worst   plan gerçekleşirse ulaşılacak en yüksek değer
//   worstAt o değerin oluştuğu an (ISO) — null ise tepe zaten bugün
export function cumulativesOutlook(baseline, duties, asOf, rules = null) {
  const asOfT = asOf.getTime();
  const now = cumulatives(baseline, duties, asOf, rules);

  const points = [...new Set(
    (duties || [])
      .filter(d => d.status !== 'cancelled')
      .map(d => d.duty_end || d.report_time || d.duty_date)
      .filter(Boolean)
      .map(x => new Date(x).getTime())
      .filter(t => Number.isFinite(t) && t > asOfT)
  )].sort((a, b) => a - b);

  const out = {};
  Object.keys(now).forEach(k => { out[k] = { now: now[k], worst: now[k], worstAt: null }; });

  for (const t of points) {
    const c = cumulatives(baseline, duties, new Date(t), rules);
    Object.keys(c).forEach(k => {
      if (c[k] > out[k].worst) { out[k].worst = c[k]; out[k].worstAt = new Date(t).toISOString(); }
    });
  }
  return out;
}

// ── SEKTÖR SAATLERİ — TEK KAYNAK (19 Eyl 2026) ────────────────────────
//
// 🔑 Serkan: *"Bizim felsefemiz gereği tek kaynak / tek veri; bütün datalar
//    tek tabloda olmalı ve ihtiyaç hâlinde hangi modülde olursak olalım
//    oradan çekmeliyiz."* · *"Aynı data farklı farklı yerlerde olamaz, bu
//    mimari karara aykırı."*
//
// 🔴 ÖLÇÜLEN HAL (19 Eyl): aynı dört saat ÜÇ yerde duruyordu —
//    `archived_flights` (478-481, DÖRDÜ, tam zaman damgası) ·
//    `flt_report` (747-748, DÖRDÜ) ·
//    `crew_duties.sectors` (1290/1492/1567, YALNIZ İKİSİ, tarihsiz "HH:MM").
//    Sektördeki kopya hem FAZLA hem EKSİKti: EDIT ekranında T/O ve LND her
//    seferinde boş geliyordu — Serkan sahada bunu gördü ve sordu.
//
// 🔴 VE BİÇİMİ DE YANLIŞTI. Sektör saati tarihsiz `"00:10"`dur; sahibi olan
//    uçuş kaydı ise tam andır (`2026-09-16T00:10:00Z`). 15 Eyl EGLF–LTBA'daki
//    gün devri kusuru tam buradan çıkmıştı: tarihsiz saat yanlış güne çakıldı,
//    FDP −19:25 oldu, azami UGS fiilen denetlenmedi. Sahip uçuş kaydı olunca
//    o kusur SINIF OLARAK ortadan kalkar — tarih zaten değerin içinde.
//
// 🔑 SAHİPLİK: uçulmuş sektörün saatlerinin sahibi UÇUŞ KAYDIdır. Sektör
//    yalnız bağı taşır. Uçulmamış/kâğıt girişte sahip sektörün kendisidir
//    (henüz bir uçuş kaydı yoktur) — her sektör için sahip TEKTİR.
//
// ⚠️ Dakikalar burada TÜRETİLİR, saklanmaz — ama `archived_flights` ve
//    `manual_flights` kendi `block_minutes`/`airborne_minutes` sütunlarını
//    tutmaya devam eder: STATISTICS onları okuyor ve gece/gündüz sayacı
//    onlara dayanıyor (Serkan: *"dakika önemli, gece gündüz için bence de
//    dk kalmalı"*).
const hhmm = (iso) => {
  if (!iso) return '';
  const t = new Date(iso);
  return isNaN(t.getTime()) ? '' : t.toISOString().slice(11, 16);   // UTC
};

/**
 * Bir sektörün gerçekleşen saatleri, TEK sahipten.
 * @param {object} sector crew_duties.sectors[] ögesi
 * @param {object|null} ucus bagli `archived_flights` satiri (varsa SAHIP odur)
 * @returns {{off_block:string, takeoff_time:string, landing_time:string,
 *            on_block:string, offISO:string|null, toISO:string|null,
 *            lndISO:string|null, onISO:string|null,
 *            blockMin:number|null, airborneMin:number|null,
 *            kaynak:'flight'|'sector'|null}}
 */
// ── UÇULMUŞ BACAĞIN DÖRT ZAMANI — TEK KURAL (2 Eki 2026) ─────────────
// 🔑 Serkan (2 Eki 2026): *"kalkış iniş girilmeyen uçuş olmaz"* · *"off block take off land on blok girilmek
//    zorunda"* · geriye dönük uçuşta dört gerçek zaman sorulur (*"a"*).
// 🔴 ÖNCESİ (ölçüldü 2 Eki): yalnız iPad End Flt dördünü zorunlu tutuyordu; web RECORD AS FLOWN yalnız OFF/ON'u,
//    geriye dönük atama planlanan ETD/ETA'yı GERÇEK blok diye yazıyordu (T/O–LDG boş), PAPER OFP zamana bakmıyordu,
//    ARCHIVED FLTS'te zaman silinebiliyordu. T/O ya da LDG'si eksik uçuş uçak/motor saatine HİÇ girmiyordu.
// Dönüş: eksikler (insan-okur); boş dizi = tamam. DH bacağı ölçülmez (pilot yolcu, uçmuyor).
/** Günün saati (00:00–23:59) geçerli mi — uçulmuş bacak kapısının ölçüsü; zorunlu alan rengi de bunu okur (5 Eki 2026). */
export const saatGecerli = (v) => /^([01]?\d|2[0-3]):[0-5]\d$/.test(String(v || ''));

export function ucusZamanlariEksigi(sektorler) {
  const ad = { off_block: 'OFF BLOCK', takeoff_time: 'T/O', landing_time: 'LND', on_block: 'ON BLOCK' };   // ekrandaki sütun adları
  const gecerli = saatGecerli;
  const out = [];
  (sektorler || []).forEach((s, i) => {
    if (!s || s.deadhead) return;
    const eksik = Object.keys(ad).filter(k => !gecerli(s[k]));
    if (eksik.length) {
      out.push(`Sector ${i + 1}${s.dep && s.dest ? ` ${s.dep}→${s.dest}` : ''}: ${eksik.map(k => ad[k]).join(', ')} missing (HH:MM)`);
    }
  });
  return out;
}

// ── ROTA KOPUKLUĞU — UYARI (5 Eki 2026) ─────────────────────────────────────────────────────────────────────────
// 🔑 Serkan: *"LTAC-LTBA / LTBA-LTFE / LTFE-LTDB uçuşunda 2. bacak silinirse uçak İstanbul'dan Bodrum'a uçuşu olmadan gitmiş
//    gibi görünür, uyarı vermesi lazım, EDIT ekranında en azından"*. Bir bacağın kalkışı öncekinin varışı (divertte
//    gerçek varış) değilse ADIYLA söylenir. ENGEL DEĞİL: ekip arada karayoluyla gidebilir; bilgi ekrana gelir.
// @returns string[] — boşsa rota kesintisiz. DH bacağı da rotanın parçasıdır (ekip orada).
export function rotaKopukluklari(sektorler) {
  const kod = (v) => String(v || '').trim().toUpperCase();
  const out = [];
  const s = sektorler || [];
  for (let i = 1; i < s.length; i++) {
    const onceki = kod(s[i - 1]?.actual_dest || s[i - 1]?.dest);
    const simdi = kod(s[i]?.dep);
    if (onceki && simdi && onceki !== simdi) {   // boş meydan ölçülmez (eksiği başka kural söyler)
      out.push(`ROUTE GAP — sector ${i} ends at ${onceki}, sector ${i + 1} departs ${simdi}: no flight ${onceki}→${simdi} `
        + 'is recorded. A sector may be missing — add it with + ADD (or the crew travelled by road).');
    }
  }
  return out;
}

// ── SKPK RAPORUNUN İŞLETİCİYE SON TARİHİ — TEK KURAL (5 Eki 2026, Serkan A) ─────────────────────────────────────────
// Md.12(1)(c)(1): kaptan UGS'yi uzattığında / dinlenmeyi kısalttığında işleticiye rapor sunar — metin SÜRE VERMEZ; süre
// şirketin kural setindeki `company.mandatory_report_hours`. Yoksa ya da sayı değilse son tarih YOK (null) — koddan sayı
// uydurulmaz. 🔴 Önce motor, ASSIGN, EDIT ve arşiv boş alanda sessizce 72 saat kullanıyordu; RULE SET ekranı "boş" gösteriyordu.
export function skpkRaporSonTarihi(bitisISO, saat) {
  const h = saat == null || saat === '' ? NaN : Number(saat);
  if (!bitisISO || !Number.isFinite(h)) return null;
  const t = new Date(bitisISO).getTime();
  return Number.isNaN(t) ? null : new Date(t + h * 3600000).toISOString();
}

// ── BACAK SAATLERİNİN SIRASI — TURNAROUND, Md.4(1)(v) · Md.7(1)(e) (5 Eki 2026, Serkan A) ─────────────────────────
// 🔑 Serkan: *"a"* — bir bacak bir öncekinin inişinden ÖNCE kalkıyorsa giriş durur, bacak ADIYLA söylenir.
// 🔴 ÖLÇÜLDÜ (5 Eki): 08:00–10:00 + 09:30–11:00 sessizce LEGAL kaydediliyordu — ekran UGS 4:00 sayıyor, sunucu görev bitişini
//    ERTESİ GÜNE yazıyordu (dinlenme, sonraki görev, kümülatif bir gün kayardı).
// Saatler tarihsiz (SS:DD UTC) girilir; motor onları SIRAYLA okur ve geriye düşen saati ertesi güne alır (`sonrakiAn`,
// `sektorZamanlari`) — gece yarısını geçen bacak (inişi 23:50, sonraki kalkış 00:30) böyle doğru okunur. Çakışan bacak da
// aynı okumayla ertesi güne kayar, ama görevi 24 saatin ötesine taşır: tarihsiz saatle 24 saatten uzun görev YAZILAMAZ
// (hiçbir SHT-FTL/HG azami UGS'si 24 saate yaklaşmaz). Sınır mevzuat sayısı değil, giriş biçiminin sınırıdır.
// Turnaround için asgari bir süre YOK (SHT sayı vermez, Md.7(1)(e) işletici planlaması) — 0 dakika geçer.
// @param sektorler sıralı sektörler (DH dahil) · @param alanlar her sektörde okunacak saat alanları, sırasıyla
// @returns null = sıra doğru · metin = ilk hatanın yeri (insan-okur)
const BACAK_SAAT_ADI = { etd: 'ETD', eta: 'ETA', off_block: 'OFF BLOCK', takeoff_time: 'T/O', landing_time: 'LND',
                         on_block: 'ON BLOCK' };
export function bacakSirasiHatasi(sektorler, alanlar = ['etd', 'eta']) {
  const dk = (v) => {
    const m = /^([01]?\d|2[0-3]):([0-5]\d)$/.exec(String(v || ''));
    return m ? Number(m[1]) * 60 + Number(m[2]) : null;
  };
  const bacakAdi = (s, i) => `SECTOR ${i + 1}${s?.dep && s?.dest ? ` ${String(s.dep).toUpperCase()}→${String(s.dest).toUpperCase()}` : ''}`;
  // Hata, görevi 24 saatin ötesine taşıyan GERİ ADIMDA söylenir (saatin geriye düştüğü yer) — aşımın fark edildiği sonraki
  // saatte değil: OFF BLOCK 10:00, T/O 09:50, LND 11:00 → "T/O 09:50 IS BEFORE OFF BLOCK 10:00".
  let onceki = null, toplam = 0, geri = null;
  for (let i = 0; i < (sektorler || []).length; i++) {
    const s = sektorler[i];
    for (const k of alanlar) {
      const v = dk(s?.[k]);
      if (v == null) continue;                     // boş/eksik alan atlanır (eksiği başka kural söyler)
      const bu = { v, i, k, ham: s[k] };
      if (onceki) {
        if (v < onceki.v) geri = { bu, onceki };   // saat geriye düştü — gün devri (gece yarısı) ya da çakışma
        toplam += v >= onceki.v ? v - onceki.v : v + 1440 - onceki.v;
        if (toplam >= 1440) {
          const { bu: h, onceki: o } = geri || { bu, onceki };
          return `${bacakAdi(sektorler[h.i], h.i)}: ${BACAK_SAAT_ADI[h.k] || h.k} ${h.ham} IS BEFORE `
            + `${o.i === h.i ? '' : `${bacakAdi(sektorler[o.i], o.i)} `}${BACAK_SAAT_ADI[o.k] || o.k} ${o.ham} — times are entered `
            + 'without a date, so this would run the duty past 24 hours. Correct the time; a flight on a later day is a separate '
            + 'duty (SHT-FTL/HG Md.4(1)(v), Md.7(1)(e)).';
        }
      }
      onceki = bu;
    }
  }
  return null;
}

/** EDIT → ARŞİV: TEK SAHİP 2. ADIM (5 Eki 2026).
 *  🔑 Serkan: *"ekip görev saatleri arşive de yansımalı çünkü ekip kayıt etmiş ve bunun sehven yanlış olduğunu beyan eder,
 *     edit yapılır, log açıklaması ile kayıt edilir; aksi halde veri uyuşmazlığı olur."*
 *  🔴 ÖNCESİ: iPad uçuşunda EDIT yalnız görevin sektör saatini değiştiriyordu; uçak saatlerinin kaynağı arşiv kaydı aynı
 *     kalıyordu (veri uyuşmazlığı) ve sonraki rapor yeniden üretimi görevi arşivin saatine geri çekiyordu.
 *  Arşivi olan (plan_id → archived_flights) bacağın dört zamanı EDIT'te değiştiyse arşivin düzeltmesi: ISO zamanlar görevin
 *  gün devri zinciriyle (`sektorZamanlari`, EDIT'in görev yazmasıyla aynı), süreler dört zamandan, iz ARCHIVED FLTS biçiminde
 *  (alan alan, SS:DD). Uçulmuş uçuş dört zamanını korur: biri boşsa `eksik` dolu döner, arşiv yazılmaz.
 *  @param sektorler görevin kayıttaki sektörleri · @param yeni / ilk EDIT'teki dört zaman (yeni / açılış — arşivden)
 *  @param ucuslar { plan_id: archived_flights satırı (id dahil) } · @param tarih görevin tarihi
 *  @returns {{ afId, planId, rota, guncelle, izler: {alan, eski, yeni}[], eksik: string[] }[]} */
export function arsivSaatDuzeltmeleri({ sektorler, yeni, ilk, ucuslar, tarih }) {
  const K = [['off_block', 'off_blocks'], ['takeoff_time', 'takeoff_time'], ['landing_time', 'landing_time'], ['on_block', 'on_blocks']];
  const zincir = sektorZamanlari(tarih, (yeni || []).flatMap(g => K.map(([k]) => g?.[k] || null)));
  const ss = (iso) => (iso ? new Date(iso).toISOString().slice(11, 16) : '');
  const sure = (dk) => (dk == null ? '' : `${String(Math.floor(dk / 60)).padStart(2, '0')}:${String(dk % 60).padStart(2, '0')}`);
  const fark = (b, e) => Math.round((new Date(e).getTime() - new Date(b).getTime()) / 60000);
  const out = [];
  (sektorler || []).forEach((x, i) => {
    const af = x?.plan_id ? ucuslar?.[String(x.plan_id)] : null;
    if (!af) return;
    const g = yeni?.[i] || {}, o = ilk?.[i] || {};
    if (!K.some(([k]) => (g[k] || '') !== (o[k] || ''))) return;
    const rota = `${x.dep || '?'}-${x.dest || '?'}`;
    const eksik = K.filter(([k]) => !g[k]).map(([k]) => k);
    if (eksik.length) { out.push({ afId: af.id ?? null, planId: x.plan_id, rota, guncelle: {}, izler: [], eksik }); return; }
    const an = zincir.slice(i * 4, i * 4 + 4);
    const guncelle = {}, izler = [];
    K.forEach(([k, a], j) => {
      if ((g[k] || '') === (o[k] || '')) return;
      guncelle[a] = an[j];
      izler.push({ alan: a, eski: ss(af[a]), yeni: g[k] });
    });
    const blok = fark(an[0], an[3]), hava = fark(an[1], an[2]);
    if (blok !== af.block_minutes) { guncelle.block_minutes = blok; izler.push({ alan: 'block_minutes', eski: sure(af.block_minutes), yeni: sure(blok) }); }
    if (hava !== af.airborne_minutes) { guncelle.airborne_minutes = hava; izler.push({ alan: 'airborne_minutes', eski: sure(af.airborne_minutes), yeni: sure(hava) }); }
    out.push({ afId: af.id ?? null, planId: x.plan_id, rota, guncelle, izler, eksik: [] });
  });
  return out;
}
export function sektorSaatleri(sector, ucus = null) {
  const s = sector || {};
  // Uçuş kaydı bu dördünden BİRİNİ bile taşıyorsa sahip odur.
  const ucusVar = !!ucus && [ucus.off_blocks, ucus.takeoff_time,
                             ucus.landing_time, ucus.on_blocks].some(Boolean);

  // Geçiş dönemi: sahip bir alanı taşımıyorsa sektörün eski kopyasına düşülür.
  // Adım 2'de sektördeki kopya kalkınca bu dallar kendiliğinden ölür.
  const offISO = ucusVar ? (ucus.off_blocks || null) : null;
  const toISO  = ucusVar ? (ucus.takeoff_time || null) : null;
  const lndISO = ucusVar ? (ucus.landing_time || null) : null;
  const onISO  = ucusVar ? (ucus.on_blocks || null) : null;

  const off = hhmm(offISO) || s.off_block || '';
  const to  = hhmm(toISO)  || s.takeoff_time || '';
  const lnd = hhmm(lndISO) || s.landing_time || '';
  const on  = hhmm(onISO)  || s.on_block || '';

  // SÜRE: tam an varsa DÜZ çıkarma (gün devri diye bir sorun yok). Yoksa
  // "HH:MM" karşılaştırması — geriye giden saat ertesi gündür (spanMin).
  const fark = (a, b, aS, bS) => {
    if (a && b) {
      const d = (new Date(b).getTime() - new Date(a).getTime()) / 60000;
      return Number.isFinite(d) ? Math.round(d) : null;
    }
    return (aS && bS) ? spanMin(aS, bS) : null;
  };

  return {
    off_block: off, takeoff_time: to, landing_time: lnd, on_block: on,
    offISO, toISO, lndISO, onISO,
    blockMin: fark(offISO, onISO, off, on),
    airborneMin: fark(toISO, lndISO, to, lnd),
    kaynak: ucusVar ? 'flight' : ((off || on || to || lnd) ? 'sector' : null),
  };
}

// ── İMKÂNSIZ DEĞER KAPISI (19 Eyl 2026 — 18 Eyl saha turu, 14 numara) ──
//
// 🔑 Serkan: *"−19:25'lik bir FDP bir hesap değil, ARIZA işaretidir."*
//
// 🔴 NEDEN VAR: dinlenme kapısı `earliest_next_report` adlı SAKLANMIŞ, TÜREV
//    bir değere güveniyor. O değer bozulduğunda kapı sessizce açılıyor —
//    çünkü bozuk değer *geçerli bir tarih* gibi görünüyor, sadece YANLIŞ.
//    18 Eyl 2026 vakası: gün devri kusuru yüzünden FDP −19:25 çıktı,
//    `earliest_next_report` 15 Eyl 10:40 (GEÇMİŞ) oldu, 16 Eylül görevi
//    atanırken `lastENR > newReport` FALSE döndü ve **hiçbir uyarı çıkmadı**.
//    Kapı kurgu olarak doğruydu; onu delen VERİYDİ.
//
// 🔑 KURAL: bunlar bir eşik değil, ARİTMETİK. Negatif süre yoktur; görev
//    raporundan önce bitemez; dinlenme, bitirdiği görevden önce bitemez.
//    Hiçbir sayı uydurulmadı (İlke A6).
//
// ⚠️ NE YAPAR, NE YAPMAZ: imkânsız değer taşıyan görev "uygun" SAYILMAZ —
//    ama "ihlal" de denmez. Doğrusu **ÖLÇÜLEMEDİ**'dir (İlke 1): o görevin
//    dinlenme borcu bilinmiyordur, dolayısıyla arkasına görev konamaz.
//    Kaydın kendisi silinmez/gizlenmez; ekranda adıyla görünür.
/**
 * Bir görev kaydındaki fiziksel olarak imkânsız değerler.
 * @returns {string[]} insan-okur liste; boşsa değerler tutarlı demektir.
 */
export function imkansizDegerler(d) {
  const out = [];
  if (!d) return out;
  const an = (x) => { const t = x ? new Date(x).getTime() : null; return Number.isFinite(t) ? t : null; };
  const rep = an(d.report_time), end = an(d.duty_end), enr = an(d.earliest_next_report);

  if (d.fdp_minutes != null && d.fdp_minutes < 0) out.push(`FDP ${fmtMin(d.fdp_minutes)}`);
  if (d.min_rest_minutes != null && d.min_rest_minutes < 0) out.push(`MIN REST ${fmtMin(d.min_rest_minutes)}`);
  if (rep != null && end != null && end < rep) out.push('DUTY ENDS BEFORE REPORT');
  // Dinlenme görevin bitişinden başlar; ondan ÖNCE bitmesi imkânsızdır.
  if (end != null && enr != null && enr < end) out.push('REST ENDS BEFORE THE DUTY IT FOLLOWS');
  return out;
}

// ── Uygunluk (fitness) — "bu pilot bu görevi uçabilir mi?" ──────────
// newDuty: {reportLocal, sectors:[{etd,eta}...], dutyDate}
// Dönen: {legal, reasons:[...], checks:{...}}
// simdi: TEBLİĞ süresi (Md.7(1)(c)) için "şu an" — `asOf` kümülatif penceresinin ucudur (çoğu yerde rapor anı), şu an değil.
export function fitness({ pilot, baseline, duties, ruleset, newDuty, asOf,
                          excludeId = null, offTypes = null, tz = null, simdi = Date.now(),
                          tzMap = undefined, homeBase = null }) {
  // `tzMap` (Md.16 ⑥): VERİLMEZSE uzun menzil dinlenmesi kontrolü koşmaz — paneldeki her çağrı verir (kaynak testi
  // `UzunMenzilDinlenmesiKapi.test.js`); yüklenirken `{}` gelir ve ölçülemedi der (geçici durdurur, sessiz geçmez).
  const lrOlc = tzMap !== undefined;
  const { rules, company: kurCompany } = effectiveRules(ruleset);
  const lim = rules.cumulative_limits || {};
  const reasons = [];
  // ── GEREKÇE + KÜNYE (29 Eyl 2026) ────────────────────────────────────
  // 🔑 Serkan: kural ihlali kartında her gerekçenin yanında ⓘ, içinde maddenin
  //    KENDİ metni (seçenek B — *"bence B"*). Metin künyeden okunur
  //    (`maddeMetni('Md.16')`); künyeyi gerekçeyi ÜRETEN yer bilir — ekran
  //    metinden TAHMİN ETMEZ. `reasons` (düz metin) aynen kalır, ekranlar ve
  //    testler onu okur; `kunyeli` AYNI SIRADA { metin, ref } taşır. (Ad bilerek
  //    `gerekceler` DEĞİL: ekip kapılarında o ad düz metin listesidir.)
  //    ref null = maddeye bağlı değil (çakışma, bozuk kayıt: fizik/kayıt kusuru).
  const kunyeli = [];
  const neden = (metin, ref = null) => { reasons.push(metin); kunyeli.push({ metin, ref }); };

  // 🔑 GEREKCE ile UYARI AYRI SEYLERDIR (4 Eyl 2026).
  // `reasons` ENGELLER: dinlenme borcu, cakisma, kumulatif asim — bunlarin
  // hepsi ATAMAYI YAPMAYARAK duzelir, o yuzden satiri secilemez yapmak dogru.
  // `warnings` GORUNUR AMA ENGELLEMEZ: aylik bos gun eksigi bu sinifta.
  // 25 Agustos'ta hic OFF planlanmamissa Agustos gercekten dolamaz — ama bunu
  // atamayi reddederek DUZELTEMEZSINIZ; engel yapmak ayin kalanindaki her
  // atamayi kilitler, ucus yine ucrulacaktir. Serkan'in sozu de zaten
  // *"uyari vermesi lazim"*di.
  const warnings = [];

  // 🔑 DUZENLEME AYNI KAPIDAN GECER (4 Eyl 2026, Serkan onayi).
  // Olculdu: `EditDutyModal` 600 satir ve icinde TEK BIR yasallik kontrolu
  // yoktu (`fitness` 0 · `daysOffSummary` 0 · `offDayRelease` 0). FDP'yi
  // yeniden hesaplayip KAYDEDIYOR, "EXCEEDED" yazisini gosteriyor, ama hicbir
  // seyi engellemiyordu. Yani atama ekranindan yapilamayan sey DUZENLEYEREK
  // yapilabiliyordu: gorevi bos gunun ustune kaydirmak, dinlenmenin icine
  // sokmak, cakistirmak, kumulatif limiti asmak.
  // Ayri bir kontrol YAZILMAZ — ayni fonksiyon cagrilir (Ilke 3). Duzenlenen
  // gorev kendisiyle cakismasin diye disarida birakilir.
  duties = (duties || []).filter(d => !excludeId || d.id !== excludeId);

  if (!baseline) neden('BASELINE NOT SET', 'SHT-FTL/HG Md.13');

  const newReport = newDuty.reportISO ? new Date(newDuty.reportISO) : null;
  // 🔑 MD.16 ASGARİ DİNLENME YALNIZ UGS'DEN ÖNCE (3 Eki 2026, Serkan "A — tabiki"): madde *"… herhangi bir UGS'nin
  //    öncesinde sağlanan asgari dinlenme süresi …"* der. Yer görevi (ofis, simülatör, eğitim) ya da tek başına DH
  //    UGS değildir: dinlenme dolmadan BAŞLAYABİLİR. Uçuştan önceki dinlenme ise o uçuştan hemen önceki görevin —
  //    yer görevi de olsa — bitişinden ölçülür (her görevin `earliest_next_report`ı = "en erken UGS"). Kümülatif görev
  //    limitleri ve çakışma her tipte aynen geçerli. Önceki hâl: dinlenme HER görevden önce aranıyordu (metinden sıkı).
  const yeniUgs = (newDuty.duty_type || 'flight') === 'flight';

  // 1) DINLENME TAMAMLANMIS MI — YALNIZ ONCEKI GOREVLER (23 Agu 2026 duzeltmesi)
  //
  // 🔴 SAHA (Serkan): *"Selcuk icin gorev ataması yapamıyorum, neden?"*
  //    25 Agu'ya gorev atanamiyordu, sebep `REST UNTIL 08-29 11:00 > report`.
  //    O tarih 28 AGUSTOS'taki gorevin dinlenmesiydi — yani SONRAKI bir gorev,
  //    ONCEKI bir gorevi kilitliyordu.
  //
  // KOK NEDEN: degiskenin adi `past` idi ama ZAMAN SUZGECI HIC YAZILMAMISTI.
  // Butun gorevler arasindan `earliest_next_report`'u EN GEC olani aliyordu,
  // gelecektekiler dahil. Bir pilota ileri tarihli bir gorev atandigi anda,
  // ondan onceki her gune atama yapmak imkansiz hale geliyordu.
  //
  // Dogrusu: bir gorevin dinlenme borcu, ancak O GOREVDEN SONRAKI raporlari
  // baglar. `previousDuty` ayni suzgeci zaten dogru uyguluyordu.
  const bitmisler = duties.filter(d =>
    d.duty_type !== 'off' && d.status !== 'cancelled' && d.duty_end && newReport &&
    new Date(d.duty_end).getTime() <= newReport.getTime());

  const damga = (x) => new Date(x).toISOString().slice(5, 16).replace('T', ' ');

  // 🔴 İMKÂNSIZ DEĞER TAŞIYAN GÖREV "ÖLÇÜLMÜŞ" SAYILMAZ (19 Eyl 2026, 14 no).
  // `earliest_next_report` saklanmış bir TÜREVDİR; kaynağı bozuksa kendisi de
  // bozuktur ama GEÇERLİ BİR TARİH gibi görünür. 18 Eyl'de tam bu oldu:
  // FDP −19:25 -> ENR geçmişte bir an -> `lastENR > newReport` FALSE ->
  // 16 Eylül görevi UYARISIZ atandı. Bozuk satır artık ölçünün DIŞINDA kalır
  // ve durumu adıyla söylenir (İlke 1: ölçemediğimize "uygun" demeyiz).
  const bozuklar = bitmisler
    .map(d => ({ d, kusur: imkansizDegerler(d) }))
    .filter(x => x.kusur.length > 0);
  const bozukIdler = new Set(bozuklar.map(x => x.d));
  const saglamlar = bitmisler.filter(d => !bozukIdler.has(d));

  // ÇAĞRI (Md.17, 5 Eki 2026, Serkan A): yeni UGS bir nöbetten çağrıysa nöbetin "görevsiz biterse" dinlenmesi ARANMAZ;
  // UGS'den önceki Md.16 dinlenmesi nöbetin BAŞINDAN önce aranır (nöbet dinlenme değildir — Md.4(d)).
  // Md.23(1) (5 Eki 2026, 2. adım): simülatörle aynı görev periyodu da aynı mantık — simülatörün dinlenmesi aranmaz, Md.16
  // dinlenmesi simülatörün başından önce aranır.
  const nobetCagri = yeniUgs && newReport ? standbyBefore(saglamlar, pilot?.id, null, newReport.toISOString()) : null;
  const simBag = yeniUgs && newReport && !nobetCagri ? simBaglantisi(saglamlar, pilot?.id, newReport.toISOString()) : null;
  const cagri = nobetCagri || simBag;
  const cagriBas = cagri ? new Date(cagri.report_time) : null;
  // Simülatör kayıtta öndeki uçuşun periyodundaysa (14 Eki 2026) o uçuşun kayıttaki bitişi / dinlenmesi PERİYODUNDUR; yeni
  // uçuş simülatörü devralınca uçuş tek başına kalır — dinlenme onun TEK BAŞINA hesabından ölçülür (sunucuyla aynı).
  const kapsayan = simBag ? ucusunKapsadigi(saglamlar, simBag) : null;
  const tabanlar = kapsayan
    ? saglamlar.map(d => (d === kapsayan ? { ...d, ...gorevHesabi(d, { tz: tzMap || {}, anaUs: homeBase }).alanlar } : d))
    : saglamlar;
  const oncekiler = tabanlar.filter(d => d.earliest_next_report && d !== cagri
                                         && (!cagriBas || new Date(d.duty_end) <= cagriBas));
  const lastENR = oncekiler
    .sort((a, b) => new Date(b.earliest_next_report) - new Date(a.earliest_next_report))[0]
    ?.earliest_next_report;
  if (simBag && lastENR && new Date(lastENR) > cagriBas) {
    const b = UGS_BASLATAN_YER_GOREVLERI[simBag.ground_kind];
    neden(`EARLIEST ${b.etiket} ${damga(lastENR)} — THE ${b.etiket} ${damga(simBag.report_time)} STARTS THIS DUTY PERIOD `
          + `(SHT-FTL/HG Md.16, ${b.ref})`, 'SHT-FTL/HG Md.16');
  } else if (cagri && lastENR && new Date(lastENR) > cagriBas) {
    neden(`EARLIEST STANDBY ${damga(lastENR)} — THE STANDBY ${damga(cagri.report_time)} LEADS TO THIS FDP AND IS NOT REST `
          + '(SHT-FTL/HG Md.16, Md.4(d), Md.17)', 'SHT-FTL/HG Md.16');
  } else if (!cagri && yeniUgs && lastENR && newReport && new Date(lastENR) > newReport) {
    // 🔑 Serkan (19 Eyl): *"bu görev planlanamaz, EN ERKEN REPORTING TIME
    //    HH:MM olabilir diyerek"* — cümle önce YAPILABİLİRİ söyler, sonra
    //    sebebini. Eski hâli `REST UNTIL … > report` idi: doğruydu ama
    //    planlayıcıya ne yapacağını söylemiyordu.
    neden(`EARLIEST REPORT ${damga(lastENR)} — REST UNTIL THEN (SHT-FTL/HG Md.16)`, 'SHT-FTL/HG Md.16');
  }

  if (yeniUgs && bozuklar.length) {
    const en = bozuklar.sort((a, b) => new Date(b.d.duty_end) - new Date(a.d.duty_end))[0];
    neden(`CANNOT VERIFY REST — DUTY ${damga(en.d.duty_end)} HAS IMPOSSIBLE VALUES (${en.kusur.join(', ')})`,
          'SHT-FTL/HG Md.16');
  }

  // 🔑 Md.16 ⑥ (4 Eki 2026, Serkan A · 2. adım): UZUN MENZİL DİNLENMESİNİN İÇİNE HİÇBİR GÖREV ATANAMAZ — yer görevi ve DH
  //    dahil. Md.16(3) "UGS öncesi" demez; Md.4(d) dinlenme tüm görevlerden muaf. Uçuş için yukarıdaki EARLIEST REPORT
  //    zaten bütün önceki dinlenmelere bakar; burada UGS OLMAYAN yeni görev. Ölçü sunucuyla aynı (`uzunMenzilDinlenmesi`);
  //    `tzMap` önceki görevlerin meydan dilimleri, `homeBase` pilotun ana üssü (sunucunun `anaUs`'u).
  if (lrOlc && !yeniUgs && newReport) {
    const adaylar = saglamlar.filter(d => d.earliest_next_report && new Date(d.earliest_next_report) > newReport)
      .sort((a, b) => new Date(b.earliest_next_report) - new Date(a.earliest_next_report));
    let olcEksik = [];
    for (const d of adaylar) {
      const lr = uzunMenzilDinlenmesi(d, duties, { anaUs: homeBase, tz: tzMap || {} });
      if (lr.uzunMenzil == null) { olcEksik.push(...lr.eksik); continue; }
      if (!lr.uzunMenzil) continue;
      neden(`EARLIEST DUTY ${damga(d.earliest_next_report)} — LONG-RANGE REST UNTIL THEN (SHT-FTL/HG ${lr.kural}): `
            + 'no duty may start inside it (Md.4(d))', `SHT-FTL/HG ${lr.kural}`);
      olcEksik = [];
      break;
    }
    if (olcEksik.length) {
      neden(`CANNOT VERIFY LONG-RANGE REST — TIME ZONE UNKNOWN: ${[...new Set(olcEksik)].join(', ')} (SHT-FTL/HG Md.16(3))`,
            'SHT-FTL/HG Md.16(3)');
    }
  }

  // 🔴 DINLENMESI OLCULEMEYEN GOREV SESSIZCE GECMEZ (23 Agu 2026).
  // Olculdu: onceki gorevin `earliest_next_report`'u BOSSA dinlenme HIC
  // kontrol edilmiyordu ve satir sessizce LEGAL cikiyordu. 23:00'te biten bir
  // gorevin arkasina 23:00'te yeni gorev — hicbir gerekce olmadan.
  // 🔑 Serkan: *"bir gorev bitip hemen arkasina baska bir gorev planlaniyorsa
  //    max FDP ve/veya min rest bakilmasi lazim."*
  // Kural: OLCEMEDIGIMIZ seye "uygun" demeyiz (Ilke 1). Dinlenme borcu
  // bilinmiyorsa gerekce yazilir ve satir secilemez.
  const dinlenmesizler = saglamlar.filter(d => !d.earliest_next_report);
  if (yeniUgs && dinlenmesizler.length) {
    const d = dinlenmesizler.sort((a, b) => new Date(b.duty_end) - new Date(a.duty_end))[0];
    neden(`CANNOT VERIFY REST — DUTY ${new Date(d.duty_end).toISOString().slice(5, 16).replace('T', ' ')} HAS NO REST TIME`,
          'SHT-FTL/HG Md.16');
  }

  // 1b) SONRAKİ GÖREV — YENİ GÖREVİN DİNLENMESİ ONU DELİYOR MU? (30 Eyl 2026 · B3)
  // 🔑 Serkan: planlı görevde ENGELLER (önceki göreve bakan kapıyla aynı Md.16);
  //    uçulmuş görevde kayıt geçer ama KIRMIZI UYARI olmadan geçemez — *"red
  //    uyarısız kayıt olamaz; kural setine aykırı durum belirlenir, uyarır."*
  // 🔴 ÖNCESİ: yalnız ÖNCEKİ görevlerin dinlenmesine bakılıyordu. Mevcut bir
  //    görevin önüne giren görev onu yasadışı yapsa ASSIGN sessizce kabul ediyordu;
  //    EDIT kayıttan SONRA "CHAIN … review" diyordu.
  // Dinlenme bitişi (`earliestNextReportISO`) çağırandan gelir — aynı karar
  // noktasından (`restForDuty` / yer görevi formülü) hesaplanır; motor tahmin etmez.
  const yeniBitis = newDuty.dutyEndISO ? new Date(newDuty.dutyEndISO).getTime() : NaN;
  const yeniENR = newDuty.earliestNextReportISO ? new Date(newDuty.earliestNextReportISO).getTime() : NaN;
  if (Number.isFinite(yeniBitis) && Number.isFinite(yeniENR)) {
    const sonraki = duties
      .filter(d => d.duty_type !== 'off' && d.status !== 'cancelled' && d.report_time
                   && new Date(d.report_time).getTime() >= yeniBitis)
      .sort((a, b) => new Date(a.report_time) - new Date(b.report_time))[0];
    // Md.17 (5 Eki 2026): yeni görev NÖBETSE ve sonraki uçuş onun dinlenmesinin içindeyse bu bir ÇAĞRIDIR — ihlal değil;
    // o zaman nöbetten ÖNCE Md.16 dinlenmesi tamamlanmış olmalı (nöbet dinlenme değildir, Md.4(d)).
    const yeniNobet = newDuty.duty_type === 'ground'
      && (newDuty.ground_kind === 'airport_standby' || newDuty.ground_kind === 'other_standby');
    // Md.23(1) simülatör + Md.4(z) yer eğitimi (5 Eki 2026): sonraki uçuşun görev periyodunu başlatır.
    const yeniSim = ugsBaslatanMi({ duty_type: newDuty.duty_type, ground_kind: newDuty.ground_kind });
    const yb = yeniSim ? UGS_BASLATAN_YER_GOREVLERI[newDuty.ground_kind] : null;
    const cagriyaYolAcar = (yeniNobet || yeniSim) && sonraki && sonraki.duty_type === 'flight'
      && new Date(sonraki.report_time).getTime() < yeniENR;
    if (cagriyaYolAcar) {
      const oncekiENR = saglamlar.filter(d => d.earliest_next_report)
        .sort((a, b) => new Date(b.earliest_next_report) - new Date(a.earliest_next_report))[0]?.earliest_next_report;
      // 5 Eki 2026 (Serkan "yap"): bağlanan uçuşun UGS'si yeni yer görevinin BAŞINDAN ölçülür — sunucunun motoruyla (`gorevHesabi`,
      //   bağ `sim`). Aşıyorsa kayıt DURUR, ölçülemiyorsa geçmez. 🔴 Önce kapı yalnız yer görevinden önceki dinlenmeye bakıyordu:
      //   akşam ofis + ertesi sabah uçuş (arada 12 saat yok) kaydediliyor, uçuş sonra sunucuda FDP aşımıyla NOT LEGAL oluyordu.
      if (yeniSim && tzMap !== undefined && newReport) {
        const bagli = { id: '__yeni', pilot_id: pilot?.id ?? null, duty_type: 'ground', ground_kind: newDuty.ground_kind,
          report_time: newReport.toISOString(), duty_end: newDuty.dutyEndISO, earliest_next_report: newDuty.earliestNextReportISO };
        const bagliOncesi = previousDuty(saglamlar, pilot?.id, bagli.report_time);
        const h = gorevHesabi(sonraki, { tz: tzMap || {}, anaUs: homeBase, sim: bagli, simOncesi: bagliOncesi });
        const a = h.alanlar || {};
        if (a.fdp_exceeded) {
          neden(`NEXT FLIGHT ${damga(sonraki.report_time)} ${gorevKisaAdi(sonraki)}: FDP ${fmtMin(a.fdp_minutes)} > MAX `
            + `${fmtMin(a.max_fdp_minutes)}${baglantiNotu(bagli)}`, maxFdpKunyesi(hesapTuru(a.operation_type, rules)));
        } else if (a.fdp_minutes == null) {
          neden(`CANNOT VERIFY THE NEXT FLIGHT ${damga(sonraki.report_time)} ${gorevKisaAdi(sonraki)} — its FDP from this `
            + `${yb.etiket.toLowerCase()} cannot be measured (${(h.eksik || [])[0] || 'no result'})`);
        }
      }
      if (oncekiENR && newReport && new Date(oncekiENR) > newReport) {
        neden(yeniSim
          ? `EARLIEST ${yb.etiket} ${damga(oncekiENR)} — THIS ${yb.etiket} STARTS THE DUTY PERIOD OF THE FDP ${damga(sonraki.report_time)} `
            + `(SHT-FTL/HG Md.16, ${yb.ref})`
          : `EARLIEST STANDBY ${damga(oncekiENR)} — THIS STANDBY LEADS TO THE FDP ${damga(sonraki.report_time)} AND IS NOT `
            + 'REST (SHT-FTL/HG Md.16, Md.4(d), Md.17)', 'SHT-FTL/HG Md.16');
      }
    } else if (sonraki && sonraki.duty_type === 'flight' && new Date(sonraki.report_time).getTime() < yeniENR) {
      neden(`NEXT DUTY ${damga(sonraki.report_time)} STARTS BEFORE THIS DUTY'S REST ENDS `
            + `(${damga(new Date(yeniENR).toISOString())}) (SHT-FTL/HG Md.16)`, 'SHT-FTL/HG Md.16');
    } else if (lrOlc && sonraki && new Date(sonraki.report_time).getTime() < yeniENR && (newDuty.sectors || []).length) {
      // …ama yeni görevin dinlenmesi UZUN MENZİL dinlenmesiyse (Md.16 ⑥, 4 Eki 2026) içine yer görevi de giremez.
      const lr = uzunMenzilDinlenmesi({ id: '__yeni', duty_type: newDuty.duty_type || 'flight', sectors: newDuty.sectors,
        report_time: newDuty.reportISO, duty_end: newDuty.dutyEndISO, ruleset_snapshot: ruleset },
        duties, { anaUs: homeBase, tz: tzMap || {} });
      if (lr.uzunMenzil) {
        neden(`NEXT DUTY ${damga(sonraki.report_time)} STARTS INSIDE THIS DUTY'S LONG-RANGE REST `
              + `(ENDS ${damga(new Date(yeniENR).toISOString())}) (SHT-FTL/HG ${lr.kural}; Md.4(d))`, `SHT-FTL/HG ${lr.kural}`);
      } else if (lr.uzunMenzil == null) {
        neden(`CANNOT VERIFY LONG-RANGE REST — TIME ZONE UNKNOWN: ${lr.eksik.join(', ')} (SHT-FTL/HG Md.16(3))`,
              'SHT-FTL/HG Md.16(3)');
      }
    }
  }

  // 1b) ÇAKIŞMA — YENİ KONTROL (23 Agu 2026)
  //
  // ⚠️ Yukaridaki suzgec eklenmeden ONCE, ayni pilota UST USTE gorev atanmasini
  // engelleyen tek sey o kazara "en gec ENR kazanir" davranisiydi. Suzgeci
  // eklerken bu koruma da kalkardi ve cakisan gorev SESSIZCE "LEGAL" gorunurdu
  // — kusuru duzeltirken daha kotusunu acardik.
  //
  // Kural: iki gorev ayni ani paylasamaz. Yeni gorevin penceresi
  // [rapor, gorev sonu] mevcut bir gorevin penceresiyle kesisiyorsa ENGELLENIR.
  // Gorev sonu bilinmiyorsa yalniz rapor ani bakilir (uydurma pencere yok).
  const newEnd = newDuty.dutyEndISO ? new Date(newDuty.dutyEndISO)
               : (newReport && newDuty.dutyMin ? new Date(newReport.getTime() + newDuty.dutyMin * 60000) : null);
  if (newReport) {
    const izlenebilir = duties.filter(d => d.duty_type !== 'off' && d.status !== 'cancelled');
    const cakisan = izlenebilir.find(d => {
      if (!d.report_time || !d.duty_end) return false;
      const a = new Date(d.report_time).getTime(), b = new Date(d.duty_end).getTime();
      const x = newReport.getTime(), y = newEnd ? newEnd.getTime() : x;
      return x < b && y > a;                       // yarı açık aralık kesişimi
    });
    if (cakisan) {
      // Maddeye bağlı değil: iki görev aynı anı paylaşamaz (fizik).
      neden(`OVERLAPS DUTY ${new Date(cakisan.report_time).toISOString().slice(5, 16).replace('T', ' ')}`
            + `–${new Date(cakisan.duty_end).toISOString().slice(11, 16)}`);
    }
    // 🔴 SAATI OLMAYAN GOREV DE SESSIZCE GECMEZ: cakisma penceresi
    // kurulamiyorsa "cakisma yok" DENMEZ, "olculemedi" denir (Ilke 1).
    const saatsiz = izlenebilir.filter(d => !d.report_time || !d.duty_end);
    if (saatsiz.length) {
      neden(`CANNOT VERIFY OVERLAP — ${saatsiz.length} DUTY(S) WITHOUT START/END TIMES`);
    }
  }

  // 2) kümülatifler — bu görev eklenince limit aşılır mı (tablo `KUMULATIF_LIMITLER` — görev durumu da onu okur)
  // Md.13 "herhangi 7 / 14 / 28 gün" (4 Eki 2026, Serkan A): pencere yeni görevin BİTİŞİNDE biter ve yeni görev de aynı
  //    ölçüyle (pencere içindeki dakikaları) sayılır — görev durumuyla AYNI (`kumulatifIhlaller`). Bitiş bilinmiyorsa eski
  //    yol: `asOf`'ta biten pencere + görevin tamamı.
  const yeniSatir = newReport && newEnd ? { id: '__yeni', pilot_id: pilot?.id ?? null, duty_type: newDuty.duty_type || 'flight',
    ground_kind: newDuty.ground_kind ?? null, status: 'planned', duty_date: newDuty.dutyDate,
    report_time: newReport.toISOString(), duty_end: newEnd.toISOString(), sectors: newDuty.sectors || [] } : null;
  const olcuAni = yeniSatir ? newEnd : (asOf || new Date());
  const cum = cumulatives(baseline, duties, olcuAni, rules);
  const cumYeni = yeniSatir ? cumulatives(baseline, [...duties, yeniSatir], olcuAni, rules) : null;
  // Md.13(2) "sektörlerin uçuş süresi" — DH bacağı sektör değildir (Md.14(1)(b)), uçuş süresine girmez (4 Eki 2026).
  const addFlt = (newDuty.sectors || []).filter(s => !s?.deadhead).reduce((a, s) => a + (spanMin(s.etd, s.eta) || 0), 0);
  const addDuty = newDuty.dutyMin || 0;
  // Eksik zorunlu sınır → kapı DURUR, adıyla (4 Eki 2026, Md.13 ③) — ölçülemeyen toplam "aşılmadı" sayılmaz.
  kumulatifSinirEksik(rules).forEach(x => neden(kumulatifEksikMetni(x), x.ref));
  const oranYokK = kumulatifNobetOraniEksik(rules, yeniSatir ? [...duties, yeniSatir] : duties);
  if (oranYokK.length) neden(nobetOraniEksikMetni(oranYokK), 'SHT-FTL/HG Md.17');
  KUMULATIF_LIMITLER.forEach(({ cum: k, lim: l, etiket, ref, tur }) => {
    const used = cum[k], limit = lim[l];
    const add = cumYeni ? cumYeni[k] - used : (tur === 'flt' ? addFlt : addDuty);
    if (limit != null && used + add > limit) neden(`${etiket} ${fmtMin(used)} + ${fmtMin(add)} > ${fmtMin(limit)}`, ref);
  });
  // SONRAKİ GÖREVLERİN PENCERELERİ (4 Eki 2026, Md.13 ⑥ — Serkan A): metin "görevlendirildiği toplam görev süresi …
  //    aşmayacaktır" der. Yeni görev, sonraki görevlerin bitişinde biten pencerelere de girer; onlardan biri aşılıyorsa kapı
  //    DURUR ve o görevi adıyla söyler. 🔴 Önce yalnız yeni görevin penceresi ölçülüyordu: atama geçiyor, sunucu sonradan o
  //    sonraki görevi NOT LEGAL yazıyordu. Toplamın tepesi hep bir görevin bitişindedir — o anlar ölçülür. Sınır başına ilk
  //    aşılan görev yazılır.
  if (yeniSatir) {
    const yeniBitis = newEnd.getTime();
    const sonrakiler = duties
      .filter(d => d.status !== 'cancelled' && d.duty_type !== 'off' && d.duty_end
                   && new Date(d.duty_end).getTime() > yeniBitis
                   && new Date(d.duty_end).getTime() - yeniBitis <= 367 * 86400000)
      .sort((x, y) => new Date(x.duty_end) - new Date(y.duty_end));
    const yazildi = new Set();
    for (const d of sonrakiler) {
      const an = new Date(d.duty_end);
      const once = cumulatives(baseline, duties, an, rules);
      const sonra = cumulatives(baseline, [...duties, yeniSatir], an, rules);
      KUMULATIF_LIMITLER.forEach(({ cum: k, lim: l, etiket, ref }) => {
        const limit = lim[l];
        if (yazildi.has(k) || limit == null || sonra[k] === once[k] || sonra[k] <= limit) return;
        yazildi.add(k);
        neden(`${etiket} AT ${utcGunAy(d.report_time || d.duty_end)} ${gorevKisaAdi(d)} ${fmtMin(once[k])} + `
          + `${fmtMin(sonra[k] - once[k])} > ${fmtMin(limit)}`, ref);
      });
    }
  }

  // TEORİK EĞİTİM — Md.27(1)(c) (5 Eki 2026, Serkan A): yeni yer eğitimi günlük ve 7 günlük sınırı aşıyor mu; sonraki yer
  //    eğitimlerini aşırıyor mu (Md.13 ⑥ gibi — onların günü ve 7 günü yeni görevi de içerir). Ölçü sunucuyla AYNI fonksiyon.
  if (yeniSatir && teorikEgitimMi(yeniSatir)) {
    teorikEgitimIhlalleri({ duty: yeniSatir, gorevler: duties, rules }).forEach(x => neden(x.metin, x.ref));
    const yeniBitis = newEnd.getTime();
    const sonrakiTeori = duties.filter(d => teorikEgitimMi(d) && d.report_time && d.duty_end
      && new Date(d.duty_end).getTime() > yeniBitis && new Date(d.duty_end).getTime() - yeniBitis <= 8 * 86400000)
      .sort((x, y) => new Date(x.duty_end) - new Date(y.duty_end));
    for (const d of sonrakiTeori) {
      const once = new Set(teorikEgitimIhlalleri({ duty: d, gorevler: duties, rules }).map(x => x.metin));
      const yeni = teorikEgitimIhlalleri({ duty: d, gorevler: [...duties, yeniSatir], rules })
        .filter(x => x.tur === 'theoretical_training' && !once.has(x.metin));
      if (yeni.length) {
        yeni.forEach(x => neden(`AT ${utcGunAy(d.report_time)} ${gorevKisaAdi(d)}: ${x.metin}`, x.ref));
        break;
      }
    }
  }
  // SİMÜLATÖR — Md.27(1)(a) (5 Eki 2026, Serkan A): yeni SIM görevinin kendi günlük oturum sınırı ve (ç) gün toplamı.
  if (yeniSatir && simMi(yeniSatir)) {
    simulatorIhlalleri({ duty: yeniSatir, gorevler: duties, rules, company: kurCompany }).forEach(x => neden(x.metin, x.ref));
  }
  // Md.27(1)(ç) (5 Eki 2026, Serkan A): yeni DERS ya da SİMÜLATÖR aynı UTC günündeki eğitim uçuşlarını ve simülatörleri etkiler —
  //    ders sınırlarını yarıya indirir, ikisi de gün toplamına girer. Önce / sonra karşılaştırılır, yeni doğan sebep etkilenen
  //    görevin adıyla yazılır. Gün sektör / oturum saatlerinden (sunucuyla aynı ölçü — kayıttaki rapor saatine bakılmaz).
  if (yeniSatir && (teorikEgitimMi(yeniSatir) || simMi(yeniSatir))) {
    const yakin = (t) => t != null && Math.abs(t - newReport.getTime()) <= 2 * GUN_MS;
    const etkilenen = [
      ...duties.filter(d => d.duty_type === 'flight' && d.operation_type === 'training' && d.status !== 'cancelled')
        .map(d => ({ d, ilk: egitimBloklari(d)[0]?.[0] ?? null,
                     olc: (l) => egitimUcusuIhlalleri(d, l, rules, kurCompany) })),
      ...duties.filter(simMi)
        .map(d => ({ d, ilk: simOturumu(d, rules, kurCompany)?.[0] ?? null,
                     olc: (l) => simulatorIhlalleri({ duty: d, gorevler: l, rules, company: kurCompany }) })),
    ].filter(({ ilk }) => yakin(ilk));
    etkilenen.forEach(({ d, ilk, olc }) => {
      const once = new Set(olc(duties).map(x => x.metin));
      // Yeni görevin kendi gerekçesiyle AYNI cümle (ör. aynı günün toplamı) ikinci kez yazılmaz.
      olc([...duties, yeniSatir]).filter(x => !once.has(x.metin) && x.tur !== 'ruleset_missing' && !reasons.includes(x.metin))
        .forEach(x => neden(`AT ${utcGunAy(new Date(ilk).toISOString())} ${gorevKisaAdi(d)}: ${x.metin}`, x.ref));
    });
  }

  // SHT-FTL/HG Md.5(1)(a): birbirini takip eden 6 gunu muteakip asgari 1 tek bos gun. Ruleset'te days_off
  // tanimli DEGILSE (eski SHT-FTL semasi) kontrol calismaz. Seri TEK KAYNAKTAN (`gorevSerileri`) — 3 Eki 2026 A:
  // seri = takvimde ARDISIK gorev gunleri; gorevsiz gun seriyi kirar. Yeni gorev seriyi geriye ve ileriye birlikte uzatir.
  // Seri 6'ya ulasirsa ERTESI GUN girilmis gecerli OFF olmali (`altiGunSonrasiOff`): tebligi suresi varsa UYARI,
  // gectiyse ENGEL (Serkan A). Yeni gorevin serisi ve hemen yanindaki gunun istedigi OFF gosterilir.
  const consecReq = rules.days_off?.single_day_off_after_consecutive_days;
  // Yeni görevin günleri — gece yarısını geçerse ikisi de (4 Eki 2026, A): seri ve aylık boş gün hesabı ikisini de görür.
  const yeniGunler = newDuty.dutyDate
    ? gorevGunleri({ duty_type: newDuty.duty_type || 'flight', duty_date: newDuty.dutyDate, duty_end: newDuty.dutyEndISO || null })
    : [];
  if (consecReq != null && newDuty.dutyDate) {
    const { seriler } = gorevSerileri(duties, rules, { extraBusy: yeniGunler });
    const seri = seriler.find(r => r.bas <= newDuty.dutyDate && newDuty.dutyDate <= r.son);
    if (seri && seri.gun > consecReq) {
      neden(`${seri.gun} CONSECUTIVE DUTY DAYS (${seri.bas} → ${seri.son}) WITHOUT A DAY OFF — `
        + `A SINGLE DAY OFF IS REQUIRED AFTER ${consecReq} (SHT-FTL/HG Md.5)`,
        'SHT-FTL/HG Md.5(1)(a)');
    }
    const yakin = new Set([shiftDate(newDuty.dutyDate, -1), shiftDate(newDuty.dutyDate, 1)]);
    // Yeni görev SAATLERİYLE ölçüme girer: erken raporu komşu OFF'un gecesini bozuyorsa o OFF geçerli sayılmaz.
    const yeni = newDuty.reportISO && newDuty.dutyEndISO
      ? [{ duty_type: newDuty.duty_type || 'flight', status: 'planned', duty_date: newDuty.dutyDate,
           report_time: newDuty.reportISO, duty_end: newDuty.dutyEndISO }] : [];
    altiGunSonrasiOff([...duties, ...yeni], rules,
                      { tz, offTypes, simdi, extraBusy: yeni.length ? [] : yeniGunler })
      .filter(x => x.durum !== 'var' && x.gun !== newDuty.dutyDate
                   && ((x.seri.bas <= newDuty.dutyDate && newDuty.dutyDate <= x.seri.son) || yakin.has(x.gun)))
      .forEach(x => (x.durum === 'gecti' ? neden(altiGunMetni(x), 'SHT-FTL/HG Md.5(1)(a)')
                                          : warnings.push(altiGunMetni(x))));
  }

  // BOŞ GÜN KORUMASI (Md.5 · 8 Ağu · 1 Eki 2026) — aynı gün VE komşu günlerin OFF'u. Regülatif OFF ENGELLER,
  // değilse UYARI (planlamacı o günü REST olarak düzenler). Burada olduğu için ASSIGN, uçuş EDIT'i ve yer görevi
  // EDIT'i AYNI kapıdan geçer (eskiden yalnız ASSIGN'da ve yalnız aynı gün).
  if (newDuty.reportISO && newDuty.dutyEndISO) {
    gorevinBozduguOfflar(duties, pilot?.id || null,
      { report_time: newDuty.reportISO, duty_end: newDuty.dutyEndISO, duty_type: newDuty.duty_type || 'flight' },
      rules, { offTypes, tz, baseline })
      .forEach(x => (x.r.allowed ? warnings.push(bozulanOffMetni(x)) : neden(bozulanOffMetni(x), 'SHT-FTL/HG Md.5')));
  }

  // SHT-FTL/HG Md.5(1)(b) — AYLIK ASGARI 7 YEREL GUN.
  // Sayac her zaman doner (`off`), gerekce YALNIZ ay kesin dolmaz hale
  // gelince yazilir. Ayrintili gerekce icin `monthlyOffFeasibility`.
  let off = null;
  if (newDuty.dutyDate) {
    const [yy, mm] = String(newDuty.dutyDate).split('-').map(Number);
    off = monthlyOffFeasibility(duties, rules,
      { year: yy, month: mm, tz, offTypes, asOf: asOf || new Date(), excludeId,
        extraBusy: yeniGunler, baseline });
    const ay = String(newDuty.dutyDate).slice(0, 7);
    // 🔴 OLCULEMEDIYSE SUSMAYIZ (21 Eyl 2026). Asagidaki uc uyari `=== false`
    //    ariyor; olculemeyen ay hepsinde `null` oldugu icin ekran eskiden
    //    TAMAMEN sessiz kalirdi — "sorun yok" ile "bakamadim" ayni gorunurdu.
    if (off.measured === false) {
      warnings.push('DAYS OFF (Md.5) — NOT MEASURED: PILOT HOME BASE NOT SET. '
        + 'A day off is one local day and two local nights (Md.4/u); local night '
        + 'needs a home base. Set it in CREWS & OFFICERS.');
    }
    if (off.reachable === false) {
      warnings.push(`DAYS OFF (Md.5) — ${ay} CANNOT REACH `
        + `${off.required}: ${off.count} PLANNED, ${off.candidates} FREE DAY(S) LEFT`);
    }

    // Md.5(3) denge · Md.5(4) 2+2+1+1+1 — ayin 15'inden itibaren (Serkan esigi).
    const faz = daysOffPhase(newDuty.dutyDate);
    if (faz) {
      const nerede = faz === 'final' ? 'FINAL WEEK' : 'MID-MONTH';
      if (off.balancedOk === false) {
        warnings.push(`DAYS OFF (Md.5/3) — ${ay} NOT BALANCED (${nerede}): `
          + `${off.firstHalf} IN 1ST HALF, ${off.secondHalf} IN 2ND`);
      }
      if (off.groupingOk === false) {
        // Gereken blok sayısı kural setinden (4 Eki 2026 — "2 REQUIRED" koda gömülüydü; tek kaynak).
        warnings.push(`DAYS OFF (Md.5/4) — ${ay} GROUPING 2+2+1+1+1 (${nerede}): `
          + `${off.blocksOf2} BLOCK(S) OF 2, ${rules.days_off?.month_grouping_min_blocks_of_2 ?? '—'} REQUIRED`);
      }
    }
  }

  return { legal: reasons.length === 0, reasons, kunyeli, warnings, cum, off };
}

// ── Görev penceresi (sihirbaz sonucu) ───────────────────────────────
// legs: [{dep,dest,etd,eta}] yerel saat. Dönen tüm değerler dk / "HH:MM".
/** UZUN MENZIL TABANI — Md.22(3), TEK KURAL (30 Eyl 2026 · FTL nobetcisi B2-3).
 *
 *  🔑 Serkan (30 Eyl): *"B olsun — split ile tavan yukselecek."* Standart ekipte
 *     (artirilmis DEGIL) uzun menzilde TABLO degeri Md.22(3) siniriyla (kural seti
 *     `long_range.max_daily_fdp`) sinirlanir; acik mesai (Md.15) uzatmasi bu
 *     sinirlanmis degerin USTUNE eklenir. Talimat ikisinin birlesimini yazmiyor;
 *     Md.15(1)(b) "bu Talimat kapsaminda belirtilen azami UGS'ler" dedigi icin
 *     metne en yakin okuma bu. Konusulup SECILMEYENLER: A (split dahil Md.22(3)
 *     siniri son tavan — 29 Eyl'e kadar planlama boyleydi), C (sinir sabit deger + split).
 *  ⚠️ Serkan (30 Eyl): uzun menzil FDP siniri icin SAYI yazilmaz — tablo degeri ile
 *     karistirilip kural sanilir; deger yalniz kural setinde durur.
 *  ⚠️ Bugunku Tablo 1 kural setindeki uzun menzil sinirinin altinda kalir → sinir hicbir
 *     sayiyi kirpmaz; uzun menzilin etkisi dinlenmededir (Md.16(3)). Kural yine de
 *     tek yerde: planlama (`dutyWindow`) ve kayittan yeniden hesap (`azamiUgsYeniden`)
 *     AYNI yardimciyi cagirir.
 *  Artirilmis ekipte uygulanmaz: Md.22(3) "standart sayida ekip" der; Md.11 gecerli.
 *  @returns {{ dk: number|null, kirpildi: boolean }} */
export function uzunMenzilTabani(tabloDk, rules, opType, uzunMenzilStandart) {
  if (tabloDk == null || !uzunMenzilStandart || !ruleAppliesTo(rules?.long_range, opType)) return { dk: tabloDk, kirpildi: false };
  // 5 Eki 2026 (Md.22 ②): uzun menzil standart ekipte Md.22(3) sınırı kural setinde YOKSA sessizce atlanmaz — ölçülemedi.
  const cap = toMin(rules?.long_range?.max_daily_fdp);
  if (cap == null) return { dk: null, kirpildi: false, kuralEksik: 'long_range.max_daily_fdp' };
  if (tabloDk <= cap) return { dk: tabloDk, kirpildi: false };
  return { dk: cap, kirpildi: true };
}

export function dutyWindow(legs, accommodation, ruleset, opts = {}) {
  // opts: { operationType, trainingKind, sameDayTheory, singlePilot,
  //         threePilot, fourPilot, longRange, standbyReductionMin }
  //   longRange: kalkis-varis dilim farki >=4h (SHT-FTL/HG Md.4(ee)) — cagiran
  //   meydan tz'lerinden tespit edip gecirir; motor tz sorgusu YAPMAZ (saf kalir).
  const { rules, company } = effectiveRules(ruleset);
  if (!legs?.length) return null;
  // BACAK BASINA FAALIYET TIPI (Serkan, 22 Agu): *"cok bacakli bir planlamada
  // ucusun tipini secerken her bacak icin ayri ayri secelim."* Bacaklar kendi
  // `operation_type`'ini tasiyorsa gorevin YONETICI tipi EN KISITLAYICI olandir
  // (Md.9 + Ilke 7). Tasimiyorlarsa eski davranis: `opts.operationType`.
  const bacakTipleri = [...new Set(
    (legs || []).filter(l => !l.deadhead).map(l => l.operation_type).filter(Boolean))];
  const mixedOperation = bacakTipleri.length > 1;
  // BILDIRIM SURELERI (Md.10) — tek kaynak `bildirimSureleri`. Karisik gorevde EGITIM varsa egitim tabani (emniyetli yon).
  const onTip = bacakTipleri.length
    ? (bacakTipleri.includes('training') ? 'training' : bacakTipleri[0])
    : (opts.operationType || 'air_taxi');
  const bs = bildirimSureleri(rules, company, { egitim: hesapTuru(onTip, rules) === 'training' });
  if (!bs) return null;           // kural seti Md.10 surelerini vermiyor — pencere kurulamaz (koddan sayi uydurulmaz)
  const { preFlightMin, postFlightMin } = bs;
  // ── KONUMLANDIRMA (DH) BACAKLARI (SHT-FTL/HG Md.14, 22 Agu 2026) ────
  // Md.14(1)(b): *"Uçuş görev başlangıç ve sonrasındaki konumlandırmalar
  // SEKTÖR SAYILMAYACAKTIR. Ancak, uçuş operasyonu öncesindeki konumlandırma
  // UGS OLARAK SAYILACAKTIR."* Yani DH bacagi:
  //   · UGS'nin (FDP) ICINDEDIR — pencere onunla baslar
  //   · SEKTOR DEGILDIR — Tablo-1'in sektor kolonunu artirmaz
  //   · UCUS SURESI degildir — Md.27 gunluk ucus siniri onu saymaz
  // Md.4(n): yerel ulasim konumlandirma DEGILDIR -> DH ile baslayan gorevde
  // ucus oncesi RAPOR PAYI (60 dk) EKLENMEZ; gorev konumlandirma ucusunun
  // kalkisiyla baslar.
  const flightLegs = legs.filter(l => !l.deadhead);
  const startsWithDh = !!legs[0]?.deadhead;
  // Md.23(1) (5 Eki 2026): simülatöre bağlı uçuşta UGS simülatörün BAŞINDA başlar — çağıran farkı dakika olarak verir.
  const reportMin = (startsWithDh ? toMin(legs[0].etd) : toMin(legs[0].etd) - preFlightMin) - (opts.simOnEkiDk || 0);
  const report = fmtMin((reportMin + 1440) % 1440);
  const bandReport = opts.bandReport || report;
  // YONETICI TIP: karisik gorevde EN KISITLAYICI olan. Sira koda gomulmez,
  // ayni bant ve sektor sayisiyla ruleset'ten OLCULUR.
  const opType = bacakTipleri.length
    ? (mixedOperation
        ? governingOperation(bacakTipleri, bandReport, flightLegs.length, rules,
                             { singlePilot: opts.singlePilot })
        : bacakTipleri[0])
    : (opts.operationType || 'air_taxi');
  // HESAP TÜRÜ (30 Eki 2026, şirket esası): limitler bununla okunur; `opType` kayıtta ve ekranda uçuşun kendi türü olarak kalır.
  const hesapTipi = hesapTuru(opType, rules);

  // en büyük ardışık mola — YALNIZ UCUS BACAKLARI ARASINDA.
  // Acik mesai (Md.15) uzatmasi bir UGS UZATMASIDIR; konumlandirma aktarma
  // beklemesini "mola" sayip UGS uzatmak emniyet kapisini GEVSETIRDI (Ilke 7).
  // Belirsizlikte uzatma VERMEYEN taraf secilir.
  // 29 Eyl 2026: beklemeler ve karar TEK fonksiyondan (`gorevAcikMesai`) —
  // arşiv ve EDIT'in kayıt üzerinden yeniden hesabı da onu çağırır.
  const { en: maxBreak, adaylar: beklemeler } = acikMesaiBeklemeleri(flightLegs);
  // ACIK MESAI (Md.15) yalniz uygulanabilir faaliyet tiplerinde (applies_to).
  const splitAllowed = ruleAppliesTo(rules.split_duty, hesapTipi);
  const split = (maxBreak && splitAllowed)
    ? { ...splitDuty(maxBreak.start, maxBreak.end, accommodation, rules), bekleme: maxBreak, adaylar: beklemeler }
    : { isSplit: false, extensionMin: 0, adaylar: beklemeler };
  // İNTİBAK (Md.22/1): Tablo 1'in bandı, ekibin İNTİBAK ETTİĞİ meydanın yerel
  // saatiyle okunur — kalkış meydanınınkiyle değil. Doğu-batı uçuşundan sonra
  // ikisi ayrışır ve yanlış bant, azami UGS'yi olduğundan büyük/küçük gösterir.
  // Çağıran ofset farkını çözüp `bandReport`'u geçirir (motor TZ sorgusu yapmaz).
  // Geçilmezse bandı kalkış saati belirler — eski davranış (tek dilimli operasyon).
  // SEKTOR SAYISI: DH haric (Md.14/1/b). Saf DH gorevinde (ucus bacagi yok)
  // Tablo-1 okunamaz — o zaten UCUS gorevi degildir, yer gorevi olarak yazilir.
  const baseFdp = maxFdpMinutes(bandReport, flightLegs.length, rules,
    { singlePilot: opts.singlePilot, operationType: hesapTipi });
  // ARTIRILMIS UCUS EKIBI — SHT-FTL/HG Md.11(4): azami gunluk UGS, ucus
  // sirasindaki dinlenmeye bagli olarak BIR ilave pilotla +2 saat, IKI ilave
  // pilotla +3 saat uzatilir (tablo degerinin USTUNE — sabit tavan degil).
  // Md.11(2): UGS 3 sektorle sinirlidir. Md.15(d): acik mesai (split) ile
  // BIRLESTIRILEMEZ — bu yuzden augmented'da split uzatmasi uygulanmaz.
  // 4 Eki 2026: tek kural `artirilmisEkipUzatmasi` — Md.11(2) 3 sektörün üstünde uzatma yok, ekip standart sayılır.
  const aug = artirilmisEkipUzatmasi(rules, hesapTipi, flightLegs.length,
    { ucPilot: !!opts.threePilot, dortPilot: !!opts.fourPilot, dinlenmeOlanagi: opts.inflightRest ?? null });
  const artirilmisEkip = !!aug?.uygulanir;
  // UZUN MENZIL (Md.22(3)) — tek kural `uzunMenzilTabani` (30 Eyl 2026, Serkan B):
  // standart ekipte TABLO degeri Md.22(3) siniriyla sinirlanir, split uzatmasi USTUNE eklenir.
  const lrTaban = uzunMenzilTabani(baseFdp, rules, hesapTipi, !!opts.longRange && !artirilmisEkip);
  let maxFdp = lrTaban.dk != null ? lrTaban.dk + split.extensionMin : null;
  let augmented = false;
  // Md.11(2) — sektör sınırı DH'siz sayılır (Md.14/1/b); aşıldıysa uzatma yok, bayrak ekrana nedenini söyletir.
  const augmentedSectorLimitExceeded = !!aug?.sinirAsildi;
  // Üçüncü pilot var ama dinlenme olanağı kullanımda değil / beyan yok (Md.11(1)(4)) — uzatma yok, ekran nedenini söyler.
  const augmentedNoRestFacility = !!aug?.olanakYok;
  // Beyan hiç SEÇİLMEMİŞ (NOT IN USE değil) — Serkan 4 Eki: roster'daki NOT LEGAL notu "seçilmedi" desin, admin EDIT'ten seçsin.
  const augmentedRestNotSelected = augmentedNoRestFacility && !aug?.beyan;
  // Ekran yazısı (5 Eki 2026, 4 pilotlu ekip): kaç pilot ve bu ekibin kural setindeki uzatması — "+2:00" / "three crew"
  // ekranda SABİT yazılıydı; iki ilave pilotta (Md.11(4) +3 saat) yanlış söylerdi. Uzatma uygulanmasa da kural değeri döner.
  const augmentedCrewSize = opts.fourPilot ? 4 : (opts.threePilot ? 3 : null);
  const augEkKural = augmentedCrewSize == null ? null
    : rules?.augmented_crew?.[opts.fourPilot ? 'extension_two_additional_min' : 'extension_one_additional_min'];
  const augmentedExtensionMin = augEkKural != null && Number.isFinite(Number(augEkKural)) ? Number(augEkKural) : null;
  if (artirilmisEkip) {
    // Md.15(1)(d): açık mesai BİRLEŞMEZ — soru da sorulmaz, uzatma da verilmez.
    if (split.isSplit) Object.assign(split, { extensionMin: 0, cevapGerekli: false, birlesmez: true });
    maxFdp = baseFdp != null ? baseFdp + aug.ekDk : null;  // split BILEREK haric
    augmented = true;
  }
  const longRangeCapped = lrTaban.kirpildi;
  const longRangeKuralEksik = lrTaban.kuralEksik || null;   // Md.22 ②: 14 saat sınırı kural setinde yok
  // NOBET (Md.17): once nobette gecen sure kadar azami UGS kisalir. Cagiran
  // hesaplar (standbyReductionMin), motor yalnizca uygular ve raporlar.
  let standbyReducedMin = 0;
  if (opts.standbyReductionMin > 0 && maxFdp != null) {
    standbyReducedMin = opts.standbyReductionMin;
    maxFdp = Math.max(0, maxFdp - standbyReducedMin);
  }
  // UGS SON UCUSUN INISINDE BITER. Ucustan SONRAKI konumlandirma UGS'ye
  // girmez (Md.14/1/b yalniz ucus OPERASYONU ONCESI icin UGS der); Md.14/1/c
  // geregi hak edilen DINLENMEDE dikkate alinir — gorev suresi asagida
  // butun bacaklardan turer.
  const lastEta = (flightLegs[flightLegs.length - 1] || legs[legs.length - 1]).eta;
  // UÇUŞTAN SONRA BAĞLI SİMÜLATÖR (14 Eki 2026): çağıran son inişten simülatörün kayıttaki bitişine dakikayı (`arkaGorevSonuDk` —
  // görev oraya uzar, Md.4(h)) ve UGS'ye katılan kısmı (`arkaFdpEkiDk` — simülatör sonuna, bekleme dahil, Md.23(1)) verir.
  // Simülatör sektör değildir; Md.15 beklemesi değildir.
  const arkaFdpDk = opts.arkaFdpEkiDk > 0 ? opts.arkaFdpEkiDk : 0;
  const ucusFdpMin = spanMin(report, lastEta);
  const fdpMin = ucusFdpMin != null ? ucusFdpMin + arkaFdpDk : null;   // FDP = report → son on block (→ bağlı yer görevinin sonu)
  // GÖREV SONU (4 Eki 2026, Md.14(1)(a)(c) — Serkan A): "son uçuş + uçuş sonrası süre" ile uçuştan SONRAKİ son DH'nin
  // inişinden geç olanı (`gorevHesabi` ile aynı kural). Önce sondaki DH görev süresine girmiyordu.
  const sonUcusIdx = legs.lastIndexOf(flightLegs[flightLegs.length - 1]);
  const sondakiDhDk = flightLegs.length && sonUcusIdx < legs.length - 1 ? spanMin(report, legs[legs.length - 1].eta) : null;
  const arkaGorevDk = opts.arkaGorevSonuDk > 0 && ucusFdpMin != null ? ucusFdpMin + opts.arkaGorevSonuDk : 0;
  const dutyMin = ucusFdpMin != null ? Math.max(ucusFdpMin + postFlightMin, sondakiDhDk ?? 0, arkaGorevDk) : null;
  const dutyEndMin = dutyMin != null ? reportMin + dutyMin : toMin(lastEta) + postFlightMin;
  const latestFdpEnd = maxFdp != null ? fmtMin((reportMin + maxFdp + 2880) % 1440) : null;
  // UCUS SURESI (blok) — Md.27 egitim gunluk siniri icin gerekli.
  const flightMin = flightLegs.reduce((a, l) => a + (spanMin(l.etd, l.eta) || 0), 0);
  const egitimSiniri = hesapTipi === 'training' ? egitimUcusSiniri(rules, opts.trainingKind, opts.sameDayTheory) : null;
  const flightLimitMin = egitimSiniri?.dk ?? null;
  return {
    report, bandReport, acclimatisedTo: opts.acclimatisedTo ?? null,
    fdpMin, dutyMin,
    dutyEnd: fmtMin(((dutyEndMin ?? 0) + 2880) % 1440),
    maxFdpMin: maxFdp, latestFdpEnd,
    split, breakMin: maxBreak?.min ?? null,
    fdpExceeded: fdpMin != null && maxFdp != null && fdpMin > maxFdp,
    augmented, augmentedSectorLimitExceeded, augmentedNoRestFacility, augmentedRestNotSelected, longRangeCapped, longRangeKuralEksik,
    augmentedCrewSize, augmentedExtensionMin,
    operationType: opType, hesapTuru: hesapTipi, preFlightMin, postFlightMin,
    // KARISIK GOREV: ekran bunu SOYLEMEK zorunda (Serkan: "mutlaka uyari olarak
    // verilmeli ... planlama yapilirken"). `operationTypes` bacaklarda gecen
    // tipler, `operationType` ise uygulanan (en kisitlayici) tiptir.
    // Şirket esası seçiliyse bütün bacaklar aynı kuralla hesaplanır — "en kısıtlayıcı" uyarısı yanıltırdı.
    mixedOperation: mixedOperation && !esasSecili(rules), operationTypes: bacakTipleri,
    flightMin, flightLimitMin,
    flightLimitExceeded: flightLimitMin != null && flightMin > flightLimitMin,
    flightLimitRef: egitimSiniri?.ref ?? null, flightLimitLabel: egitimSiniri?.etiket ?? null,
    flightLimitHalved: !!egitimSiniri?.yari,
    flightLimitKindMissing: !!egitimSiniri?.turYok, flightLimitKuralEksik: egitimSiniri?.kuralEksik ?? null,
    standbyReducedMin,
  };
}

// ── YER GÖREVİ DİNLENMESİ (FTLPanel'den taşındı, 3 Eki 2026 — tek hesap fonksiyonu da kullanır) ──────────
// Diğer nöbet (Md.17/2): görev kredisi ya da görevsiz biterse asgari dinlenme · diğer yer görevleri: görev süresi,
// en az ana üs asgarisi.
export function yerGoreviDinlenmesi(kind, dMin, gEffect, rules) {
  return kind === 'other_standby'
    // Md.17(2)(b) 8 saat YALNIZ kural setinden (5 Eki 2026, Md.17 ③) — etki ölçülemiyorsa dinlenme de ölçülemez.
    ? (gEffect && !gEffect.unavailable && gEffect.restIfNoDutyMin != null
        ? Math.max(gEffect.dutyCreditMin || 0, gEffect.restIfNoDutyMin) : null)
    : (rules?.min_rest?.home_base_min == null || !Number.isFinite(Number(rules.min_rest.home_base_min)) ? null
      : Math.max(dMin, Number(rules.min_rest.home_base_min)));   // Md.16 ④ (4 Eki 2026): yedek 720 kalktı
}

/** TEK BAŞINA DH SONRASI DİNLENME — TEK KAYNAK (4 Eki 2026; sunucu `gorevHesabi` + ASSIGN kapısı, Md.16 ⑦).
 *  Taban yer görevi formülü (Md.16(1), kural setinden); DH üsse (DH dahil son varış) dönüyorsa ve rotasyonda uzun menzil
 *  varsa 48 saat + 2 yerel gece (Md.16(3)(b), `rotasyondaUzunMenzil`). Ölçülemeyen → `rest: null` + sebep.
 *  @param duty  { id, sectors, report_time, duty_end }
 *  @returns {{ rest: number|null, eksik: string[] }} */
export function dhDinlenmesi(duty, dMin, rules, { oncekiler = [], anaUs = null, tz = {} } = {}) {
  const rest = yerGoreviDinlenmesi('dh', dMin, null, rules);
  if (rest == null) return { rest: null, eksik: ['RULE SET: min_rest.home_base_min missing — the minimum rest cannot be computed (Md.16)'] };
  const dhSek = (duty?.sectors || []).filter(Boolean);
  const son = dhSek[dhSek.length - 1];
  const varis = String(son?.actual_dest ?? son?.dest ?? '').toUpperCase();
  if (!dhSek.length || !endedAtBase(varis, anaUs)) return { rest, eksik: [] };
  const rot = rotasyondaUzunMenzil(duty, oncekiler, { anaUs, tz, raporISO: duty.report_time });
  if (rot.uzunMenzil == null) {
    return { rest: null, eksik: [`time zone unknown — ${rot.eksik.join(', ')} (Md.16(3)(b): the long-range rotation before this return cannot be measured)`] };
  }
  if (!rot.uzunMenzil) return { rest, eksik: [] };
  const dr = restForDuty({ dutyMin: dMin, atBase: true, longRange: false, rotasyonUzunMenzil: true,
    dutyEndISO: duty.duty_end, arrivalTz: tz[varis] || null, rules });
  return dr.restMin == null ? { rest: null, eksik: [dr.olculemedi] } : { rest: Math.max(rest, dr.restMin), eksik: [] };
}

// ── GÖREV HESABI — TÜRETİLMİŞ ALANLAR, TEK KAYNAK (3 Eki 2026) ─────────────────────────────────────────────
// 🔑 Serkan (3 Eki 2026): *"en ufak bir edit dahi yapılsa hesap yapılacak bir yapı"* · *"FTL legal bir durum, hiçbir
//    soru işareti kalmamalı"* · *"FTL içinde ne kadar hesap motoru varsa hepsi için geçerli"*.
// 🔴 ÖLÇÜLDÜ (3 Eki): türetilmiş alanlar her yazma yolunda AYRI hesaplanıyordu ve bazı yollar bazılarını hiç bilmiyordu —
//    7 Eki OMAA→LTAC'ta intibak OMDW kaldı (rota 1 Eki'de değişti, EDIT yeniden hesaplamadı, üstelik bandı eski değerle
//    seçiyordu) · uçulmuş görevde tip/ekip değişince Tablo 1 UTC ile okunuyordu · SKPK 2× dinlenme telafisi saat
//    düzeltmesinde kayboluyordu · uçuş sonrası görev süresi üç yerde üç formüldü (ASSIGN şirket, EDIT snapshot, motor).
// Bu fonksiyon görevin TÜRETİLMİŞ alanlarını GİRDİLERİNDEN sıfırdan hesaplar; kayıttaki eski türetilmiş değerleri
// (max_fdp_minutes, acclimatised_to, min_rest_minutes, standby_*, fdp_exceeded …) OKUMAZ. Saf — G/Ç yok: meydan
// dilimleri, önceki görev ve nöbet çağırandan gelir (zincir hesabı bunları sırayla verir).
//   GİRDİ (görevin kendisinden): duty_type, ground_kind, sectors (planlı etd/eta + gerçek off_block/on_block — GERÇEK
//     PLANI EZER, alan alan), duty_date, accommodation (beyan), ruleset_snapshot, operation_type (bacaklarda tip yoksa),
//     training_kind, same_day_theory, skpk_fdp_extension_min, skpk_rest_reduction_min; yer görevinde report_time/duty_end.
//   ctx: { onceki: önceki görevin HESAPLANMIŞ hali | null, nobet: önündeki nöbet görevi | null,
//          oncekiler: pilotun önceki görevleri (Md.16(3)(b) rotasyonu için, `rotasyondaUzunMenzil`),
//          tz: { ICAO: IANA }, anaUs: ICAO | null, tekPilot: bool, ucPilot: bool }
//   ÇIKTI: { alanlar: yazılacak türetilmiş alanlar, eksik: [ADIYLA sebep] — boş değilse görev CANNOT VERIFY,
//            aciklama: { intibak, uzunMenzil } }
// HESAPLANAMAYAN GÖREV (3 Eki 2026, Serkan "B"): türetilmiş alanlar BOŞALTILIR — eski girdilere ait bir değer kayıtta
// durmaz; görev CANNOT VERIFY kalır (eksik dolu). operation_type(_source) boşaltılmaz: bacaklarda tip yoksa görevin tipi
// GİRDİDİR. Yer görevinde başlangıç/bitiş GİRDİDİR.
export const UCUS_TURETILMIS = ['report_time', 'duty_end', 'report_tz', 'fdp_minutes', 'split_duty', 'break_minutes',
  'max_fdp_minutes', 'fdp_exceeded', 'acclimatised_to', 'standby_reduction_min', 'standby_duty_id', 'standby_ref',
  'min_rest_minutes', 'earliest_next_report', 'mandatory_report_due', 'ftl_durum', 'ftl_gerekce'];
export const YER_TURETILMIS = ['fdp_minutes', 'min_rest_minutes', 'earliest_next_report', 'ftl_durum', 'ftl_gerekce'];
// TEK MOTOR TEK YOL (3 Eki 2026, Serkan: *"tek motorumuz tek yolumuz olması gerekir"*): ekranların kayda yazabileceği
// alanlar — türetilmiş olanlar GÖREV TİPİNE göre süzülür (uçuş: UCUS_TURETILMIS · yer görevi / DH: YER_TURETILMIS —
// başlangıç/bitiş girdidir · OFF: hiçbiri). Türetilmişleri yalnız sunucudaki motor yazar (kayıt değişince tetikleyici).
export function turetilmisleriAyikla(kayit, gorevTipi) {
  const liste = gorevTipi === 'flight' ? UCUS_TURETILMIS : gorevTipi === 'off' ? [] : YER_TURETILMIS;
  return Object.fromEntries(Object.entries(kayit || {}).filter(([k]) => !liste.includes(k)));
}
const bosAlanlar = (duty) =>
  Object.fromEntries((duty.duty_type === 'flight' ? UCUS_TURETILMIS : YER_TURETILMIS).map(k => [k, null]));

// ── GÖREVİN YASALLIK DURUMU (3 Eki 2026, FTL adım 4a) ────────────────────────────────────────────────────────
// 🔑 Serkan: *"FTL legal bir durum hiçbir soru işareti kalmamalı"* · tanım **A** · *"NOT LEGAL ve CANNOT VERIFY'da sorun
//    metin olarak net açıklansın"* — ekran kural ihlali kartıyla gösterir (her sebep ayrı satır, ⓘ madde metni, "ne yapmalı"
//    `durumNeYapmali`dan). Sunucu yazar (`ftl_durum`, `ftl_gerekce`); kümülatif limitler 4b'de eklenir.
//   NOT_LEGAL: UGS > azami UGS · uçuştan önce asgari dinlenme yok (Md.16) · nöbet sınırı (Md.17)
//   CANNOT_VERIFY: motorun eksik listesi · tarihi geçmiş PLN (ne olduğu kaydedilmemiş) · OPEN (uçulmamış bacak)
//   LEGAL: hiçbiri · OFF ve iptal: durum yok.
export const FTL_DURUM = { LEGAL: 'LEGAL', NOT_LEGAL: 'NOT_LEGAL', CANNOT_VERIFY: 'CANNOT_VERIFY' };
// Azami UGS'nin maddesi faaliyet tipine göre (Md.9): hava taksi Tablo 1 Md.22(2) · genel havacılık Md.25 · hava işi Md.26 ·
// eğitim Md.27. (FTLPanel'den taşındı — kural ihlali kartı ve görev durumu aynı künyeyi yazar.)
const MAX_FDP_KUNYESI = { air_taxi: 'SHT-FTL/HG Md.22(2)', general_aviation: 'SHT-FTL/HG Md.25',
                          aerial_work: 'SHT-FTL/HG Md.26', training: 'SHT-FTL/HG Md.27' };
export const maxFdpKunyesi = (tip) => MAX_FDP_KUNYESI[tip] || 'SHT-FTL/HG Md.22(2)';
/** SKPK'nın (Md.12) kapsadığı gerekçe mi — künyesinden: azami UGS (Md.22(2)/25/26/27) ya da asgari dinlenme (Md.16).
 *  Uçulmuş görevin EDIT kutusunda bu satırlar "SKPK + rapor" cümlesini alır (durum kartıyla aynı — 3 Eki 2026). */
// EĞİTİMDE SKPK UGS'Yİ UZATMAZ (5 Eki 2026, Serkan A): Md.27(1)(b) "UGS ise 12 saati geçemez" kesin tavan (⑥ B kararı) — Md.12'nin
// uzatması da onu aşamaz. Kaptan raporu yine yazılır (Md.12(1)(c)), ama görev NOT LEGAL kalır. Tek kural; motor, arşiv yeniden hesabı ve
// EDIT bunu okur. (Dinlenme kısaltmasına dokunmaz.)
export const skpkUgsUzatirMi = (opType) => opType !== 'training';
export const SKPK_EGITIM_NOTU = 'the commander\'s discretion does not extend a training FDP: 12:00 cannot be exceeded (Md.27(1)(b))';
export const skpkKapsamindaMi = (ref) => ref === 'SHT-FTL/HG Md.16'
  || (Object.values(MAX_FDP_KUNYESI).includes(ref) && ref !== MAX_FDP_KUNYESI.training);
export const planliAsimMetni = (fdpMin, maxMin) =>
  `FDP ${fmtMin(fdpMin)} > MAX ${fmtMin(maxMin)} — a planned duty cannot exceed the maximum FDP; `
  + `a commander's discretion (Md.12) is not a planning tool`;
// Motorun eksik cümlesinden sebep türü (ne yapmalı bunu okur). Bilinmeyen cümle 'missing_input' olur — gizlenmez.
const EKSIK_TURU = [
  [/^time zone unknown/, 'time_zone_unknown'], [/^ACCLIMATISATION NOT DETERMINED/, 'acclimatisation_unknown'],
  [/^crew composition unknown/, 'crew_unknown'], [/^start or end time missing/, 'duty_times_missing'],
  [/^(sector times missing|no sectors|no flight sector|duty window could not be built)/, 'sector_times_missing'],
  [/^(ruleset snapshot missing|FDP limit could not be read|RULE SET:)/, 'ruleset_missing'], [/^rest could not be computed/, 'rest_not_computed'],
  [/^REST BEFORE THIS DUTY NOT MEASURED/, 'prior_rest_unmeasured'], [/^TRAINING KIND NOT SELECTED/, 'training_kind_missing'],
];
const anDamga = (x) => new Date(x).toISOString().slice(5, 16).replace('T', ' ');
/** @returns {{ ftl_durum, ftl_gerekce: { tur, durum, metin, ref, olanakSecilmedi? }[] }} — OFF / iptal: ikisi de null
 *  `olanakSecilmedi` (4 Eki 2026, Md.11(1)(4)): yalnız fdp_exceeded'de, uçuş içi dinlenme beyanı seçilmemişse — "ne yapmalı" onu söyler. */
export function gorevDurumu({ duty, alanlar = {}, eksik = [], ihlaller = [], simdi = Date.now() }) {
  if (!duty || duty.duty_type === 'off' || duty.status === 'cancelled') return { ftl_durum: null, ftl_gerekce: null };
  const g = ihlaller.map(x => ({ tur: x.tur, durum: x.durum || FTL_DURUM.NOT_LEGAL, metin: x.metin, ref: x.ref ?? null,
                                 ...(x.olanakSecilmedi ? { olanakSecilmedi: true } : {}) }));
  (eksik || []).forEach(m => g.push({ tur: (EKSIK_TURU.find(([re]) => re.test(m)) || [null, 'missing_input'])[1],
                                       durum: FTL_DURUM.CANNOT_VERIFY, metin: m, ref: null }));
  const bitis = alanlar.duty_end || duty.duty_end;
  if (duty.status === 'planned' && bitis && new Date(bitis).getTime() < simdi) g.push(gecmisPlnSebebi(bitis));
  if (duty.status === 'open') {
    g.push({ tur: 'open_duty', durum: FTL_DURUM.CANNOT_VERIFY, ref: null,
             metin: 'DUTY NEVER CLOSED — left open at archive and no closing record followed' });
  }
  return { ftl_durum: durumOf(g), ftl_gerekce: g };
}
// NOT_LEGAL CANNOT_VERIFY'ı ezer; sebep yoksa LEGAL.
const durumOf = (g) => (g.some(x => x.durum === FTL_DURUM.NOT_LEGAL) ? FTL_DURUM.NOT_LEGAL
  : g.length ? FTL_DURUM.CANNOT_VERIFY : FTL_DURUM.LEGAL);
/** Tarihi geçmiş PLN sebebi — tek metin (sunucu ve ekran). */
export const gecmisPlnSebebi = (bitis) => ({ tur: 'past_planned', durum: FTL_DURUM.CANNOT_VERIFY, ref: null,
  metin: `PLANNED DUTY IN THE PAST (ended ${anDamga(bitis)}) — what happened has not been recorded` });
/** EKRANDA GÖSTERİLEN DURUM (3 Eki 2026, adım 4c) — kayıttaki durum (sunucunun yazdığı) + zamana bağlı TEK kural anında:
 *  tarihi geçmiş PLN. Sunucu bunu yalnız hesap anında görür (gece taraması adım 6); ekran beklemez.
 *  @returns null (OFF / iptal: durum yok) · { durum: null, gerekce: [] } (henüz hesaplanmamış — NOT COMPUTED) ·
 *           { durum, gerekce } */
export function ekranDurumu(duty, simdi = Date.now()) {
  if (!duty || duty.duty_type === 'off' || duty.status === 'cancelled') return null;
  if (duty.ftl_durum == null) return { durum: null, gerekce: [] };
  const g = Array.isArray(duty.ftl_gerekce) ? [...duty.ftl_gerekce] : [];
  if (duty.status === 'planned' && duty.duty_end && Date.parse(duty.duty_end) < simdi
      && !g.some(x => x.tur === 'past_planned')) g.push(gecmisPlnSebebi(duty.duty_end));
  return { durum: durumOf(g), gerekce: g };
}
// Kural ihlali kartının "ne yapmalı" cümleleri (29–30 Eyl 2026) — FTLPanel'den taşındı (3 Eki 2026, 4a).
export const NE_YAPMALI = {
  pilot: 'Change the report time, sectors or date so that this limit is met, or choose another pilot. '
       + 'The limit cannot be overridden from this screen — safety gates are not relaxed.',
  ekip: 'Change the crew: this rule depends on who flies together — choose another pilot, or add '
      + 'one where the rule allows it.',
  kayit: 'This is not a regulation limit but a fact about the records (for example two duties at the '
       + 'same time, or a time that is missing). Correct the records or the times, then try again.',
  // EDIT (30 Eyl 2026 · adım ①) — SKPK yalnız uçulmuş görevde girilir: "başka
  // pilot seç" orada yanlış olur. Uçulmuş görevin gerekçesi engellemez, görünür.
  skpk: 'Enter the commander\'s discretion within the limit of this article. An entry beyond it cannot be saved.',
  uculdu: 'The flight has happened, so the record is not blocked. The exceedance stays visible here and in '
        + 'the records. If a time is wrong, correct it.',
  // 3 Eki 2026 (Serkan): uçulmuş görevde UGS aşımı / kısa dinlenme — SKPK + rapor, sınırlar içinde, LEGAL'e döndürür.
  skpkRapor: 'If the commander used discretion (Md.12), record it in EDIT with the commander\'s report: within the '
           + 'limits of Md.12 the duty becomes LEGAL when it is saved; beyond them it stays NOT LEGAL. If a time is '
           + 'wrong, correct it.',
  // 4 Eki 2026 (Md.16 ⑥, Serkan A): uzun menzil dinlenmesinin içinde başlamış, olmuş görev — SKPK yer görevini kapsamaz.
  uzunMenzilDinlenmesiUculdu: 'The duty has happened, so the record is not blocked: it started inside a long-range rest '
    + '(Md.16(3)) and stays NOT LEGAL. If a time is wrong, correct it.',
  // 4 Eki 2026 (Md.11(1)(4), Serkan): artırılmış ekipte uçuş içi dinlenme olanağı beyanı SEÇİLMEMİŞ.
  dinlenmeBeyani: 'Open the duty in EDIT and choose the IN-FLIGHT REST FACILITY (Md.11(1)). IN USE — a reclining seat or '
                + 'bed is free for crew rest on this duty — adds the +2:00. NOT IN USE — the seats are taken by passengers — '
                + 'keeps the standard limit; then change the times or the crew.',
  dinlenmeBeyaniUculdu: 'Open the duty in EDIT and choose the IN-FLIGHT REST FACILITY (Md.11(1)). IN USE — a reclining seat '
                      + 'or bed was free for crew rest on this duty — adds the +2:00 and the duty is measured again when '
                      + 'saved. NOT IN USE — the seats were taken by passengers — keeps the standard limit; then only the '
                      + 'commander\'s discretion with the report (Md.12) can make it LEGAL.',
};
/** Bir sebebin "ne yapmalı" cümlesi — kural ihlali kartının dili. Uçulmuş görevde ihlal engellemez, görünür kalır. */
export function durumNeYapmali(gerekce, duty) {
  const uculdu = duty?.status === 'actual';
  switch (gerekce?.tur) {
    // NOT LEGAL — kural ihlali kartının cümleleri (planlı: engeller · uçulmuş: kayıt durur, görünür kalır).
    case 'fdp_exceeded':
      if (gerekce.olanakSecilmedi) return uculdu ? NE_YAPMALI.dinlenmeBeyaniUculdu : NE_YAPMALI.dinlenmeBeyani;
      // Eğitimde SKPK azami UGS'yi uzatmaz (Md.27(1)(b)) — olmuş görev kayıtta kalır, NOT LEGAL.
      if (gerekce.ref === MAX_FDP_KUNYESI.training) return uculdu ? NE_YAPMALI.uculdu : NE_YAPMALI.pilot;
      return uculdu ? NE_YAPMALI.skpkRapor : NE_YAPMALI.pilot;
    case 'rest_short': return uculdu ? NE_YAPMALI.skpkRapor : NE_YAPMALI.pilot;
    case 'training_flight_time': return uculdu ? NE_YAPMALI.uculdu : NE_YAPMALI.pilot;   // Md.27 — SKPK kapsamaz
    case 'training_day_total': return uculdu ? NE_YAPMALI.uculdu : NE_YAPMALI.pilot;     // Md.27(1)(ç)
    case 'simulator_time': return uculdu ? NE_YAPMALI.uculdu : NE_YAPMALI.pilot;         // Md.27(1)(a) sentetik
    case 'theoretical_training': return uculdu ? NE_YAPMALI.uculdu : NE_YAPMALI.pilot;   // Md.27(1)(c)
    case 'long_range_rest': return uculdu ? NE_YAPMALI.uzunMenzilDinlenmesiUculdu : NE_YAPMALI.pilot;
    case 'standby_limit': return uculdu ? NE_YAPMALI.uculdu : NE_YAPMALI.pilot;
    case 'skpk_report_missing': return 'Open the duty in EDIT and write the commander\'s report (Md.12(1)(c)). Within the '
      + 'limits of Md.12 the duty becomes LEGAL when it is saved.';
    case 'skpk_limit': return 'The recorded discretion is beyond the limits of Md.12. If a value is wrong, correct it in '
      + 'EDIT; otherwise the duty stays NOT LEGAL.';
    case 'cumulative_limit': return uculdu
      ? 'The duty has happened, so the record stands and the exceedance stays visible. If a time on this or an earlier '
        + 'duty in the period is wrong, correct it.'
      : 'Shorten or remove duties in the period, or choose another pilot — the total must stay within the limit for '
        + 'every period that contains this duty.';
    case 'baseline_missing': return 'Enter the pilot\'s FTL baseline (the flight and duty totals at its start date): '
      + 'CREWS & OFFICERS → the pilot → SET BASELINE. Without it no total can be measured.';
    case 'skpk_unmeasured': return 'The duty\'s ruleset does not define the commander\'s discretion limits — tell GO2.';
    // CANNOT VERIFY — neyin eksik olduğu ve nereden tamamlanacağı.
    case 'time_zone_unknown': return 'Add the time zone of the aerodrome named here in AIRPORTS (GO2). Without it the FDP band, '
      + 'long range and acclimatisation cannot be measured.';
    case 'acclimatisation_unknown': return 'Complete the previous duty (its times, or its aerodrome\'s time zone in AIRPORTS); '
      + 'acclimatisation is measured from it.';
    case 'sector_times_missing': return 'Enter the sector times in EDIT (ETD / ETA, or the actual block times if the flight happened).';
    case 'crew_unknown': return 'This duty has no assignment, so who flies together (single pilot, two pilots, augmented) '
      + 'is unknown. Tell GO2 — the duty cannot be verified until it is linked.';
    case 'duty_times_missing': return 'Enter the start and end times of this duty in EDIT.';
    case 'training_kind_missing': return 'Open the duty in EDIT and choose this pilot\'s TRAINING KIND in CREW: instructor / '
      + 'examiner, or the kind of training the trainee receives (Md.27(1)). The daily flight time limit is measured from it.';
    case 'ruleset_missing': return 'The duty\'s ruleset copy cannot give this limit. Tell GO2 — the duty cannot be verified until it is fixed.';
    case 'standby_unmeasured': return 'Correct the standby duty before this flight (its start and end), or tell GO2 if the '
      + 'ruleset does not define standby — the standby\'s effect on this duty cannot be measured until then.';
    case 'prior_rest_unmeasured': return 'Open the previous duty and correct its times (or its arrival aerodrome\'s time zone); '
      + 'the rest before this duty is measured from it.';
    case 'rest_not_computed': return 'Check the arrival aerodrome and its time zone in AIRPORTS; the rest is measured from them.';
    case 'past_planned': return 'Click PLN ? on this duty and record what happened: it took place (with the actual times) or it did not.';
    // Md.5(1)(a) seri (3 Eki 2026)
    case 'consecutive_days': return uculdu
      ? 'The duty has happened, so the record stands and the breach stays visible. If a duty in the run did not take place '
        + 'or a date is wrong, correct it.'
      : 'Move or remove a duty so that no more than 6 duty days follow each other, with an entered OFF after the 6th — or '
        + 'choose another pilot.';
    case 'day_off_after_6': return 'If the day has not begun, enter the OFF now — its 24 h notice (Md.7(1)(c)) has already '
      + 'passed. If the day has passed, the record stands and the breach stays visible; if a duty or a date is wrong, correct it.';
    case 'day_off_notice_unmeasured': return 'Enter the pilot\'s home base (CREWS & OFFICERS) and make sure its time zone is in '
      + 'AIRPORTS; the rule set must give the notice hours. Until then the day after the 6th duty day cannot be checked.';
    case 'open_duty': return 'Click OPEN ? on this duty and close it with the actual times.';
    default: return NE_YAPMALI.kayit;
  }
}

export function gorevHesabi(duty, ctx = {}) {
  const eksik = [];
  const alanlar = {};
  const aciklama = {};
  if (!duty) return { alanlar, eksik: ['no duty'], aciklama };
  if (duty.duty_type === 'off' || duty.status === 'cancelled') return { alanlar, eksik, aciklama };
  // 4a (3 Eki 2026): her yol yasallık durumunu da yazar (`gorevDurumu`) — erken çıkışlar CANNOT VERIFY.
  const simdi = ctx.simdi ?? Date.now();
  const sonuc = (al, ek, ihlaller = []) =>
    ({ alanlar: { ...al, ...gorevDurumu({ duty, alanlar: al, eksik: ek, ihlaller, simdi }) }, eksik: ek, aciklama });
  if (!duty.ruleset_snapshot?.regulation) {
    return sonuc(bosAlanlar(duty), ['ruleset snapshot missing — the limits cannot be computed']);
  }
  const ruleset = duty.ruleset_snapshot;
  const { rules, company } = effectiveRules(ruleset);
  const ekleDk = (iso, dk) => (iso && dk != null ? new Date(new Date(iso).getTime() + dk * 60000).toISOString() : null);
  const kod = (x) => String(x || '').toUpperCase();

  // ── YER GÖREVİ / DH: saatler GİRDİ, türetilen yalnız dinlenme ──────────────────────────────────────
  if (duty.duty_type !== 'flight') {
    if (!duty.report_time || !duty.duty_end) {
      return sonuc(bosAlanlar(duty), ['start or end time missing']);
    }
    const dMin = Math.round((new Date(duty.duty_end) - new Date(duty.report_time)) / 60000);
    const kind = duty.ground_kind || duty.duty_type;
    const gEffect = (kind === 'airport_standby' || kind === 'other_standby') ? standbyEffect(duty, rules) : null;
    let rest;
    // Md.23(1) (14 Eki 2026, Serkan): uçuştan SONRA aynı görev periyodundaki simülatör — dinlenme BÜTÜN periyottan, uçuşun
    // hesabından (tek kaynak; çağıran `bagliUcus` = uçuşun hesaplanmış satırı). 🔴 Önce simülatörün dinlenmesi yalnız kendi
    // süresinden ölçülüyordu: 05:00Z raporlu uçuş + 16:00–20:00Z SIM'den sonra sonraki rapor 13 saatlik periyoda değil 4 saatlik
    // simülatöre göre aranıyordu.
    const bagliUcus = ctx.bagliUcus || null;
    if (bagliUcus) {
      rest = bagliUcus.min_rest_minutes ?? null;
      if (rest == null) eksik.push('rest could not be computed — this ground duty is in the duty period of the flight before it, whose rest is not computed (Md.16, Md.4(h))');
    } else if (duty.duty_type === 'dh') {
      // Md.16(3)(b) rotasyon (4 Eki 2026, Serkan A): üsse DH ile dönüş de dönüştür — `dhDinlenmesi` (ASSIGN de kullanır).
      const dr = dhDinlenmesi(duty, dMin, rules, { oncekiler: ctx.oncekiler || [], anaUs: ctx.anaUs || null, tz: ctx.tz || {} });
      eksik.push(...dr.eksik);
      rest = dr.rest;
    } else {
      rest = yerGoreviDinlenmesi(kind, dMin, gEffect, rules);
      if (rest == null && kind === 'other_standby') {
        eksik.push(`RULE SET: ${(gEffect?.eksikAlan || ['standby']).join(' / ')} missing — the rest after standby cannot be computed (Md.17(2)(b))`);
      } else if (rest == null) {
        eksik.push('RULE SET: min_rest.home_base_min missing — the minimum rest cannot be computed (Md.16)');
      }
    }
    alanlar.fdp_minutes = null;
    alanlar.min_rest_minutes = rest;
    alanlar.earliest_next_report = bagliUcus ? (bagliUcus.earliest_next_report ?? null) : ekleDk(duty.duty_end, rest);
    // Md.16 ⑥ (4 Eki 2026, Serkan A): uzun menzil dinlenmesinin içinde başlayan yer görevi / DH / nöbet NOT LEGAL. Bağlı
    // simülatör kendi uçuşunun dinlenmesinde değil, onun görev periyodundadır (14 Eki 2026).
    const lrY = uzunMenzilDinlenmesiIhlali(duty, duty.report_time, ctx.oncekiler || [], { anaUs: ctx.anaUs || null,
      tz: ctx.tz || {}, ...(bagliUcus ? { haric: bagliUcus.id ?? null } : {}) });
    eksik.push(...lrY.eksik);
    // Md.27(1)(c) (5 Eki 2026, Serkan A): yer eğitimi (simülatör hariç) günde 8 / 7 günde 40 saat — kural setinden.
    const teori = teorikEgitimIhlalleri({ duty: { ...duty, ...alanlar }, gorevler: ctx.oncekiler || [], rules });
    // Md.27(1)(a) simülatör (5 Eki 2026, Serkan A): günlük oturum 4 saat (aynı gün teoride yarı) + (ç) gün toplamı.
    teori.push(...simulatorIhlalleri({ duty: { ...duty, ...alanlar }, gorevler: ctx.tumGorevler || ctx.oncekiler || [], rules, company }));
    return sonuc(alanlar, eksik, [...(lrY.ihlal ? [lrY.ihlal] : []), ...teori,
                                  ...(ctx.kumulatif ? ctx.kumulatif(alanlar, rules) : [])]);
  }

  // ── UÇUŞTAN SONRA SİMÜLATÖR — Md.23(1) (14 Eki 2026, Serkan: *"FDP dahil olmalı bence"*) ────────────────────────
  // AÇIK BAĞ (Serkan "tamam"): simülatör uçuşla AYNI PAKETTE girildiyse (ASSIGN'da aynı kayıt → aynı `assignment_id`) ve uçuşun
  // KENDİ dinlenmesi dolmadan başlıyorsa aynı görev periyodudur. Saatten tahmin YOK — 🔴 tahmin, akşam uçuşundan sonra ertesi
  // sabah ayrı girilen simülatörü / ofisi uçuşa yapıştırıyor, 3 Eki kuralını (yer görevinden önce dinlenme aranmaz) ve uzun
  // menzil 48 saat dinlenmesini (Md.16(3)(b)) bozuyordu. Uçuştan sonra GND şimdilik YOK (Serkan: konuşulup karara bağlanınca).
  // Çağıran (zincir) sonraki ham satırı `arkaYer` olarak verir; bağ önce uçuşun tek başına hesabıyla ölçülür.
  if (duty.duty_type === 'flight' && ctx.arkaYer && !ctx.arkaYerBagli) {
    const s = ctx.arkaYer;
    const yalniz = gorevHesabi(duty, { ...ctx, arkaYer: null });
    const r = Date.parse(yalniz.alanlar.report_time), b = Date.parse(s.report_time);
    const enr = Date.parse(yalniz.alanlar.earliest_next_report);
    const bagli = ayniPakettekiSim(duty, s)
      && Number.isFinite(r) && Number.isFinite(b) && Number.isFinite(enr) && r < b && b < enr;
    return bagli ? gorevHesabi(duty, { ...ctx, arkaYer: null, arkaYerBagli: s }) : yalniz;
  }

  // ── UÇUŞ ────────────────────────────────────────────────────────────────────────────────────────
  // GERÇEK PLANI EZER (alan alan): gerçek off/on-block varsa o, yoksa planlı ETD/ETA.
  const legs = (duty.sectors || []).map(x => ({ ...x, etd: x.off_block || x.etd, eta: x.on_block || x.eta }));
  if (!legs.length) return sonuc(bosAlanlar(duty), ['no sectors']);
  const eksikSaat = legs.filter(l => toMin(l.etd) == null || toMin(l.eta) == null)
    .map(l => `${kod(l.dep) || '?'}-${kod(l.dest) || '?'}`);
  if (eksikSaat.length) return sonuc(bosAlanlar(duty), [`sector times missing — ${eksikSaat.join(', ')}`]);
  const ucusBacaklari = legs.filter(l => !l.deadhead);
  if (!ucusBacaklari.length) return sonuc(bosAlanlar(duty), ['no flight sector']);
  if (ctx.ekipBilinmiyor) eksik.push('crew composition unknown — the duty has no assignment link (computed as a two-pilot crew)');

  // Mutlak anlar — gün devri BÜTÜN zincirde (sektorZamanlari, tek kural).
  const zincir = sektorZamanlari(duty.duty_date, legs.flatMap(l => [l.etd, l.eta]));
  const ilkKalkisISO = zincir[0];
  const sonUcus = legs.lastIndexOf(ucusBacaklari[ucusBacaklari.length - 1]);
  const sonInisISO = zincir[sonUcus * 2 + 1];
  // Md.23(1) (5 Eki 2026, Serkan A): simülatöre bağlı uçuş — UGS simülatörün başında başlar (çağıran `simBaglantisi` ile bulur).
  const sim = ctx.sim || null;
  const opts0 = {
    operationType: duty.operation_type || undefined,
    // Md.27(1)(ç) (5 Eki 2026, Serkan A): aynı gün teori KAYITTAN — aşağıda `egitimGunu` ile kurulur (kayıttaki kutu okunmaz).
    trainingKind: duty.training_kind || undefined, sameDayTheory: false,
    singlePilot: !!ctx.tekPilot, threePilot: !!ctx.ucPilot, fourPilot: !!ctx.dortPilot,   // iki CRZ CPT (5 Eki 2026)
    inflightRest: duty.inflight_rest_facility ?? null,
  };
  // Md.23(1) uçuştan SONRA simülatör (14 Eki 2026): UGS simülatörün bitişinde (kayıttaki bitiş − Md.10(1)(c) sonrası süre,
  // simülatörün KENDİ kural seti kopyasından — ASSIGN kaydı aynı süreyi ekledi), görev kayıttaki bitişinde (Md.4(h)).
  const arkaYer = ctx.arkaYerBagli || null;
  if (arkaYer) {
    const sk = arkaYer.ruleset_snapshot?.regulation ? effectiveRules(arkaYer.ruleset_snapshot) : { rules, company };
    const sonrasiDk = bildirimSureleri(sk.rules, sk.company, { egitim: true })?.postFlightMin ?? null;
    if (sonrasiDk == null) {
      eksik.push('RULE SET: notification_times missing — the end of the simulator after this flight cannot be read (Md.10(1)(c))');
    }
    const simSonuISO = ekleDk(arkaYer.duty_end, -(sonrasiDk ?? 0));
    const gorevDk = Math.round((new Date(arkaYer.duty_end) - new Date(sonInisISO)) / 60000);
    const fdpDk = Math.round((new Date(simSonuISO) - new Date(sonInisISO)) / 60000);
    if (gorevDk > 0) {
      Object.assign(opts0, { arkaGorevSonuDk: gorevDk, ...(fdpDk > 0 ? { arkaFdpEkiDk: fdpDk } : {}) });
      aciklama.arkaYer = { id: arkaYer.id ?? null, fdpBitis: simSonuISO };
    }
  }
  const w0 = dutyWindow(legs, duty.accommodation ?? null, ruleset, opts0);
  if (!w0) return sonuc(bosAlanlar(duty), ['duty window could not be built']);
  // Md.27(1)(ç): pilotun aynı UTC günündeki yer eğitimi (önce ya da sonra) — eğitim uçuş sınırı yarıya iner, gün toplamı ölçülür.
  const egGun = w0.hesapTuru === 'training'
    ? egitimGunu({ ucus: duty, gorevler: ctx.tumGorevler || ctx.oncekiler || [], rules, company }) : null;
  if (egGun) opts0.sameDayTheory = egGun.teoriVar;
  // Rapor: ilk kalkıştan bildirim süresi önce; DH ile başlıyorsa DH'nin kalkışı (Md.14/1/b) — motorla AYNI.
  const raporISO = legs[0].deadhead ? ilkKalkisISO : ekleDk(ilkKalkisISO, -w0.preFlightMin);
  // UGS'nin başı: simülatöre bağlıysa simülatörün raporu (Md.23(1)); kayıttaki rapor uçuşun kendi raporu kalır.
  const fdpBasISO = sim ? new Date(sim.report_time).toISOString() : raporISO;
  const simOnEkiDk = sim ? Math.max(0, Math.round((new Date(raporISO) - new Date(fdpBasISO)) / 60000)) : 0;
  if (sim) { opts0.simOnEkiDk = simOnEkiDk; aciklama.sim = { id: sim.id ?? null, fdpBaslangic: fdpBasISO }; }
  // GÖREV SONU — Md.14(1)(a)(c) (4 Eki 2026, Serkan A: *"30 dk uçuş görevinin sonuna eklenir, DH'nin değil"*; 3 Eki:
  // *"uçuş sonrası DH olursa FDT değil DT uzar, devam eden resti etkiler"*). UGS son uçuşun inişinde biter (Md.14(1)(b));
  // görev "son uçuş inişi + uçuş sonrası süre (Md.10)" ile "son DH inişi"nden geç olanında biter, dinlenme oradan başlar.
  // 🔴 Önce sondaki DH hiç sayılmıyordu: uçuş 08–09 + DH 12–13 → görev sonu 09:30, en erken rapor 19:30.
  const ucusSonuISO = ekleDk(sonInisISO, w0.postFlightMin);
  const sonDhInisISO = legs.length - 1 > sonUcus ? zincir[(legs.length - 1) * 2 + 1] : null;
  const ucusBitisISO = sonDhInisISO && new Date(sonDhInisISO) > new Date(ucusSonuISO) ? ekleDk(sonDhInisISO, 0) : ucusSonuISO;
  // Md.4(h) (14 Eki 2026): bağlı yer görevi varsa görev onun kayıttaki bitişinde (simülatörde SIM sonu + Md.10(1)(c) süresi).
  const bitisISO = aciklama.arkaYer && new Date(arkaYer.duty_end) > new Date(ucusBitisISO)
    ? ekleDk(arkaYer.duty_end, 0) : ucusBitisISO;

  // Meydan dilimleri — uzun menzil, intibak, bant için. Eksik dilim UYDURULMAZ (İlke 1).
  const tz = ctx.tz || {};
  const um = uzunMenzilOlcumu(legs, tz, rules, { raporISO, bitisISO });
  aciklama.uzunMenzil = um;
  if (um.olculemedi && um.kuralEksik) {
    eksik.push(`RULE SET: ${um.kuralEksik} missing — long range cannot be measured (Md.4(ee), Md.22(3))`);
  } else if (um.olculemedi) {
    eksik.push(`time zone unknown — ${[...new Set(um.eksik)].join(', ')} (long range and the FDP band cannot be measured)`);
  }
  const uzunMenzil = um.uzunMenzil === true;

  // İNTİBAK (Md.22/1): önceki görevin HESAPLANMIŞ referansı — kayıttaki eski değer değil.
  const kalkis = kod(legs[0].dep);
  const raporMs = new Date(raporISO).getTime();
  const ofset = (icao) => (tz[kod(icao)] ? tzOffsetMin(tz[kod(icao)], raporMs) : null);
  const onc = ctx.onceki || null;
  // Simülatöre bağlı uçuşta intibak, periyodun ÖNCESİNDEKİ görevden ve periyodun başından ölçülür (sim bir meydan bildirmez).
  const intOnc = sim ? (ctx.simOncesi || null) : onc;
  const oncSon = (intOnc?.sectors || []).slice(-1)[0];
  const oncRef = intOnc ? kod(intOnc.acclimatised_to || oncSon?.actual_dest || oncSon?.dest) || null : null;
  const accl = acclimatisation(
    intOnc && oncRef ? { refIcao: oncRef, refOffsetMin: ofset(oncRef), dutyEndISO: intOnc.duty_end,
                         minRestMin: intOnc.min_rest_minutes ?? null } : null,
    { depIcao: kalkis, depOffsetMin: ofset(kalkis), reportISO: fdpBasISO, homeBaseIcao: ctx.anaUs || null },
    rules);
  aciklama.intibak = accl;
  if (accl.unavailable && accl.kuralEksik) {
    eksik.push(`RULE SET: ${accl.kuralEksik} missing — acclimatisation cannot be determined (Md.22(1))`);
  } else if (accl.unavailable) {
    eksik.push(`ACCLIMATISATION NOT DETERMINED (Md.22/1) — ${accl.reason}`);
  }
  // Bant: intibak edilen meydanın YEREL saati (Md.22/2). Çözülemezse kalkış meydanının yereli — değer yazılır ama
  // görev CANNOT VERIFY kalır (eksik dolu).
  const bandOfset = !accl.unavailable ? accl.offsetMin : ofset(kalkis);
  // Bant UGS'nin BAŞINDAN (Md.22(2) "görev başlangıç saati") — simülatöre bağlıysa simülatörün başı.
  const bandReport = bandOfset != null ? bandReportHHMM(fdpBasISO.slice(11, 16), 0, bandOfset) : null;

  // Ortak pencere (nöbetsiz) — nöbetin "UGS uzatıldı mı" sorusu bundan okunur (ASSIGN ile aynı).
  const optsBant = { ...opts0, longRange: uzunMenzil,
    ...(bandReport ? { bandReport } : {}), ...(accl.icao ? { acclimatisedTo: accl.icao } : {}) };
  const wBant = dutyWindow(legs, duty.accommodation ?? null, ruleset, optsBant);
  // NÖBET (Md.17): önündeki nöbet görevi (çağıran `standbyBefore` ile bulur).
  const sbEtki = ctx.nobet
    ? standbyEffect(ctx.nobet, rules, { fdpExtended: !!(wBant.split.extensionMin > 0 || wBant.augmented), cagriISO: raporISO })
    : null;
  const win = sbEtki?.fdpReductionMin
    ? dutyWindow(legs, duty.accommodation ?? null, ruleset, { ...optsBant, standbyReductionMin: sbEtki.fdpReductionMin })
    : wBant;
  const sb = sbEtki ? standbyLimits(sbEtki, win.fdpMin) : null;

  // Azami UGS: pencere + SKPK uzatması (Md.12(1)(a) — girdi, olmuş bir olayın kaydı).
  const skpkUgs = skpkUgsUzatirMi(win.hesapTuru) ? (duty.skpk_fdp_extension_min || 0) : 0;   // eğitimde 0 (Md.27(1)(b))
  const maxFdp = win.maxFdpMin != null ? win.maxFdpMin + skpkUgs : null;
  if (maxFdp == null && win.longRangeKuralEksik) {
    eksik.push(`RULE SET: ${win.longRangeKuralEksik} missing — the long-range FDP limit cannot be applied (Md.22(3))`);
  } else if (maxFdp == null) {
    eksik.push('FDP limit could not be read from Table 1');
  }
  const asim = win.fdpMin != null && maxFdp != null && win.fdpMin > maxFdp;

  // DİNLENME (Md.16; uzun menzilde Md.16(3)) + SKPK telafisi (Md.12(2): kısaltılan miktarın 2 katı).
  // Md.16 ⑤ (4 Eki 2026, Serkan A): dinlenme yeri görevin DH DAHİL gerçekten bittiği meydan — eskiden son UÇUŞ bacağının
  // varışıydı; KTEB→EGLF uçuşu + aynı görevde EGLF→LTAC DH'de ekip Ankara'dayken 'üs dışı' (14:00) sayılıyordu. Görev sonu
  // da DH dahildir (Md.14); panel önizlemeleri zaten son bacağı okuyordu — sunucu ile ekran artık aynı.
  const sonBacak = legs[legs.length - 1];
  const sonVaris = kod(sonBacak.actual_dest ?? sonBacak.dest);
  // Md.16(3)(b) rotasyon (4 Eki 2026, Serkan A): üste biten, kendisi uzun menzil olmayan görevde rotasyona bakılır.
  const usteBitti = endedAtBase(sonVaris, ctx.anaUs || null);
  const rot = !um.olculemedi && usteBitti && !uzunMenzil
    ? rotasyondaUzunMenzil(duty, ctx.oncekiler || [], { anaUs: ctx.anaUs || null, tz, raporISO }) : null;
  const rotOlculemedi = rot != null && rot.uzunMenzil == null;
  if (rotOlculemedi) eksik.push(`time zone unknown — ${rot.eksik.join(', ')} (Md.16(3)(b): the long-range rotation before this return cannot be measured)`);
  // Md.17(1)(ç) ikinci cümle (5 Eki 2026): havaalanı nöbetinden çağrılan UGS'de nöbet, asgari dinlenme hesabında görev
  // süresine EKLENİR (06:00–12:00 nöbet + 12:00–19:30 görev → dinlenme 13:30, önce 12:00).
  const nobetEki = sbEtki?.kind === 'airport_standby' && !sbEtki.invalid ? (sbEtki.standbyMin || 0) : 0;
  const dr = um.olculemedi || rotOlculemedi ? null : restForDuty({
    dutyMin: win.dutyMin + nobetEki, atBase: usteBitti, longRange: uzunMenzil, rotasyonUzunMenzil: rot?.uzunMenzil === true,
    dutyEndISO: bitisISO, arrivalTz: um.varisTz, rules });
  if (dr?.olculemedi) eksik.push(dr.olculemedi);   // Md.16 ④: kural setinde taban yok — adıyla
  const dinlenme = dr?.restMin ?? null;
  const minRest = dinlenme != null ? dinlenme + 2 * (duty.skpk_rest_reduction_min || 0) : null;
  if (minRest == null && !um.olculemedi && !rotOlculemedi && !dr?.olculemedi) eksik.push('rest could not be computed');

  Object.assign(alanlar, {
    report_time: raporISO, duty_end: bitisISO, fdp_minutes: win.fdpMin,
    operation_type: win.operationType,
    ...(win.mixedOperation ? { operation_type_source: `mixed duty — most restrictive applies (${win.operationTypes.join(' + ')})` } : {}),
    report_tz: tz[kalkis] || null,
    split_duty: !!(win.split.isSplit && !win.split.birlesmez), break_minutes: win.breakMin,
    max_fdp_minutes: maxFdp, fdp_exceeded: asim,
    acclimatised_to: accl.icao || null,
    standby_reduction_min: sbEtki?.fdpReductionMin || null,
    standby_duty_id: sbEtki ? (ctx.nobet.id ?? null) : null,
    standby_ref: sbEtki ? standbyRef(ctx.nobet, sb) : null,
    min_rest_minutes: minRest,
    earliest_next_report: minRest != null ? ekleDk(bitisISO, minRest) : null,
    // Zorunlu rapor (Md.12(1)(c)) aşım VARSA konur, YOKSA silinir — eskiden yalnız konuyordu.
    mandatory_report_due: asim ? skpkRaporSonTarihi(bitisISO, company.mandatoryReportHours) : null,
  });
  // 4a: NOT LEGAL sebepleri — madde künyeli.
  const ihlaller = [];
  // SKPK (Md.12) GEÇERLİ Mİ (3 Eki 2026, Serkan): rapor yazılmış ve kural setinin sınırları içinde. Geçersiz SKPK UGS'yi
  // uzatmaz, dinlenmeyi örtmez; kendi sebebi yazılır. (EDIT raporsuz ve sınır dışı SKPK'yı zaten kaydetmez — bu, başka
  // yoldan gelen kayıt için.) Kaydedilen `max_fdp_minutes` / `fdp_exceeded` değişmez; yalnız durum.
  const skpkUz = duty.skpk_fdp_extension_min || 0, skpkKis = duty.skpk_rest_reduction_min || 0;
  let skpkGecerli = true;
  if (skpkUz > 0 || skpkKis > 0) {
    const raporVar = !!String(duty.skpk_reason || '').trim();
    const lim = skpkLimits({ fdpExtensionMin: skpkUz, restReductionMin: skpkKis }, rules,
      { augmented: !!(ctx.ucPilot || ctx.dortPilot), prevMinRestMin: onc?.min_rest_minutes ?? null,
        prevHadSkpkExtension: (onc?.skpk_fdp_extension_min || 0) > 0 });
    if (!raporVar) ihlaller.push({ tur: 'skpk_report_missing', ref: 'SHT-FTL/HG Md.12(1)(c)',
      metin: 'COMMANDER\'S DISCRETION RECORDED WITHOUT THE COMMANDER\'S REPORT' });
    if (lim.unavailable) ihlaller.push({ tur: 'skpk_unmeasured', durum: FTL_DURUM.CANNOT_VERIFY,
                                          metin: lim.kunyeli[0].metin, ref: lim.kunyeli[0].ref });
    else lim.kunyeli.forEach(k => ihlaller.push({ tur: 'skpk_limit', metin: k.metin, ref: k.ref }));
    skpkGecerli = raporVar && lim.ok;
  }
  const durumMax = win.maxFdpMin != null ? win.maxFdpMin + (skpkGecerli ? skpkUgs : 0) : null;
  const skpkEgitim = skpkUz > 0 && !skpkUgsUzatirMi(win.hesapTuru);
  if (win.fdpMin != null && durumMax != null && win.fdpMin > durumMax) {
    // Beyan seçilmemişse (Serkan 4 Eki: *"not legal remark'da uçakta istirahat seçilmedi desin"*) bu, notun İLK parçasında
    // durur — duty sheet kutusu ilk ' — ' öncesini basar; "ne yapmalı" EDIT'te seçmeyi söyler (`olanakSecilmedi`).
    const secilmedi = !!win.augmentedRestNotSelected;
    ihlaller.push({ tur: 'fdp_exceeded', ref: maxFdpKunyesi(win.hesapTuru),
      metin: `FDP ${fmtMin(win.fdpMin)} > MAX ${fmtMin(durumMax)}`
        + (sim ? baglantiNotu(sim) : '')
        + (aciklama.arkaYer ? simSonraNotu(arkaYer) : '')
        + (secilmedi ? ' · IN-FLIGHT REST NOT SELECTED' : '')
        + (skpkUz > 0 && !skpkGecerli && !skpkEgitim ? ` (the commander's discretion +${fmtMin(skpkUz)} does not count — see below)` : '')
        + (skpkEgitim ? ` — ${SKPK_EGITIM_NOTU}` : '')
        // Md.11(2) (4 Eki 2026): üçüncü pilot vardı ama 3 sektörün üstünde uzatma yok — MAX neden standart değer, söylenir.
        + (win.augmentedSectorLimitExceeded ? ' — the augmented crew extension does not apply above 3 sectors (Md.11(2))' : '')
        + (secilmedi
          ? ' — the augmented crew extension applies only when the in-flight rest facility is IN USE: choose it in EDIT '
            + '(Md.11(1)(4))'
          : (win.augmentedNoRestFacility ? ' — the augmented crew extension does not apply: the in-flight rest facility is '
            + 'not in use (Md.11(1)(4))' : '')),
      ...(secilmedi ? { olanakSecilmedi: true } : {}) });
  }
  // Md.27 (5 Eki 2026, Serkan A): eğitimde günlük azami uçuş süresi UGS aşımı gibi KURAL İHLALİDİR — planlı görev kaydedilmez
  // (ASSIGN ve EDIT bu gerekçeyi önizlemeden okur), uçulmuş görev NOT LEGAL kalır. Gerçek blok saatleri planı ezer (`legs`).
  // SKPK (Md.12) UGS'yi uzatır, uçuş süresini değil — kapsamaz. 🔴 Önce yalnız ASSIGN'da kırmızı nottu: 7 saatlik tip
  // eğitimi (sınır 4 saat) LEGAL yazılıyor, kayıt geçiyordu.
  if (win.flightLimitExceeded) {
    ihlaller.push({ tur: 'training_flight_time', ref: win.flightLimitRef, metin: egitimUcusAsimMetni(win) });
  }
  if (egGun) {
    // Md.27(1)(a)(b) günlük uçuş süresi — günün bütün eğitim uçuşları (sınır pencerenin kendi türünden).
    ihlaller.push(...egitimGunlukUcusIhlalleri(duty, egGun, { dk: win.flightLimitMin, ref: win.flightLimitRef,
      etiket: win.flightLimitLabel, yari: win.flightLimitHalved }));
    ihlaller.push(...egitimGunuToplamIhlalleri(egGun));   // Md.27(1)(ç) gün toplamı
  }
  // Tür seçilmemiş / sayısı kural setinde yok → ölçülemedi (CANNOT VERIFY) — sınır uydurulmaz (5 Eki 2026, Serkan A).
  if (win.flightLimitKindMissing) eksik.push(EGITIM_TURU_SECILMEDI);
  if (win.flightLimitKuralEksik) {
    eksik.push(`RULE SET: ${win.flightLimitKuralEksik} missing — the training flight time limit cannot be measured (Md.27(1))`);
  }
  // Md.16 — uçuştan önce asgari dinlenme. Ölçü roster'daki REST SHORT / REST NOT MEASURED rozetiyle AYNI kaynak
  // (`dinlenmeDurumu`), bu görevin HESAPLANMIŞ raporu ve önceki görevin HESAPLANMIŞ hâliyle. SKPK kaydı olan kısa dinlenme
  // rozette amber (Md.12 istisnası) — burada da ihlal sayılmaz.
  // ÇAĞRI (Md.17, 5 Eki 2026, Serkan A): nöbetin "görevsiz biterse" dinlenmesi ARANMAZ ((2)(b), (1)(d)); UGS'den önceki
  // Md.16 dinlenmesi NÖBETİN BAŞINDAN önce aranır — nöbet dinlenme değildir (Md.4(d) "tüm görevlerden ve nöbetten muaf").
  const cagri = ctx.nobet || null;
  // Md.23(1): simülatöre bağlı uçuşta da aynısı — simülatörün dinlenmesi aranmaz, Md.16 dinlenmesi simülatörden ÖNCE aranır.
  const dinlenmeOncesi = sim ? (ctx.simOncesi || null) : cagri ? (ctx.nobetOncesi || null) : onc;
  const dinlenmeAni = sim ? fdpBasISO : cagri ? cagri.report_time : raporISO;
  const dd = dinlenmeOncesi ? dinlenmeDurumu({ ...duty, report_time: dinlenmeAni }, [dinlenmeOncesi]) : null;
  if (dd?.kisa && !dd.skpkKarsilar) {
    ihlaller.push({ tur: 'rest_short', ref: 'SHT-FTL/HG Md.16',
      metin: (sim
        ? `REST SHORT ${fmtMin(dd.eksikMin)} — THE SIMULATOR THAT STARTS THIS DUTY PERIOD STARTS ${anDamga(dinlenmeAni)}, REST ENDS `
          + `${anDamga(dd.gerekenISO)} (Md.23(1), Md.16)`
        : cagri
        ? `REST SHORT ${fmtMin(dd.eksikMin)} — THE STANDBY THAT LEADS TO THIS FDP STARTS ${anDamga(dinlenmeAni)}, REST ENDS `
          + `${anDamga(dd.gerekenISO)} — standby is not rest (Md.4(d), Md.17)`
        : `REST SHORT ${fmtMin(dd.eksikMin)} — REPORT ${anDamga(raporISO)}, REST ENDS ${anDamga(dd.gerekenISO)}`)
        + (dd.skpkNeden ? ` — ${dd.skpkNeden}` : '') });
  }
  // Md.16 ⑥ (4 Eki 2026, Serkan A): hemen önceki görevden ÖNCEKİ bir uzun menzil dinlenmesinin içinde mi — araya giren
  // ofis o dinlenmeyi silmez. Hemen önceki görev hariç (onu yukarıdaki REST SHORT ölçer, SKPK istisnasıyla).
  const lrU = uzunMenzilDinlenmesiIhlali(duty, raporISO, ctx.oncekiler || [], { anaUs: ctx.anaUs || null, tz,
    haric: (sim || cagri ? dinlenmeOncesi?.id : onc?.id) ?? null });
  if (lrU.ihlal) ihlaller.push(lrU.ihlal);
  eksik.push(...lrU.eksik);
  if (dd?.olculemedi) {
    eksik.push(`REST BEFORE THIS DUTY NOT MEASURED — the previous duty `
      + (dd.oncekiKusur.length ? `carries impossible values (${dd.oncekiKusur.join(', ')})` : 'has no rest time'));
  }
  // Nöbet (Md.17): `standbyLimits` önce ÖLÇÜLEMEYENİ yazar (kural seti nöbeti tanımlamıyor · nöbet kaydı bozuk), sonra
  // ihlalleri (birleşik tavan · havaalanı harici nöbet azamisi). Ölçülemeyen ihlal değildir → CANNOT VERIFY.
  if (sb && sb.ok === false) (sb.kunyeli || []).forEach((k, i) => {
    const olcu = sb.unavailable || (sb.invalid && i === 0);
    ihlaller.push(olcu ? { tur: 'standby_unmeasured', durum: FTL_DURUM.CANNOT_VERIFY, metin: k.metin, ref: k.ref }
                       : { tur: 'standby_limit', metin: k.metin, ref: k.ref });
  });
  // 4b: kümülatif limitler — çağıran (zincir) pilotun öteki görevlerini ve baseline'ını bilir.
  if (ctx.kumulatif) ihlaller.push(...ctx.kumulatif(alanlar, rules));
  return sonuc(alanlar, eksik, ihlaller);
}

/** EKİP BİLGİSİ — atama başına (aynı `assignment_id`'nin iptal edilmemiş uçuş satırları): tek pilot mu, artırılmış
 *  ekip (CRZ CPT) var mı. ASSIGN'daki karar: tek pilot = ekipte bir pilot; artırılmış = bir bacakta CRZ CPT.
 *  @returns {(duty) => { tekPilot: boolean, ucPilot: boolean }} */
export function ekipBilgisi(tumGorevler) {
  const gruplar = new Map();
  (tumGorevler || []).filter(d => d.duty_type === 'flight' && d.status !== 'cancelled' && d.assignment_id)
    .forEach(d => { const g = gruplar.get(d.assignment_id) || []; g.push(d); gruplar.set(d.assignment_id, g); });
  return (duty) => {
    // Atama bağı yoksa ekip BİLİNEMEZ — sessizce "tek pilot" sayılmaz (İlke 1): standart iki pilotla hesaplanır, görev
    // CANNOT VERIFY olur (gorevHesabi `ekipBilinmiyor`).
    if (!duty?.assignment_id || !gruplar.get(duty.assignment_id)) {
      return duty?.duty_type === 'flight' ? { tekPilot: false, ucPilot: false, ekipBilinmiyor: true }
                                          : { tekPilot: false, ucPilot: false };
    }
    const g = gruplar.get(duty.assignment_id);
    const pilotlar = new Set(g.map(x => x?.pilot_id).filter(Boolean));
    const crz = g.some(x => (x?.sectors || []).some(s => !s?.deadhead && String(s?.role || '').toUpperCase() === 'CRZ CPT'));
    // İKİ İLAVE PİLOT (5 Eki 2026, Serkan "ekleyelim" — tasarım: PF · PM · CRZ CPT · CRZ CPT): AYNI bacakta iki CRZ CPT → Md.11(4)
    // +3 saat. Bacak, sektörün yolu ve planlı saatleriyle eşlenir (her pilotun satırı kendi rolünü taşır).
    const bacakCrz = new Map();
    g.forEach(x => (x?.sectors || []).forEach(s => {
      if (s?.deadhead || String(s?.role || '').toUpperCase() !== 'CRZ CPT') return;
      const k = `${s.dep}|${s.dest}|${s.etd}|${s.eta}`;
      bacakCrz.set(k, (bacakCrz.get(k) || 0) + 1);
    }));
    const dort = [...bacakCrz.values()].some(n => n >= 2);
    // ARTIRILMIŞ EKİP = uçakta AYNI ANDA asgariden fazla pilot — bir bacakta CRZ CPT (5 Eki 2026, Serkan A; Md.4(1)(b): "görev
    // yerinden ayrılma ve … başka bir uçuş ekibi üyesi ile değiştirilme imkânı"). 🔴 Önce atamada 3+ farklı pilot da yetiyordu: bacaklar
    // arasında yerde ekip değişimi (her bacakta 2 pilot) artırılmış sayılıyor, yersiz "IN-FLIGHT REST NOT SELECTED" doğabiliyordu.
    return { tekPilot: pilotlar.size <= 1, ucPilot: crz, dortPilot: dort };
  };
}

/** ZİNCİR HESABI (3 Eki 2026) — bir pilotun görevleri kronolojik sırayla `gorevHesabi`nden geçer; her görev bir
 *  öncekinin ve önündeki nöbetin YENİ hesaplanmış hâlini görür (dinlenme, intibak, nöbet zinciri). Saf.
 *  🔑 Serkan: *"en ufak bir edit dahi yapılsa hesap yapılacak"* — değişen görevden SONRAKİ bütün görevler de etkilenebilir.
 *  @param gorevler  pilotun satırları (her tür); iptal edilenler atlanır, OFF bağlamdır (türetilecek alanı yok)
 *  @param ctx       { tz, anaUs, ekip: (duty) => { tekPilot, ucPilot }, baslangic: 'YYYY-MM-DD' } — farklar
 *                   `baslangic`tan itibaren döner; öncekiler yalnız bağlamdır (yine hesaplanır)
 *  @returns {{ duty, alanlar, farklar, eksik }[]} */
export function zincirHesabi(gorevler, pilotId, ctx = {}) {
  const { tz = {}, anaUs = null, ekip = () => ({ tekPilot: false, ucPilot: false }), baslangic = null, simdi,
          kumulatif = null, offTypes = null } = ctx;
  // Md.5(1)(a) serisi (3 Eki 2026, 2. adım): bir gündeki değişiklik ÖNCEKİ günlerin SERİ durumunu da değiştirir (ör. 11'in
  // OFF'u silinince 10'un "6. gün" sebebi doğar; 12'nin erken raporu 11'in OFF'unu bozunca 10 etkilenir). Başlangıçtan
  // önceki 7 gün bağlam kalır; yalnız DURUMU değişen görev ve yalnız durum alanları döner.
  const seriBas = baslangic ? shiftDate(baslangic, -7) : null;
  const erken = [];
  const satirlar = (gorevler || []).filter(d => d.pilot_id === pilotId && d.status !== 'cancelled');
  // 1. geçiş: sıralama anı — uçuşta rapor GİRDİLERDEN (kayıttaki eski rapor değil), diğerlerinde kayıttaki başlangıç.
  const an = new Map();
  satirlar.forEach(d => {
    const r = d.duty_type === 'flight' ? gorevHesabi(d, { tz, anaUs, ...ekip(d) }).alanlar.report_time : null;
    an.set(d, r || d.report_time || `${d.duty_date}T00:00:00Z`);
  });
  const sirali = [...satirlar].sort((a, b) => String(a.duty_date).localeCompare(String(b.duty_date))
    || new Date(an.get(a)) - new Date(an.get(b)));
  // 2. geçiş: zincir — bağlam olarak hesaplanmış satırlar biriktirilir.
  const hesaplanan = [];
  const sonuc = [];
  // Md.23(1) uçuştan SONRA simülatör (14 Eki 2026): bağlanan simülatörün kimliği → uçuşun HESAPLANMIŞ satırı (dinlenme oradan).
  const bagliUcuslar = new Map();
  for (const [i, d] of sirali.entries()) {
    if (d.duty_type === 'off') { hesaplanan.push(d); continue; }
    const rapor = an.get(d);
    const onceki = d.duty_type === 'flight' ? previousDuty(hesaplanan, pilotId, rapor) : null;
    const nobet = d.duty_type === 'flight' ? standbyBefore(hesaplanan, pilotId, d.duty_date, rapor) : null;
    // Çağrıda UGS'den önceki dinlenme nöbetin başından önce ölçülür (Md.17 ⑥ şartı) — nöbetten önceki görev.
    const nobetOncesi = nobet ? previousDuty(hesaplanan, pilotId, nobet.report_time, nobet.id) : null;
    // Md.23(1): simülatörle aynı görev periyodu — UGS simülatörden, dinlenme simülatörden önceki göreve göre.
    const sim = d.duty_type === 'flight' ? simBaglantisi(hesaplanan, pilotId, rapor, d.id) : null;
    const simOncesi = sim ? previousDuty(hesaplanan, pilotId, sim.report_time, sim.id) : null;
    // 4b: kümülatif ölçü — `kumulatif.gecmis` zincirden önceki kayıtlı satırlar (12 ay / takvim yılı için), artı zincirin
    // HESAPLANMIŞ satırları. Verilmezse (ör. ekran önizlemesi) kümülatif ölçülmez.
    const kum = kumulatif ? (alanlar, kurallar) => kumulatifIhlaller({ duty: d, alanlar, rules: kurallar,
      gorevler: [...(kumulatif.gecmis || []), ...hesaplanan], baseline: kumulatif.baseline ?? null }) : null;
    // Md.16(3)(b) rotasyonu geriye doğru aranır: zincirin hesaplanmış satırları + zincirden önceki kayıtlı satırlar.
    const oncekiler = [...(kumulatif?.gecmis || []), ...hesaplanan];
    // Md.27(1)(ç): aynı gündeki yer eğitimi uçuştan SONRA da olabilir — ham satırların tamamı (5 Eki 2026).
    const tumGorevler = [...(kumulatif?.gecmis || []), ...satirlar];
    // Uçuştan hemen sonraki görev (OFF hariç — `previousDuty` gibi) aynı paketteki simülatörse bağ adayı; bağı `gorevHesabi` ölçer.
    let arkaYer = null;
    if (d.duty_type === 'flight') {
      let j = i + 1;
      while (j < sirali.length && sirali[j].duty_type === 'off') j++;
      if (j < sirali.length && ayniPakettekiSim(d, sirali[j])) arkaYer = sirali[j];
    }
    const bagliUcus = d.duty_type === 'ground' ? (bagliUcuslar.get(d.id) || null) : null;
    const h = gorevHesabi(d, { tz, anaUs, onceki, nobet, nobetOncesi, sim, simOncesi, arkaYer, bagliUcus, simdi,
                               kumulatif: kum, oncekiler, tumGorevler, ...ekip(d) });
    const yeni = { ...d, ...h.alanlar };
    if (h.aciklama?.arkaYer) bagliUcuslar.set(h.aciklama.arkaYer.id, yeni);
    hesaplanan.push(yeni);
    if (!baslangic || String(d.duty_date) >= baslangic) {
      sonuc.push({ duty: d, alanlar: h.alanlar, farklar: gorevFarklari(d, h.alanlar), eksik: h.eksik, aciklama: h.aciklama });
    } else if (String(d.duty_date) >= seriBas) {
      erken.push({ duty: d, alanlar: { ftl_durum: h.alanlar.ftl_durum, ftl_gerekce: h.alanlar.ftl_gerekce } });
    }
  }
  // Md.5(1)(a) — seri sebepleri HESAPLANMIŞ satırlardan (yeni rapor / bitişlerle): OFF'un geceleri onlarla ölçülür.
  const seri = seriSebepleri(hesaplanan, { tz: tz[String(anaUs || '').toUpperCase()] || null, offTypes, simdi });
  const seriyle = (x) => {
    const ek = seri.get(x.duty.id);
    if (!ek) return x;
    const g = [...(Array.isArray(x.alanlar.ftl_gerekce) ? x.alanlar.ftl_gerekce : []), ...ek];
    const alanlar = { ...x.alanlar, ftl_durum: durumOf(g), ftl_gerekce: g };
    return { ...x, alanlar, farklar: gorevFarklari(x.duty, alanlar) };
  };
  for (let i = 0; i < sonuc.length; i++) sonuc[i] = seriyle(sonuc[i]);
  // Başlangıçtan önceki bağlam: yalnız seri durumu kayıttakinden farklıysa (yeni sebep çıktı ya da eskisi kalktı).
  erken.forEach(x => {
    const y = seriyle({ ...x, farklar: [] });
    const farklar = gorevFarklari(x.duty, y.alanlar);
    const seriIzi = (gg) => JSON.stringify((Array.isArray(gg) ? gg : []).filter(k => SERI_TURLERI.has(k?.tur)));
    if (farklar.length && seriIzi(y.alanlar.ftl_gerekce) !== seriIzi(x.duty.ftl_gerekce)) {
      sonuc.unshift({ duty: x.duty, alanlar: y.alanlar, farklar, eksik: [], aciklama: {} });
    }
  });
  // 4a: OFF'un ve iptal edilen görevin DURUMU YOKTUR — görev OFF'a çevrildiyse ya da iptal edildiyse eski durum silinir
  // (yoksa iptal edilmiş bir uçuş "NOT LEGAL" görünmeye devam ederdi). Yalnız durumu dolu olan satır döner.
  (gorevler || []).filter(d => d.pilot_id === pilotId && (d.duty_type === 'off' || d.status === 'cancelled')
      && (d.ftl_durum != null || d.ftl_gerekce != null) && (!baslangic || String(d.duty_date) >= baslangic))
    .forEach(d => {
      const alanlar = { ftl_durum: null, ftl_gerekce: null };
      sonuc.push({ duty: d, alanlar, farklar: gorevFarklari(d, alanlar), eksik: [], aciklama: {} });
    });
  return sonuc;
}

/** DÜZENLEME ÖNİZLEMESİ (3 Eki 2026, tek motor adım 1b) — düzenlenen görevin, kaydedildiğinde SUNUCUNUN yazacağı
 *  değerleri. İkinci bir formül YOK: pilotun görev listesine düzenlenen satırın YENİ hâli konur ve sunucunun koştuğu
 *  `zincirHesabi` aynen koşar (önceki görev, nöbet, intibak, uzun menzil, dinlenme — hepsi aynı). EDIT ekranı kaydetme
 *  kapısını ve "eski → yeni" tablosunu bundan kurar; böylece kaydetmeden önce görülen değer, sunucunun birkaç saniye
 *  sonra yazacağı değerin AYNISIDIR.
 *  🔴 Neden: EDIT kendi parça hesaplarını yapıyordu — uçulmuş görevde tip değişince Tablo 1'i UTC ile okudu (10 Eyl:
 *     rapor 12:05Z = yerel 15:05 → doğrusu 12:30, ekran ve kayıt 13:30 dedi).
 *  @param satirlar      düzenlenen görevin satırları, KAYDEDİLDİKTEN SONRAKİ hâlleriyle (pilot başına bir satır; yeni
 *                       eklenen üyenin `id`'si geçici olabilir)
 *  @param tumGorevler   şirketin bütün satırları (kayıttaki hâlleri)
 *  @param ekipDuzenlenen { tekPilot, ucPilot, dortPilot } — düzenlenen görevin YENİ ekip düzeni (ekrandaki ekip); diğer görevlerin
 *                       ekibi kayıttan (`ekipBilgisi`) — sunucuyla aynı
 *  @returns {{ [id]: { alanlar, eksik } | null }} */
export function duzenlemeOnizlemesi({ satirlar, tumGorevler, tz = {}, anaUslar = {}, baslangic = null,
                                      ekipDuzenlenen = null }) {
  const ids = new Set((satirlar || []).map(x => x.id));
  const liste = [...(tumGorevler || []).filter(d => !ids.has(d.id)), ...(satirlar || [])];
  const kayittan = ekipBilgisi(liste);
  const ekip = (d) => (ekipDuzenlenen && ids.has(d.id)) ? ekipDuzenlenen : kayittan(d);
  const out = {};
  for (const sat of satirlar || []) {
    const z = zincirHesabi(liste.filter(d => d.pilot_id === sat.pilot_id), sat.pilot_id,
      { tz, anaUs: anaUslar[sat.pilot_id] || null, ekip, baslangic });
    const r = z.find(x => x.duty.id === sat.id);
    out[sat.id] = r ? { alanlar: r.alanlar, eksik: r.eksik, aciklama: r.aciklama } : null;
  }
  return out;
}

const kanonik = (v) => Array.isArray(v) ? v.map(kanonik)
  : v && typeof v === 'object' ? Object.fromEntries(Object.keys(v).sort().map(k => [k, kanonik(v[k])])) : v;
/** Hesaplanan alanlarla kayıttaki değerlerin FARKI — yalnız değişenler (zaman damgaları an olarak karşılaştırılır).
 *  🔑 21 Ağu dersi: "…+00:00" ile "….000Z" aynı andır, farklı metindir — metin karşılaştıran koruma boş iz üretmişti.
 *  @returns {{ alan, eski, yeni }[]} */
export function gorevFarklari(duty, alanlar) {
  const zamanAlani = (k) => /(_time|_end|_report|_due)$/.test(k) || k === 'earliest_next_report';
  const ayni = (k, a, b) => {
    if ((a ?? null) === null && (b ?? null) === null) return true;
    if (zamanAlani(k) && a && b) return new Date(a).getTime() === new Date(b).getTime();
    // Anahtar sırası anlam taşımaz: veritabanı jsonb'yi kendi sırasıyla döndürür (`ftl_gerekce`, 4a) — sıralı karşılaştırılır.
    return JSON.stringify(kanonik(a ?? null)) === JSON.stringify(kanonik(b ?? null));
  };
  return Object.entries(alanlar || {})
    .filter(([k, v]) => !ayni(k, (duty || {})[k], v))
    .map(([k, v]) => ({ alan: k, eski: (duty || {})[k] ?? null, yeni: v }));
}

// ── SON DÖNEM TECRÜBESİ — PF YAKINLIĞI (4 Eyl 2026, Serkan) ─────────
//
// 🔑 Serkan: *"FTL limits yazan yerde son 90 gün içinde yapılan PF görevlerini
//    takip eden çizelge olsun."* · *"60'a kadar yeşil, 80'ne kadar amber,
//    90 gün olduğunda KIRMIZI."*
//
// 🔑 SERKAN KENDİ ÖNERİSİNİ DÜZELTTİ — ve düzeltmesi doğruydu: önce "son PF
//    sektöründen bu yana geçen gün" konuşuldu, sonra *"bu mantıkta 1 tane
//    yaparsa sorun yok gibi anlaşılıyor, biz son 90 gün içinde 3'ü takip
//    ediyoruz."*  Tek iniş barı sıfırlardı; kural üç iniş istiyor.
//
// ÖLÇÜ: 3. EN YENİ PF SEKTÖRÜNÜN YAŞI. Yakınlığı ayakta tutan iniş odur;
// 90 günü doldurduğu an sayı 3'ün altına iner. Pencerede 3'ten az sektör
// varsa şart zaten sağlanmıyor → kırmızı.
//
// ⚠️ BU BİR FARKINDALIK ARACIDIR, onaylı bir currency sistemi DEĞİL.
//    Ölçemediklerimiz `ruleset-fcl/ruleset_fcl_regulation.json` içindeki
//    `measurability` bloğunda açıkça yazılıdır (tip/sınıf ayrımı, FFS
//    kalkış/inişleri, FCL.060(b)(1) nezaretli hat uçuşu ile 120 güne uzatma).
//
// 🔑 Serkan: *"Bizde PF yaklaşma, iniş, kalkış hepsini yapar — PF olarak
//    tanımlıysa 3 durum gerçekleşir."*  Yani BİR PF SEKTÖRÜ = 1 kalkış +
//    1 yaklaşma + 1 iniş. FCL.060(a)(1)'in üç ayağı da o sektörden gelir.
export const PF_RECENCY = { windowDays: 90, required: 3, amberFromDays: 60, redFromDays: 80 };

const GUN_MS = 86400000;

// ── "SON 90 GÜN İÇERİSİNDE" — TAKVİM GÜNÜ, TEK YÖNTEM (21 Eki 2026, Serkan: B) ──
// 🔴 Önce SAATLE sayılıyordu: sektör görev gününün öğlenine (12:00Z) konuyor, pencere "şimdi − 90 × 24 saat"ti → tam 90 gün
//    önceki sektör aynı gün 12:00Z'ye kadar sayılıyor, sonra düşüyordu (pilot öğleden önce current, öğleden sonra kırmızı);
//    dünkü sektör öğleden önce "0 günlük"tü. Beş hesap (gündüz PF, FFS, gece PF, seyir yedek, taban) aynı kopyayı taşıyordu.
// 🔑 Metin ("son 90 gün içerisinde" / "in the preceding 90 days") sayma yöntemini söylemiyor; Serkan B'yi seçti: OLAY GÜNÜ
//    SAYILMAZ, 90. GÜN DAHİL — AB süre tüzüğü 1182/71 Md.3(1) ("olayın olduğu gün süreye dahil edilmez") ve SKPK son günüyle
//    aynı yöntem. 23 JUL'deki sektör 21 OCT'un sonuna kadar sayılır, 22 OCT'ta düşer. Gün UTC (görev tarihi UTC). Bugünün
//    gerçekleşmiş olayı (0 gün) dahil, ileri tarih hariç. Yaş = geçen takvim günü (dün = 1).
/** Olay günü FCL.060 penceresinde mi: 0 ≤ geçen takvim günü ≤ `windowDays`. */
export function fclPenceresinde(gun, simdi, windowDays = PF_RECENCY.windowDays) {
  const gecen = utcGunFarki(simdi, gun);
  return gecen != null && gecen >= 0 && gecen <= windowDays;
}

// ── SİMÜLATÖR OTURUMLARI (4 Eyl 2026, Serkan) ───────────────────────
//
// 🔑 Serkan: *"Ahmet kaptan geçenlerde SIM'e gitti — gece gündüz yetkisi ordan
//    çekilebiliyor mu?"*  Talimat EVET diyor; FCL.060(a)(1) ve (a)(2) ikisi de
//    *"…veya söz konusu hava aracı tipinin/sınıfının TAM UÇUŞ SİMÜLATÖRÜNDE
//    (FFS)…"* der.
//
// 🔑 YALNIZ FFS SAYILIR. Serkan cihazı oturuma bağladı: *"GND-SIM seçince sim
//    için bize bir hücre daha açsın — FFS LEVEL D veya FNPT ayrı ayrı
//    seçilebilsin."*  FNPT tam uçuş simülatörü DEĞİLDİR ve currency'ye
//    sayılmaz; "bizim sim Level D'dir" diye şirket beyanı yazmak kolaydı ama
//    yanlış olurdu — cihaz her oturumda kayıtlıdır.
//
// ⚠️ SİMÜLATÖRDE GECE HESAPLANMAZ, GİRİLİR: gerçek uçuşta gece meydan
//    koordinatı ve saatten çıkar, simülatörde oturumda ne uçulduysa odur.
export const FFS_KABUL = ['FFS_D'];

/** FFS oturumlarını sektör listesine çevirir — gerçek sektörlerle aynı biçimde. */
export function simSectors(duties, pilotId, asOf = null, windowDays = PF_RECENCY.windowDays) {
  const simdi = asOf ? new Date(asOf).getTime() : Date.now();
  const out = [];
  (duties || [])
    .filter(d => (!pilotId || d.pilot_id === pilotId)
                 && d.duty_type === 'ground' && d.ground_kind === 'sim'
                 && d.status !== 'planned' && d.status !== 'cancelled' && d.duty_date
                 && FFS_KABUL.includes(d.sim_device))
    .forEach(d => {
      const ms = new Date(`${d.duty_date}T12:00:00Z`).getTime();   // yalnız sıralama için
      if (!fclPenceresinde(d.duty_date, simdi, windowDays)) return;
      // 🔑 2 Eki 2026 (Serkan): *"simülatör programları zaten mevzuata göre min sayıda iniş kalkış içerir, o programlar
      //    mevzuata tabi"* → her FFS Level D oturumu programın ASGARİSİ sayılır: FCL.060(a)(1)'in sayısı kadar kalkış +
      //    iniş (`PF_RECENCY.required`, 3). Sayı artık sorulmaz; eski girişler kayıtta kalır ama hesap bunu kullanır.
      //    Gece SORULMAZ (IR muafiyeti, FCL.060(a)(2)(ii)) — olay "sim" diye işaretlenir, gece/gündüz sayımına girmez.
      for (let i = 0; i < PF_RECENCY.required; i++) {
        out.push({ date: d.duty_date, ms, dutyId: d.id, sim: true,
                   dep: null, dest: null, takeoffNight: null, landingNight: null });
      }
    });
  return out.sort((a, b) => b.ms - a.ms);   // en yeni önce — `[0]` son oturumdur
}

export function pfRecency(duties, pilotId, asOf = null, opts = {}) {
  const { windowDays, required, amberFromDays, redFromDays } = { ...PF_RECENCY, ...opts };
  const simdi = asOf ? new Date(asOf).getTime() : Date.now();
  // 🔑 TABAN (4 Eyl 2026, Serkan): *"İniş kalkış için base girelim — sistem
  //    canlıya geçince base'leri girmemiz lazım, aynı uçuş saatleri gibi."*
  //    Sisteme geçmeden önce uçulan sektörlerin TARİHLERİ; sayı değil tarih,
  //    çünkü soru "kaç iniş" değil "son 90 günde 3 tane var mı".
  //    Bu tarihler 90 gün sonra pencereden çıkar ve kendiliğinden ölür.
  const tabanTarihleri = (opts.baselineDates || [])
    .filter(Boolean)
    .map(x => ({ date: String(x).slice(0, 10),
                 ms: new Date(`${String(x).slice(0, 10)}T12:00:00Z`).getTime(),
                 fromBaseline: true }));

  // Yalnız GERÇEKLEŞMİŞ uçuşlar: yakınlık ne PLANLANDIĞIYLA değil, ne
  // UÇULDUĞUYLA ilgilenir (İlke 1). İptaller de doğal olarak dışarıda.
  const sektorler = [];
  (duties || [])
    .filter(d => (!pilotId || d.pilot_id === pilotId)
                 && d.duty_type === 'flight'
                 && d.status !== 'planned' && d.status !== 'cancelled'
                 && d.duty_date)
    .forEach(d => {
      const gunMs = new Date(`${d.duty_date}T12:00:00Z`).getTime();   // yalnız sıralama için
      if (!fclPenceresinde(d.duty_date, simdi, windowDays)) return;
      (d.sectors || []).forEach(sec => {
        if (String(sec.role || '').toUpperCase() !== 'PF') return;
        sektorler.push({ date: d.duty_date, ms: gunMs, dutyId: d.id });
      });
    });

  // FFS oturumları da sayılır — talimat açıkça kabul eder (FCL.060(a)(1)). 2 Eki 2026: her oturum programın asgarisi
  // kadar olay üretir (`simSectors`); eskiden gecesi null olan olay "girilen sayının ötesi" demekti ve süzülüyordu —
  // gece artık hiç sorulmadığı için süzgeç KALKTI (yoksa bütün oturumlar düşerdi).
  simSectors(duties, pilotId, simdi, windowDays)
    .forEach(x => sektorler.push({ date: x.date, ms: x.ms, sim: true }));

  // Taban tarihleri pencereye giriyorsa sayıma katılır; aynı güne hem taban
  // hem kayıt düşerse KAYIT esastır (taban bir tahmindir, kayıt ölçümdür).
  const kayitliGunler = new Set(sektorler.map(x => x.date));
  tabanTarihleri.forEach(t => {
    if (fclPenceresinde(t.date, simdi, windowDays) && !kayitliGunler.has(t.date)) sektorler.push(t);
  });

  sektorler.sort((a, b) => b.ms - a.ms);              // en yeni önce
  const count = sektorler.length;

  // 🔑 "KAYIT YOK" ile "YAKINLIK YOK" AYRI ŞEYLERDİR (4 Eyl 2026).
  // Sistemde o pilota ait HİÇ uçuş görevi yoksa yakınlığı ÖLÇMEDİK — yok
  // demedik. Yeni eklenen pilot, ya da geçmişi bu sistemden eski olan pilot
  // böyle görünür (FTL'de bunun karşılığı `ftl_pilot_baselines`tir; inişler
  // için öyle bir taban YOK). Kırmızı yakmak, ölçmediğimize hüküm vermek
  // olurdu (İlke 1) ve zili gereksiz kırmızıya boğardı.
  // Pencere DIŞINDA uçuşu olan pilot bu kapsamda değildir: onun için kanıt
  // vardır ve "son 90 günde uçmamış" demek doğru bir ölçümdür.
  // Taban girilmişse "kaydı yok" DEMEYİZ — ölçecek bir şeyimiz vardır.
  const hicKayitYok = !tabanTarihleri.length
    && !simSectors(duties, pilotId, simdi, windowDays).length
    && !(duties || []).some(
    d => (!pilotId || d.pilot_id === pilotId) && d.duty_type === 'flight'
         && d.status !== 'planned' && d.status !== 'cancelled'
         && (d.sectors || []).some(x => String(x.role || '').toUpperCase() === 'PF'));
  if (hicKayitYok) {
    return { count: 0, required, windowDays, state: 'unknown', ageDays: null,
             daysLeft: null, lastPfDate: null, keepDate: null,
             reference: 'SHT-FCL FCL.060(a)(1)',
             note: 'No PF sector on record for this pilot — recency not measured.' };
  }
  const ucuncu = sektorler[required - 1] || null;     // yakınlığı ayakta tutan
  const ageDays = ucuncu ? utcGunFarki(simdi, ucuncu.date) : null;   // geçen takvim günü

  const state = count < required ? 'red'
    : ageDays >= redFromDays ? 'red'
    : ageDays >= amberFromDays ? 'amber'
    : 'green';

  return {
    count, required, windowDays, state,
    ageDays,                                   // 3. en yeni sektörün yaşı (gün)
    daysLeft: ageDays == null ? null : Math.max(0, windowDays - ageDays),
    lastPfDate: sektorler[0]?.date || null,
    keepDate: ucuncu?.date || null,            // yakınlığı ayakta tutan tarih
    fromBaseline: sektorler.filter(x => x.fromBaseline).length,
    reference: 'SHT-FCL FCL.060(a)(1)',
  };
}

// ── PF SEKTÖRLERİ, GECE/GÜNDÜZ AYRIMIYLA (4 Eyl 2026, Serkan) ───────
//
// 🔑 Serkan: *"Geçmişe dönük verilerden gece gündüz iniş kalkış hepsini
//    görebilmemiz lazım."*
//
// 🔑 SAKLAMIYORUZ, HESAPLIYORUZ. Sektörde kalkış meydanı, varış meydanı ve
//    saatler zaten var; `airports` tablosunda `lat`/`lon` var. Gece/gündüz her
//    seferinde `SolarTimes` ile bulunur → GEÇMİŞ uçuşlar için de doğru cevap
//    çıkar, göç ve geriye doldurma gerekmez. (`archived_flights`teki
//    `is_night_landing` saklanmaya çalışıldı ve sabit `false` kaldı — bugüne
//    kadar "gece inişin yok" diye yanlış konuştu.)
//
// ⚠️ Koordinat yoksa gece/gündüz `null` döner — "gündüz" DEMEYİZ (İlke 1).

/** "HH:MM" + gün → UTC ISO. Bitiş başlangıçtan küçükse ertesi gün. */
function sektorAnlari(duty, sec) {
  const g = duty.duty_date;
  if (!g) return { off: null, on: null };
  const kalkis = sec.off_block || sec.etd || null;
  const inis = sec.on_block || sec.eta || null;
  if (!kalkis || !inis) return { off: null, on: null };
  const dk = (h) => { const [a, b] = String(h).split(':').map(Number); return a * 60 + b; };
  const ertesi = dk(inis) < dk(kalkis);
  const gunSonra = new Date(new Date(`${g}T12:00:00Z`).getTime() + 86400000)
    .toISOString().slice(0, 10);
  return { off: `${g}T${kalkis}:00Z`, on: `${ertesi ? gunSonra : g}T${inis}:00Z` };
}

/**
 * Pencere içindeki PF sektörleri, her biri için kalkış ve iniş gece mi.
 * @param {object} geo ICAO → {lat, lon}
 */
export function pfSectors(duties, pilotId, asOf = null, geo = {}, windowDays = PF_RECENCY.windowDays) {
  const simdi = asOf ? new Date(asOf).getTime() : Date.now();
  // 🔑 TEK GIRIS NOKTASI (21 Eyl 2026): koordinat varsa hesaplanir, yoksa
  //    GOREVIN KENDI beyanina bakilir (`ad_hoc_airports`). Beyan goreve aittir
  //    — bu yuzden `gece` artik gorevi de alir; kuresel bir "tanimsiz meydan"
  //    tablosu YOK (Serkan: "bu meydan database'e girmez").
  const gece = (icao, an, d) => geceMiMeydan(icao, an, { geo, beyan: d?.ad_hoc_airports });

  const out = [];
  (duties || [])
    .filter(d => (!pilotId || d.pilot_id === pilotId) && d.duty_type === 'flight'
                 && d.status !== 'planned' && d.status !== 'cancelled' && d.duty_date)
    .forEach(d => {
      const gunMs = new Date(`${d.duty_date}T12:00:00Z`).getTime();   // yalnız sıralama için
      if (!fclPenceresinde(d.duty_date, simdi, windowDays)) return;
      (d.sectors || []).forEach(sec => {
        if (String(sec.role || '').toUpperCase() !== 'PF') return;
        const { off, on } = sektorAnlari(d, sec);
        out.push({
          date: d.duty_date, ms: gunMs, dutyId: d.id,
          dep: sec.dep || null, dest: sec.actual_dest || sec.dest || null,
          offISO: off, onISO: on,
          takeoffNight: gece(sec.dep, off, d),
          landingNight: gece(sec.actual_dest || sec.dest, on, d),
        });
      });
    });
  return out.sort((a, b) => b.ms - a.ms);
}

/** Gece/gündüz kırılımı — "hepsini görebilmemiz lazım" (Serkan). */
export function pfDayNightCounts(sectors) {
  // FFS oturumu gece/gündüz ÖLÇÜLMEZ (2 Eki 2026) — "?" (koordinatsız meydan) sayılmasın, AYRI sayılır.
  const ucus = sectors.filter(s => !s.sim);
  const say = (alan, deger) => ucus.filter(s => s[alan] === deger).length;
  return {
    takeoffs: { day: say('takeoffNight', false), night: say('takeoffNight', true),
                unknown: say('takeoffNight', null) },
    landings: { day: say('landingNight', false), night: say('landingNight', true),
                unknown: say('landingNight', null) },
    ffsOturum: new Set(sectors.filter(s => s.sim).map(s => s.dutyId)).size,
    total: sectors.length,
  };
}

/**
 * FCL.060(a)(2) — GECE PIC yakınlığı: son 90 günde gece şartlarında en az
 * 1 kalkış, yaklaşma ve iniş. Talimat üçünü de gece ister → kalkış VE iniş
 * gece olan sektör sayılır. Ölçülemeyen (koordinatsız) sektör SAYILMAZ.
 */
export function pfNightRecency(sectors, asOf = null, opts = {}) {
  const { windowDays, amberFromDays, redFromDays } = { ...PF_RECENCY, ...opts };
  const simdi = asOf ? new Date(asOf).getTime() : Date.now();

  // ── IR MUAFİYETİ (5 Eyl 2026, Serkan) ────────────────────────────
  // 🔑 *"Hepimizin IR rating'i var, geceye zaten takılmıyoruz."*
  //
  // 🔴 SHT-FCL'in TÜRKÇE metni iki OLUMSUZU "veya" ile bağlıyor:
  //    *"(i) … icra etmemiş ise; VEYA (ii) aletli uçuş yetkisine (IR) sahip
  //     DEĞİL ise"* — kelimesi kelimesine okununca İKİSİ DE gerekli çıkar.
  //    EASA'nın orijinali (1178/2011 FCL.060(b)(2)) ise *"unless (i) … OR
  //    (ii) holds an IR"* der: orada IR, gece yakınlığının YERİNE geçer.
  //    İki olumsuzu "veya" ile bağlamak mantığı ters çeviriyor.
  //
  // Karar operatörün ve RULE SET'te yazılı (`night_recency_ir_exemption`).
  // ⚠️ DAYANAK — Serkan: *"Bu uçakta uçan herkes ATPL, yani IR yetkisi var,
  //    ve kaptan."*  ATPL(A) zaten geçerli bir IR gerektirir. Muafiyet BU
  //    KOŞULA bağlıdır: ATPL'siz ya da IR'si askıda bir pilot ekibe girerse
  //    yeniden ele alınmalı — kayıtta pilot başına lisans/IR alanı YOKTUR.
  if (opts.irExempt) {
    return { required: 1, windowDays, state: 'exempt', ageDays: null, daysLeft: null,
             count: 0, takeoffs: 0, landings: 0, missing: null, unmeasured: 0, keepDate: null,
             reference: 'SHT-FCL FCL.060(a)(2)(ii)',
             note: 'All flight crew on this type hold an ATPL, which requires a valid instrument '
                 + 'rating — under FCL.060(a)(2)(ii) the night recency requirement does not apply. '
                 + 'Company decision, recorded in RULE SET with its reasoning.' };
  }

  // 🔑 KALKIŞ VE İNİŞ AYNI SEKTÖRDE OLMAK ZORUNDA DEĞİL (Serkan, 4 Eyl 2026):
  //    *"Ayrı ayrı olabilir, tek başına bir uçuşta da gerçekleşebilir — zaten
  //     bu açık: bir uçuş gündüz başlayıp gece inişiyle bitebilir."*
  //    Madde *"gece şartlarında en az 1 kalkış, yaklaşma ve inişi"* der ve
  //    AYNI SEKTÖR demez; dar okuma bir varsayım olurdu. Karar RULE SET'te
  //    `company.night_recency_interpretation` altında yazılıdır.
  //
  // Yakınlığı bağlayan, iki olayın ESKİ olanıdır: hangisi önce 90 günü
  // doldurursa şart o an düşer.
  const geceKalkis = sectors.filter(s => s.takeoffNight === true);
  const geceInis = sectors.filter(s => s.landingNight === true);
  const olculemeyen = sectors.filter(s => s.takeoffNight === null || s.landingNight === null).length;

  const sonKalkis = geceKalkis[0] || null;      // sectors zaten en yeniden eskiye
  const sonInis = geceInis[0] || null;
  const tamam = !!(sonKalkis && sonInis);
  const tutan = tamam ? (sonKalkis.ms < sonInis.ms ? sonKalkis : sonInis) : null;
  const ageDays = tutan ? utcGunFarki(simdi, tutan.date) : null;   // geçen takvim günü
  const state = !tamam ? 'red'
    : ageDays >= redFromDays ? 'red'
    : ageDays >= amberFromDays ? 'amber' : 'green';

  return {
    required: 1, windowDays, state, ageDays,
    // Ekranda "1/1" degil, NEYIN EKSIK OLDUGU gorunsun diye ikisi ayri sayilir.
    count: tamam ? 1 : 0,
    takeoffs: geceKalkis.length, landings: geceInis.length,
    missing: tamam ? null : (!sonKalkis && !sonInis ? 'both'
                            : !sonKalkis ? 'takeoff' : 'landing'),
    daysLeft: ageDays == null ? null : Math.max(0, windowDays - ageDays),
    unmeasured: olculemeyen, keepDate: tutan?.date || null,
    reference: 'SHT-FCL FCL.060(a)(2)',
  };
}

// ── SİM YAMASI (4 Eyl 2026) ─────────────────────────────────────────
//
// 🔴 SAHA: Serkan sim görevini açtı, FFS LEVEL D ve sayıları girdi, Save dedi
//    — hiçbir şey olmadı. *"Girdim save ettim ama remark olarak FFS LVL D
//    görünmüyor."*  SQL doğruladı: iki satırda da `sim_device` NULL.
//    KÖK NEDEN: alanlar `if (kindChanged)` DALININ İÇİNDE hesaplanıyordu;
//    görevin türü değişmediği için dal hiç çalışmadı ve kayıt SESSİZCE düştü.
//
// 🔑 Bu yüzden karar UI'dan çıkarıldı: hangi alanların yazılacağını SAF BİR
//    FONKSİYON söyler, ekran yalnız çağırır. Dal mantığı burada sürülür.
// 🔑 2 Eki 2026 (Serkan): kalkış/iniş sayıları SORULMAZ — *"simülatör programları zaten mevzuata göre min sayıda iniş
//    kalkış içerir"*; yerlerine OPC / LPC. Eski sayı kolonlarına DOKUNULMAZ (girilmiş değer kayıtta kalır).
export function simYamasi(mevcut, form) {
  if (!form || form.kind !== 'sim') return null;
  const yeni = { sim_device: form.device || null, sim_checks: simKontrolleriYaz(form.checks) };
  const yama = {};
  Object.entries(yeni).forEach(([k, v]) => {
    if (JSON.stringify((mevcut || {})[k] ?? null) !== JSON.stringify(v)) yama[k] = v;
  });
  return Object.keys(yama).length ? yama : null;
}

// ── SIM GÖREVİ: OPC / LPC (2 Eki 2026) — TEK KAYNAK ─────────────────────────────────────────────────────────
// 🔑 Serkan: sim girilince kaldırılan hücrelerin yerinde OPC ve LPC kutuları; roster'da SIM/OPC · SIM/LPC · SIM/LPC&OPC.
//    A: yalnız roster'da görünür — TRAINING'deki OPC/LPC kaydı ayrıca girilir (kontrolün sonucu roster'da yoktur).
/** Ekrandaki kutu sırası. */
export const SIM_KONTROL_KUTULARI = ['OPC', 'LPC'];
/** Etiketteki sıra — Serkan'ın yazdığı gibi "SIM/LPC&OPC". */
const SIM_ETIKET_SIRASI = ['LPC', 'OPC'];
/** Kayda yazılacak değer: yalnız bilinen kontroller, sabit sırayla; hiçbiri yoksa null. */
export function simKontrolleriYaz(liste) {
  const k = SIM_ETIKET_SIRASI.filter(x => (liste || []).includes(x));
  return k.length ? k : null;
}
/** SIM · SIM/OPC · SIM/LPC · SIM/LPC&OPC — roster, DUTY HISTORY, yazdırma ve DUTY SHEET bunu çağırır. */
export function simEtiketi(d) {
  const k = simKontrolleriYaz(d?.sim_checks);
  return k ? `SIM/${k.join('&')}` : 'SIM';
}

// ── SAĞLIK KISITLAMASI: OML (5 Eyl 2026, SHT-MED) ───────────────────
//
// 🔑 Serkan: *"İki OML pilot aynı uçuşa assign olursa uyarı verecek mi?"* ·
//    *"Veya OML ve 60 yaş üstü, ve OML olan başka pilot."*
//
// TALİMATIN KENDİ CÜMLESİ (SHT-MED):
//   *"OML şerhi düşülen bir sağlık sertifikasına sahip olan kişiler sadece
//    DİĞER PİLOTUN ilgili hava aracı tipinde gerekli tüm vasıflara sahip
//    olduğu, OML'ye tabi OLMADIĞI ve 60 yaşına ULAŞMADIĞI durumlarda ÇOK
//    PİLOTLU operasyonlarda bir hava aracı kullanabilirler."*
//
// 🔑 BU KURAL PİLOT ÇİFTİ ÜZERİNDE ÇALIŞIR, PİLOT BAŞINA DEĞİL.
//    `fitness()` her pilotu tek tek ölçer; OML'yi oraya koysaydık iki OML'li
//    pilot AYRI AYRI "legal" görünür, birlikte seçilince kimse itiraz etmezdi.
//    Bu yüzden ölçü SEÇİLİ EKİBİN TAMAMIDIR.
//
// ⚠️ ENGELDİR, UYARI DEĞİL: madde *"sadece … durumlarda … kullanabilirler"*
//    der — izin şartlıdır. Sağlık kısıtlaması esnetilecek bir şey değildir.

/**
 * @param {Array} ekip [{id, code, oml:boolean, age:number|null, typeOk:boolean|null}]
 * @returns {Array} gerekçeler — boşsa engel yok
 */
export function omlKontrol(ekip) {
  const liste = (ekip || []).filter(p => p && p.id);
  const omlliler = liste.filter(p => p.oml);
  if (!omlliler.length) return [];

  const gerekce = [];
  for (const p of omlliler) {
    const digerleri = liste.filter(x => x.id !== p.id);

    // ÇOK PİLOTLU olacak: tek başına atanamaz.
    if (!digerleri.length) {
      gerekce.push(`OML (${p.code}) — SINGLE-PILOT OPERATION NOT PERMITTED (SHT-MED)`);
      continue;
    }
    // Şartları SAĞLAYAN en az bir diğer pilot bulunmalı.
    const uygun = digerleri.filter(x => !x.oml && x.age != null && x.age < 60 && x.typeOk !== false);
    if (uygun.length) continue;

    // Neden bulunamadığını AYRI AYRI söyleriz — "uygun pilot yok" demek,
    // dispatcher'a ne yapacağını söylemez (Ilke: gerekçe eylem gösterir).
    if (digerleri.every(x => x.oml)) {
      gerekce.push(`OML (${p.code}) — OTHER PILOT IS ALSO UNDER OML (SHT-MED)`);
    } else if (digerleri.filter(x => !x.oml).every(x => x.age != null && x.age >= 60)) {
      gerekce.push(`OML (${p.code}) — OTHER PILOT IS 60 OR OVER (SHT-MED)`);
    } else if (digerleri.filter(x => !x.oml).some(x => x.age == null)) {
      // Ölçemediğimize "uygun" DEMEYİZ (İlke 1).
      gerekce.push(`OML (${p.code}) — OTHER PILOT'S DATE OF BIRTH NOT RECORDED, AGE CANNOT BE CHECKED`);
    } else {
      gerekce.push(`OML (${p.code}) — NO OTHER PILOT QUALIFIED ON TYPE (SHT-MED)`);
    }
  }
  return gerekce;
}

// ── SAĞLIK KISITLAMALARININ ATAMAYA ETKİSİ (6 Eyl 2026) ─────────────
//
// 🔑 Serkan: *"Sen en son revizyonu referans alacaksın ve limitasyonların ops
//    etkisi varsa MED rule set'e ekleme yapacaksın değil mi?"* → evet.
//
// On sekiz kodun ÇOĞU pilotun kendi yükümlülüğüdür (gözlüğü tak, yedeğini
// bulundur) ve ATAMAYI DEĞİŞTİRMEZ. Kapıya giren yalnız `ops` alanı işaretli
// olanlardır; hangi kodun hangi etkisi olduğu `data/medLimitations.js`de
// yazar — burada İKİNCİ BİR LİSTE TUTULMAZ (İlke 3).
//
// ⚠️ NE ÖLÇEBİLDİĞİMİZ AÇIKÇA YAZILIDIR (İlke 1). Bilinmeyen bağlam
//    "uygun" saymaz; AMBER olarak görünür. Örneğin gece/gündüz ölçülemediyse
//    VCL'li pilot sessizce geçmez.
//
// 🔴 OCL'İN SINIRI: kural *"yalnızca yardımcı pilot olarak"* der; ama bu
//    sistemde roller PF / PM / CRZ CPT'dir — KAPTAN / YARDIMCI PİLOT ayrımı
//    modellenmemiştir (PF olmak kaptan olmak değildir). Bu yüzden burada
//    OCL'in ANCAK GEREKLİ ŞARTI denetlenir: ekipte kaptanlık yapabilecek,
//    OML/OCL'e tabi OLMAYAN başka bir pilot bulunmalıdır. Koltuğun kendisi
//    DOĞRULANMAZ — bu sınır kural setinde de yazılıdır.
/**
 * @param {Array} ekip  [{ id, code, limits:[], age, typeOk, oalTypes, sslText }]
 * @param {Object} baglam { gece: true|false|null, tip: string|null, yolcu: bool|null }
 * @returns {{ gerekceler: string[], uyarilar: string[] }}
 *          `gerekceler` atamayı ENGELLER · `uyarilar` AMBER'dır, engellemez.
 */
export function medKisitlamaKontrol(ekip, baglam = {}) {
  const liste = (ekip || []).filter(p => p && p.id).map(p => ({ ...p, limits: p.limits || [] }));
  const gerekceler = [];
  const uyarilar = [];
  // Künyeli kopya (29 Eyl 2026 · bkz. fitness): kısıtlama KODU gerekçeyi üreten
  // dalda bilinir; kart ⓘ'de o kodun AMC2 MED.B.001 tanımını açar.
  const kunyeli = [];
  const engel = (kod, metin) => { gerekceler.push(metin); kunyeli.push({ metin, ref: `SHT-MED ${kod}` }); };
  const { gece = null, tip = null, yolcu = null } = baglam;

  const var_ = (p, kod) => p.limits.includes(kod);
  // Kaptanlık yapabilecek pilot: OML de OCL de yok.
  const kaptanOlabilir = (p) => !var_(p, 'OML') && !var_(p, 'OCL');

  for (const p of liste) {
    const digerleri = liste.filter(x => x.id !== p.id);

    // ── OCL — yalnızca yardımcı pilot ─────────────────────────────
    if (var_(p, 'OCL')) {
      if (!digerleri.length) {
        engel('OCL', `OCL (${p.code}) — VALID ONLY AS CO-PILOT: SINGLE-PILOT OPERATION NOT PERMITTED`);
      } else if (!digerleri.some(kaptanOlabilir)) {
        engel('OCL', `OCL (${p.code}) — VALID ONLY AS CO-PILOT: NO OTHER PILOT ON THE CREW CAN ACT AS PIC`);
      }
    }

    // ── VCL — yalnızca gündüz ─────────────────────────────────────
    if (var_(p, 'VCL')) {
      if (gece === true) {
        engel('VCL', `VCL (${p.code}) — VALID BY DAY ONLY: DUTY CONTAINS A NIGHT SECTOR`);
      } else if (gece == null) {
        uyarilar.push(`VCL (${p.code}) — VALID BY DAY ONLY, BUT DAY/NIGHT COULD NOT BE MEASURED `
          + '(AERODROME COORDINATES OR TIMES MISSING)');
      }
    }

    // ── OAL — gösterilen tiple sınırlı ────────────────────────────
    if (var_(p, 'OAL')) {
      const izinli = p.oalTypes || [];
      if (!izinli.length) {
        // Veritabanı bunu reddediyor; yine de savunma katmanı bırakıyoruz.
        uyarilar.push(`OAL (${p.code}) — RESTRICTED TO DEMONSTRATED AIRCRAFT TYPE, BUT NO TYPE IS RECORDED`);
      } else if (tip == null) {
        uyarilar.push(`OAL (${p.code}) — RESTRICTED TO ${izinli.join(' / ')}: `
          + 'AIRCRAFT TYPE NOT KNOWN AT THIS POINT, NOT VERIFIED');
      } else if (!izinli.includes(tip)) {
        engel('OAL', `OAL (${p.code}) — RESTRICTED TO ${izinli.join(' / ')}: NOT VALID ON ${tip}`);
      }
    }

    // ── OSL — emniyet pilotu + çift kumanda (Sınıf 2 / LAPL) ──────
    if (var_(p, 'OSL') && !digerleri.length) {
      engel('OSL', `OSL (${p.code}) — SAFETY PILOT REQUIRED: NO SECOND PILOT ON THE CREW`);
    }

    // ── OPL — yalnızca yolcusuz ───────────────────────────────────
    if (var_(p, 'OPL')) {
      if (yolcu === true) engel('OPL', `OPL (${p.code}) — VALID ONLY WITHOUT PASSENGERS`);
      else if (yolcu == null) uyarilar.push(`OPL (${p.code}) — VALID ONLY WITHOUT PASSENGERS, `
        + 'PASSENGER CARRIAGE NOT KNOWN AT THIS POINT');
    }

    // ── ORL — yolcu varsa emniyet pilotu ──────────────────────────
    if (var_(p, 'ORL')) {
      if (yolcu === true && !digerleri.length) {
        engel('ORL', `ORL (${p.code}) — SAFETY PILOT REQUIRED WHEN PASSENGERS ARE CARRIED`);
      } else if (yolcu == null) {
        uyarilar.push(`ORL (${p.code}) — SAFETY PILOT REQUIRED IF PASSENGERS ARE CARRIED, `
          + 'PASSENGER CARRIAGE NOT KNOWN AT THIS POINT');
      }
    }

    // ── SSL — etkisi SİSTEMCE BİLİNEMEZ (Serkan: (a) şıkkı) ───────
    if (var_(p, 'SSL')) {
      const metin = (p.sslText || '').trim();
      uyarilar.push(`SSL (${p.code}) — SPECIAL RESTRICTION, ASSESS BEFORE DISPATCH: `
        + (metin || 'TEXT NOT RECORDED'));
    }
  }

  return { gerekceler, uyarilar, kunyeli };
}

// ── SEYİR YEDEK İKİNCİ PİLOT YAKINLIĞI (6 Eyl 2026) ─────────────────
//
// 🔑 Serkan: *"CRZ CPT uçuş görevindedir, ama PF veya PM değildir (FD yazar
//    yani)."*  Bu yüzden `pfSectors` onları hiç saymıyordu — FCL.060(a)(1)
//    yakınlığına girmiyorlar ve kendi bentleri hiç uygulanmıyordu.
//
// TALİMAT — FCL.060(a)(3): seyir safhası yedek ikinci pilot olarak uçulamaz;
//   (i)  (a)(1) gereklilikleri karşılanmıyorsa;  VEYA
//   (ii) son 90 günde en az 3 SEKTÖRDE aynı tip/sınıf UZUN UÇUŞLARDA seyir
//        yedek ikinci pilot görevi yapılmamışsa;  VEYA
//   (iii) FFS'te 90 GÜNÜ AŞMAYAN aralıklarla güncellik/tazeleme eğitimi
//        alınmamışsa.
// 🔑 ÜÇ YOLDAN BİRİ YETER ("veya"). PF yakınlığı olan pilot zaten (i)'yi sağlar.
//
// 🔑 "UZUN UÇUŞ" TANIMI SERKAN'DAN, TALİMATTAN: *"Md.4(ee), 4 saatten fazla
//    dilim geçişi — bu talimatta yazdığı gibi uzun uçuş, long range."*
//    SHT-FCL bunu tanımlamıyor; SHT-FTL/HG Md.4(ee) tanımlıyor ve ölçü ondan
//    alınır. Uydurmak yerine mevcut tanımı kullanırız.
export const CRZ_RECENCY = { windowDays: 90, sectors: 3, ffsRefreshDays: 90 };

// Uzun menzil ölçüsü `uzunMenzilOlcumu`dadır (30 Eyl 2026 · B2-3: ayrı kopya
// `uzunMenzilMi` kalktı — dilimi bilinmeyen meydanı atlayıp kalanla ölçüyordu,
// eşiği sabit 4'tü).

/**
 * @param {object} opts { tzMap, pfDurumu } — `pfDurumu` (a)(1) sonucudur.
 * @returns {{ state, route, sectors, unmeasured, ... }}
 */
export function crzRecency(duties, pilotId, asOf = null, opts = {}) {
  const { windowDays, sectors: gerekli, ffsRefreshDays } = { ...CRZ_RECENCY, ...opts };
  const tzMap = opts.tzMap || {};
  const simdi = asOf ? new Date(asOf).getTime() : Date.now();

  // (i) — PF yakınlığı sağlanıyorsa başka bir şey aranmaz.
  if (opts.pfDurumu === 'green' || opts.pfDurumu === 'amber') {
    return { state: 'green', route: 'a1', sectors: 0, unmeasured: 0,
             reference: 'SHT-FCL FCL.060(a)(3)(i)',
             note: 'Met through FCL.060(a)(1) — the pilot is current as PF.' };
  }

  // (ii) — uzun uçuşlarda CRZ sektörleri
  let sayi = 0, olculemeyen = 0, enEski = null;
  (duties || [])
    .filter(d => (!pilotId || d.pilot_id === pilotId) && d.duty_type === 'flight'
                 && d.status !== 'planned' && d.status !== 'cancelled' && d.duty_date)
    .forEach(d => {
      if (!fclPenceresinde(d.duty_date, simdi, windowDays)) return;
      const crz = (d.sectors || []).filter(
        s => String(s.role || '').toUpperCase() === 'CRZ CPT');
      if (!crz.length) return;
      // Tek kaynak (B2-3): görevin kendi anları ve kural seti; anı yoksa görev günü öğlen.
      const um = uzunMenzilOlcumu(d.sectors, tzMap, effectiveRules(d.ruleset_snapshot || null).rules,
        { raporISO: d.report_time || `${d.duty_date}T12:00:00Z`, bitisISO: d.duty_end || null });
      const uzun = um.olculemedi ? null : um.uzunMenzil;
      if (uzun === null) { olculemeyen += crz.length; return; }   // İlke 1
      if (!uzun) return;
      sayi += crz.length;
      if (enEski === null || d.duty_date < enEski) enEski = d.duty_date;
    });
  if (sayi >= gerekli) {
    return { state: 'green', route: 'a3ii', sectors: sayi, unmeasured: olculemeyen,
             ageDays: enEski == null ? null : utcGunFarki(simdi, enEski),
             reference: 'SHT-FCL FCL.060(a)(3)(ii)' };
  }

  // (iii) — FFS tazeleme, 90 GÜNÜ AŞMAYAN aralıklarla
  const sonFfs = simSectors(duties, pilotId, simdi, ffsRefreshDays)[0] || null;
  if (sonFfs) {
    return { state: 'green', route: 'a3iii', sectors: sayi, unmeasured: olculemeyen,
             ageDays: utcGunFarki(simdi, sonFfs.date),
             reference: 'SHT-FCL FCL.060(a)(3)(iii)' };
  }

  return { state: 'red', route: null, sectors: sayi, required: gerekli,
           unmeasured: olculemeyen, reference: 'SHT-FCL FCL.060(a)(3)',
           note: `Not met: ${sayi} long-range cruise-relief sector(s) in the last ${windowDays} `
               + `days (${gerekli} required), no FFS refresher within ${ffsRefreshDays} days, `
               + 'and the FCL.060(a)(1) requirement is not satisfied either.' };
}
